webpackJsonp([10,8],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(525);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueResource = __webpack_require__(553);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(554);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueI18n = __webpack_require__(524);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _home = __webpack_require__(540);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _events = __webpack_require__(533);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _tournament = __webpack_require__(545);
	
	var _tournament2 = _interopRequireDefault(_tournament);
	
	var _vueCharts = __webpack_require__(488);
	
	var _vueCharts2 = _interopRequireDefault(_vueCharts);
	
	var _loguin = __webpack_require__(552);
	
	var _loguin2 = _interopRequireDefault(_loguin);
	
	var _account = __webpack_require__(550);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _data = __webpack_require__(548);
	
	var _data2 = _interopRequireDefault(_data);
	
	var _puzzles = __webpack_require__(542);
	
	var _puzzles2 = _interopRequireDefault(_puzzles);
	
	var _torneos = __webpack_require__(544);
	
	var _torneos2 = _interopRequireDefault(_torneos);
	
	var _clubs = __webpack_require__(529);
	
	var _clubs2 = _interopRequireDefault(_clubs);
	
	__webpack_require__(416);
	
	__webpack_require__(413);
	
	__webpack_require__(409);
	
	__webpack_require__(417);
	
	__webpack_require__(410);
	
	__webpack_require__(415);
	
	__webpack_require__(418);
	
	__webpack_require__(412);
	
	__webpack_require__(414);
	
	__webpack_require__(411);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vueSocket = __webpack_require__(575);
	
	var _vueSocket2 = _interopRequireDefault(_vueSocket);
	
	var _socket = __webpack_require__(428);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	var _locales = __webpack_require__(295);
	
	var _locales2 = _interopRequireDefault(_locales);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueMaterialComponents2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueCharts2.default);
	
	_vue2.default.http.interceptors.push(function (request, next) {
	  var token = _lstorage2.default.get('token');
	  if (token) {
	    request.headers['Authorization'] = 'Bearer ' + token;
	  }
	
	  next(function (response) {
	    if (response.status === 401 || response.status === 403) {
	      var ctx = { $http: _vue2.default.http };
	
	      _user2.default.logout(ctx);
	    }
	  });
	});
	_lstorage2.default.setPrefix('chessPlaza');
	_user2.default.init();
	
	var dirServer = 'https://' + window.location.hostname;
	
	_lstorage2.default.set('serverDir', dirServer);
	
	_vue2.default.http.options.root = _lstorage2.default.get('serverDir');
	
	
	_vue2.default.filter('timeBoard', function (s) {
	  var hours = parseInt(s / 3600);
	  var minutes = parseInt(s % 3600 / 60);
	  var seconds = s % 60;
	  return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
	});
	
	_vue2.default.filter('moment', function (date, format) {
	  return (0, _moment2.default)(date).format(format);
	});
	_vue2.default.filter('reverse', function (value) {
	  return value.slice().reverse();
	});
	
	if (_lstorage2.default.get('token')) {
	  var socket = _socket2.default.connect(_lstorage2.default.get('serverDir'), { query: 'token=' + 'Bearer ' + _lstorage2.default.get('token') });
	  _vue2.default.use(_vueSocket2.default, socket);
	}
	
	_vue2.default.use(_vueI18n2.default);
	
	var lan = _lstorage2.default.get('lenguaje', 'es');
	var locales = _locales2.default.i18n;
	_vue2.default.config.lang = lan;
	
	(0, _keys2.default)(locales).forEach(function (lang) {
	  _vue2.default.locale(lang, locales[lang]);
	});
	_vue2.default.transition('entern', {
	  enterClass: 'pulse',
	  leaveClass: 'invisible'
	});
	
	var router = new _vueRouter2.default();
	
	router.map({
	  '/home': {
	    name: 'home',
	    component: _home2.default
	  },
	  '/events': {
	    name: 'events',
	    component: _events2.default
	  },
	  '/tournament': {
	    name: 'tournament',
	    component: _tournament2.default
	  },
	  '/user': {
	    name: 'user',
	    component: {
	      template: '<div class="row"><router-view></router-view></div>'
	    },
	    subRoutes: {
	      '/:username': {
	        component: _account2.default,
	        name: 'user',
	        subRoutes: {
	          '/': {
	            name: 'userdata',
	            component: _data2.default
	          },
	          '/otheruser': {
	            name: 'otheruser',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          },
	          '/elo': {
	            name: 'elo',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(549)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          },
	          '/admin': {
	            name: 'admin',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(547)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          },
	          '/activity': {
	            name: 'activity',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(546)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          },
	          '/registernew': {
	            name: 'registernew',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(70)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          },
	          '/edit': {
	            name: 'edituser',
	            component: function component(resolve) {
	              __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(70)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	            }
	          }
	        }
	      },
	      '/register': {
	        name: 'register',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(70)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/guest': {
	        name: 'guest',
	        component: function component(resolve) {
	          __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(70)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	        }
	      },
	      '/loguin': {
	        name: 'loguin',
	        component: _loguin2.default
	      }
	    }
	  },
	
	  '/game/:idBoard': {
	    name: 'game',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(536)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	
	  '/visor/:idBoard/:skip/:u1/:u2': {
	    name: 'visor',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(527)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/lesson/:idBoard/:skip/:u1/:u2': {
	    name: 'lesson',
	    component: function component(resolve) {
	      __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(526)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  },
	  '/puzzle': {
	    name: 'puzzle',
	    component: _puzzles2.default
	  },
	  '/torneo': {
	    name: 'torneo',
	    component: _torneos2.default
	  },
	  '/club': {
	    name: 'club',
	    component: _clubs2.default
	  }
	});
	
	router.beforeEach(function () {
	  window.scrollTo(0, 0);
	});
	
	router.redirect({
	  '*': '/home'
	});
	
	router.start(_App2.default, '#app');

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(41);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(22);
	exports.default = {
	  prefix: 'chessPlaza',
	  lStorage: window.localStorage, setPrefix: function setPrefix(name) {
	    this.prefix = name;
	    if (config.debug) {
	      window.sessionStorage.tabID = window.sessionStorage.tabID ? window.sessionStorage.tabID : Math.random();
	      this.prefix = name + window.sessionStorage.tabID;
	      console.log('* Prefijo Debug', this.prefix);
	    } else {
	      this.prefix = name;
	      console.log('* Prefijo ', this.prefix);
	    }
	  },
	  get: function get(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (this.lStorage.getItem(this.prefix + '-' + name)) {
	      return JSON.parse(this.lStorage.getItem(this.prefix + '-' + name));
	    } else {
	      return this.set(name, value);
	    }
	  },
	  normalizeString: function normalizeString(str) {
	    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	  },
	  normalizeObject: function normalizeObject(obj) {
	    for (var key in obj) {
	      if (obj[key] !== undefined && typeof obj[key] === 'string') {
	        obj[key] = this.normalizeString(obj[key]);
	      } else if ((0, _typeof3.default)(obj[key]) === 'object' && obj[key] !== null) {
	        this.normalizeObject(obj[key]);
	      } else {}
	    }
	  },
	  set: function set(name, data) {
	    if (typeof data === 'string') {
	      this.normalizeString(data);
	    } else {
	      this.normalizeObject(data);
	    }
	    this.lStorage.setItem(this.prefix + '-' + name, (0, _stringify2.default)(data));
	    return this.get(name);
	  },
	  del: function del(name) {
	    this.lStorage.removeItem(this.prefix + '-' + name);
	  },
	  clearLocal: function clearLocal() {
	    var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var prefixRegex = new RegExp('^' + this.prefix);
	    var store = this.lStorage;
	    (0, _keys2.default)(store).forEach(function (key) {
	      if (prefixRegex.test(key) && key.includes('styleBoard') === false) {
	        store.removeItem(key);
	      }
	    });
	    if (reload) {
	      window.location.reload();
	    }
	  }
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(41);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  writeFile: function writeFile(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/writefile', data);
	  },
	  authenticate: function authenticate(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/authenticate', data);
	  },
	  signin: function signin(ctx, data) {
	    if (data._id) {
	      return ctx.$http.put(_lstorage2.default.get('serverDir') + '/user/signin', data);
	    } else {
	      return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/signin', data);
	    }
	  },
	  deleteImage: function deleteImage(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/chat/upload', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	
	  user: null,
	  userShow: {},
	  setUserShow: function setUserShow(some) {
	    this.userShow = some;
	  },
	  getUser: function getUser() {
	    return _lstorage2.default.get('user');
	  },
	  setUser: function setUser(newUser) {
	    this.user = _lstorage2.default.set('user', newUser);
	  },
	  getAll: function getAll(ctx, data) {
	    console.log('user::getAll', (0, _stringify2.default)(data));
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/getAll', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  getNum: function getNum(ctx, data) {
	    console.log('user::getNum', (0, _stringify2.default)(data));
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/getNum', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  get: function get(ctx, data) {
	    console.log('user::get', (0, _stringify2.default)(data));
	    return ctx.$http.get(_lstorage2.default.get('serverDir') + '/user/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  testUser: function testUser(ctx, data) {
	    console.log('user::testUser', (0, _stringify2.default)(data));
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/user/test', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  logout: function logout(ctx) {
	    var _this = this;
	
	    var user = this.getUser();
	    if (user) {
	      return ctx.$http.put(_lstorage2.default.get('serverDir') + '/user/updatelogout', user).then(function (r) {
	        if (r.status === 200) {
	          _lstorage2.default.clearLocal(true);
	          _this.user = null;
	          return r.text();
	        } else {
	          return r.text().then(function (d) {
	            _lstorage2.default.clearLocal(true);
	            _this.user = null;
	            throw d;
	          });
	        }
	      });
	    } else {
	      _lstorage2.default.clearLocal(true);
	      this.user = null;
	    }
	  },
	  updateELO: function updateELO(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/user/updateelo', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  updateUser: function updateUser(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/user/updateuser', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  writeFILE: function writeFILE(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/user/writefile', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  init: function init() {
	    this.user = _lstorage2.default.get('user');
	  },
	  user_acces: function user_acces() {
	    var perm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'authenticate';
	
	    if (this.getUser() && perm !== 'authenticate') {
	      return this.user.rol === perm;
	    }
	    if (perm === 'authenticate') {
	      if (this.getUser()) {
	        return true;
	      }
	    }
	    if (perm === 'guest') {
	      return true;
	    }
	    return false;
	  }
	};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var config = {
	  db: {
	    options: {
	      poolSize: 20,
	      useNewUrlParser: true,
	      useUnifiedTopology: true,
	      maxIdleTimeMS: 30000,
	      connectTimeoutMS: 10000,
	      socketTimeoutMS: 45000,
	      user: 'esacosta',
	      pass: 'Che55!!P1a2a_2022'
	    },
	    options_debug: {
	      autoIndex: false,
	      bufferCommands: false,
	      useNewUrlParser: true,
	      useUnifiedTopology: true,
	      poolSize: 20,
	      maxIdleTimeMS: 30000,
	      connectTimeoutMS: 10000,
	      socketTimeoutMS: 45000 },
	
	    uri_debug: ({"NODE_ENV":"production"}).MONGO_URL || 'mongodb+srv://esacosta:Che55!!P1a2a_2022@clusterbackup.bpmi2.mongodb.net/ChessPlaza',
	    uri: ({"NODE_ENV":"production"}).MONGO_URL || 'mongodb+srv://esacosta:Che55!!P1a2a_2022@cluster0.ma8fg18.mongodb.net/ChessPlaza'
	  },
	  host_uri: 'https://play.mainchess.com',
	  host_uri_debug: 'https://localhost',
	  stream_uri: 'https://stream.mainchess.com',
	  stream_uri_debug: 'https://localhost:2053',
	  video_uri: 'https://video.mainchess.com',
	  video_uri_debug: 'https://localhost:2083',
	  porthttp: ({"NODE_ENV":"production"}).PORT || 2023,
	  porthttp_debug: ({"NODE_ENV":"production"}).PORT || 443,
	  multicore: false,
	  https: true,
	  debug: false,
	  ipaddr: ''
	};
	module.exports = config;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  add: function add(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/club', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  del: function del(ctx, data) {
	    return ctx.$http.delete(_lstorage2.default.get('serverDir') + '/club/del/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  get: function get(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/club/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  count: function count(ctx) {
	    return ctx.$http.get(_lstorage2.default.get('serverDir') + '/club/get').then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  resolve: function resolve(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/club/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  }
	};

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  filter: function filter(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/filter', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  filterclub: function filterclub(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/filterclub', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  filterid: function filterid(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/filterid', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  addclubtogenerallessons: function addclubtogenerallessons(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/addclubtogenerallessons', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  filterlesson: function filterlesson(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/filterlesson', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  putlesson: function putlesson(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/putlesson', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  filtertorneo: function filtertorneo(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/filtertorneo', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  stats: function stats(ctx, data) {
	    return ctx.$http.get(_lstorage2.default.get('serverDir') + '/board/stats' + this.urlGetParms(data)).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  del: function del(ctx, data) {
	    return ctx.$http.delete(_lstorage2.default.get('serverDir') + '/board/del/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  decpos: function decpos(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/decpos/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  incpos: function incpos(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/board/incpos/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  urlGetParms: function urlGetParms(data) {
	    var parms = '?';
	    for (var key in data) {
	      parms += (parms === '?' ? '' : '&') + key + '=' + data[key];
	    }
	    return parms;
	  },
	
	  boardParms: _lstorage2.default.get('parmsBoard'),
	  setParms: function setParms(parms) {
	    this.boardParms = parms;
	    _lstorage2.default.set('parmsBoard', parms);
	  }
	};

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGamePgn = getGamePgn;
	exports.getGameFen = getGameFen;
	exports.getGameTurn = getGameTurn;
	exports.getUser = getUser;
	exports.getGameTimesUsers = getGameTimesUsers;
	function getGamePgn(state) {
	  return state.boards.pgn;
	}
	function getGameFen(state) {
	  return state.boards.fen;
	}
	function getGameTurn(state) {
	  return state.boards.turn;
	}
	function getUser(state) {
	  return state.user.user;
	}
	function getGameTimesUsers(state) {
	  var times = {
	    white: state.boards.twhite,
	    black: state.boards.tblack,
	    incremento: 0
	  };
	  return times;
	}

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(334)
	__vue_template__ = __webpack_require__(501)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	__webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var engine;
	var funcCallMove;
	
	function engineGame(options) {
	    options = options || {};
	    var game = new Chess();
	
	    mostrarMensaje("Arrancando el motor de ajedrez.");
	    var wasmSupported = (typeof WebAssembly === 'undefined' ? 'undefined' : (0, _typeof3.default)(WebAssembly)) === 'object' && WebAssembly.validate(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
	    console.log('wasmsupport: ' + wasmSupported);
	    try {
	        var engine = new Worker(wasmSupported ? 'static/libs/stockfish.wasm.js' : options.stockfishjs || 'static/libs/stockfish.js');
	    } catch (err) {
	        return null;
	    }
	
	    var engineStatus = {};
	    var displayScore = false;
	    var time = { wtime: 300000, btime: 300000, winc: 2000, binc: 2000, depth: 10 };
	    var playerColor = 'white';
	    var clockTimeoutID = null;
	    var isEngineRunning = false;
	
	    function uciCmd(cmd) {
	        engine.postMessage(cmd);
	    }
	    uciCmd('uci');
	
	    function mostrarMensaje(texto) {
	        var mensaje = document.createElement('div');
	        mensaje.textContent = texto;
	        mensaje.style.position = 'fixed';
	        mensaje.style.top = '50px';
	        mensaje.style.left = '50%';
	        mensaje.style.transform = 'translateX(-50%)';
	        mensaje.style.backgroundColor = '#5c005c';
	        mensaje.style.color = '#fff';
	        mensaje.style.padding = '10px 20px';
	        mensaje.style.border = '1px solid #ccc';
	        mensaje.style.borderRadius = '5px';
	        mensaje.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
	        mensaje.style.zIndex = '1000';
	
	        document.body.appendChild(mensaje);
	
	        setTimeout(function () {
	            mensaje.remove();
	        }, 2000);
	    }
	
	    function displayStatus() {
	        var status = 'Motor: ';
	        if (!engineStatus.engineLoaded) {
	            status += 'cargando ...';
	        } else if (!engineStatus.engineReady) {
	            status += 'cargado.';
	        } else {
	            status += 'listo.';
	        }
	
	        if (engineStatus.search) {
	            status += '<br>' + engineStatus.search;
	            if (engineStatus.score && displayScore) {
	                status += ' Puntos: ' + engineStatus.score;
	            }
	        }
	        var evalStatus = document.getElementById('eval');
	        if (evalStatus != undefined) {
	            evalStatus.innerHTML = status;
	        }
	    }
	
	    function displayClock(color, t) {
	        var isRunning = false;
	        if (time.startTime > 0 && color == time.clockColor) {
	            t = Math.max(0, t + time.startTime - Date.now());
	            isRunning = true;
	        }
	        var id = color == playerColor ? '#time2' : '#time1';
	        var sec = Math.ceil(t / 1000);
	        var min = Math.floor(sec / 60);
	        sec -= min * 60;
	        var hours = Math.floor(min / 60);
	        min -= hours * 60;
	        var display = hours + ':' + ('0' + min).slice(-2) + ':' + ('0' + sec).slice(-2);
	        if (isRunning) {
	            display += sec & 1 ? ' <--' : ' <-';
	        }
	    }
	
	    function updateClock() {
	        displayClock('white', time.wtime);
	        displayClock('black', time.btime);
	    }
	
	    function clockTick() {
	        updateClock();
	        var t = (time.clockColor == 'white' ? time.wtime : time.btime) + time.startTime - Date.now();
	        var timeToNextSecond = t % 1000 + 1;
	        clockTimeoutID = setTimeout(clockTick, timeToNextSecond);
	    }
	
	    function stopClock() {
	        if (clockTimeoutID !== null) {
	            clearTimeout(clockTimeoutID);
	            clockTimeoutID = null;
	        }
	        if (time.startTime > 0) {
	            var elapsed = Date.now() - time.startTime;
	            time.startTime = null;
	            if (time.clockColor == 'white') {
	                time.wtime = Math.max(0, time.wtime - elapsed);
	            } else {
	                time.btime = Math.max(0, time.btime - elapsed);
	            }
	        }
	    }
	
	    function startClock() {
	        if (game.turn() == 'w') {
	            time.wtime += time.winc;
	            time.clockColor = 'white';
	        } else {
	            time.btime += time.binc;
	            time.clockColor = 'black';
	        }
	        time.startTime = Date.now();
	        clockTick();
	    }
	
	    function _prepareMove(fen, pgn, funcCall, wtime, btime, winc, binc) {
	        funcCallMove = funcCall;
	        stopClock();
	
	        if (pgn.length > 0) {
	            game.load_pgn(pgn);
	        } else if (fen.length > 0) {
	            game.load(fen);
	        }
	
	        updateClock();
	        var turn = game.turn() == 'w' ? 'white' : 'black';
	
	        if (!game.game_over()) {
	            if (turn != playerColor) {
	                var moves = '';
	                if (pgn.length > 0) {
	                    var history = game.history({ verbose: true });
	                    for (var i = 0; i < history.length; ++i) {
	                        var move = history[i];
	                        moves += ' ' + move.from + move.to + (move.promotion ? move.promotion : '');
	                    }
	                    uciCmd('position startpos moves' + moves);
	                } else {
	                    uciCmd('position fen ' + fen);
	                }
	                if (time.depth) {
	                    uciCmd('go depth ' + time.depth);
	                } else if (time.nodes) {
	                    uciCmd('go nodes ' + time.nodes);
	                } else {
	                    if (wtime < 60000 || btime < 60000) {
	                        uciCmd('go wtime ' + wtime + ' winc ' + winc + ' btime ' + btime + ' binc ' + binc);
	                    } else {
	                        uciCmd('go movetime 3000');
	                    }
	                }
	                isEngineRunning = true;
	                startClock();
	            }
	        }
	    }
	
	    engine.onmessage = function (event) {
	        var line = event.data;
	        if (engineStatus.engineReady == false) {
	            console.log(line);
	        }
	
	        if (line == 'uciok') {
	            engineStatus.engineLoaded = true;
	        } else if (line == 'readyok') {
	            engineStatus.engineReady = true;
	        } else {
	            var match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbk])?/);
	            if (match) {
	                isEngineRunning = false;
	                game.move({ from: match[1], to: match[2], promotion: match[3] });
	
	                funcCallMove({ from: match[1], to: match[2], promotion: match[3] });
	            } else if (match = line.match(/^info .*\bdepth (\d+) .*\bnps (\d+)/)) {
	                engineStatus.search = 'Profundidad: ' + match[1] + ' Nps: ' + match[2];
	            }
	            if (match = line.match(/^info .*\bscore (\w+) (-?\d+)/)) {
	                var score = parseInt(match[2]) * (game.turn() == 'w' ? 1 : -1);
	                if (match[1] == 'cp') {
	                    engineStatus.score = (score / 100.0).toFixed(2);
	                } else if (match[1] == 'mate') {
	                    engineStatus.score = '#' + score;
	                }
	                if (match = line.match(/\b(upper|lower)bound\b/)) {
	                    engineStatus.score = (match[1] == 'upper' == (game.turn() == 'w') ? '<= ' : '>= ') + engineStatus.score;
	                }
	            }
	        }
	        displayStatus();
	    };
	
	    if (options.book) {
	        var bookRequest = new XMLHttpRequest();
	        bookRequest.open('GET', options.book, true);
	        bookRequest.responseType = "arraybuffer";
	        bookRequest.onload = function (event) {
	            if (bookRequest.status == 200) {
	                engine.postMessage({ book: bookRequest.response });
	                engineStatus.book = options.book;
	                displayStatus();
	            } else {
	                engineStatus.book = 'No exite.';
	                displayStatus();
	            }
	        };
	        bookRequest.send(null);
	    } else {
	        engineStatus.book = 'none';
	    }
	
	    return {
	        reset: function reset() {
	            game.reset();
	
	            uciCmd('setoption name Contempt Factor value 0');
	            uciCmd('setoption name Skill Level value 10');
	            uciCmd('setoption name Aggressiveness value 100');
	            uciCmd('setoption name OwnBook value false');
	        },
	        setOwnBook: function setOwnBook(value) {
	            uciCmd('setoption name OwnBook value ' + value);
	        },
	        loadPgn: function loadPgn(pgn) {
	            game.load_pgn(pgn);
	        },
	        setPlayerColor: function setPlayerColor(color) {
	            playerColor = color;
	        },
	        setSkillLevel: function setSkillLevel(skill) {
	            uciCmd('setoption name Skill Level value ' + skill);
	        },
	        setTime: function setTime(baseTime, inc) {
	            time = { wtime: baseTime * 1000, btime: baseTime * 1000, winc: inc * 1000, binc: inc * 1000 };
	        },
	        setDepth: function setDepth(depth) {
	            time = { depth: depth };
	        },
	        setNodes: function setNodes(nodes) {
	            time = { nodes: nodes };
	        },
	        setContempt: function setContempt(contempt) {
	            uciCmd('setoption name Contempt Factor value ' + contempt);
	        },
	        setAggressiveness: function setAggressiveness(value) {
	            uciCmd('setoption name Aggressiveness value ' + value);
	        },
	        setDisplayScore: function setDisplayScore(flag) {
	            displayScore = flag;
	            displayStatus();
	        },
	        start: function start() {
	            uciCmd('ucinewgame');
	            uciCmd('isready');
	            engineStatus.engineReady = false;
	            engineStatus.search = null;
	            displayStatus();
	        },
	        close: function close() {
	            uciCmd('stop');
	            engineStatus.engineReady = false;
	            engineStatus.search = null;
	            engine.terminate();
	            mostrarMensaje("Liberando el motor de ajedrez");
	        },
	        prepareMove: function prepareMove(fen, pgn, funcCall, wtime, btime, winc, binc) {
	            _prepareMove(fen, pgn, funcCall, wtime, btime, winc, binc);
	        },
	        undo: function undo() {
	            if (isEngineRunning) return false;
	            game.undo();
	            game.undo();
	            engineStatus.search = null;
	            displayStatus();
	
	            return true;
	        }
	    };
	}
	
	module.exports.engineGame = engineGame;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var boardGameMove = exports.boardGameMove = makeAction('MOVE');
	var boardGameTurn = exports.boardGameTurn = makeAction('TURN');
	var boardGameCountDown = exports.boardGameCountDown = makeAction('COUNTDOWN');
	var setUser = exports.setUser = makeAction('SETUSER');
	function makeAction(type) {
	  return function (_ref) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var dispatch = _ref.dispatch;
	    return dispatch.apply(undefined, [type].concat(args));
	  };
	}

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(320)
	__vue_template__ = __webpack_require__(493)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(400)
	__vue_script__ = __webpack_require__(312)
	__vue_template__ = __webpack_require__(506)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(399)
	__vue_script__ = __webpack_require__(314)
	__vue_template__ = __webpack_require__(505)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(407)
	__vue_script__ = __webpack_require__(318)
	__vue_template__ = __webpack_require__(511)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  add: function add(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  del: function del(ctx, data) {
	    return ctx.$http.delete(_lstorage2.default.get('serverDir') + '/puzzle/del/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  get: function get(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  count: function count(ctx) {
	    return ctx.$http.get(_lstorage2.default.get('serverDir') + '/puzzle/get').then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  resolve: function resolve(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/puzzle/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  decpos: function decpos(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle/decpos/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  addclubtogeneralpuzzles: function addclubtogeneralpuzzles(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle/addclubtogeneralpuzzles', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  putpuzzle: function putpuzzle(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle/putpuzzle', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  incpos: function incpos(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/puzzle/incpos/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  }
	};

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	var MAX_SCORE_DIFFERENCE = 20;
	
	Match.RESULT_WIN = 1;
	Match.RESULT_DRAW = 0;
	Match.RESULT_LOSS = -1;
	
	Match.SUM_WIN = 1;
	Match.SUM_DRAW = 0.5;
	Match.SUM_LOSS = 0;
	Match.RONDAS = 8;
	
	var matchesCount = 0;
	
	function Match(round, player1, player2, result) {
	    this.player1 = player1;
	    this.player2 = player2;
	    this.round = round;
	    this.result = result;
	
	    this.player1.addMatch(this);
	    this.player2.addMatch(this);
	    matchesCount++;
	    console.log(matchesCount, player1.getMatchesWhite(), player1.getMatchesBlack(), player1.name, "vs", player2.getMatchesWhite(), player2.getMatchesBlack(), player2.name, "\t", result == Match.RESULT_WIN ? "1-0" : result == Match.RESULT_LOSS ? "0-1" : "½", "\t", player1.score, ":", player2.score);
	}
	
	Match.randomResult = function () {
	    return Math.floor(Math.random() * (Match.RESULT_WIN - Match.RESULT_LOSS + 1)) + Match.RESULT_LOSS;
	};
	
	function Player(name, score, elo) {
	    this.name = name;
	    this.elo = elo;
	    this.score = 0;
	    this.buchholz = 1;
	    this.wins = 0;
	    this.losses = 0;
	    this.draws = 0;
	    this.notpair = 0;
	    this.matches = [];
	}
	
	Player.prototype.deleteMatch = function (match) {
	    this.matches.pop(match);
	
	    if (match.result == Match.RESULT_DRAW) {
	        this.draws--;
	        this.score -= Match.SUM_DRAW;
	    } else {
	        if (match.player1 == this) {
	            if (match.result == Match.RESULT_WIN) {
	                this.wins--;
	                this.score -= Match.SUM_WIN;
	            } else {
	                this.wins++;
	                this.score -= Match.SUM_LOSS;
	            }
	        } else {
	            if (match.result == Match.RESULT_LOSS) {
	                this.wins--;
	                this.score -= Match.SUM_WIN;
	            } else {
	                this.wins++;
	                this.score -= Match.SUM_LOSS;
	            }
	        }
	    }
	};
	
	Player.prototype.addMatch = function (match) {
	    this.matches.push(match);
	
	    if (match.result == Match.RESULT_DRAW) {
	        this.draws++;
	        this.score += Match.SUM_DRAW;
	    } else {
	        if (match.player1 == this) {
	            if (match.result == Match.RESULT_WIN) {
	                this.wins++;
	                this.score += Match.SUM_WIN;
	            } else {
	                this.wins--;
	                this.score += Match.SUM_LOSS;
	            }
	        } else {
	            if (match.result == Match.RESULT_LOSS) {
	                this.wins++;
	                this.score += Match.SUM_WIN;
	            } else {
	                this.wins--;
	                this.score += Match.SUM_LOSS;
	            }
	        }
	    }
	};
	
	Player.prototype.popMatch = function (round) {
	    for (var i = 0; i < this.matches.length; i++) {
	        var match = this.matches[i];
	
	        if (match && match.round == round) {
	            console.log('borro match', match.player1.name, 'vs', match.player2.name);
	            match.player1.deleteMatch(match);
	            match.player2.deleteMatch(match);
	        }
	    }
	};
	
	Player.prototype.hasPlayedAgainst = function (player) {
	    if (this == player) return false;
	    for (var i = 0; i < this.matches.length; i++) {
	        var match = this.matches[i];
	
	        if (match.player1 == player || match.player2 == player) {
	            return true;
	        }
	    }
	
	    return false;
	};
	
	Player.prototype.getMatches = function () {
	    return this.matches.length;
	};
	
	Player.prototype.getMatchesWhite = function () {
	    var n = 0;
	    for (var i = 0; i < this.matches.length; i++) {
	        var match = this.matches[i];
	
	        if (match.player1 == this) n++;
	    }
	
	    return n;
	};
	
	Player.prototype.getMatchesBlack = function () {
	    var n = 0;
	    for (var i = 0; i < this.matches.length; i++) {
	        var match = this.matches[i];
	
	        if (match.player2 == this) n++;
	    }
	
	    return n;
	};
	
	Player.prototype.getVs = function (round) {
	    for (var i = this.matches.length; i >= 0; i--) {
	        var match = this.matches[i];
	
	        if (match && match.round == round) {
	            if (match.player1 == this) return match.player2;
	            if (match.player2 == this) return match.player1;
	        }
	    }
	
	    return false;
	};
	
	Player.prototype.hasPlayed = function (round) {
	    for (var i = this.matches.length; i >= 0; i--) {
	        var match = this.matches[i];
	
	        if (match && match.round == round && (match.player1 == this || match.player2 == this)) return true;
	    }
	
	    return false;
	};
	
	function createNextSwiss(round1, numRonda) {
	    var playerList = [];
	}
	
	function Resultados(playerList) {
	    for (var i = 0; i < playerList.length; i++) {
	        var player1 = playerList[i];
	        for (var ii = 0; ii < playerList.length; ii++) {
	            var player2 = playerList[ii];
	            if (player1 == player2) {
	                continue;
	            }
	            if (player1.hasPlayedAgainst(player2)) {
	                player1.buchholz += player2.score;
	            }
	        }
	    }
	
	    playerList.sort(function (player1, player2) {
	        return player2.score * player2.buchholz - player1.score * player1.buchholz;
	    });
	    console.log("---------------", "Resultados", "---------------");
	
	    for (var i = 0; i < playerList.length; i++) {
	        var player = playerList[i];
	        console.log("Puesto", i + 1, ":", player.name, "con", player.score, "puntos", "y", "buchholz", player.buchholz, "y", "elo", player.elo, "y", player.getMatches(), "partidas + ", player.notpair, "descanso", player.getMatchesWhite(), "con blancas y", player.getMatchesBlack(), "con negras");
	    }
	}
	
	function createSwiss(players, round1, numRonda) {
	    var playerList = [];
	
	    for (var i in players) {
	        console.log(i, players[i].name, players[i].juega);
	        if (players[i].juega === true) {
	            playerList.push(new Player(players[i].name, players[i].score, players[i].elo));
	        }
	    }
	
	    var matchPossible = true;
	    console.log("Jugadores:", playerList.length);
	    console.log("Rondas:", Match.RONDAS);
	
	    playerList.sort(function (player1, player2) {
	        if (player2.score == 0 && player1.score == 0) {
	            return player2.elo - player1.elo;
	        }
	        return player2.score * player2.buchholz - player1.score * player1.buchholz;
	    });
	
	    var round = {};
	    var rondaRoundRobin = {};
	
	    if (round1[0] != undefined) {
	        console.log("--------------- poniendo puntos", "---------------");
	
	        for (var r in round1) {
	            if (round1[r] != undefined) {
	                var bNotFinish = false;
	                for (var partida in round1[r].rounds) {
	                    var player1 = playerList[0];
	                    for (var i = 0; i < playerList.length; i++) {
	                        player1 = playerList[i];
	                        if (round1[r].rounds[partida].white == player1.name) {
	                            break;
	                        }
	                    }
	                    var player2 = playerList[0];
	                    for (var i = 0; i < playerList.length; i++) {
	                        player2 = playerList[i];
	                        if (round1[r].rounds[partida].black == player2.name) {
	                            break;
	                        }
	                    }
	                    if (player1 && player2 && round1[r].rounds[partida].wins != '') {
	                        var result = Match.RESULT_WIN;
	                        if (round1[r].rounds[partida].wins == 'white') result = Match.RESULT_WIN;else if (round1[r].rounds[partida].wins == 'black') result = Match.RESULT_LOSS;else if (round1[r].rounds[partida].wins == 'draw') result = Match.RESULT_DRAW;
	                        new Match(numRonda, player1, player2, result);
	                    } else {
	                        bNotFinish = true;
	                        break;
	                    }
	                }
	
	
	                if (bNotFinish == false) numRonda++;
	            }
	        }
	        rondaRoundRobin = round1;
	    }
	    Resultados(playerList);
	    if (bNotFinish == true) {
	        if (window.confirm('No ha finalizado la ronda: ' + (numRonda + 1) + ' ¿Forzar finalización?')) {
	            numRonda = numRonda + 1;
	        } else {
	            rondaRoundRobin = round1;
	
	            return rondaRoundRobin;
	        }
	    }
	
	    {
	        if (numRonda == 0) {
	            console.log("--------------- Ronda ", numRonda, "---------------");
	            var round = {};
	            for (var i = 0; i < Math.round(playerList.length / 2); i++) {
	                var player1 = playerList[i];
	
	                matchFound = false;
	                for (var ii = Math.round(playerList.length / 2); ii < playerList.length; ii++) {
	                    var player2 = playerList[ii];
	
	                    if (player1 == player2) {
	                        continue;
	                    }
	                    if (player2.hasPlayed(numRonda)) {
	                        continue;
	                    }
	                    matchFound = true;
	
	                    new Match(numRonda, player1, player2, Match.randomResult());
	                    var partida = { white: player1.name, black: player2.name, wins: '' };
	                    round[i] = partida;
	                    break;
	                }
	
	                if (matchFound == false && (playerList.length + 1) % 2 == 0) {
	                    player1.notpair++;
	                    console.log("Descansa", player1.name, player1.notpair, "veces");
	                }
	            }
	
	            var roundaux = { rounds: round };
	            rondaRoundRobin[numRonda] = roundaux;
	
	            return rondaRoundRobin;
	        } else {
	            while (matchPossible) {
	                matchPossible = false;
	
	                for (var i = 0; i < playerList.length; i++) {
	                    var player1 = playerList[i];
	                    for (var ii = 0; ii < playerList.length; ii++) {
	                        var player2 = playerList[ii];
	                        if (player1 == player2) {
	                            continue;
	                        }
	                        if (player1.hasPlayedAgainst(player2)) {
	                            player1.buchholz += player2.score;
	                        }
	                    }
	                }
	                playerList.sort(function (player1, player2) {
	                    return player2.score * player2.buchholz - player1.score * player1.buchholz;
	                });
	                var max = 0;
	                console.log("--------------- Round ", numRonda, "---------------");
	                matchesCount = 0;
	                var noencontrado = 0;
	                var round = {};
	                for (var i = 0; i < playerList.length; i++) {
	                    var player1 = playerList[i];
	                    max++;
	
	                    if (max > 5000) break;
	
	
	                    if (player1.hasPlayed(numRonda)) {
	                        continue;
	                    }
	                    var matchFound = false;
	
	                    for (var ii = 0; ii < playerList.length; ii++) {
	                        var player2 = playerList[ii];
	
	                        if (player1 == player2) {
	                            continue;
	                        }
	
	
	                        if (player1.hasPlayedAgainst(player2)) {
	                            continue;
	                        }
	
	                        if (player2.hasPlayed(numRonda)) {
	                            continue;
	                        }
	
	
	                        matchPossible = true;
	
	                        var partida = { white: '', black: '', wins: '' };
	                        if (player1.getMatchesWhite() <= player2.getMatchesWhite()) {
	                            new Match(numRonda, player1, player2, Match.randomResult());
	                            partida = { white: player1.name, black: player2.name, wins: '' };
	                        } else {
	                            new Match(numRonda, player2, player1, Match.randomResult());
	                            partida = { white: player2.name, black: player1.name, wins: '' };
	                        }
	                        round[i] = partida;
	
	
	                        matchFound = true;
	                        break;
	                    }
	
	                    if (matchFound == false && playerList.length % 2 != 0) {
	                        if (player1.notpair == 0) {
	                            player1.notpair++;
	                            console.log("Descansa", player1.name);
	                            break;
	                        } else {
	                            console.log(noencontrado, "Ya ha descansado antes", player1.name);
	                            for (var i = 1; i < playerList.length; i++) {
	                                var player = playerList[playerList.length - i];
	                                if (player != undefined && player != player1 && player.notpair == 0 && player1.hasPlayedAgainst(player) == false && player.getVs(numRonda).notpair == 0) {
	                                    player.popMatch(numRonda);
	                                    var partida = { white: '', black: '', wins: '' };
	                                    if (player1.getMatchesWhite() <= player.getMatchesWhite()) {
	                                        new Match(numRonda, player1, player, Match.randomResult());
	                                        partida = { white: player1.name, black: player.name, wins: '' };
	                                    } else {
	                                        new Match(numRonda, player, player1, Match.randomResult());
	                                        partida = { white: player.name, black: player2.name, wins: '' };
	                                    }
	                                    round[i] = partida;
	                                    matchesCount--;
	                                    matchFound = true;
	                                    break;
	                                }
	                            }
	                        }
	                    }
	
	                    if (matchFound == false && playerList.length % 2 == 0) {
	                        if (player1.notpair == 0) {
	                            console.log("No encuentro pareja para", player1.name);
	                        } else {}
	                        for (var i = 1; i < playerList.length; i++) {
	                            var player = playerList[playerList.length - i];
	                            if (player != undefined && player1.hasPlayedAgainst(player) == false && player != player1) {
	                                player.popMatch(numRonda);
	                                matchesCount--;
	                                var partida = { white: '', black: '', wins: '' };
	                                if (player1.getMatchesWhite() <= player.getMatchesWhite()) {
	                                    new Match(numRonda, player1, player, Match.randomResult());
	                                    partida = { white: player1.name, black: player.name, wins: '' };
	                                } else {
	                                    new Match(numRonda, player, player1, Match.randomResult());
	                                    partida = { white: player.name, black: player.name, wins: '' };
	                                }
	                                round[i] = partida;
	
	                                break;
	                            }
	                        }
	                        matchPossible = true;
	                        i = 0;
	                        continue;
	                    }
	                }
	
	                var roundaux = { rounds: round };
	                rondaRoundRobin[numRonda] = roundaux;
	
	                return rondaRoundRobin;
	            }
	        }
	    }
	    return rondaRoundRobin;
	}
	
	module.exports.createSwiss = createSwiss;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var files = __webpack_require__(579);
	var modules = {};
	
	files.keys().forEach(function (key) {
	  if (key === './index.js') return;
	  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
	});
	
	exports.default = modules;

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(323)
	__vue_template__ = __webpack_require__(495)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  lenguajes: [{
	    label: 'Español',
	    value: 'es'
	  }, {
	    label: 'English',
	    value: 'en'
	  }]
	};

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  i18n: {
	    es: {
	      login: {
	        title: 'Autentificar usuario',
	        username: 'Usuario',
	        password: 'Contraseña',
	        authenticate: 'Autentificar',
	        createaccount: 'Crear una cuenta',
	        createguest: 'Invitado',
	        links: 'Enlaces',
	        errors: {
	          user_not_found: 'Usuario no encontrado',
	          passw_incorrect: 'Contraseña incorrecta',
	          consultando: 'Consultando'
	        },
	        terms: 'Terminos y condiciones',
	        terms_text: 'Si continua utilizando esta plataforma acepta los términos, condiciones y las políticas de privacidad. Utilizamos cookies para darle una mejor experiencia en la plataforma.'
	      },
	      ELO: {
	        title: 'Calculo de ELO',
	        username: 'Usuario',
	        password: 'Contraseña',
	        authenticate: 'Autentificar',
	        eloaccount: 'Calcular ELO',
	        errors: {
	          user_not_found: 'Usuario no encontrado',
	          passw_incorrect: 'Contraseña incorrecta',
	          consultando: 'Consultando'
	        }
	      },
	      BBDD: {
	        title: 'Base de datos',
	        username: 'Usuario',
	        password: 'Contraseña',
	        authenticate: 'Autentificar',
	        basedatos: 'Base de datos',
	        errors: {
	          user_not_found: 'Usuario no encontrado',
	          passw_incorrect: 'Contraseña incorrecta',
	          consultando: 'Consultando'
	        }
	      },
	      tournament: {
	        title: 'Torneos'
	      },
	      events: {
	        title: 'Retransmisión'
	      },
	      listing: {
	        title: 'Listado de usuarios',
	        username: 'Usuario',
	        password: 'Contraseña',
	        authenticate: 'Autentificar',
	        listaccount: 'Listar usuarios',
	        errors: {
	          user_not_found: 'Usuario no encontrado',
	          passw_incorrect: 'Contraseña incorrecta',
	          consultando: 'Consultando'
	        }
	      },
	      register: {
	        title: 'Registrar usuario',
	        username: 'Usuario > 4',
	        password: 'Contraseña (entre 4 y 10)',
	        name: 'Nombre',
	        email: 'Correo',
	        codigo: 'Código',
	        firstName: 'Primer Apellido',
	        lastName: 'Segundo Apellido',
	        club: 'Club',
	        insert: 'Crear',
	        cancel: 'Cancelar',
	        mascul: 'Masculino',
	        femen: 'Femenino',
	        age: 'Edad',
	        elo: 'ELO',
	        edit: 'Editar',
	        chat: 'Vídeo',
	        chattext: 'Chat',
	        chataudio: 'Audio',
	        live: 'Retransmisión',
	        cast: 'Emitir clases',
	        analyse: 'Analizar con motor',
	        download: 'Descargar PGN',
	        sendtoanalyse: 'Enviar posición',
	        passwordRepit: 'Repetir Password',
	        admin: 'Adminitrador',
	        teacher: 'Profesor',
	        user: 'Usuario',
	        save: 'Guardar',
	        errors: {
	          user_not_found: 'Usuario no encontrado',
	          passw_incorrect: 'Contraseña incorrecta',
	          consultando: 'Consultando'
	        }
	      },
	      account: {
	        title: 'Cuenta',
	        personalData: {
	          title: 'Mis datos',
	          name: 'Nombre',
	          username: 'Usuario',
	          email: 'Correo',
	          created: 'Creado',
	          edit: 'Editar cuenta'
	        },
	        activity: {
	          title: 'Actividad',
	          vsPC: 'Estadísticas contra la CPU',
	          vsOtherUser: 'Estadísticas humanos',
	          wins: 'Ganadas',
	          draws: 'Tablas',
	          losses: 'Perdidos',
	          whites: 'Blancas',
	          blacks: 'Negras'
	        }
	      },
	      home: {
	        title: 'Inicio',
	        online: 'Usuarios conectados',
	        played: 'Partidas en curso',
	        upload: 'Archivo',
	        invite: 'Invitar',
	        send: 'Enviar',
	        viewer: 'Visor',
	        chat: 'Vídeo',
	        chattext: 'Chat',
	        inviteSend: 'invitación de juego enviada',
	        createPart: {
	          title: 'Crear partida',
	          time: 'Tiempo minutos',
	          type: 'Tipo partida',
	          publicAnalisis: 'Retransmitir para el club',
	          typeAnalisis: 'Retransmitir para todos los clubs',
	          typeBroadcast: 'Retransmisión en directo para los torneos',
	          create: 'Crear',
	          cancel: 'Cancelar',
	          black: 'Negras',
	          white: 'Blancas',
	          timePersonal: 'Establecer tiempo',
	          fieldTime: 'Tiempo',
	          public: 'Publica',
	          broadcast: 'Retransmisión',
	          private: 'Privada',
	          save: 'Guardar',
	          close: 'Cerrar',
	          incremento: 'Incremento'
	        },
	        uploadMens: {
	          success: 'Archivos subidos correctamente',
	          path_not_permit: 'Extensión de archivo no permitida',
	          size_not_permit: 'Excede del tamaño permitido'
	        }
	      },
	      invites: {
	        title: 'Crear partida',
	        numIn: 'Retos de usuarios',
	        vspc: 'Jugar contra el ordenador',
	        vsanalisis: 'Analizar partida',
	        initgame: 'Iniciando juego'
	      },
	      visor: {
	        title: 'Archivo',
	        found: 'Encontrados',
	        whiteName: 'Nombre blancas',
	        blackName: 'Nombre negras',
	        result: 'Resultado',
	        wins: 'Ganan',
	        by: 'por'
	      },
	      lesson: {
	        title: 'Lecciones',
	        found: 'Encontrados',
	        whiteName: 'Nombre blancas',
	        blackName: 'Nombre negras',
	        name: 'Nombre',
	        result: 'Resultado',
	        wins: 'Ganan',
	        by: 'por',
	        option: 'Convertir el análisis en lección (aparecerá en la sección Lecciones)'
	      },
	      puzzles: {
	        title: 'Ejercicios',
	        create: {
	          title: 'Crea un ejercicio',
	          description: 'Añade y comparte un ejercicio',
	          create: 'Crear',
	          delete: 'Eliminar',
	          edit: 'Editar',
	          cancel: 'Cancelar',
	          add: 'Añadiendo un ejercicio',
	          fenInit: 'Posición inicial',
	          fenFinish: 'Posición final'
	        },
	        list: 'Listado',
	        types: {
	          MateIn1: {
	            name: 'Mate en 1',
	            descript: 'Las blancas ganan en un movimiento'
	          },
	          Estrategia: {
	            name: 'Estrategia',
	            descript: 'Encuentra el mejor movimiento'
	          },
	          Finales: {
	            name: 'Finales teóricos',
	            descript: 'Encuentra el mejor moviento en el final'
	          },
	          Tactic: {
	            name: 'Encontrar mejor movimiento',
	            descript: 'Buscar movimiento que da como resultado otra posición'
	          },
	          Aperturas: {
	            name: 'Estudia la apertura',
	            descript: '¿Cuál es el siguiente mejor moviento en la apertura?'
	          },
	          Iniciacion: {
	            name: 'Iniciación al ajedrez',
	            descript: 'Aprende los conceptos básicos del ajedrez'
	          },
	          MateIn: {
	            name: 'Mate en x',
	            descript: 'Las blancas ganan en x movimientos'
	          },
	          Practica: {
	            name: 'Practica',
	            descript: 'Practica contra el ordenador'
	          },
	          Test: {
	            name: 'Test',
	            descript: 'Comprueba tu nivel con diferentes ejercicios'
	          }
	        },
	        attention: 'Información',
	        attMen: 'Selecciona un tipo de ejercicio a resolver',
	        createBy: 'Creado por',
	        date: 'Fecha',
	        played: 'Juega',
	        movs: 'Movimientos restantes',
	        wins: 'Ganas',
	        lost: 'Pierdes',
	        reintent: 'Reintentar',
	        intents: 'Intentos',
	        color: {
	          black: 'Negras',
	          white: 'Blancas'
	        }
	      },
	      clubs: {
	        title: 'Clubs',
	        create: {
	          title: 'Crea un club',
	          description: 'Añade y comparte un club',
	          create: 'Crear',
	          delete: 'Eliminar',
	          edit: 'Editar',
	          cancel: 'Cancelar',
	          add: 'Añadiendo un club',
	          fenInit: 'Posición inicial',
	          fenFinish: 'Posición final'
	        },
	        list: 'Listado',
	        types: {
	          Liga: {
	            name: 'Pago',
	            descript: 'Clubs de pago'
	          },
	          Simultanea: {
	            name: 'Escuelas',
	            descript: 'Clubs de escuelas'
	          },
	          Suizo: {
	            name: 'Suizo',
	            descript: 'Torneo con emparejamiento Suizo'
	          },
	          Aleatorio: {
	            name: 'Aleatorio',
	            descript: 'Emparejamiento aleatorio'
	          }
	        },
	        attention: 'Información',
	        attMen: 'Selecciona un tipo de club',
	        createBy: 'Creado por',
	        date: 'Fecha',
	        played: 'Juega',
	        movs: 'Movimientos restantes',
	        wins: 'Ganas',
	        lost: 'Pierdes',
	        reintent: 'Reintentar',
	        intents: 'Intentos',
	        color: {
	          black: 'Negras',
	          white: 'Blancas'
	        }
	      },
	      torneos: {
	        title: 'Torneos',
	        create: {
	          title: 'Crea un torneo',
	          description: 'Añade y comparte un torneo',
	          create: 'Crear',
	          delete: 'Eliminar',
	          edit: 'Editar',
	          cancel: 'Cancelar',
	          add: 'Añadiendo un torneo',
	          fenInit: 'Posición inicial',
	          fenFinish: 'Posición final'
	        },
	        list: 'Listado',
	        types: {
	          Liga: {
	            name: 'Liga',
	            descript: 'Todos contra todos'
	          },
	          Simultanea: {
	            name: 'Simultanea',
	            descript: 'Todos contra uno'
	          },
	          Suizo: {
	            name: 'Suizo',
	            descript: 'Torneo con emparejamiento Suizo'
	          },
	          Aleatorio: {
	            name: 'Aleatorio',
	            descript: 'Emparejamiento aleatorio'
	          }
	        },
	        attention: 'Información',
	        attMen: 'Selecciona un tipo de torneo',
	        createBy: 'Creado por',
	        date: 'Fecha',
	        played: 'Juega',
	        movs: 'Movimientos restantes',
	        wins: 'Ganas',
	        lost: 'Pierdes',
	        reintent: 'Reintentar',
	        intents: 'Intentos',
	        color: {
	          black: 'Negras',
	          white: 'Blancas'
	        }
	      },
	      about: {
	        title: 'Acerca de',
	        description: 'Información sobre la plataforma',
	        namegame: 'Plataforma educativa de ajedrez',
	        seemore: 'Leer más',
	        des: 'Plataforma de ajedrez online. Permite dar y recibir clases en directo analizando partidas, enfrentarte a otros jugadores en tiempo real y al propio computador. Resuelve los ejercicios y crea otros nuevos.',
	        tecn: 'Tecnologías',
	        dev: 'Desarrollador',
	        licenses: 'Licencias',
	        close: 'Cerrar'
	      },
	      game: {
	        analisys: 'Análisis',
	        title: 'Partida',
	        chat: 'Chat de la partida',
	        rend: 'Rendir',
	        chatConverTooltip: 'Selecciona un usuario conectado',
	        chatConver: 'Seleccionar usuario',
	        white: 'Seleccionar blancas...',
	        black: 'Seleccionar negras...',
	        pieces: 'Piesas',
	        board: 'Tablero',
	        invert: 'Invertir',
	        text: 'Texto',
	        check: 'Jaque a las',
	        delete: 'Eliminar',
	        descriptiontext: 'Enviar mensaje',
	        turnColor: 'Juegan las',
	        wins: 'Ganan',
	        cancel: 'Partida cancelada',
	        draw: 'Tablas',
	        incheck: 'En jaque',
	        motives: {
	          time: 'por tiempo',
	          rendi: 'por rendición',
	          login: 'Autenticarse'
	        },
	        class: 'Aula',
	        play: 'Jugar',
	        createClass: 'Crear un análisis',
	        nameClass: 'Nombre del análisis',
	        accept: 'Aceptar',
	        comment: 'Comentario',
	        sendvideo: 'Enviar URL',
	        sendfile: 'Enviar Archivo',
	        pantallacompleta: 'FullScreen'
	      },
	      user: {
	        finduser: 'Buscar usuario',
	        title: 'Usuario',
	        logout: 'Salir',
	        login: 'Autenticarse',
	        config: 'Gestión'
	      }
	    },
	    en: {
	      login: {
	        title: 'user Login',
	        username: 'Username',
	        password: 'Password',
	        authenticate: 'Login',
	        createaccount: 'Create account',
	        createguest: 'Guest',
	        links: 'Links',
	        errors: {
	          user_not_found: 'user not found',
	          passw_incorrect: 'Incorrect password',
	          consultando: 'Consulting'
	        },
	        terms: 'Read terms and conditions',
	        terms_text: 'If you continue to use this site means you accept Terms and Conditions and Privacy Policy. We use cookies to ensure that we give you the best experience on our website.'
	      },
	      BBDD: {
	        title: 'DataBase',
	        username: 'User',
	        password: 'Password',
	        authenticate: 'Authenticate',
	        basedatos: 'DataBase',
	        errors: {
	          user_not_found: 'User not found',
	          passw_incorrect: 'Password incorrect',
	          consultando: 'Searching'
	        }
	      },
	      ELO: {
	        title: 'Calculo de ELO',
	        username: 'User',
	        password: 'Password',
	        authenticate: 'Authenticate',
	        eloaccount: 'ELO calculate',
	        errors: {
	          user_not_found: 'User not found',
	          passw_incorrect: 'Password incorrect',
	          consultando: 'Searching'
	        }
	      },
	      register: {
	        title: 'Register user',
	        username: 'Username > 4',
	        password: 'Password (more than 4 and less than 10)',
	        name: 'Name',
	        codigo: 'Code',
	        email: 'Email',
	        firstName: 'Surname',
	        club: 'Club',
	        lastName: 'Second surname',
	        insert: 'Insert',
	        cancel: 'Cancel',
	        mascul: 'Male',
	        femen: 'Female',
	        age: 'Age',
	        chat: 'Vídeo',
	        chattext: 'Chat',
	        chataudio: 'Audio',
	        live: 'Live',
	        edit: 'Editar',
	        cast: 'Emit',
	        analyse: 'Analyse with engine',
	        download: 'Download PGN',
	        sendtoanalyse: 'Send position',
	        passwordRepit: 'Repeat Password',
	        admin: 'Admin',
	        teacher: 'Teacher',
	        save: 'Save',
	        user: 'User',
	        errors: {
	          user_not_found: 'User not found',
	          passw_incorrect: 'Incorrect password',
	          consultando: 'Consulting'
	        }
	      },
	      account: {
	        title: 'Account',
	        personalData: {
	          title: 'Personal data',
	          name: 'Name',
	          username: 'Username',
	          email: 'Email',
	          created: 'Created',
	          edit: 'Edit account'
	        },
	        activity: {
	          title: 'Activity',
	          vsPC: 'Stats against CPU',
	          vsOtherUser: '2 Player Stats',
	          wins: 'Wins',
	          draws: 'Draws',
	          losses: 'Losses',
	          whites: 'Whites',
	          blacks: 'Blacks'
	        }
	      },
	      home: {
	        title: 'Home',
	        online: 'Online',
	        played: 'Played',
	        upload: 'File',
	        invite: 'Invite',
	        send: 'Send',
	        viewer: 'Viewer',
	        chat: 'Video',
	        chattext: 'Chat',
	        inviteSend: 'Game invitation sent',
	        createPart: {
	          title: 'Create match',
	          time: 'Time minutes',
	          type: 'Match type',
	          publicAnalisis: 'Public',
	          typeAnalisis: 'For all clubs',
	          typeBroadcast: 'For broadcast',
	          create: 'Create',
	          cancel: 'Cancel',
	          black: 'Black',
	          white: 'White',
	          timePersonal: 'Personal time',
	          fieldTime: 'Time',
	          public: 'public',
	          broadcast: 'broadcast',
	          private: 'private',
	          save: 'Save',
	          close: 'Close',
	          incremento: 'Increment'
	        },
	        uploadMens: {
	          success: 'Files Uploaded Correctly',
	          path_not_permit: 'File extension not allowed',
	          size_not_permit: 'Exceeds allowed size'
	        }
	      },
	      invites: {
	        title: 'Invitations',
	        numIn: 'Users invitations',
	        vspc: 'Play against computer',
	        vsanalisis: 'Analyse',
	        initgame: 'Starting game'
	      },
	      visor: {
	        title: 'Viewer',
	        found: 'Found',
	        whiteName: 'White name',
	        blackName: 'Black name',
	        result: 'Result',
	        wins: 'Wins',
	        by: 'by'
	      },
	      lesson: {
	        title: 'Lessons',
	        found: 'Found',
	        whiteName: 'White name',
	        blackName: 'Black name',
	        name: 'Name',
	        result: 'Result',
	        wins: 'Wins',
	        by: 'by',
	        option: 'Convert the analysis to a lesson (it will appear in the Lessons section)'
	      },
	      puzzles: {
	        title: 'Puzzles',
	        create: {
	          title: 'Create a Puzzle',
	          description: 'Add and share a challenging puzzle',
	          create: 'Create',
	          delete: 'Delete',
	          edit: 'Edit',
	          cancel: 'Cancel',
	          add: 'Adding puzzle',
	          fenInit: 'Initial position',
	          fenFinish: 'Finish position '
	        },
	        list: 'List',
	        types: {
	          MateIn1: {
	            name: 'Mate in 1',
	            descript: 'White wins in one move'
	          },
	          Estrategia: {
	            name: 'Strategic',
	            descript: 'Find the best next move'
	          },
	          Finales: {
	            name: 'Finals',
	            descript: 'Best move on final game'
	          },
	          Tactic: {
	            name: 'Tactic',
	            descript: 'Find white move that results in tactic'
	          },
	          Iniciacion: {
	            name: 'Dummy',
	            descript: 'Learn about chess'
	          },
	          Aperturas: {
	            name: 'Opennings',
	            descript: 'Find best move for the openning'
	          },
	          MateIn: {
	            name: 'Mate in x',
	            descript: 'White wins in x moves'
	          },
	          Practica: {
	            name: 'Practica',
	            descript: 'Practice versus computer'
	          },
	          Test: {
	            name: 'Test',
	            descript: 'Test your level with different samples'
	          }
	        },
	        attention: 'Attention',
	        attMen: 'Select the puzzle to resolver',
	        createBy: 'Create by',
	        date: 'Date',
	        played: 'Played',
	        movs: 'Remaining moves',
	        wins: 'Wins',
	        lost: 'Lost',
	        reintent: 'Reintent',
	        intents: 'Intents',
	        color: {
	          black: 'black',
	          white: 'white'
	        }
	      },
	      clubs: {
	        title: 'Clubs',
	        create: {
	          title: 'Create a club',
	          description: 'Add and share a club',
	          create: 'Create',
	          delete: 'Delete',
	          edit: 'Edit',
	          cancel: 'Cancel',
	          add: 'Adding tournament',
	          fenInit: 'Initial position',
	          fenFinish: 'Finish position '
	        },
	        list: 'List',
	        types: {
	          Liga: {
	            name: 'Paid',
	            descript: 'Clubs'
	          },
	          Simultanea: {
	            name: 'Schools',
	            descript: 'Schools'
	          },
	          Suizo: {
	            name: 'Suizo',
	            descript: 'Torneo con emparejamiento Suizo'
	          },
	          Aleatorio: {
	            name: 'Aleatorio',
	            descript: 'Emparejamiento aleatorio'
	          }
	        },
	        attention: 'Attention',
	        attMen: 'Select the club',
	        createBy: 'Create by',
	        date: 'Date',
	        played: 'Played',
	        movs: 'Remaining moves',
	        wins: 'Wins',
	        lost: 'Lost',
	        reintent: 'Reintent',
	        intents: 'Intents',
	        color: {
	          black: 'black',
	          white: 'white'
	        }
	      },
	      torneos: {
	        title: 'Tournaments',
	        create: {
	          title: 'Create a tournament',
	          description: 'Add and share a tournament',
	          create: 'Create',
	          delete: 'Delete',
	          edit: 'Edit',
	          cancel: 'Cancel',
	          add: 'Adding tournament',
	          fenInit: 'Initial position',
	          fenFinish: 'Finish position '
	        },
	        list: 'List',
	        types: {
	          Liga: {
	            name: 'Liga',
	            descript: 'Todos contra todos'
	          },
	          Simultanea: {
	            name: 'Simultanea',
	            descript: 'Todos contra uno'
	          },
	          Suizo: {
	            name: 'Suizo',
	            descript: 'Torneo con emparejamiento Suizo'
	          },
	          Aleatorio: {
	            name: 'Aleatorio',
	            descript: 'Emparejamiento aleatorio'
	          }
	        },
	        attention: 'Attention',
	        attMen: 'Select the tournament',
	        createBy: 'Create by',
	        date: 'Date',
	        played: 'Played',
	        movs: 'Remaining moves',
	        wins: 'Wins',
	        lost: 'Lost',
	        reintent: 'Reintent',
	        intents: 'Intents',
	        color: {
	          black: 'black',
	          white: 'white'
	        }
	      },
	      about: {
	        title: 'About',
	        description: 'About app',
	        namegame: 'Online chess game',
	        seemore: 'Read more',
	        des: 'Online multiplayer chess game that will allow you to face other players in real time and the computer itself. Solve puzzles and create new ones.',
	        tecn: 'Technologies',
	        dev: 'Developed',
	        licenses: 'Licenses',
	        close: 'Close'
	      },
	      tournament: {
	        title: 'Tournaments'
	      },
	      events: {
	        title: 'Events'
	      },
	      game: {
	        title: 'Game',
	        analisys: 'Analisys',
	        chat: 'Game´s chat',
	        chatConver: 'converse with',
	        chatConverTooltip: 'Select a user online',
	        white: 'Select white...',
	        black: 'Select black...',
	        rend: 'surrend',
	        pieces: 'Pieces',
	        board: 'Board',
	        invert: 'Invert',
	        text: 'Text',
	        descriptiontext: 'Send message',
	        turnColor: 'Played ',
	        wins: 'Wins',
	        cancel: 'Game cancel',
	        draw: 'Draw',
	        incheck: 'in jaque',
	        motives: {
	          time: 'by time',
	          rendi: 'by capitulation',
	          login: 'Login'
	        },
	        class: 'Classroom',
	        play: 'Play',
	        createClass: 'Create a classroom',
	        nameClass: 'Name of classroom',
	        accept: 'Ok',
	        comment: 'Comment',
	        sendvideo: 'Send URL',
	        sendfile: 'Send File',
	        pantallacompleta: 'FullScreen'
	      },
	      user: {
	        finduser: 'Find user',
	        title: 'User',
	        logout: 'Exit',
	        login: 'Login',
	        config: 'Config'
	      },
	      gametitle: {
	        title: 'Mainchess'
	      }
	    }
	  }
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__dirname) {'use strict';
	
	var _stringify = __webpack_require__(41);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var path = __webpack_require__(427);
	var outputDirectory = path.resolve(__dirname, '..', 'outputs');
	
	
	function transcribeAudio(file) {
	  return new _promise2.default(function (resolve, reject) {
	    var apiKey = 'sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc';
	    var url = 'https://api.openai.com/v1/audio/transcriptions';
	
	    var formData = new FormData();
	    formData.append('file', file);
	    formData.append('model', 'whisper-1');
	
	    var requestOptions = {
	      method: 'POST',
	      headers: {
	        'Authorization': 'Bearer ' + apiKey
	      },
	      body: formData
	    };
	
	    fetch(url, requestOptions).then(function (response) {
	      if (!response.ok) {
	        throw new Error('Error en la solicitud de transcripci\xF3n: ' + response.statusText);
	      }
	      return response.json();
	    }).then(function (data) {
	      resolve(data.text);
	    }).catch(function (error) {
	      console.error('Error in transcribeAudio: ' + error.message);
	      reject(error);
	    });
	  });
	}
	
	function generateQuestion(text, pgn, conversation) {
	  return new _promise2.default(function (resolve, reject) {
	    try {
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
	        },
	        body: (0, _stringify2.default)({
	          'model': 'gpt-4o',
	          "messages": [{
	            "role": "system",
	            "content": 'Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.\n              Nunca respondes a nada que no est\xE9 relacionado con el ajedrez.\n              Tambi\xE9n puedes incluir temas relacionados con el ajedrez, como pel\xEDculas, comics, im\xE1genes, webs y otros temas relacionados con el ajedrez.\n              Responde siempre a preguntas relacionadas con este PGN. ' + pgn + ' o con temas de ajedrez.\n              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos s\xEDmbolos <<< y >>>\n              Algunas informaciones \xFAtiles:\n              **Reglas de FEN Correcto**:\n              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.\n              - **Piezas**: Blancas en may\xFAsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en min\xFAsculas (k, q, r, b, n, p).\n              - **Casillas Vac\xEDas**: Usa n\xFAmeros para indicar cantidad de casillas vac\xEDas (ej. "3" para tres casillas vac\xEDas).\n              - **Separaci\xF3n de Filas**: Con "/".\n              - **Fila Vac\xEDa Total**: Usa "8".\n              - **Siempre 2 Reyes y No Juntos**.\n              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".\n              Verifica siempre la legalidad de la posici\xF3n y las reglas b\xE1sicas del ajedrez.\n              El formato PGN (Portable Game Notation en ingl\xE9s) es utilizado por los programas inform\xE1ticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso m\xE1s generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es f\xE1cil de acceder a los datos por medio de editores ASCII ordinarios.\n              Etiquetas de formato PGN\n              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.\n              Para almacenar la informaci\xF3n en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:\n              Etiqueta\tTraducci\xF3n\tDescripci\xF3n\n              Event\tEvento\t\n              El nombre del torneo o de la competencia.\n              Site              Lugar              El lugar donde se llev\xF3 a cabo el evento, Esto debe ser en formato "Ciudad, Regi\xF3n PA\xCDS", donde PA\xCDS es el c\xF3digo del mismo en tres letras de acuerdo a l c\xF3digo del Comit\xE9 Ol\xEDmpico Internacional. C\xF3mo ejemplo: "M\xE9xico, D.F. MEX".\n              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".\n              Round             Ronda              La ronda original de la partida.\n              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".\n              Black             Negras             El jugador de las negras en el mismo formato.\n              Result            Resultado          El resultado del juego. S\xF3lo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego est\xE1 actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).\n              Muchos otros pares de etiquetas son definidos por los est\xE1ndares, entre los que est\xE1n:\n              Time              tiempo              La hora en que el juego empez\xF3 en formato "HH:MM:SS" de tiempo local.\n              Termination       fin                Da m\xE1s detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicaci\xF3n" (resultado determinado por adjudicaci\xF3n de una tercera parte), "muerte", "emergencia", "normal", "infracci\xF3n a las reglas", "tiempo acabado" o "no finalizado".\n              FEN              Posici\xF3n inicial del juego  La posici\xF3n inicial del juego en notaci\xF3n de Forsyth-Edwards (del ingl\xE9s Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posici\xF3n determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicializaci\xF3n) con un valor de "1".\n              Texto de las jugadas\n              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del n\xFAmero de la jugada (un n\xFAmero seguido de cero o m\xE1s puntos) y notaci\xF3n est\xE1ndar algebraica (NEA). El texto de las jugadas en la mayor\xEDa de los casos, es simplemente la letra descriptiva de la pieza en ingl\xE9s, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplaz\xF3. Las abreviaturas de las piezas en ingl\xE9s son:\n              K = (king) Rey\n              Q = (queen) Dama\n              R = (rook) Torre\n              B = (bishop) Alfil\n              N = (knight) Caballo\n              P = (pawn) Pe\xF3n\n              Al pe\xF3n se le da una abreviaci\xF3n vac\xEDa, pero en otros contextos su abreviaci\xF3n es "P". El nombre algebraico de cada escaque es el usual de la notaci\xF3n algebraica.\n              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es as\xED, el nombre algebraico de la pieza, su num\xE9ro de fila, o el escaque exacto es colocado despu\xE9s del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que est\xE1 en g y se mueve a e2.\n              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras may\xFAsculas y no n\xFAmeros ceros).\n              Promoci\xF3n del pe\xF3n              Una promoci\xF3n de un pe\xF3n se denota a\xF1adiendo un signo "=" seguido del nombre algebraico de la pieza a la que el pe\xF3n se promueve. Si el movimiento genera un jaque, se a\xF1ade el signo "+"; si el movimiento implica un jaque mate se a\xF1ade el signo de numeral "#".\n              Comentarios              Los comentarios deben ser a\xF1adidos ya sea con un ";" (un comentario de una sola l\xEDnea) o con un "{" (que continuar\xE1 hasta que aparece un "}".\n              El resto de la conversaci\xF3n ha sido: ' + conversation
	          }, { "role": "user", "content": text }],
	          "temperature": 1,
	          "max_tokens": 4096,
	          "top_p": 1,
	          "frequency_penalty": 0,
	          "presence_penalty": 0
	        })
	      };
	
	      fetch('https://api.openai.com/v1/chat/completions', requestOptions).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        resolve(data);
	      }).catch(function (err) {
	        console.log("No tienes mas tokens por hoy");
	        reject(err);
	      });
	    } catch (error) {
	      console.error('Error in generateText: [' + error.type + '] ' + error.message);
	      reject(error);
	    }
	  });
	}
	
	function analisisPGN(text, pgn) {
	  return new _promise2.default(function (resolve, reject) {
	    try {
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
	        },
	        body: (0, _stringify2.default)({
	          'model': 'o1-preview',
	          "messages": [{
	            "role": "user",
	            "content": 'Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.\n              Nunca respondes a nada que no est\xE9 relacionado con el ajedrez.\n              Tambi\xE9n puedes incluir temas relacionados con el ajedrez, como pel\xEDculas, comics, im\xE1genes, webs y otros temas relacionados con el ajedrez.\n              Responde siempre a preguntas relacionadas con este PGN. ' + pgn + ' o con temas de ajedrez.\n              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos s\xEDmbolos <<< y >>>\n              El lenguaje es para que lo entienda un ni\xF1o o un joven que est\xE1 aprendiendo a jugar o tiene un ELO de 1500 aproximadamente.\n              '
	          }, { "role": "user", "content": text }],
	          "temperature": 1,
	          "top_p": 1,
	          "frequency_penalty": 0,
	          "presence_penalty": 0
	        })
	      };
	
	      fetch('https://api.openai.com/v1/chat/completions', requestOptions).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        resolve(data);
	      }).catch(function (err) {
	        console.log("No tienes mas tokens por hoy");
	        reject(err);
	      });
	    } catch (error) {
	      console.error('Error in generateText: [' + error.type + '] ' + error.message);
	      reject(error);
	    }
	  });
	}
	
	function generatePGN(text, pgn) {
	  return new _promise2.default(function (resolve, reject) {
	    try {
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
	        },
	        body: (0, _stringify2.default)({
	          'model': 'o1-preview',
	          "messages": [{
	            "role": "user",
	            "content": 'Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.\n              Nunca respondes a nada que no est\xE9 relacionado con el ajedrez.\n              Tambi\xE9n puedes incluir temas relacionados con el ajedrez, como pel\xEDculas, comics, im\xE1genes, webs y otros temas relacionados con el ajedrez.\n              Responde siempre a preguntas relacionadas con este PGN. ' + pgn + ' o con temas de ajedrez.\n              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos s\xEDmbolos <<< y >>>\n              Algunas informaciones \xFAtiles:\n              **Reglas de FEN Correcto**:\n              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.\n              - **Piezas**: Blancas en may\xFAsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en min\xFAsculas (k, q, r, b, n, p).\n              - **Casillas Vac\xEDas**: Usa n\xFAmeros para indicar cantidad de casillas vac\xEDas (ej. "3" para tres casillas vac\xEDas).\n              - **Separaci\xF3n de Filas**: Con "/".\n              - **Fila Vac\xEDa Total**: Usa "8".\n              - **Siempre 2 Reyes y No Juntos**.\n              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".\n              Verifica siempre la legalidad de la posici\xF3n y las reglas b\xE1sicas del ajedrez.\n              El formato PGN (Portable Game Notation en ingl\xE9s) es utilizado por los programas inform\xE1ticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso m\xE1s generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es f\xE1cil de acceder a los datos por medio de editores ASCII ordinarios.\n              Etiquetas de formato PGN\n              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.\n              Para almacenar la informaci\xF3n en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:\n              Etiqueta\tTraducci\xF3n\tDescripci\xF3n\n              Event\tEvento\t\n              El nombre del torneo o de la competencia.\n              Site              Lugar              El lugar donde se llev\xF3 a cabo el evento, Esto debe ser en formato "Ciudad, Regi\xF3n PA\xCDS", donde PA\xCDS es el c\xF3digo del mismo en tres letras de acuerdo a l c\xF3digo del Comit\xE9 Ol\xEDmpico Internacional. C\xF3mo ejemplo: "M\xE9xico, D.F. MEX".\n              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".\n              Round             Ronda              La ronda original de la partida.\n              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".\n              Black             Negras             El jugador de las negras en el mismo formato.\n              Result            Resultado          El resultado del juego. S\xF3lo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego est\xE1 actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).\n              Muchos otros pares de etiquetas son definidos por los est\xE1ndares, entre los que est\xE1n:\n              Time              tiempo              La hora en que el juego empez\xF3 en formato "HH:MM:SS" de tiempo local.\n              Termination       fin                Da m\xE1s detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicaci\xF3n" (resultado determinado por adjudicaci\xF3n de una tercera parte), "muerte", "emergencia", "normal", "infracci\xF3n a las reglas", "tiempo acabado" o "no finalizado".\n              FEN              Posici\xF3n inicial del juego  La posici\xF3n inicial del juego en notaci\xF3n de Forsyth-Edwards (del ingl\xE9s Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posici\xF3n determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicializaci\xF3n) con un valor de "1".\n              Texto de las jugadas\n              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del n\xFAmero de la jugada (un n\xFAmero seguido de cero o m\xE1s puntos) y notaci\xF3n est\xE1ndar algebraica (NEA). El texto de las jugadas en la mayor\xEDa de los casos, es simplemente la letra descriptiva de la pieza en ingl\xE9s, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplaz\xF3. Las abreviaturas de las piezas en ingl\xE9s son:\n              K = (king) Rey\n              Q = (queen) Dama\n              R = (rook) Torre\n              B = (bishop) Alfil\n              N = (knight) Caballo\n              P = (pawn) Pe\xF3n\n              Al pe\xF3n se le da una abreviaci\xF3n vac\xEDa, pero en otros contextos su abreviaci\xF3n es "P". El nombre algebraico de cada escaque es el usual de la notaci\xF3n algebraica.\n              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es as\xED, el nombre algebraico de la pieza, su num\xE9ro de fila, o el escaque exacto es colocado despu\xE9s del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que est\xE1 en g y se mueve a e2.\n              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras may\xFAsculas y no n\xFAmeros ceros).\n              Promoci\xF3n del pe\xF3n              Una promoci\xF3n de un pe\xF3n se denota a\xF1adiendo un signo "=" seguido del nombre algebraico de la pieza a la que el pe\xF3n se promueve. Si el movimiento genera un jaque, se a\xF1ade el signo "+"; si el movimiento implica un jaque mate se a\xF1ade el signo de numeral "#".\n              Comentarios              Los comentarios deben ser a\xF1adidos ya sea con un ";" (un comentario de una sola l\xEDnea) o con un "{" (que continuar\xE1 hasta que aparece un "}".\n              '
	          }, { "role": "user", "content": text }],
	          "temperature": 1,
	          "top_p": 1,
	          "frequency_penalty": 0,
	          "presence_penalty": 0
	        })
	      };
	
	      fetch('https://api.openai.com/v1/chat/completions', requestOptions).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        resolve(data);
	      }).catch(function (err) {
	        console.log("No tienes mas tokens por hoy");
	        reject(err);
	      });
	    } catch (error) {
	      console.error('Error in generateText: [' + error.type + '] ' + error.message);
	      reject(error);
	    }
	  });
	}
	
	function generateText(text, pgn) {
	  return new _promise2.default(function (resolve, reject) {
	    try {
	      var requestOptions = {
	        method: 'POST',
	        headers: {
	          'Content-Type': 'application/json',
	          'Authorization': 'Bearer ' + String('sk-proj-uwxa7oEyvILEgr2cKLynT3BlbkFJV3AwgO5izcfu9pmWB7Jc')
	        },
	        body: (0, _stringify2.default)({
	          'model': 'gpt-4o',
	          "messages": [{
	            "role": "system",
	            "content": 'Respondes al nombre de MainchessBot. Tus respuestas son cortas y siempre referidas al ajedrez.\n              Nunca respondes a nada que no est\xE9 relacionado con el ajedrez.\n              Tambi\xE9n puedes incluir temas relacionados con el ajedrez, como pel\xEDculas, comics, im\xE1genes, webs y otros temas relacionados con el ajedrez.\n              Responde siempre a preguntas relacionadas con este PGN. ' + pgn + ' o con temas de ajedrez.\n              Cuando devuelvas una partida siempre en formato PGN y el PGN siempre entre estos s\xEDmbolos <<< y >>>\n              Algunas informaciones \xFAtiles:\n              **Reglas de FEN Correcto**:\n              - **Tablero**: Se lee de fila 8 a 1, de izquierda a derecha.\n              - **Piezas**: Blancas en may\xFAsculas (K=King, Q=Queen, R=Rook, B=Bishop, N=Knight, P=Pawn), negras en min\xFAsculas (k, q, r, b, n, p).\n              - **Casillas Vac\xEDas**: Usa n\xFAmeros para indicar cantidad de casillas vac\xEDas (ej. "3" para tres casillas vac\xEDas).\n              - **Separaci\xF3n de Filas**: Con "/".\n              - **Fila Vac\xEDa Total**: Usa "8".\n              - **Siempre 2 Reyes y No Juntos**.\n              - **Formato Completo**: "Piezas turno enroque al-paso medio-movimientos turnos". Ejemplo: "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1".\n              Verifica siempre la legalidad de la posici\xF3n y las reglas b\xE1sicas del ajedrez.\n              El formato PGN (Portable Game Notation en ingl\xE9s) es utilizado por los programas inform\xE1ticos de ajedrez para almacenar y gestionar partidas de ajedrez. Existen otros formatos pero este es el de uso m\xE1s generalizado. Muchos programas de ajedrez reconocen el formato PGN, el cual ha llegado a ser popular debido a que es f\xE1cil de acceder a los datos por medio de editores ASCII ordinarios.\n              Etiquetas de formato PGN\n              Cada etiquetas comienza con un "[", y otro para "]" para cerrar.\n              Para almacenar la informaci\xF3n en el formato PGN es necesario dar siete etiquetas, el orden es el siguiente:\n              Etiqueta\tTraducci\xF3n\tDescripci\xF3n\n              Event\tEvento\t\n              El nombre del torneo o de la competencia.\n              Site              Lugar              El lugar donde se llev\xF3 a cabo el evento, Esto debe ser en formato "Ciudad, Regi\xF3n PA\xCDS", donde PA\xCDS es el c\xF3digo del mismo en tres letras de acuerdo a l c\xF3digo del Comit\xE9 Ol\xEDmpico Internacional. C\xF3mo ejemplo: "M\xE9xico, D.F. MEX".\n              Date              Fecha              La fecha de inicio de la partida. en formato AAAA.MM.DD. Cuando se desconocen los valores se utilizan "??".\n              Round             Ronda              La ronda original de la partida.\n              White             Blancas            El jugador de las piezas blancas, en formato "apellido, nombre".\n              Black             Negras             El jugador de las negras en el mismo formato.\n              Result            Resultado          El resultado del juego. S\xF3lo puede tener cuatro posibles valores: "1-0" (las blancas ganaron), "0-1" (Las negras ganaron), "1/2-1/2" (Tablas), o "*" (cuando el juego est\xE1 actualmente en disputa,  un jugador fallece durante la partida o la partida ha sido postergada).\n              Muchos otros pares de etiquetas son definidos por los est\xE1ndares, entre los que est\xE1n:\n              Time              tiempo              La hora en que el juego empez\xF3 en formato "HH:MM:SS" de tiempo local.\n              Termination       fin                Da m\xE1s detalles del fin del juego de ajedrez. Puede ser "abandono", "adjudicaci\xF3n" (resultado determinado por adjudicaci\xF3n de una tercera parte), "muerte", "emergencia", "normal", "infracci\xF3n a las reglas", "tiempo acabado" o "no finalizado".\n              FEN              Posici\xF3n inicial del juego  La posici\xF3n inicial del juego en notaci\xF3n de Forsyth-Edwards (del ingl\xE9s Forsyth-Edwards Notation). Esta se utiliza para registrar juegos parciales, que empiezan en alguna posici\xF3n determinada.Si se utiliza una etiqueta FEN entonces debe colocarse un par de etiquetas adicional llamado "SetUp" (inicializaci\xF3n) con un valor de "1".\n              Texto de las jugadas\n              El texto de las jugadas describe los movimientos realizados en el juego del ajedrez. Esto debe incluir indicadores del n\xFAmero de la jugada (un n\xFAmero seguido de cero o m\xE1s puntos) y notaci\xF3n est\xE1ndar algebraica (NEA). El texto de las jugadas en la mayor\xEDa de los casos, es simplemente la letra descriptiva de la pieza en ingl\xE9s, una "x" si existe una captura, y el nombre algebraico de dos caracteres del escaque final a donde la pieza se desplaz\xF3. Las abreviaturas de las piezas en ingl\xE9s son:\n              K = (king) Rey\n              Q = (queen) Dama\n              R = (rook) Torre\n              B = (bishop) Alfil\n              N = (knight) Caballo\n              P = (pawn) Pe\xF3n\n              Al pe\xF3n se le da una abreviaci\xF3n vac\xEDa, pero en otros contextos su abreviaci\xF3n es "P". El nombre algebraico de cada escaque es el usual de la notaci\xF3n algebraica.\n              Ambiguedad              En algunos casos lo anterior puede ser ambiguo; si es as\xED, el nombre algebraico de la pieza, su num\xE9ro de fila, o el escaque exacto es colocado despu\xE9s del nombre de la pieza que se mueve (en este orden de preferencia). De esta forma, "Nge2" se refiere a un caballo que est\xE1 en g y se mueve a e2.\n              Enroque              El enroque corto en NEA se indica con "O-O" y el enroque largo con "O-O-O" (son letras may\xFAsculas y no n\xFAmeros ceros).\n              Promoci\xF3n del pe\xF3n              Una promoci\xF3n de un pe\xF3n se denota a\xF1adiendo un signo "=" seguido del nombre algebraico de la pieza a la que el pe\xF3n se promueve. Si el movimiento genera un jaque, se a\xF1ade el signo "+"; si el movimiento implica un jaque mate se a\xF1ade el signo de numeral "#".\n              Comentarios              Los comentarios deben ser a\xF1adidos ya sea con un ";" (un comentario de una sola l\xEDnea) o con un "{" (que continuar\xE1 hasta que aparece un "}".\n              '
	          }, { "role": "user", "content": text }],
	          "temperature": 1,
	          "max_tokens": 4096,
	          "top_p": 1,
	          "frequency_penalty": 0,
	          "presence_penalty": 0
	        })
	      };
	
	      fetch('https://api.openai.com/v1/chat/completions', requestOptions).then(function (response) {
	        return response.json();
	      }).then(function (data) {
	        resolve(data);
	      }).catch(function (err) {
	        console.log("No tienes mas tokens por hoy");
	        reject(err);
	      });
	    } catch (error) {
	      console.error('Error in generateText: [' + error.type + '] ' + error.message);
	      reject(error);
	    }
	  });
	}
	
	module.exports.analisisPGN = analisisPGN;
	module.exports.generateText = generateText;
	module.exports.generatePGN = generatePGN;
	module.exports.generateQuestion = generateQuestion;
	module.exports.transcribeAudio = transcribeAudio;
	/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  add: function add(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/torneo', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  del: function del(ctx, data) {
	    return ctx.$http.delete(_lstorage2.default.get('serverDir') + '/torneo/del/' + data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  get: function get(ctx, data) {
	    return ctx.$http.post(_lstorage2.default.get('serverDir') + '/torneo/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  count: function count(ctx) {
	    return ctx.$http.get(_lstorage2.default.get('serverDir') + '/torneo/get').then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  },
	  resolve: function resolve(ctx, data) {
	    return ctx.$http.put(_lstorage2.default.get('serverDir') + '/torneo/get', data).then(function (r) {
	      if (r.status === 200) {
	        return r.text();
	      } else {
	        return r.text().then(function (d) {
	          throw d;
	        });
	      }
	    });
	  }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(121);
	
	var state = {
	  pgn: 'none',
	  turn: 'none',
	  twhite: 60 * 1,
	  tblack: 60 * 1
	};
	var mutations = {
	  MOVE: function MOVE(state, newPgn) {
	    state.pgn = newPgn;
	  },
	  TURN: function TURN(state, turnNow) {
	    state.turn = turnNow;
	  },
	  COUNTDOWN: function COUNTDOWN(state, time, color) {
	    state['t' + color] = time;
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(121);
	
	var state = {
	  user: {}
	};
	var mutations = {
	  SETUSER: function SETUSER(state, newValue, key) {
	    if (key) {
	      state.user[key] = newValue;
	    } else {
	      state.user = newValue;
	    }
	  }
	};
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(576);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _modules = __webpack_require__(120);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	exports.default = new _vuex2.default.Store({
	  modules: _modules2.default,
	  strict: true
	});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* @license
	 * Copyright (c) 2018, Jeff Hlywa (jhlywa@gmail.com)
	 * Released under the BSD license
	 * https://github.com/jhlywa/chess.js/blob/master/LICENSE
	 */
	var Chess = function Chess(fen) {
	  var BLACK = 'b';
	  var WHITE = 'w';
	
	  var EMPTY = -1;
	
	  var PAWN = 'p';
	  var KNIGHT = 'n';
	  var BISHOP = 'b';
	  var ROOK = 'r';
	  var QUEEN = 'q';
	  var KING = 'k';
	
	  var SYMBOLS = 'pnbrqkPNBRQK';
	
	  var DEFAULT_POSITION = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	
	  var POSSIBLE_RESULTS = ['1-0', '0-1', '1/2-1/2', '*'];
	
	  var PAWN_OFFSETS = {
	    b: [16, 32, 17, 15],
	    w: [-16, -32, -17, -15]
	  };
	
	  var PIECE_OFFSETS = {
	    n: [-18, -33, -31, -14, 18, 33, 31, 14],
	    b: [-17, -15, 17, 15],
	    r: [-16, 1, 16, -1],
	    q: [-17, -16, -15, 1, 17, 16, 15, -1],
	    k: [-17, -16, -15, 1, 17, 16, 15, -1]
	  };
	
	  var ATTACKS = [20, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 20, 0, 0, 20, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 20, 0, 0, 0, 0, 24, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 24, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 24, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 24, 2, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 53, 56, 53, 2, 0, 0, 0, 0, 0, 0, 24, 24, 24, 24, 24, 24, 56, 0, 56, 24, 24, 24, 24, 24, 24, 0, 0, 0, 0, 0, 0, 2, 53, 56, 53, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 2, 24, 2, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 24, 0, 0, 20, 0, 0, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 24, 0, 0, 0, 20, 0, 0, 0, 0, 0, 0, 20, 0, 0, 0, 0, 24, 0, 0, 0, 0, 20, 0, 0, 0, 0, 20, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 20, 0, 0, 20, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 20];
	
	  var RAYS = [17, 0, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 0, 15, 0, 0, 17, 0, 0, 0, 0, 0, 16, 0, 0, 0, 0, 0, 15, 0, 0, 0, 0, 17, 0, 0, 0, 0, 16, 0, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 17, 0, 0, 0, 16, 0, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 0, 16, 0, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 0, 16, 0, 15, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 17, 16, 15, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, -15, -16, -17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, -16, 0, -17, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, 0, -16, 0, 0, -17, 0, 0, 0, 0, 0, 0, 0, 0, -15, 0, 0, 0, -16, 0, 0, 0, -17, 0, 0, 0, 0, 0, 0, -15, 0, 0, 0, 0, -16, 0, 0, 0, 0, -17, 0, 0, 0, 0, -15, 0, 0, 0, 0, 0, -16, 0, 0, 0, 0, 0, -17, 0, 0, -15, 0, 0, 0, 0, 0, 0, -16, 0, 0, 0, 0, 0, 0, -17];
	
	  var SHIFTS = { p: 0, n: 1, b: 2, r: 3, q: 4, k: 5 };
	
	  var FLAGS = {
	    NORMAL: 'n',
	    CAPTURE: 'c',
	    BIG_PAWN: 'b',
	    EP_CAPTURE: 'e',
	    PROMOTION: 'p',
	    KSIDE_CASTLE: 'k',
	    QSIDE_CASTLE: 'q'
	  };
	
	  var BITS = {
	    NORMAL: 1,
	    CAPTURE: 2,
	    BIG_PAWN: 4,
	    EP_CAPTURE: 8,
	    PROMOTION: 16,
	    KSIDE_CASTLE: 32,
	    QSIDE_CASTLE: 64
	  };
	
	  var RANK_1 = 7;
	  var RANK_2 = 6;
	  var RANK_3 = 5;
	  var RANK_4 = 4;
	  var RANK_5 = 3;
	  var RANK_6 = 2;
	  var RANK_7 = 1;
	  var RANK_8 = 0;
	
	  var SQUARES = {
	    a8: 0, b8: 1, c8: 2, d8: 3, e8: 4, f8: 5, g8: 6, h8: 7,
	    a7: 16, b7: 17, c7: 18, d7: 19, e7: 20, f7: 21, g7: 22, h7: 23,
	    a6: 32, b6: 33, c6: 34, d6: 35, e6: 36, f6: 37, g6: 38, h6: 39,
	    a5: 48, b5: 49, c5: 50, d5: 51, e5: 52, f5: 53, g5: 54, h5: 55,
	    a4: 64, b4: 65, c4: 66, d4: 67, e4: 68, f4: 69, g4: 70, h4: 71,
	    a3: 80, b3: 81, c3: 82, d3: 83, e3: 84, f3: 85, g3: 86, h3: 87,
	    a2: 96, b2: 97, c2: 98, d2: 99, e2: 100, f2: 101, g2: 102, h2: 103,
	    a1: 112, b1: 113, c1: 114, d1: 115, e1: 116, f1: 117, g1: 118, h1: 119
	  };
	
	  var ROOKS = {
	    w: [{ square: SQUARES.a1, flag: BITS.QSIDE_CASTLE }, { square: SQUARES.h1, flag: BITS.KSIDE_CASTLE }],
	    b: [{ square: SQUARES.a8, flag: BITS.QSIDE_CASTLE }, { square: SQUARES.h8, flag: BITS.KSIDE_CASTLE }]
	  };
	
	  var _board = new Array(128);
	  var kings = { w: EMPTY, b: EMPTY };
	  var _turn = WHITE;
	  var castling = { w: 0, b: 0 };
	  var ep_square = EMPTY;
	  var half_moves = 0;
	  var move_number = 1;
	  var _history = [];
	  var header = {};
	
	  if (typeof fen === 'undefined') {
	    _load(DEFAULT_POSITION);
	  } else {
	    _load(fen);
	  }
	
	  function _clear(keep_headers) {
	    if (typeof keep_headers === 'undefined') {
	      keep_headers = false;
	    }
	
	    _board = new Array(128);
	    kings = { w: EMPTY, b: EMPTY };
	    _turn = WHITE;
	    castling = { w: 0, b: 0 };
	    ep_square = EMPTY;
	    half_moves = 0;
	    move_number = 1;
	    _history = [];
	    if (!keep_headers) header = {};
	    update_setup(generate_fen());
	  }
	
	  function _reset() {
	    _load(DEFAULT_POSITION);
	  }
	
	  function _load(fen, keep_headers) {
	    if (typeof keep_headers === 'undefined') {
	      keep_headers = false;
	    }
	
	    var tokens = fen.split(/\s+/);
	    var position = tokens[0];
	    var square = 0;
	
	    if (!_validate_fen(fen).valid) {
	      return false;
	    }
	
	    _clear(keep_headers);
	
	    for (var i = 0; i < position.length; i++) {
	      var piece = position.charAt(i);
	
	      if (piece === '/') {
	        square += 8;
	      } else if (is_digit(piece)) {
	        square += parseInt(piece, 10);
	      } else {
	        var color = piece < 'a' ? WHITE : BLACK;
	        _put({ type: piece.toLowerCase(), color: color }, algebraic(square));
	        square++;
	      }
	    }
	
	    _turn = tokens[1];
	
	    if (tokens[2].indexOf('K') > -1) {
	      castling.w |= BITS.KSIDE_CASTLE;
	    }
	    if (tokens[2].indexOf('Q') > -1) {
	      castling.w |= BITS.QSIDE_CASTLE;
	    }
	    if (tokens[2].indexOf('k') > -1) {
	      castling.b |= BITS.KSIDE_CASTLE;
	    }
	    if (tokens[2].indexOf('q') > -1) {
	      castling.b |= BITS.QSIDE_CASTLE;
	    }
	
	    ep_square = tokens[3] === '-' ? EMPTY : SQUARES[tokens[3]];
	    half_moves = parseInt(tokens[4], 10);
	    move_number = parseInt(tokens[5], 10);
	
	    update_setup(generate_fen());
	
	    return true;
	  }
	
	  function _validate_fen(fen) {
	    var errors = {
	      0: 'No errors.',
	      1: 'FEN string must contain six space-delimited fields.',
	      2: '6th field (move number) must be a positive integer.',
	      3: '5th field (half move counter) must be a non-negative integer.',
	      4: '4th field (en-passant square) is invalid.',
	      5: '3rd field (castling availability) is invalid.',
	      6: '2nd field (side to move) is invalid.',
	      7: "1st field (piece positions) does not contain 8 '/'-delimited rows.",
	      8: '1st field (piece positions) is invalid [consecutive numbers].',
	      9: '1st field (piece positions) is invalid [invalid piece].',
	      10: '1st field (piece positions) is invalid [row too large].',
	      11: 'Illegal en-passant square'
	    };
	
	    var tokens = fen.split(/\s+/);
	    if (tokens.length !== 6) {
	      return { valid: false, error_number: 1, error: errors[1] };
	    }
	
	    if (isNaN(tokens[5]) || parseInt(tokens[5], 10) <= 0) {
	      return { valid: false, error_number: 2, error: errors[2] };
	    }
	
	    if (isNaN(tokens[4]) || parseInt(tokens[4], 10) < 0) {
	      return { valid: false, error_number: 3, error: errors[3] };
	    }
	
	    if (!/^(-|[abcdefgh][36])$/.test(tokens[3])) {
	      return { valid: false, error_number: 4, error: errors[4] };
	    }
	
	    if (!/^(KQ?k?q?|Qk?q?|kq?|q|-)$/.test(tokens[2])) {
	      return { valid: false, error_number: 5, error: errors[5] };
	    }
	
	    if (!/^(w|b)$/.test(tokens[1])) {
	      return { valid: false, error_number: 6, error: errors[6] };
	    }
	
	    var rows = tokens[0].split('/');
	    if (rows.length !== 8) {
	      return { valid: false, error_number: 7, error: errors[7] };
	    }
	
	    for (var i = 0; i < rows.length; i++) {
	      var sum_fields = 0;
	      var previous_was_number = false;
	
	      for (var k = 0; k < rows[i].length; k++) {
	        if (!isNaN(rows[i][k])) {
	          if (previous_was_number) {
	            return { valid: false, error_number: 8, error: errors[8] };
	          }
	          sum_fields += parseInt(rows[i][k], 10);
	          previous_was_number = true;
	        } else {
	          if (!/^[prnbqkPRNBQK]$/.test(rows[i][k])) {
	            return { valid: false, error_number: 9, error: errors[9] };
	          }
	          sum_fields += 1;
	          previous_was_number = false;
	        }
	      }
	      if (sum_fields !== 8) {
	        return { valid: false, error_number: 10, error: errors[10] };
	      }
	    }
	
	    if (tokens[3][1] == '3' && tokens[1] == 'w' || tokens[3][1] == '6' && tokens[1] == 'b') {
	      return { valid: false, error_number: 11, error: errors[11] };
	    }
	
	    return { valid: true, error_number: 0, error: errors[0] };
	  }
	
	  function generate_fen() {
	    var empty = 0;
	    var fen = '';
	
	    for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	      if (_board[i] == null) {
	        empty++;
	      } else {
	        if (empty > 0) {
	          fen += empty;
	          empty = 0;
	        }
	        var color = _board[i].color;
	        var piece = _board[i].type;
	
	        fen += color === WHITE ? piece.toUpperCase() : piece.toLowerCase();
	      }
	
	      if (i + 1 & 0x88) {
	        if (empty > 0) {
	          fen += empty;
	        }
	
	        if (i !== SQUARES.h1) {
	          fen += '/';
	        }
	
	        empty = 0;
	        i += 8;
	      }
	    }
	
	    var cflags = '';
	    if (castling[WHITE] & BITS.KSIDE_CASTLE) {
	      cflags += 'K';
	    }
	    if (castling[WHITE] & BITS.QSIDE_CASTLE) {
	      cflags += 'Q';
	    }
	    if (castling[BLACK] & BITS.KSIDE_CASTLE) {
	      cflags += 'k';
	    }
	    if (castling[BLACK] & BITS.QSIDE_CASTLE) {
	      cflags += 'q';
	    }
	
	    cflags = cflags || '-';
	    var epflags = ep_square === EMPTY ? '-' : algebraic(ep_square);
	
	    return [fen, _turn, cflags, epflags, half_moves, move_number].join(' ');
	  }
	
	  function set_header(args) {
	    for (var i = 0; i < args.length; i += 2) {
	      if (typeof args[i] === 'string' && typeof args[i + 1] === 'string') {
	        header[args[i]] = args[i + 1];
	      }
	    }
	    return header;
	  }
	
	  function update_setup(fen) {
	    if (_history.length > 0) return;
	
	    if (fen !== DEFAULT_POSITION) {
	      header['SetUp'] = '1';
	      header['FEN'] = fen;
	    } else {
	      delete header['SetUp'];
	      delete header['FEN'];
	    }
	  }
	
	  function _get(square) {
	    var piece = _board[SQUARES[square]];
	    return piece ? { type: piece.type, color: piece.color } : null;
	  }
	
	  function _put(piece, square) {
	    if (!('type' in piece && 'color' in piece)) {
	      return false;
	    }
	
	    if (SYMBOLS.indexOf(piece.type.toLowerCase()) === -1) {
	      return false;
	    }
	
	    if (!(square in SQUARES)) {
	      return false;
	    }
	
	    var sq = SQUARES[square];
	
	    if (piece.type == KING && !(kings[piece.color] == EMPTY || kings[piece.color] == sq)) {
	      return false;
	    }
	
	    _board[sq] = { type: piece.type, color: piece.color };
	    if (piece.type === KING) {
	      kings[piece.color] = sq;
	    }
	
	    update_setup(generate_fen());
	
	    return true;
	  }
	
	  function _remove(square) {
	    var piece = _get(square);
	    _board[SQUARES[square]] = null;
	    if (piece && piece.type === KING) {
	      kings[piece.color] = EMPTY;
	    }
	
	    update_setup(generate_fen());
	
	    return piece;
	  }
	
	  function build_move(board, from, to, flags, promotion) {
	    var move = {
	      color: _turn,
	      from: from,
	      to: to,
	      flags: flags,
	      piece: board[from].type
	    };
	
	    if (promotion) {
	      move.flags |= BITS.PROMOTION;
	      move.promotion = promotion;
	    }
	
	    if (board[to]) {
	      move.captured = board[to].type;
	    } else if (flags & BITS.EP_CAPTURE) {
	      move.captured = PAWN;
	    }
	    return move;
	  }
	
	  function generate_moves(options) {
	    function add_move(board, moves, from, to, flags) {
	      if (board[from].type === PAWN && (rank(to) === RANK_8 || rank(to) === RANK_1)) {
	        var pieces = [QUEEN, ROOK, BISHOP, KNIGHT];
	        for (var i = 0, len = pieces.length; i < len; i++) {
	          moves.push(build_move(board, from, to, flags, pieces[i]));
	        }
	      } else {
	        moves.push(build_move(board, from, to, flags));
	      }
	    }
	
	    var moves = [];
	    var us = _turn;
	    var them = swap_color(us);
	    var second_rank = { b: RANK_7, w: RANK_2 };
	
	    var first_sq = SQUARES.a8;
	    var last_sq = SQUARES.h1;
	    var single_square = false;
	
	    var legal = typeof options !== 'undefined' && 'legal' in options ? options.legal : true;
	
	    if (typeof options !== 'undefined' && 'square' in options) {
	      if (options.square in SQUARES) {
	        first_sq = last_sq = SQUARES[options.square];
	        single_square = true;
	      } else {
	        return [];
	      }
	    }
	
	    for (var i = first_sq; i <= last_sq; i++) {
	      if (i & 0x88) {
	        i += 7;
	        continue;
	      }
	
	      var piece = _board[i];
	      if (piece == null || piece.color !== us) {
	        continue;
	      }
	
	      if (piece.type === PAWN) {
	        var square = i + PAWN_OFFSETS[us][0];
	        if (_board[square] == null) {
	          add_move(_board, moves, i, square, BITS.NORMAL);
	
	          var square = i + PAWN_OFFSETS[us][1];
	          if (second_rank[us] === rank(i) && _board[square] == null) {
	            add_move(_board, moves, i, square, BITS.BIG_PAWN);
	          }
	        }
	
	        for (j = 2; j < 4; j++) {
	          var square = i + PAWN_OFFSETS[us][j];
	          if (square & 0x88) continue;
	
	          if (_board[square] != null && _board[square].color === them) {
	            add_move(_board, moves, i, square, BITS.CAPTURE);
	          } else if (square === ep_square) {
	            add_move(_board, moves, i, ep_square, BITS.EP_CAPTURE);
	          }
	        }
	      } else {
	        for (var j = 0, len = PIECE_OFFSETS[piece.type].length; j < len; j++) {
	          var offset = PIECE_OFFSETS[piece.type][j];
	          var square = i;
	
	          while (true) {
	            square += offset;
	            if (square & 0x88) break;
	
	            if (_board[square] == null) {
	              add_move(_board, moves, i, square, BITS.NORMAL);
	            } else {
	              if (_board[square].color === us) break;
	              add_move(_board, moves, i, square, BITS.CAPTURE);
	              break;
	            }
	
	            if (piece.type === 'n' || piece.type === 'k') break;
	          }
	        }
	      }
	    }
	
	    if (!single_square || last_sq === kings[us]) {
	      if (castling[us] & BITS.KSIDE_CASTLE) {
	        var castling_from = kings[us];
	        var castling_to = castling_from + 2;
	
	        if (_board[castling_from + 1] == null && _board[castling_to] == null && !attacked(them, kings[us]) && !attacked(them, castling_from + 1) && !attacked(them, castling_to)) {
	          add_move(_board, moves, kings[us], castling_to, BITS.KSIDE_CASTLE);
	        }
	      }
	
	      if (castling[us] & BITS.QSIDE_CASTLE) {
	        var castling_from = kings[us];
	        var castling_to = castling_from - 2;
	
	        if (_board[castling_from - 1] == null && _board[castling_from - 2] == null && _board[castling_from - 3] == null && !attacked(them, kings[us]) && !attacked(them, castling_from - 1) && !attacked(them, castling_to)) {
	          add_move(_board, moves, kings[us], castling_to, BITS.QSIDE_CASTLE);
	        }
	      }
	    }
	
	    if (!legal) {
	      return moves;
	    }
	
	    var legal_moves = [];
	    for (var i = 0, len = moves.length; i < len; i++) {
	      make_move(moves[i]);
	      if (!king_attacked(us)) {
	        legal_moves.push(moves[i]);
	      }
	      undo_move();
	    }
	
	    return legal_moves;
	  }
	
	  function move_to_san(move, sloppy) {
	    var output = '';
	
	    if (move.flags & BITS.KSIDE_CASTLE) {
	      output = 'O-O';
	    } else if (move.flags & BITS.QSIDE_CASTLE) {
	      output = 'O-O-O';
	    } else {
	      var disambiguator = get_disambiguator(move, sloppy);
	
	      if (move.piece !== PAWN) {
	        output += move.piece.toUpperCase() + disambiguator;
	      }
	
	      if (move.flags & (BITS.CAPTURE | BITS.EP_CAPTURE)) {
	        if (move.piece === PAWN) {
	          output += algebraic(move.from)[0];
	        }
	        output += 'x';
	      }
	
	      output += algebraic(move.to);
	
	      if (move.flags & BITS.PROMOTION) {
	        output += '=' + move.promotion.toUpperCase();
	      }
	    }
	
	    make_move(move);
	    if (_in_check()) {
	      if (_in_checkmate()) {
	        output += '#';
	      } else {
	        output += '+';
	      }
	    }
	    undo_move();
	
	    return output;
	  }
	
	  function stripped_san(move) {
	    return move.replace(/=/, '').replace(/[+#]?[?!]*$/, '');
	  }
	
	  function attacked(color, square) {
	    for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	      if (i & 0x88) {
	        i += 7;
	        continue;
	      }
	
	      if (_board[i] == null || _board[i].color !== color) continue;
	
	      var piece = _board[i];
	      var difference = i - square;
	      var index = difference + 119;
	
	      if (ATTACKS[index] & 1 << SHIFTS[piece.type]) {
	        if (piece.type === PAWN) {
	          if (difference > 0) {
	            if (piece.color === WHITE) return true;
	          } else {
	            if (piece.color === BLACK) return true;
	          }
	          continue;
	        }
	
	        if (piece.type === 'n' || piece.type === 'k') return true;
	
	        var offset = RAYS[index];
	        var j = i + offset;
	
	        var blocked = false;
	        while (j !== square) {
	          if (_board[j] != null) {
	            blocked = true;
	            break;
	          }
	          j += offset;
	        }
	
	        if (!blocked) return true;
	      }
	    }
	
	    return false;
	  }
	
	  function king_attacked(color) {
	    return attacked(swap_color(color), kings[color]);
	  }
	
	  function _in_check() {
	    return king_attacked(_turn);
	  }
	
	  function _in_checkmate() {
	    return _in_check() && generate_moves().length === 0;
	  }
	
	  function _in_stalemate() {
	    return !_in_check() && generate_moves().length === 0;
	  }
	
	  function _insufficient_material() {
	    var pieces = {};
	    var bishops = [];
	    var num_pieces = 0;
	    var sq_color = 0;
	
	    for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	      sq_color = (sq_color + 1) % 2;
	      if (i & 0x88) {
	        i += 7;
	        continue;
	      }
	
	      var piece = _board[i];
	      if (piece) {
	        pieces[piece.type] = piece.type in pieces ? pieces[piece.type] + 1 : 1;
	        if (piece.type === BISHOP) {
	          bishops.push(sq_color);
	        }
	        num_pieces++;
	      }
	    }
	
	    if (num_pieces === 2) {
	      return true;
	    } else if (num_pieces === 3 && (pieces[BISHOP] === 1 || pieces[KNIGHT] === 1)) {
	      return true;
	    } else if (num_pieces === pieces[BISHOP] + 2) {
	      var sum = 0;
	      var len = bishops.length;
	      for (var i = 0; i < len; i++) {
	        sum += bishops[i];
	      }
	      if (sum === 0 || sum === len) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	
	  function _in_threefold_repetition() {
	    var moves = [];
	    var positions = {};
	    var repetition = false;
	
	    while (true) {
	      var move = undo_move();
	      if (!move) break;
	      moves.push(move);
	    }
	
	    while (true) {
	      var fen = generate_fen().split(' ').slice(0, 4).join(' ');
	
	      positions[fen] = fen in positions ? positions[fen] + 1 : 1;
	      if (positions[fen] >= 3) {
	        repetition = true;
	      }
	
	      if (!moves.length) {
	        break;
	      }
	      make_move(moves.pop());
	    }
	
	    return repetition;
	  }
	
	  function push(move) {
	    _history.push({
	      move: move,
	      kings: { b: kings.b, w: kings.w },
	      turn: _turn,
	      castling: { b: castling.b, w: castling.w },
	      ep_square: ep_square,
	      half_moves: half_moves,
	      move_number: move_number
	    });
	  }
	
	  function make_move(move) {
	    var us = _turn;
	    var them = swap_color(us);
	    push(move);
	
	    _board[move.to] = _board[move.from];
	    _board[move.from] = null;
	
	    if (move.flags & BITS.EP_CAPTURE) {
	      if (_turn === BLACK) {
	        _board[move.to - 16] = null;
	      } else {
	        _board[move.to + 16] = null;
	      }
	    }
	
	    if (move.flags & BITS.PROMOTION) {
	      _board[move.to] = { type: move.promotion, color: us };
	    }
	
	    if (_board[move.to].type === KING) {
	      kings[_board[move.to].color] = move.to;
	
	      if (move.flags & BITS.KSIDE_CASTLE) {
	        var castling_to = move.to - 1;
	        var castling_from = move.to + 1;
	        _board[castling_to] = _board[castling_from];
	        _board[castling_from] = null;
	      } else if (move.flags & BITS.QSIDE_CASTLE) {
	        var castling_to = move.to + 1;
	        var castling_from = move.to - 2;
	        _board[castling_to] = _board[castling_from];
	        _board[castling_from] = null;
	      }
	
	      castling[us] = '';
	    }
	
	    if (castling[us]) {
	      for (var i = 0, len = ROOKS[us].length; i < len; i++) {
	        if (move.from === ROOKS[us][i].square && castling[us] & ROOKS[us][i].flag) {
	          castling[us] ^= ROOKS[us][i].flag;
	          break;
	        }
	      }
	    }
	
	    if (castling[them]) {
	      for (var i = 0, len = ROOKS[them].length; i < len; i++) {
	        if (move.to === ROOKS[them][i].square && castling[them] & ROOKS[them][i].flag) {
	          castling[them] ^= ROOKS[them][i].flag;
	          break;
	        }
	      }
	    }
	
	    if (move.flags & BITS.BIG_PAWN) {
	      if (_turn === 'b') {
	        ep_square = move.to - 16;
	      } else {
	        ep_square = move.to + 16;
	      }
	    } else {
	      ep_square = EMPTY;
	    }
	
	    if (move.piece === PAWN) {
	      half_moves = 0;
	    } else if (move.flags & (BITS.CAPTURE | BITS.EP_CAPTURE)) {
	      half_moves = 0;
	    } else {
	      half_moves++;
	    }
	
	    if (_turn === BLACK) {
	      move_number++;
	    }
	    _turn = swap_color(_turn);
	  }
	
	  function undo_move() {
	    var old = _history.pop();
	    if (old == null) {
	      return null;
	    }
	
	    var move = old.move;
	    kings = old.kings;
	    _turn = old.turn;
	    castling = old.castling;
	    ep_square = old.ep_square;
	    half_moves = old.half_moves;
	    move_number = old.move_number;
	
	    var us = _turn;
	    var them = swap_color(_turn);
	
	    _board[move.from] = _board[move.to];
	    _board[move.from].type = move.piece;
	    _board[move.to] = null;
	
	    if (move.flags & BITS.CAPTURE) {
	      _board[move.to] = { type: move.captured, color: them };
	    } else if (move.flags & BITS.EP_CAPTURE) {
	      var index;
	      if (us === BLACK) {
	        index = move.to - 16;
	      } else {
	        index = move.to + 16;
	      }
	      _board[index] = { type: PAWN, color: them };
	    }
	
	    if (move.flags & (BITS.KSIDE_CASTLE | BITS.QSIDE_CASTLE)) {
	      var castling_to, castling_from;
	      if (move.flags & BITS.KSIDE_CASTLE) {
	        castling_to = move.to + 1;
	        castling_from = move.to - 1;
	      } else if (move.flags & BITS.QSIDE_CASTLE) {
	        castling_to = move.to - 2;
	        castling_from = move.to + 1;
	      }
	
	      _board[castling_to] = _board[castling_from];
	      _board[castling_from] = null;
	    }
	
	    return move;
	  }
	
	  function get_disambiguator(move, sloppy) {
	    var moves = generate_moves({ legal: !sloppy });
	
	    var from = move.from;
	    var to = move.to;
	    var piece = move.piece;
	
	    var ambiguities = 0;
	    var same_rank = 0;
	    var same_file = 0;
	
	    for (var i = 0, len = moves.length; i < len; i++) {
	      var ambig_from = moves[i].from;
	      var ambig_to = moves[i].to;
	      var ambig_piece = moves[i].piece;
	
	      if (piece === ambig_piece && from !== ambig_from && to === ambig_to) {
	        ambiguities++;
	
	        if (rank(from) === rank(ambig_from)) {
	          same_rank++;
	        }
	
	        if (file(from) === file(ambig_from)) {
	          same_file++;
	        }
	      }
	    }
	
	    if (ambiguities > 0) {
	      if (same_rank > 0 && same_file > 0) {
	        return algebraic(from);
	      } else if (same_file > 0) {
	        return algebraic(from).charAt(1);
	      } else {
	        return algebraic(from).charAt(0);
	      }
	    }
	
	    return '';
	  }
	
	  function _ascii() {
	    var s = '   +------------------------+\n';
	    for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	      if (file(i) === 0) {
	        s += ' ' + '87654321'[rank(i)] + ' |';
	      }
	
	      if (_board[i] == null) {
	        s += ' . ';
	      } else {
	        var piece = _board[i].type;
	        var color = _board[i].color;
	        var symbol = color === WHITE ? piece.toUpperCase() : piece.toLowerCase();
	        s += ' ' + symbol + ' ';
	      }
	
	      if (i + 1 & 0x88) {
	        s += '|\n';
	        i += 8;
	      }
	    }
	    s += '   +------------------------+\n';
	    s += '     a  b  c  d  e  f  g  h\n';
	
	    return s;
	  }
	
	  function move_from_san(move, sloppy) {
	    var clean_move = stripped_san(move);
	
	    if (sloppy) {
	      var matches = clean_move.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
	      if (matches) {
	        var piece = matches[1];
	        var from = matches[2];
	        var to = matches[3];
	        var promotion = matches[4];
	      }
	    }
	
	    var moves = generate_moves();
	    for (var i = 0, len = moves.length; i < len; i++) {
	      if (clean_move === stripped_san(move_to_san(moves[i])) || sloppy && clean_move === stripped_san(move_to_san(moves[i], true))) {
	        return moves[i];
	      } else {
	        if (matches && (!piece || piece.toLowerCase() == moves[i].piece) && SQUARES[from] == moves[i].from && SQUARES[to] == moves[i].to && (!promotion || promotion.toLowerCase() == moves[i].promotion)) {
	          return moves[i];
	        }
	      }
	    }
	
	    return null;
	  }
	
	  function rank(i) {
	    return i >> 4;
	  }
	
	  function file(i) {
	    return i & 15;
	  }
	
	  function algebraic(i) {
	    var f = file(i),
	        r = rank(i);
	    return 'abcdefgh'.substring(f, f + 1) + '87654321'.substring(r, r + 1);
	  }
	
	  function swap_color(c) {
	    return c === WHITE ? BLACK : WHITE;
	  }
	
	  function is_digit(c) {
	    return '0123456789'.indexOf(c) !== -1;
	  }
	
	  function make_pretty(ugly_move) {
	    var move = clone(ugly_move);
	    move.san = move_to_san(move, false);
	    move.to = algebraic(move.to);
	    move.from = algebraic(move.from);
	
	    var flags = '';
	
	    for (var flag in BITS) {
	      if (BITS[flag] & move.flags) {
	        flags += FLAGS[flag];
	      }
	    }
	    move.flags = flags;
	
	    return move;
	  }
	
	  function clone(obj) {
	    var dupe = obj instanceof Array ? [] : {};
	
	    for (var property in obj) {
	      if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	        dupe[property] = clone(obj[property]);
	      } else {
	        dupe[property] = obj[property];
	      }
	    }
	
	    return dupe;
	  }
	
	  function trim(str) {
	    return str.replace(/^\s+|\s+$/g, '');
	  }
	
	  function _perft(depth) {
	    var moves = generate_moves({ legal: false });
	    var nodes = 0;
	    var color = _turn;
	
	    for (var i = 0, len = moves.length; i < len; i++) {
	      make_move(moves[i]);
	      if (!king_attacked(color)) {
	        if (depth - 1 > 0) {
	          var child_nodes = _perft(depth - 1);
	          nodes += child_nodes;
	        } else {
	          nodes++;
	        }
	      }
	      undo_move();
	    }
	
	    return nodes;
	  }
	
	  return {
	    WHITE: WHITE,
	    BLACK: BLACK,
	    PAWN: PAWN,
	    KNIGHT: KNIGHT,
	    BISHOP: BISHOP,
	    ROOK: ROOK,
	    QUEEN: QUEEN,
	    KING: KING,
	    SQUARES: function () {
	      var keys = [];
	      for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	        if (i & 0x88) {
	          i += 7;
	          continue;
	        }
	        keys.push(algebraic(i));
	      }
	      return keys;
	    }(),
	    FLAGS: FLAGS,
	
	    load: function load(fen) {
	      return _load(fen);
	    },
	
	    reset: function reset() {
	      return _reset();
	    },
	
	    moves: function moves(options) {
	
	      var ugly_moves = generate_moves(options);
	      var moves = [];
	
	      for (var i = 0, len = ugly_moves.length; i < len; i++) {
	        if (typeof options !== 'undefined' && 'verbose' in options && options.verbose) {
	          moves.push(make_pretty(ugly_moves[i]));
	        } else {
	          moves.push(move_to_san(ugly_moves[i], false));
	        }
	      }
	
	      return moves;
	    },
	
	    in_check: function in_check() {
	      return _in_check();
	    },
	
	    in_checkmate: function in_checkmate() {
	      return _in_checkmate();
	    },
	
	    in_stalemate: function in_stalemate() {
	      return _in_stalemate();
	    },
	
	    in_draw: function in_draw() {
	      return half_moves >= 100 || _in_stalemate() || _insufficient_material() || _in_threefold_repetition();
	    },
	
	    insufficient_material: function insufficient_material() {
	      return _insufficient_material();
	    },
	
	    in_threefold_repetition: function in_threefold_repetition() {
	      return _in_threefold_repetition();
	    },
	
	    game_over: function game_over() {
	      return half_moves >= 100 || _in_checkmate() || _in_stalemate() || _insufficient_material() || _in_threefold_repetition();
	    },
	
	    validate_fen: function validate_fen(fen) {
	      return _validate_fen(fen);
	    },
	
	    fen: function fen() {
	      return generate_fen();
	    },
	
	    board: function board() {
	      var output = [],
	          row = [];
	
	      for (var i = SQUARES.a8; i <= SQUARES.h1; i++) {
	        if (_board[i] == null) {
	          row.push(null);
	        } else {
	          row.push({ type: _board[i].type, color: _board[i].color });
	        }
	        if (i + 1 & 0x88) {
	          output.push(row);
	          row = [];
	          i += 8;
	        }
	      }
	
	      return output;
	    },
	
	    pgn: function pgn(options) {
	      var newline = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && typeof options.newline_char === 'string' ? options.newline_char : '\n';
	      var max_width = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && typeof options.max_width === 'number' ? options.max_width : 0;
	      var result = [];
	      var header_exists = false;
	
	      for (var i in header) {
	        result.push('[' + i + ' "' + header[i] + '"]' + newline);
	        header_exists = true;
	      }
	
	      if (header_exists && _history.length) {
	        result.push(newline);
	      }
	
	      var reversed_history = [];
	      while (_history.length > 0) {
	        reversed_history.push(undo_move());
	      }
	
	      var moves = [];
	      var move_string = '';
	
	      while (reversed_history.length > 0) {
	        var move = reversed_history.pop();
	
	        if (!_history.length && move.color === 'b') {
	          move_string = move_number + '. ...';
	        } else if (move.color === 'w') {
	          if (move_string.length) {
	            moves.push(move_string);
	          }
	          move_string = move_number + '.';
	        }
	
	        move_string = move_string + ' ' + move_to_san(move, false);
	        make_move(move);
	      }
	
	      if (move_string.length) {
	        moves.push(move_string);
	      }
	
	      if (typeof header.Result !== 'undefined') {
	        moves.push(header.Result);
	      }
	
	      if (max_width === 0) {
	        return result.join('') + moves.join(' ');
	      }
	
	      var current_width = 0;
	      for (var i = 0; i < moves.length; i++) {
	        if (current_width + moves[i].length > max_width && i !== 0) {
	          if (result[result.length - 1] === ' ') {
	            result.pop();
	          }
	
	          result.push(newline);
	          current_width = 0;
	        } else if (i !== 0) {
	          result.push(' ');
	          current_width++;
	        }
	        result.push(moves[i]);
	        current_width += moves[i].length;
	      }
	
	      return result.join('');
	    },
	
	    load_pgn: function load_pgn(pgn, options) {
	      var sloppy = typeof options !== 'undefined' && 'sloppy' in options ? options.sloppy : false;
	
	      function mask(str) {
	        return str.replace(/\\/g, '\\');
	      }
	
	      function has_keys(object) {
	        for (var key in object) {
	          return true;
	        }
	        return false;
	      }
	
	      function parse_pgn_header(header, options) {
	        var newline_char = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && typeof options.newline_char === 'string' ? options.newline_char : '\r?\n';
	        var header_obj = {};
	        var headers = header.split(new RegExp(mask(newline_char)));
	        var key = '';
	        var value = '';
	
	        for (var i = 0; i < headers.length; i++) {
	          key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	          value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	          if (trim(key).length > 0) {
	            header_obj[key] = value;
	          }
	        }
	
	        return header_obj;
	      }
	
	      var newline_char = (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) === 'object' && typeof options.newline_char === 'string' ? options.newline_char : '\r?\n';
	
	      var header_regex = new RegExp('^(\\[((?:' + mask(newline_char) + ')|.)*\\])' + '(?:' + mask(newline_char) + '){2}');
	
	      var header_string = header_regex.test(pgn) ? header_regex.exec(pgn)[1] : '';
	
	      _reset();
	
	      var headers = parse_pgn_header(header_string, options);
	      for (var key in headers) {
	        set_header([key, headers[key]]);
	      }
	
	      if (headers['SetUp'] === '1') {
	        if (!('FEN' in headers && _load(headers['FEN'], true))) {
	          return false;
	        }
	      }
	
	      var ms = pgn.replace(header_string, '').replace(new RegExp(mask(newline_char), 'g'), ' ');
	
	      ms = ms.replace(/(\{[^}]+\})+?/g, '');
	
	      var rav_regex = /(\([^\(\)]+\))+?/g;
	      while (rav_regex.test(ms)) {
	        ms = ms.replace(rav_regex, '');
	      }
	
	      ms = ms.replace(/\d+\.(\.\.)?/g, '');
	
	      ms = ms.replace(/\.\.\./g, '');
	
	      ms = ms.replace(/\$\d+/g, '');
	
	      var moves = trim(ms).split(new RegExp(/\s+/));
	
	      moves = moves.join(',').replace(/,,+/g, ',').split(',');
	      var move = '';
	
	      for (var half_move = 0; half_move < moves.length - 1; half_move++) {
	        move = move_from_san(moves[half_move], sloppy);
	
	        if (move == null) {
	          return false;
	        } else {
	          make_move(move);
	        }
	      }
	
	      move = moves[moves.length - 1];
	      if (POSSIBLE_RESULTS.indexOf(move) > -1) {
	        if (has_keys(header) && typeof header.Result === 'undefined') {
	          set_header(['Result', move]);
	        }
	      } else {
	        move = move_from_san(move, sloppy);
	        if (move == null) {
	          return false;
	        } else {
	          make_move(move);
	        }
	      }
	      return true;
	    },
	
	    header: function header() {
	      return set_header(arguments);
	    },
	
	    ascii: function ascii() {
	      return _ascii();
	    },
	
	    turn: function turn() {
	      return _turn;
	    },
	
	    move: function move(_move, options) {
	      var sloppy = typeof options !== 'undefined' && 'sloppy' in options ? options.sloppy : false;
	
	      var move_obj = null;
	
	      if (typeof _move === 'string') {
	        move_obj = move_from_san(_move, sloppy);
	      } else if ((typeof _move === 'undefined' ? 'undefined' : (0, _typeof3.default)(_move)) === 'object') {
	        var moves = generate_moves();
	
	        for (var i = 0, len = moves.length; i < len; i++) {
	          if (_move.from === algebraic(moves[i].from) && _move.to === algebraic(moves[i].to) && (!('promotion' in moves[i]) || _move.promotion === moves[i].promotion)) {
	            move_obj = moves[i];
	            break;
	          }
	        }
	      }
	
	      if (!move_obj) {
	        return null;
	      }
	
	      var pretty_move = make_pretty(move_obj);
	
	      make_move(move_obj);
	
	      return pretty_move;
	    },
	
	    undo: function undo() {
	      var move = undo_move();
	      return move ? make_pretty(move) : null;
	    },
	
	    clear: function clear() {
	      return _clear();
	    },
	
	    put: function put(piece, square) {
	      return _put(piece, square);
	    },
	
	    get: function get(square) {
	      return _get(square);
	    },
	
	    remove: function remove(square) {
	      return _remove(square);
	    },
	
	    perft: function perft(depth) {
	      return _perft(depth);
	    },
	
	    square_color: function square_color(square) {
	      if (square in SQUARES) {
	        var sq_0x88 = SQUARES[square];
	        return (rank(sq_0x88) + file(sq_0x88)) % 2 === 0 ? 'light' : 'dark';
	      }
	
	      return null;
	    },
	
	    history: function history(options) {
	      var reversed_history = [];
	      var move_history = [];
	      var verbose = typeof options !== 'undefined' && 'verbose' in options && options.verbose;
	
	      while (_history.length > 0) {
	        reversed_history.push(undo_move());
	      }
	
	      while (reversed_history.length > 0) {
	        var move = reversed_history.pop();
	        if (verbose) {
	          move_history.push(make_pretty(move));
	        } else {
	          move_history.push(move_to_san(move));
	        }
	        make_move(move);
	      }
	
	      return move_history;
	    }
	  };
	};
	
	if (true) exports.Chess = Chess;
	
	if (true) !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	  return Chess;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _store = __webpack_require__(300);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _board = __webpack_require__(27);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _invites = __webpack_require__(541);
	
	var _invites2 = _interopRequireDefault(_invites);
	
	var _lenguajes = __webpack_require__(294);
	
	var _lenguajes2 = _interopRequireDefault(_lenguajes);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _config = __webpack_require__(22);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	
	exports.default = {
	  data: function data() {
	    return {
	      srciFrameChatVideo: '',
	      closeResult: '',
	      userClub: {},
	      user: _user2.default.getUser(),
	      board: _board2.default,
	      lenguaje: _lstorage2.default.get('lenguaje', 'es'),
	      lenguajes: _lenguajes2.default.lenguajes,
	      lenIndex: _lstorage2.default.get('lenIndex', '1'),
	      lenguajeName: _lenguajes2.default.lenguajes[0].label,
	      invitesLength: 0,
	      recording: false,
	      lastSocketDisconnect: '',
	      intervalId: null,
	      connectedFlag: true,
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      })
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    loadClub: function loadClub(club) {
	      var parms = {
	        name: club
	      };
	      var _self = this;
	      _club2.default.get(_self, parms).then(function (response) {
	        var theD = JSON.parse(response);
	        _self.userClub = theD;
	
	        setTimeout(function () {
	          if (_self.userClub !== undefined && _self.userClub.length > 0 && _self.userClub[0]) {
	            _self.userClub = _self.userClub[0];
	          }
	        }, 50);
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    changeStyle: function changeStyle(type) {
	      this.styles[type] = this.styles[type] + 1;
	      if (this.styles[type] > stylesBoard[type].length - 1) {
	        this.styles[type] = 0;
	      }
	
	      _lstorage2.default.set('styleBoard', this.styles);
	      this.$broadcast('updateBoards', this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]);
	    },
	    getLenguajeName: function getLenguajeName() {
	      for (var i in this.lenguajes) {
	        if (this.lenguajes[i].value !== this.lenguaje) {
	          this.lenguajeName = this.lenguajes[i].label;
	          break;
	        }
	      }
	    },
	    pcGameAnalisis: function pcGameAnalisis() {
	      this.$broadcast('modal::open', 'invitePCAnalisis');
	    },
	    changeLenguaje: function changeLenguaje(len) {
	      if (this.lenguaje !== len) {
	        _lstorage2.default.set('lenguaje', len);
	        if (len === 'es') {
	          this.lenIndex = 1;
	        } else {
	          this.lenIndex = 0;
	        }
	        _lstorage2.default.set('lenIndex', this.lenIndex);
	        window.location.reload();
	      }
	    },
	    existBoard: function existBoard(board) {
	      if (_lstorage2.default.get(board)._id) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    openMenu: function openMenu(event) {
	      this.$broadcast('dropdown-list::open', event, '');
	    },
	    openModal: function openModal() {
	      this.$broadcast('modal::open', 'aboutModal');
	    },
	    openModalResources: function openModalResources() {
	      this.$broadcast('modal::open', 'aboutModalResources');
	    },
	    openModalMenu1: function openModalMenu1() {
	      this.$broadcast('modal::open', 'aboutModalMenu1');
	    },
	    openModalMenu2: function openModalMenu2() {
	      this.$broadcast('modal::open', 'aboutModalMenu2');
	    },
	    openModalMenu3: function openModalMenu3() {
	      this.$broadcast('modal::open', 'aboutModalMenu3');
	    },
	    showInvitesGame: function showInvitesGame() {
	      this.$broadcast('modal::open', 'invitesGame');
	    },
	    imageUrl: function imageUrl(name) {
	      var ret = '';
	      if (name !== undefined) {
	        ret = _lstorage2.default.get('serverDir') + '/uploads/' + name;
	      }
	      return ret;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultClub.png';
	    },
	    logout: function logout() {
	      this.$route.router.replace('/home');
	      _user2.default.logout(this);
	      this.$route.router.replace('/');
	    },
	    testUser: function testUser(next) {
	      var clubLast = this.user.club;
	      if (_lstorage2.default.get('token')) {
	        _user2.default.testUser(this, {}).then(function (response) {
	          var data = JSON.parse(response);
	
	          var club1 = data.club1;
	          var club2 = data.club2;
	          var club = data.club;
	
	          if (clubLast === club1) {
	            data.club = club1;
	            data.club1 = club;
	          } else if (clubLast === club2) {
	            data.club = club2;
	            data.club2 = club;
	          } else {}
	          data.club = clubLast;
	
	          _user2.default.setUser(data);
	          next();
	        }, function (response) {
	          this.error = response.data;
	        });
	      }
	    },
	    userLoguinSocket: function userLoguinSocket() {
	      var access = this.$route.params.u1 === 'only' ? 'guest' : 'authenticate';
	      if (_user2.default.user_acces(access)) {
	        var data = {
	          c: 'chat',
	          f: 'username',
	          data: {
	            user: _user2.default.getUser()
	          }
	        };
	        setTimeout(function () {
	          if (this.$socket) {
	            this.$socket.emit('event', data, function () {
	              console.log(arguments.length <= 1 ? undefined : arguments[1]);
	            });
	          }
	        }.bind(this), 100);
	      }
	    },
	    openChat: function openChat() {
	      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (_config2.default.debug) {
	        var handler = window.open(_config2.default.video_uri_debug + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video);
	        handler.blur();
	      } else {
	        var _handler = window.open(_config2.default.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video);
	        _handler.blur();
	      }
	    },
	    isVideoSaving: function isVideoSaving() {
	      return window.RECORDING_ONGOING;
	    },
	    openVideoSave: function openVideoSave() {
	      window.RECORDING_ONGOING = !window.RECORDING_ONGOING;
	      if (window.RECORDING_ONGOING) {
	        window.startRecording();
	        this.recording = true;
	      } else {
	        window.stopRecording();
	        this.recording = false;
	      }
	    },
	    openChatSala: function openChatSala() {
	      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (_config2.default.debug) {
	        var handler = window.open(_config2.default.video_uri_debug + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video);
	        handler.blur();
	      } else {
	        var _handler2 = window.open(_config2.default.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video);
	        _handler2.blur();
	      }
	    },
	    loadOtherUser: function loadOtherUser(otherUser, next) {
	      if (otherUser !== 'PC' && otherUser !== undefined && otherUser.length > 0) {
	        _user2.default.get(this, otherUser).then(function (response) {
	          var dd = JSON.parse(response);
	          var somedata = dd;
	
	          next(somedata);
	        }, function (response) {});
	      } else {
	        next({
	          image: 'Droid-Robot-512.png'
	        });
	      }
	    },
	    checkServerStatus: function checkServerStatus() {
	      try {
	        if (this.user) {
	          if (this.$route.params.u1 !== 'only') {
	            _user2.default.testUser(this, {}).then(function (response) {
	              this.connectedFlag = true;
	            }, function (response) {
	              this.connectedFlag = false;
	            });
	          }
	        }
	      } catch (error) {
	        this.connectedFlag = false;
	      }
	    }
	  },
	  events: {
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    },
	    inviteGame: function inviteGame(data) {
	      if (data) {
	        var invites = _lstorage2.default.get('invitesGame', []);
	        this.invitesLength = invites.length;
	      }
	    },
	    confirmGame: function confirmGame(data) {
	      if (data) {
	        var invites = _lstorage2.default.get('invitesGame', []);
	        this.invitesLength = invites.length;
	      }
	    },
	    refreshInviteGame: function refreshInviteGame(data) {
	      if (data) {
	        var invites = _lstorage2.default.get('invitesGame', []);
	        this.invitesLength = invites.length;
	      }
	    },
	    deleteInviteGame: function deleteInviteGame(data) {
	      if (data) {
	        var invites = _lstorage2.default.get('invitesGame', []);
	        this.invitesLength = invites.length;
	      }
	    },
	    userLoguin: function userLoguin(data) {
	      this.userLoguinSocket();
	    }
	  },
	  sockets: {
	    event: function event(data) {
	      this.$broadcast(data.event, data.data ? data.data : data);
	      var invites = _lstorage2.default.get('invitesGame', []);
	
	      this.invitesLength = invites.length;
	      if (data !== undefined && data.data !== undefined && data.data.recibe === this.user.username) {
	        this.toast('Has recibio un reto, revisa los retos', 3000);
	      }
	    },
	    disconnect: function disconnect(data) {
	      if (this.user.role === 'Admin' || this.user.role === 'Teacher') {
	        if (data.data !== undefined && data.data.name !== undefined) {
	          this.loadOtherUser(data.data.name.username, function (someUser) {
	            if (this.user.club === someUser.club) {
	              if (this.lastSocketDisconnect !== data.data.name.username) {
	                this.toast(data.data.name.username + ' se ha desconectado', 3000);
	
	                this.lastSocketDisconnect = data.data.name.username;
	              }
	            }
	          }.bind(this));
	        }
	      }
	    }
	  },
	  created: function created() {
	    this.testUser(function () {
	      this.userLoguinSocket();
	    }.bind(this));
	    this.getLenguajeName();
	    this.loadClub(this.user.club);
	  },
	  ready: function ready() {
	    var _this = this;
	
	    clearInterval(this.intervalId);
	    this.intervalId = setInterval(this.checkServerStatus, 40000);
	    setInterval(function () {
	      _this.$socket.emit('heartbeat', 'Sigo vivo');
	    }, 40000);
	  },
	  destroyed: function destroyed() {
	    clearInterval(this.intervalId);
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(this.intervalId);
	  },
	
	  components: {
	    UserInvites: _invites2.default
	  },
	  store: _store2.default
	};

/***/ }),
/* 303 */,
/* 304 */,
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _enginegame = __webpack_require__(56);
	
	var _enginegame2 = _interopRequireDefault(_enginegame);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	window.pgnBoardBase = 0;
	var timesColor = 0;
	
	exports.default = {
	  name: 'clubChess',
	  props: {
	    club: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    },
	    nextClub: {
	      type: Function,
	      required: false,
	      'default': function _default() {
	        return false;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      mate: false,
	      numMoves: 1000,
	      timeMove: 120,
	      handMoves: 0,
	      userColor: 'white',
	      ground: 1,
	      turn: 'white',
	      stockfish: {},
	      chess: new _chess2.default(),
	      chessPgn: new _chess2.default(),
	      stylesBoard: stylesBoard,
	      times: 120,
	      resultPractica: '',
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      })
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    onResize: function onResize(event) {
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    },
	    chessToDests: function chessToDests(chess) {
	      var dests = {};
	      chess.SQUARES.forEach(function (s) {
	        var ms = chess.moves({ square: s, verbose: true });
	        if (ms.length) dests[s] = ms.map(function (m) {
	          return m.to;
	        });
	      });
	      return dests;
	    },
	    resolveClub: function resolveClub(parms) {
	      _club2.default.resolve(this, parms).then(function (response) {}, function (response) {});
	    },
	    chessToColor: function chessToColor(chess) {
	      var t = chess.turn();
	      var turn = t === 'w' ? 'white' : 'black';
	      this.turn = turn;
	      return turn;
	    },
	    countDown: function countDown() {
	      if (isNaN(this.timeMove) === false) {
	        this.times = this.timeMove;
	      } else {
	        this.times = 120;
	      }
	      clearInterval(timesColor);
	      timesColor = setInterval(function () {
	        this.times = this.times - 1;
	        if (this.times <= 0) {
	          clearInterval(timesColor);
	          this.times = 0;
	          this.onMove(-1, -1);
	          this.mate = false;
	          this.numMoves = 0;
	        }
	      }.bind(this), 1000);
	    },
	    pistaNext: function pistaNext() {
	      this.club.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (fen === this.club.feninit) {
	          break;
	        }
	        this.club.startPlay++;
	      }
	      if (this.club.startPlay > moves.length) {
	        this.club.startPlay = 0;
	      }
	      if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
	        var numGetMove = this.club.startPlay + this.handMoves;
	
	        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
	          this.ground.setAutoShapes({
	            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
	            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
	            brush: 'yellow',
	            modifiers: { lineWidth: 10 }
	          });
	        }
	      }
	    },
	    resultadoNext: function resultadoNext() {
	      this.countDown();
	      this.club.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (fen === this.club.feninit) {
	          break;
	        }
	        this.club.startPlay++;
	      }
	      if (this.club.startPlay > moves.length) {
	        this.club.startPlay = 0;
	      }
	      if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
	        var numGetMove = this.club.startPlay + this.handMoves;
	
	        this.onMove(window.pgnBoardBase.getPgn().getMove(numGetMove).from, window.pgnBoardBase.getPgn().getMove(numGetMove).from);
	        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
	          this.ground.setAutoShapes({
	            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
	            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).to,
	            brush: 'yellow',
	            modifiers: { lineWidth: 10 }
	          });
	        }
	      }
	    },
	    onMove: function onMove(orig, dest) {
	      this.ground.setAutoShapes({
	        orig: '-1',
	        dest: '-1',
	        brush: 'yellow',
	        modifiers: { lineWidth: 10 }
	      });
	      this.numMoves--;
	      this.chess.move({
	        from: orig,
	        to: dest,
	        promotion: 'q'
	      });
	      this.ground.move(orig, dest);
	      this.ground.set({
	        fen: this.chess.fen(),
	        turnColor: this.chessToColor(this.chess),
	        movable: {
	          color: this.chessToColor(this.chess),
	          dests: this.chessToDests(this.chess)
	        },
	        animation: {
	          enabled: true,
	          duration: 1000
	        },
	        highlight: {
	          lastMove: true,
	          check: true },
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      });
	      this.club.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (this.club.feninit !== undefined && fen === this.club.feninit) {
	          break;
	        }
	        this.club.startPlay++;
	      }
	      if (this.club.startPlay > moves.length) {
	        this.club.startPlay = 0;
	      }
	      if (this.club.pgn !== undefined && this.club.pgn.length > 0 && this.club.type !== 'Practica') {
	        var numGetMove = this.club.startPlay + this.handMoves;
	
	        if (this.chess.history()[this.handMoves] !== window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation) {
	          this.numMoves = 0;
	          this.mate = false;
	
	          this.resolveClub({ _id: this.club._id, resolve: this.mate ? 1 : 0 });
	          clearInterval(timesColor);
	        } else if (this.numMoves <= 0) {
	          this.mate = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation;
	
	          this.resolveClub({ _id: this.club._id, resolve: this.mate ? 1 : 0 });
	          clearInterval(timesColor);
	        } else {
	          orig = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).from;
	          dest = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).to;
	
	          this.numMoves--;
	          this.chess.move({
	            from: orig,
	            to: dest,
	            promotion: 'q'
	          });
	          this.ground.move(orig, dest);
	          this.ground.set({
	            fen: this.chess.fen(),
	            turnColor: this.chessToColor(this.chess),
	            movable: {
	              color: this.chessToColor(this.chess),
	              dests: this.chessToDests(this.chess)
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          });
	          this.handMoves++;
	        }
	      } else {
	        this.resultPractica = '';
	        this.movePC(this.turn);
	        this.numMoves = 1;
	        if (this.isFinish(this.chess)) {
	          clearInterval(timesColor);
	          if (this.chess.in_checkmate()) {
	            this.resultPractica = 'Jaque mate';
	            this.toast('Jaque mate', 2000);
	            this.mate = this.chess.turn() === this.turn;
	          } else if (this.chess.in_draw()) {
	            this.toast('Tablas', 2000);
	            this.resultPractica = 'Tablas';
	          } else {
	            this.mate = true;
	          }
	          this.numMoves = 0;
	        }
	      }
	      this.handMoves++;
	    },
	    PcIngeniesMoveStockfish: function PcIngeniesMoveStockfish(move) {
	      var from = move.from;
	      var to = move.to;
	
	      this.onMove(from, to);
	    },
	    movePC: function movePC(turn) {
	      if (turn !== this.userColor) {
	        setTimeout(function () {
	          this.pcMove(this.chess.fen());
	        }.bind(this), 200);
	      }
	    },
	    pcMove: function pcMove(fen) {
	      this.stockfish.setPlayerColor(this.orientation);
	
	      this.stockfish.prepareMove(fen, '', this.PcIngeniesMoveStockfish, 1000, 1000, 0, 0);
	    },
	    makeRandomMove: function makeRandomMove() {
	      var possibleMoves = this.chess.moves({
	        verbose: true
	      });
	      var randomIndex = Math.floor(Math.random() * possibleMoves.length);
	      var move = possibleMoves[randomIndex];
	      var from = move.from;
	      var to = move.to;
	      this.onMove(from, to);
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    loadClub: function loadClub(fen) {
	      try {
	        if (this.club.timemove === undefined) {
	          this.club.timemove = 120;
	        }
	        if (this.club.nummoves === undefined) {
	          this.club.nummoves = 1;
	        }
	        this.numMoves = parseInt(this.club.nummoves);
	        this.timeMove = parseInt(this.club.timemove);
	        this.titleFen = this.club.title;
	        this.handMoves = 0;
	        if (this.club.pgn !== undefined && this.club.pgn.length > 0) {
	          var Width = 500;
	          if (document.getElementById('clubBoard') !== undefined) {
	            Width = document.getElementById('clubBoard').clientWidth;
	          }
	          var pgnBoard = 0;
	          var pos = 'end';
	          var start = fen !== undefined ? fen : '';
	          this.club.pgn = this.club.pgn.split('"]').join('"]\n');
	          this.club.pgn = this.club.pgn.split('{}').join('');
	          var headers = this.parse_pgn_header(this.club.pgn);
	          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	            pos = fen !== undefined ? fen : 'end';
	            if (!this.hasBody(this.club.pgn)) {
	              start = '';
	              pos = headers['FEN'];
	            }
	            if (pos === headers['FEN']) {
	              start = '';
	            }
	          }
	          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	            start = '';
	            pos = fen;
	          }
	          if (fen === headers['FEN']) {
	            pos = headers['FEN'];
	          }
	
	          if (document.getElementById('pgnComment')) {
	            document.getElementById('pgnComment').textContent = '';
	          }
	          var winWidth = Math.min(window.innerWidth, window.outerWidth);
	          pgnBoard = window.pgnEdit({ inner: 'clubBoard', comment: 'pgnComment' }, { pgn: this.club.pgn, position: pos, startPlay: start, width: Width, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true });
	          this.ground = pgnBoard.board;
	          this.chess = pgnBoard.chess;
	          window.pgnBoardBase = pgnBoard.boardBase;
	          if (document.getElementById('clubBoard')) {
	            document.getElementById('clubBoard').style.height = Width + 'px';
	            document.getElementById('clubBoard').style.width = Width + 'px';
	          }
	          var options = {
	            orientation: 'white',
	            movable: {
	              free: false,
	              color: 'both',
	              dests: this.chessToDests(this.chess),
	              dropOff: 'revert',
	              showDests: true,
	              events: {
	                after: this.onMove
	              }
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          };
	
	          this.ground.set(options);
	          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black';
	          this.chessToColor(this.chess);
	        } else {
	          if (fen) {
	            this.chess.load(fen);
	          } else {
	            this.chess.load('8/2k5/8/8/6P1/8/8/4K3 w - - 0 1');
	          }
	          this.ground.set({
	            fen: this.chess.fen(),
	            turnColor: this.chessToColor(this.chess),
	            movable: {
	              color: this.chessToColor(this.chess),
	              dests: this.chessToDests(this.chess)
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          });
	          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black';
	          this.movePC(this.turn);
	        }
	        this.countDown();
	      } catch (error) {
	        console.error('<span>' + 'Error LoadClub: ' + error + '</span>', 3000);
	      }
	    },
	    resultado: function resultado() {
	      this.resultadoNext();
	    },
	    pista: function pista() {
	      this.pistaNext();
	    },
	    isFinish: function isFinish(chess) {
	      return chess.game_over();
	    },
	    reintent: function reintent() {
	      clearInterval(timesColor);
	      this.mate = false;
	      this.loadClub(this.club.feninit);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.stockfish !== null && this.stockfish !== undefined) {
	      this.stockfish.close();
	      this.stockfish = null;
	    }
	  },
	  ready: function ready() {
	    try {
	      this.stockfish = _enginegame2.default.engineGame({ book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js' });
	
	      var skill = 20;
	      this.stockfish.reset();
	
	      this.stockfish.setSkillLevel(skill);
	      this.stockfish.setPlayerColor(this.orientation);
	      this.stockfish.setDisplayScore(true);
	      this.stockfish.setOwnBook(false);
	      this.stockfish.start();
	      var options = {
	        orientation: 'white',
	        movable: {
	          free: false,
	          color: 'both',
	          dests: this.chessToDests(this.chess),
	          dropOff: 'revert',
	          showDests: true,
	          events: {
	            after: this.onMove
	          }
	        },
	        highlight: {
	          lastMove: true,
	          check: true },
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      };
	      window.addEventListener('resize', this.onResize);
	
	      setTimeout(function () {
	        var pgnBoard = 0;
	
	        if (document.getElementById('pgnComment') !== undefined) {
	          document.getElementById('pgnComment').textContent = '';
	        }
	        var winWidth = Math.min(window.innerWidth, window.outerWidth);
	        pgnBoard = window.pgnEdit({ inner: 'clubBoard', comment: 'pgnComment' }, { showCoords: true, width: Width, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true });
	        this.ground = pgnBoard.board;
	        window.pgnBoardBase = pgnBoard.boardBase;
	        this.ground.set(options);
	        if (document.getElementById('clubBoard') !== undefined) {
	          var Width = document.getElementById('clubBoard').clientWidth;
	          document.getElementById('clubBoard').style.height = Width + 'px';
	          document.getElementById('clubBoard').style.width = Width + 'px';
	        }
	
	        this.loadClub();
	      }.bind(this), 10);
	    } catch (error) {
	      console.error('<span>' + 'Error (ready club): ' + error + '</span>', 3000);
	    }
	  },
	
	  watch: {
	    club: function club(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.loadClub(newVal.feninit);
	      }
	    }
	  }
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _club = __webpack_require__(528);
	
	var _club2 = _interopRequireDefault(_club);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _club3 = __webpack_require__(23);
	
	var _club4 = _interopRequireDefault(_club3);
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _swiss = __webpack_require__(119);
	
	var _swiss2 = _interopRequireDefault(_swiss);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _uploadFiles = __webpack_require__(530);
	
	var _uploadFiles2 = _interopRequireDefault(_uploadFiles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groundInit = 1;
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    },
	    data: function data(transition) {
	      return _promise2.default.all([_club4.default.count(this)]).then(function (data) {
	        var theD = JSON.parse(data);
	
	        return {
	          counts: theD
	        };
	      }, function (response) {});
	    }
	  },
	  template: __webpack_require__(515),
	  data: function data() {
	    return {
	      user: _user2.default.getUser(),
	      mode: 'add',
	      fenInit: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      fenFinish: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      pgn: '',
	      startPlay: 0,
	      club: '',
	      numMoves: 1,
	      timeMove: 60,
	      titleFen: 'Club',
	      myPGNValue: '',
	      myFENValue: '',
	      results: {},
	      pgnFiles: [],
	      item: {
	        num: 0
	      },
	      counts: [],
	      foundList: [],
	      chess: new _chess2.default(),
	      clubType: {},
	      clubsType: [{
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Clubs',
	        description: 'Lista de todos los clubs de la plataforma',
	        position: true
	      }],
	
	      clubs: [],
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: '',
	      finduser: '',
	      bGuardar: false,
	      sendToAll: false,
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirServer: _lstorage2.default.get('serverDir'),
	      filesUpload: [],
	      hashFileBoard1: '',
	      hashFileBoard2: '',
	      hashFileBoard3: '',
	      fileProgress: 0,
	      allFilesUploaded: true,
	      offcanvas: false,
	      active: 'boardVisor',
	      tab: '0',
	      tabs: [],
	      chattext: '',
	      boards: [],
	      boardFiles: [],
	      boardFilesName: '',
	      boardFiles2: [],
	      boardFilesName2: '',
	      boardFiles3: [],
	      boardFilesName3: '',
	      rondas: 1,
	      rondaactual: 1,
	      nombreClub: 'Club 1',
	      precioClub: '0',
	      descripcionClub: '',
	      linkClub: '',
	      passwordClub: '',
	      MENU1Titulo: '',
	      MENU1Texto: '',
	      MENU1Link: '',
	      MENU1Video: '',
	      MENU2Titulo: '',
	      MENU2Texto: '',
	      MENU2Link: '',
	      MENU2Video: '',
	      MENU3Titulo: '',
	      MENU3Texto: '',
	      MENU3Link: '',
	      MENU3Video: '',
	      emailClub: 'info@mainchess.com',
	      imagenClub: '',
	      nombreClubResult: 'Club 1',
	      newboard: {
	        color: 'w',
	        time: '3',
	        incremento: 0,
	        elo: 1500,
	        contrincante: '',
	        public: true,
	        broadcast: false,
	        all: true,
	        club: ''
	      },
	      todosCheck: false,
	      users: [],
	      players: [],
	      playersResult: [],
	      round1: {
	        rounds: []
	      },
	      bSimultanea: false,
	      bRandColor: false,
	      bOneRound: true,
	      usersLength: 0,
	      games: [],
	      board: _lstorage2.default.get('boardSee', {}),
	      totalRecords: 0,
	      limit: 100,
	      filters: {
	        club: 'Primera liga',
	        ronda: '1'
	      }
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  components: {
	    ClubChess: _club2.default,
	    UploadFiles: _uploadFiles2.default
	  },
	  events: {
	    boards: function boards(data) {
	      this.boards = data.boards;
	    },
	    mensaje: function mensaje(data) {
	      this.recibeMensaje(data.men, true, true);
	      if (data.men.send !== this.user.username) {
	        this.chatRecibido = true;
	      }
	    },
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    },
	    users: function users(data) {
	      this.users = data.nicknames;
	
	      var playersParam = {};
	      for (var i in this.users) {
	        if (this.users[i].club === this.user.club) {
	          var nombre = this.users[i].nickname;
	          playersParam[nombre] = { name: nombre, juega: true, user: i, score: 0, buchholz: 1, elo: this.users[i].elo };
	        }
	      }
	      playersParam['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 };
	
	      this.players = playersParam;
	    },
	    mensendactivate: function mensendactivate(data) {
	      var usermen = data.men.user.username;
	      var username = this.user.username;
	      if (usermen === username) {
	        this.user.sendtoanalyse = data.men.user.sendtoanalyse;
	      }
	    },
	    updatepermissions: function updatepermissions(dta) {
	      this.user.chat = dta.men.user.chat;
	      this.user.chattext = dta.men.user.chattext;
	      this.user.chataudio = dta.men.user.chataudio;
	      this.user.cast = dta.men.user.cast;
	      this.user.live = dta.men.user.live;
	      this.user.analyse = dta.men.user.analyse;
	      this.user.sendtoanalyse = dta.men.user.sendtoanalyse;
	      this.user.download = dta.men.user.download;
	
	      if (this.user.username === dta.men.user.username) {}
	    },
	    onFileClick: function onFileClick(file) {},
	    onFileChange: function onFileChange(file) {
	      this.fileProgress = 0;
	      this.allFilesUploaded = false;
	    },
	    beforeFileUpload: function beforeFileUpload(file) {
	      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000);
	    },
	    afterFileUpload: function afterFileUpload(file) {
	      this.toast('<span>' + 'Imagen cargada' + '</span>', 2000);
	    },
	    onFileProgress: function onFileProgress(progress) {
	      this.fileProgress = parseInt(progress.percent);
	    },
	    onFileUpload: function onFileUpload(file, res) {
	      if (this.imagenClub !== '50x50defaultClub.png') {
	        _user2.default.deleteImage(this, { name: this.imagenClub }).then(function (response) {
	          console.log('eliminado correctamente');
	        }, function (response) {});
	      }
	      this.imagenClub = file.name;
	    },
	    onFileError: function onFileError(file, res) {},
	    onAllFilesUploaded: function onAllFilesUploaded(files) {
	      this.allFilesUploaded = true;
	    }
	  },
	  methods: {
	    createGuid: function createGuid() {
	      function _p8(s) {
	        var p = (Math.random().toString(16) + '000000000').substr(2, 8);
	        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
	      }
	      return _p8();
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === 'Retransmisión') {
	        this.mensjGame.push(men);
	        if (bottom) {
	          this.isAtBottom();
	        }
	      }
	      if (toast === true) {
	        if (men.send !== _user2.default.getUser().username) {
	          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000);
	        }
	      }
	    },
	    allAreConnected: function allAreConnected(round) {
	      var ret = true;
	      if (this.item !== undefined && this.item.round1 !== undefined) {
	        for (var play in this.item.round1[round].rounds) {
	          if (this.item.round1[round].rounds[play].white !== 'PC' && this.item.round1[round].rounds[play].black !== 'PC') {
	            if (this.isConnected(this.item.round1[round].rounds[play].white) === false) {
	              ret = false;
	              break;
	            }
	            if (this.isConnected(this.item.round1[round].rounds[play].black) === false) {
	              ret = false;
	              break;
	            }
	          }
	        }
	      }
	      return ret;
	    },
	    isBeginRonda: function isBeginRonda(rondaParam) {
	      var ret = false;
	      var nRonda = 0;
	      for (var ronda in this.item.round1) {
	        if (nRonda + 1 === rondaParam) {
	          for (var partida in this.item.round1[ronda].rounds) {
	            if (this.item.round1[ronda].rounds[partida].wins !== '') {
	              ret = true;
	            }
	          }
	        }
	        nRonda++;
	      }
	      return ret;
	    },
	    isBegin: function isBegin() {
	      var ret = false;
	      for (var ronda in this.item.round1) {
	        for (var partida in this.item.round1[ronda].rounds) {
	          if (this.item.round1[ronda].rounds[partida].wins !== '') {
	            ret = true;
	          }
	        }
	      }
	      return ret;
	    },
	    isConnected: function isConnected(userName) {
	      var ret = false;
	      if (userName === 'PC') {
	        ret = true;
	      } else {
	        for (var i in this.users) {
	          if (this.users[i].club === this.user.club) {
	            var nombre = this.users[i].nickname;
	            if (nombre === userName) {
	              ret = true;
	              break;
	            }
	          }
	        }
	      }
	      return ret;
	    },
	    selectItm: function selectItm(item) {
	      this.item = item;
	    },
	    nextClub: function nextClub() {
	      var post = this.clubs.indexOf(this.item);
	      if (post !== -1 && post + 1 < this.clubs.length && this.clubs[post + 1]) {
	        this.selectItm(this.clubs[post + 1]);
	      } else {
	        if (post + 1 >= this.clubs.length && this.clubsType.indexOf(this.clubType) + 1 < this.clubsType.length) {
	          this.selectClubType(this.clubsType[this.clubsType.indexOf(this.clubType) + 1]);
	        } else {
	          this.toast('<span>Ya no hay mas</span>', 2000);
	        }
	      }
	    },
	    selectClubType: function selectClubType(club) {
	      this.clubType = club;
	      var parms = {
	        type: club.type
	      };
	
	      var _self = this;
	
	      _club4.default.get(_self, parms).then(function (response) {
	        var theD = JSON.parse(response);
	
	        _self.clubs = theD;
	        setTimeout(function () {
	          if (_self.clubs.length > 0 && _self.clubs[0]) {
	            _self.selectItm(_self.clubs[0]);
	          }
	          (0, _jquery2.default)('#listSomeClubs').animate({
	            'scrollTop': 0
	          }, 'slow');
	        }, 50);
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    updateFenInit: function updateFenInit(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	
	      this.fenInit = groundInit.getFen();
	    },
	    updateFenFinish: function updateFenFinish(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	    },
	    addClub: function addClub(mode) {
	      this.mode = mode;
	
	      if (!this.clubType.type) {
	        this.toast('<span>Selecciona un tipo de club</span>', 2000);
	        return;
	      }
	      if (mode === 'add') {
	        this.nombreClub = 'C_' + this.createGuid();
	      }
	
	      this.$broadcast('modal::open', 'modalCreateClub');
	    },
	    generateHeader: function generateHeader(pgnFile) {
	      var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var onlyNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var retHeader = '';
	      var pgnInLines = pgnFile.split('"]').join('"]\n');
	      var headers = this.parse_pgn_header(pgnInLines);
	      if (headers !== undefined && headers['Event'] !== undefined) {
	        var appendHeader = function appendHeader(result, headers, separator) {
	          if (headers && headers.length > 0) {
	            if (result.length > 0) {
	              result += separator;
	            }
	            result += headers;
	          }
	          return result;
	        };
	        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']];
	        if (complete) {
	          retHeader = headers['White'] + ' vs ' + headers['Black'];
	          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']];
	        }
	        if (onlyNames) {
	          retHeader = headers['White'] + ' (' + headers['WhiteElo'] + ')' + ' vs ' + headers['Black'] + ' (' + headers['BlackElo'] + ')';
	          hh = [];
	        }
	        if (hh.length > 1) {
	          var rest = '';
	          retHeader += ' (';
	          hh.forEach(function (headers) {
	            rest = appendHeader(rest, headers, ' | ');
	          });
	          retHeader += rest;
	          retHeader += ')';
	        }
	      }
	
	      return retHeader;
	    },
	    readTextFile: function readTextFile(file, callback, encoding) {
	      var reader = new window.FileReader();
	      reader.addEventListener('load', function (e) {
	        callback(this.result);
	      });
	      if (encoding) {
	        reader.readAsText(file, encoding);
	      } else {
	        reader.readAsText(file);
	      }
	    },
	    isListFiles: function isListFiles() {
	      var input = document.getElementById('files');
	      if (input.files && input.files[0] && input.files[0].length > 0) {
	        return true;
	      }
	      return false;
	    },
	    listFiles: function listFiles() {
	      this.fileChosen();
	    },
	    hashCode: function hashCode(s) {
	      var h = 0;
	      var l = s.length;
	      var i = 0;
	      if (l > 0) {
	        while (i < l) {
	          h = (h << 5) - h + s.charCodeAt(i++) | 0;
	        }
	      }
	      var hexString = h.toString(16);
	      return hexString;
	    },
	    parsePgnFiles: function parsePgnFiles(file, number) {
	      this.pgnFiles = '';
	      var newlineChar = '\r?\n';
	      var filesObj = {};
	
	      var lines = file.split(new RegExp(newlineChar));
	      var pgntext = '';
	      var state = 0;
	      var index = 0;
	      for (var i = 0; i < lines.length; i++) {
	        if (lines[i].length > 0) {
	          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
	            if (state === 1) {
	              index = index + 1;
	              var headers = this.parse_pgn_header(pgntext);
	              var hashCode = this.hashCode(pgntext);
	              var board = { pgn: pgntext, _id: hashCode, type: 'club', u1: headers['White'], u2: headers['Black'], name: '' };
	              filesObj[index] = board;
	
	              pgntext = '';
	            }
	            state = 0;
	          } else {
	            state = 1;
	          }
	          if (state === 0) {
	            pgntext += lines[i] + '\r\n';
	          } else {
	            pgntext += lines[i] + ' ';
	          }
	        }
	      }
	      headers = this.parse_pgn_header(pgntext);
	      hashCode = this.hashCode(pgntext);
	      board = { pgn: pgntext, _id: hashCode, type: 'club', u1: headers['White'], u2: headers['Black'], name: '' };
	      index = index + 1;
	      filesObj[index] = board;
	
	      this.pgnFiles = filesObj;
	
	      return filesObj;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\}/gm, '');
	      pgn = pgn.replace(/\{\[%emt([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\]\}/gm, '');
	      pgn = pgn.replace(/\{([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}/gm, '');
	      return pgn;
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = decodeURIComponent(escape(strParam));
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    openPGN: function openPGN(pgnText) {
	      var pgnAux = pgnText;
	      pgnAux = this.prettyPgn(pgnAux);
	
	      this.myPGNValue = pgnAux;
	    },
	    fileChosen: function fileChosen() {
	      var output = document.getElementById('idTextAreaPGN');
	      var input = document.getElementById('files');
	      var _self = this;
	      if (input.files && input.files[0]) {
	        this.readTextFile(input.files[0], function (str) {
	          if (output !== undefined) {
	            output.value = '';
	            output.dispatchEvent(new window.Event('change'));
	          }
	          _self.parsePgnFiles(str);
	        }, 'ISO-8859-1');
	      }
	    },
	    changeMENU1Texto: function changeMENU1Texto() {
	      var idTextArea = document.getElementById('menu1_text');
	      if (idTextArea && idTextArea.value !== 'none') {
	        this.MENU1Texto = idTextArea.value;
	      }
	    },
	    changeMENU2Texto: function changeMENU2Texto() {
	      var idTextArea = document.getElementById('menu2_text');
	      if (idTextArea && idTextArea.value !== 'none') {
	        this.MENU2Texto = idTextArea.value;
	      }
	    },
	    changeMENU3Texto: function changeMENU3Texto() {
	      var idTextArea = document.getElementById('menu3_text');
	      if (idTextArea && idTextArea.value !== 'none') {
	        this.MENU3Texto = idTextArea.value;
	      }
	    },
	    setFenPosition: function setFenPosition() {
	      if (document.getElementById('iFramePosition')) {
	        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	        if (searchinput !== undefined && searchinput !== null) {
	          var txtPgn = '';
	          txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]';
	
	          this.fenInit = searchinput.value;
	          this.fenFinish = searchinput.value;
	          this.pgn = txtPgn;
	        }
	      }
	    },
	    createClub: function createClub(action) {
	      if (action) {
	        var newClub = {
	          type: this.clubType.type,
	          createby: _user2.default.getUser().username,
	          name: this.nombreClub,
	          price: this.precioClub,
	          description: this.descripcionClub,
	          link: this.linkClub,
	          email: this.emailClub,
	          password: this.passwordClub,
	          menu1_title: this.MENU1Titulo,
	          menu1_text: this.MENU1Texto,
	          menu1_link: this.MENU1Link,
	          menu1_video: this.MENU1Video,
	          menu2_title: this.MENU2Titulo,
	          menu2_text: this.MENU2Texto,
	          menu2_link: this.MENU2Link,
	          menu2_video: this.MENU2Video,
	          menu3_title: this.MENU3Titulo,
	          menu3_text: this.MENU3Texto,
	          menu3_link: this.MENU3Link,
	          menu3_video: this.MENU3Video,
	          image: this.imagenClub,
	          mode: this.mode
	        };
	
	        _club4.default.add(this, newClub).then(function (response) {
	          this.toast('<span>Creado correctamente</span>', 3000);
	
	          if (this.mode === 'add' && newClub) {
	            this.selectItm(newClub);
	          } else {}
	
	          this.selectClubType(this.clubType);
	        }, function (response) {
	          this.error = response.data;
	          this.toast('<span>' + this.error + '</span>', 3000);
	        });
	        this.$broadcast('modal::close', 'some', 'modalCreateClub');
	      } else {
	        this.$broadcast('modal::close', 'some', 'modalCreateClub');
	      }
	    },
	    onResize: function onResize(event) {},
	    editClub: function editClub() {
	      this.nombreClub = this.item.name;
	      this.emailClub = this.item.email;
	      this.passwordClub = this.item.password;
	      this.MENU1Titulo = this.item.menu1_title;
	      this.MENU1Texto = this.item.menu1_text;
	      this.MENU1Link = this.item.menu1_link;
	      this.MENU1Video = this.item.menu1_video;
	      this.MENU2Titulo = this.item.menu2_title;
	      this.MENU2Texto = this.item.menu2_text;
	      this.MENU2Link = this.item.menu2_link;
	      this.MENU2Video = this.item.menu2_video;
	      this.MENU3Titulo = this.item.menu3_title;
	      this.MENU3Texto = this.item.menu3_text;
	      this.MENU3Link = this.item.menu3_link;
	      this.MENU3Video = this.item.menu3_video;
	      this.precioClub = this.item.price;
	      this.descripcionClub = this.item.description;
	      this.linkClub = this.item.link;
	      this.imagenClub = this.item.image;
	
	      this.addClub(this.item._id);
	    },
	    delClub: function delClub() {
	      var _self = this;
	      window.swal('Seguro de eliminar', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          _club4.default.del(_self, _self.item._id).then(function (response) {
	            _self.selectClubType(_self.clubType);
	          }, function (response) {
	            _self.error = response.data;
	          });
	        }
	      });
	    },
	    createAllTournament: function createAllTournament() {
	      this.rondas = 1;
	      this.round1 = {};
	      for (var x = 0; x < this.rondas; x++) {
	        this.createTournament(x);
	      }
	      this.bGuardar = true;
	    },
	    addPlayersInRound: function addPlayersInRound(round1) {
	      for (var ronda in round1) {
	        for (var partida in round1[ronda].rounds) {
	          var nameBlack = round1[ronda].rounds[partida].black;
	          var nameWhite = round1[ronda].rounds[partida].white;
	          var elo = round1[ronda].rounds[partida].elo;
	
	          if (nameBlack !== undefined) {
	            this.players[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo };
	          }
	          if (nameWhite !== undefined) {
	            this.players[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo };
	          }
	        }
	      }
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    refresh: function refresh() {
	      this.selectItm(this.item);
	    },
	    showResults: function showResults(round1, title) {
	      this.nombreClubResult = title;
	      this.playersResult = {};
	
	      for (var ronda in round1) {
	        for (var partida in round1[ronda].rounds) {
	          var nameBlack = round1[ronda].rounds[partida].black;
	          var nameWhite = round1[ronda].rounds[partida].white;
	          var elo = round1[ronda].rounds[partida].elo;
	          if (nameBlack !== undefined && this.playersResult[nameBlack] === undefined) {
	            this.playersResult[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo };
	          }
	          if (nameWhite !== undefined && this.playersResult[nameWhite] === undefined) {
	            this.playersResult[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo };
	          }
	          if (round1[ronda] !== undefined && round1[ronda].rounds[partida].wins !== '') {
	            if (round1[ronda].rounds[partida].wins === 'white') {
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score += 1;
	              }
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score -= 0;
	              }
	            } else if (round1[ronda].rounds[partida].wins === 'black') {
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score -= 0;
	              }
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score += 1;
	              }
	            } else if (round1[ronda].rounds[partida].wins === 'draw') {
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score += 0.5;
	              }
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score += 0.5;
	              }
	            }
	          }
	        }
	      }
	      for (ronda in round1) {
	        for (partida in round1[ronda].rounds) {
	          nameBlack = round1[ronda].rounds[partida].black;
	          nameWhite = round1[ronda].rounds[partida].white;
	          if (this.playersResult[nameWhite] !== undefined) {
	            this.playersResult[nameWhite].buchholz = 0;
	          }
	          if (this.playersResult[nameBlack] !== undefined) {
	            this.playersResult[nameBlack].buchholz = 0;
	          }
	        }
	      }
	      for (ronda in round1) {
	        for (partida in round1[ronda].rounds) {
	          nameBlack = round1[ronda].rounds[partida].black;
	          nameWhite = round1[ronda].rounds[partida].white;
	
	          if (this.playersResult[nameWhite] !== undefined && this.playersResult[nameBlack] !== undefined) {
	            this.playersResult[nameWhite].buchholz += this.playersResult[nameBlack].score;
	            this.playersResult[nameBlack].buchholz += this.playersResult[nameWhite].score;
	          }
	        }
	      }
	      var ordered = {};
	      var _self = this;
	      (0, _keys2.default)(_self.playersResult).sort(function (a, b) {
	        if (_self.playersResult[b].score === _self.playersResult[a].score) {
	          return _self.playersResult[b].buchholz - _self.playersResult[a].buchholz;
	        } else {
	          return _self.playersResult[b].score - _self.playersResult[a].score;
	        }
	      }).forEach(function (key) {
	        ordered[key] = _self.playersResult[key];
	      });
	      this.playersResult = ordered;
	      this.$broadcast('modal::open', 'modalResultados');
	    },
	    roundRobin: function roundRobin(teams) {
	      var schedule = [];
	      var league = [];
	      var rondaRoundRobin = {};
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          league.push(this.players[i].name);
	        }
	      }
	
	      if (league.length % 2) {
	        league.push('None');
	      }
	      var rounds = league.length;
	
	      this.rondas = rounds;
	      var totalRondas = this.bOneRound === true ? rounds - 1 : (rounds - 1) * 2;
	      for (var j = 0; j < totalRondas; j++) {
	        schedule[j] = [];
	        var round = {};
	        for (var _i = 0; _i < rounds / 2; _i++) {
	          if (league[_i] !== 'None' && league[rounds - 1 - _i] !== 'None') {
	            var white = '';
	            var black = '';
	            if (j % 2 === 1) {
	              schedule[j].push([league[_i], league[rounds - 1 - _i]]);
	              white = league[_i];
	              black = league[rounds - 1 - _i];
	            } else {
	              schedule[j].push([league[rounds - 1 - _i], league[_i]]);
	              white = league[rounds - 1 - _i];
	              black = league[_i];
	            }
	            var partida = { white: white, black: black, wins: '' };
	            round[_i] = partida;
	          }
	        }
	
	        var roundaux = { rounds: round };
	        rondaRoundRobin[j] = roundaux;
	        league.splice(1, 0, league.pop());
	      }
	
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 };
	      }
	      this.round1 = rondaRoundRobin;
	
	      return schedule;
	    },
	    saveTournament: function saveTournament() {},
	    createRoundRobin: function createRoundRobin() {
	      var ret = this.randomArrayShuffle(this.players);
	      this.players = ret;
	      this.roundRobin(this.players);
	      this.bGuardar = true;
	    },
	    createSwiss: function createSwiss() {
	      var retP = this.randomArrayShuffle(this.players);
	      this.players = retP;
	      this.rondas = 1;
	
	      var ret = {};
	      var param = this.round1;
	      this.round1 = {};
	      ret = _swiss2.default.createSwiss(this.players, param, 0);
	
	      for (var k in ret) {
	        _vue2.default.set(this.round1, k, ret[k]);
	      }
	
	      this.bGuardar = false;
	    },
	    createTournament: function createTournament(ronda) {
	      var jugadores = '';
	      var partidas = 0;
	      var white = '';
	      var black = '';
	      var round = {};
	
	      var ret = this.randomArrayShuffle(this.players);
	      this.players = ret;
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          jugadores += '(' + i + ') ' + this.players[i].name + ': ' + this.players[i].juega + '\n';
	          if (this.bSimultanea === true) {
	            if (_user2.default.getUser().username !== this.players[i].name) {
	              if (this.bRandColor === true && Math.random() * 10 > 4) {
	                black = _user2.default.getUser().username;
	                white = this.players[i].name;
	              } else {
	                white = _user2.default.getUser().username;
	                black = this.players[i].name;
	              }
	              var partida = { white: white, black: black, wins: '' };
	              round[partidas] = partida;
	            }
	          } else {
	            if (partidas % 2 === 0) {
	              white = this.players[i].name;
	            } else {
	              black = this.players[i].name;
	              partida = { white: white, black: black, wins: '' };
	              round[partidas] = partida;
	            }
	          }
	          partidas++;
	        }
	      }
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 };
	      }
	
	      var roundaux = { rounds: round };
	      this.round1[ronda] = roundaux;
	    },
	    randomArrayShuffle: function randomArrayShuffle(arrayParam) {
	      var array = [];
	      var arrayRet = {};
	      var index = 0;
	      for (var ii in arrayParam) {
	        array.push(arrayParam[ii].name);
	        index++;
	      }
	      var currentIndex = this.getLength(array) - 1;
	
	      while (currentIndex > 0) {
	        var randomIndex = Math.floor(Math.random() * currentIndex);
	        currentIndex -= 1;
	        var temporaryValue = array[currentIndex];
	        array[currentIndex] = array[randomIndex];
	        array[randomIndex] = temporaryValue;
	      }
	      for (var i = this.getLength(array) - 1; i >= 0; i--) {
	        arrayRet[array[i]] = arrayParam[array[i]];
	      }
	      return arrayRet;
	    },
	    createInvites: function createInvites(rondaParam, round1, club) {
	      this.rondaactual = rondaParam - 1;
	
	      if (window.confirm(club + '\n¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?')) {
	        var rondaInvites = round1[this.rondaactual];
	        this.nombreClub = club;
	        for (var i in rondaInvites.rounds) {
	          this.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black);
	        }
	      }
	    },
	    createInvitesNextSwiss: function createInvitesNextSwiss(round1, club) {
	      this.rondas = 1;
	      this.nombreClub = club;
	
	      _swiss2.default.createSwiss(this.players, round1, 1);
	
	      this.createClub(true);
	      this.bGuardar = true;
	      this.rondaactual = 2;
	      this.bGuardar = true;
	    },
	    createdInviteGame: function createdInviteGame(userNameWhite, userNameBlack) {
	      var invite = {
	        type: 'invite',
	        public: this.item.public,
	        broadcast: false,
	        all: true,
	        vsPc: false,
	
	        ronda: this.rondaactual,
	        confirm: false,
	        club: _user2.default.getUser().club,
	        time: this.item.time,
	        incremento: this.item.incremento,
	        recibe: this.active,
	        elo: _user2.default.getUser().elo
	      };
	      if (userNameWhite === 'PC') {
	        invite.vsPc = true;
	        invite.confirm = true;
	
	        invite.elo = this.item.elo;
	      }
	
	      if (userNameBlack !== '') {
	        invite.confirm = true;
	        if (userNameBlack === 'PC') {
	          invite.vsPc = true;
	          invite.elo = this.item.elo;
	        }
	      }
	      if (this.newboard.color === 'w') {
	        invite.u1 = userNameWhite;
	        invite.u2 = userNameBlack;
	      } else {
	        invite.u2 = userNameWhite;
	        invite.u1 = userNameBlack;
	      }
	
	      if (invite.confirm === true) {
	        this.InviteGameActionConfirmado(invite);
	      }
	    },
	    InviteGameActionConfirmado: function InviteGameActionConfirmado(invite) {
	      var data = {
	        c: 'board',
	        f: 'confirmGame',
	        data: invite
	      };
	
	      if (invite.confirm || invite.vsPc) {
	        data.f = 'addBoard';
	      } else {}
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      return ret;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultClub.png';
	    },
	    imageUrl: function imageUrl(name) {
	      return this.dirServer + '/uploads/' + name;
	    },
	    loadAllData: function loadAllData() {
	      var data = {
	        c: 'chat',
	        f: 'getDataChat',
	        data: {
	          user: _user2.default.getUser()
	        }
	      };
	
	      this.$socket.emit('event', data, function () {
	        for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	          callbacks[_key] = arguments[_key];
	        }
	
	        var logUser = callbacks[1].logUser;
	        for (var i = 0; i < logUser.length; i++) {
	          if (logUser[i]) {}
	        }
	
	        this.boards = callbacks[1].boards;
	      }.bind(this));
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var historyTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var data = {
	        c: 'chat',
	        f: 'loadUserConvert',
	        data: parms
	      };
	      this.$socket.emit('event', data, function () {
	        var log = arguments.length <= 1 ? undefined : arguments[1];
	
	        var menLast = '';
	        if (log) {
	          for (var i = log.length - 1; i >= 0; i--) {
	            if (menLast !== log[i].body && log[i].board === this.board._id) {
	              this.recibeMensaje(log[i], true, false);
	              menLast = log[i].body;
	            }
	          }
	        }
	      }.bind(this));
	    }
	  },
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('tournament.title');
	  },
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	
	    this.$nextTick(function () {
	      this.active = 'boardVisor';
	      this.loadAllData();
	      this.selectClubType(this.clubsType[0]);
	    });
	    this.$dispatch('userLoguin', 'show data');
	    this.bGuardar = false;
	  },
	
	  watch: {
	    round1: function round1(val, oldVal) {
	      this.round1 = val;
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      this.fenInit = val;
	    },
	    myPGNValue: function myPGNValue(val, oldVal) {
	      this.pgn = val;
	
	      setTimeout(function () {
	        var pgnBoardInit = 0;
	        if (document.getElementById('pgnMoves')) {
	          document.getElementById('pgnMoves').textContent = '';
	        }
	        if (document.getElementById('pgnButtons')) {
	          document.getElementById('pgnButtons').textContent = '';
	        }
	        if (document.getElementById('pgnHeader')) {
	          document.getElementById('pgnHeader').textContent = '';
	        }
	        var pos = 'start';
	        var start = 'start';
	        var pgnNew = this.pgn.split('"]').join('"]\n');
	        pgnNew = pgnNew.split('{}').join('');
	        var headers = this.parse_pgn_header(pgnNew);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = headers['FEN'];
	        } else {}
	        if (start === pos) {
	          start = 0;
	        }
	        if (this.fenInit !== '' && this.fenInit !== undefined) {
	          start = this.fenInit;
	        }
	        try {
	          var winWidth = Math.min(window.innerWidth, window.outerWidth);
	          pgnBoardInit = window.pgnEdit({ inner: 'clubGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader' }, { pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true });
	          groundInit = pgnBoardInit.board;
	          window.pgnBoardBase = pgnBoardInit.boardBase;
	          window.ground = pgnBoardInit.board;
	        } catch (error) {
	          console.error('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000);
	        }
	      }.bind(this), 50);
	    },
	    fenInit: function fenInit(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    },
	    fenFinish: function fenFinish(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    }
	  }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UploadFiles',
	  props: {
	    value: {
	      type: Array
	    },
	    headers: Object,
	    action: {
	      type: String,
	      required: true
	    },
	    id: String,
	    name: {
	      type: String,
	      required: true
	    },
	    multiple: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    maxsize: String,
	    pathpermit: String,
	    method: String
	  },
	  directives: {
	    bindBoolean: {
	      priority: 850,
	      update: function update(value) {
	        var arg = this.arg;
	        if (value) {
	          this.el.setAttribute(arg, arg);
	        } else {
	          this.el.removeAttribute(arg);
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      myFiles: []
	    };
	  },
	
	  methods: {
	    OpenInputFile: function OpenInputFile() {
	      document.getElementById(this.name).click();
	      this.fileInputClick();
	    },
	    fileInputClick: function fileInputClick() {
	      this.$dispatch('onFileClick', this.myFiles);
	    },
	    validateFiles: function validateFiles(files) {
	      var sumSize = 0;
	      var allOk = true;
	      Array.prototype.slice.call(files, 0).map(function (file) {
	        sumSize += parseInt(file.size);
	        var maxSize = parseInt(this.maxsize) * 1024 * 1024;
	        if (sumSize > maxSize) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.size_not_permit'));
	          allOk = false;
	        }
	        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	        if (this.pathpermit.indexOf(type) === -1) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.path_not_permit'));
	          allOk = false;
	        }
	      }.bind(this));
	      return allOk;
	    },
	    fileInputChange: function fileInputChange() {
	      var ident = this.id || this.name;
	      this.myFiles = document.getElementById(ident).files;
	      this.$dispatch('onFileChange', this.myFiles);
	      if (this.validateFiles(this.myFiles)) {
	        this.fileUpload();
	      }
	    },
	    _onProgress: function _onProgress(e) {
	      e.percent = e.loaded / e.total * 100;
	      this.$dispatch('onFileProgress', e);
	    },
	    _handleUpload: function _handleUpload(file) {
	      this.$dispatch('beforeFileUpload', file);
	      var form = new window.FormData();
	      var xhr = new window.XMLHttpRequest();
	      try {
	        form.append('Content-Type', file.type || 'application/octet-stream');
	
	        form.append('file', file);
	      } catch (err) {
	        this.$dispatch('onFileError', file, err);
	        return;
	      }
	      return new _promise2.default(function (resolve, reject) {
	        xhr.upload.addEventListener('progress', this._onProgress, false);
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState < 4) {
	            return;
	          }
	          if (xhr.status < 400) {
	            var res = xhr.responseText;
	            var newFile = {
	              name: res,
	              size: file.size,
	              type: file.type,
	              lastModifiedDate: file.lastModifiedDate
	            };
	            this.value.push(newFile);
	            this.$dispatch('onFileUpload', newFile, res);
	            resolve(file);
	          } else {
	            var err = xhr.responseText;
	            this.$dispatch('onFileError', file, err);
	            reject(err);
	          }
	        }.bind(this);
	
	        xhr.onerror = function () {
	          var err = JSON.parse(xhr.responseText);
	          this.$dispatch('onFileError', file, err);
	          reject(err);
	        }.bind(this);
	
	        xhr.open(this.method || 'POST', this.action, true);
	        if (this.headers) {
	          for (var header in this.headers) {
	            xhr.setRequestHeader(header, this.headers[header]);
	          }
	        }
	        xhr.send(form);
	        this.$dispatch('afterFileUpload', file);
	      }.bind(this));
	    },
	    fileUpload: function fileUpload() {
	      if (this.myFiles.length > 0) {
	        var arrayOfPromises = Array.prototype.slice.call(this.myFiles, 0).map(function (file) {
	          return this._handleUpload(file);
	        }.bind(this));
	
	        _promise2.default.all(arrayOfPromises).then(function (allFiles) {
	          this.$dispatch('onAllFilesUploaded', allFiles);
	        }.bind(this)).catch(function (err) {
	          this.$dispatch('onFileError', this.myFiles, err);
	        }.bind(this));
	      } else {
	        var err = new Error('No files to upload for this field');
	        this.$dispatch('onFileError', this.myFiles, err);
	      }
	    }
	  }
	};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _boardHistory = __webpack_require__(110);
	
	var _boardHistory2 = _interopRequireDefault(_boardHistory);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	var timesColor = {
	  white: 1,
	  black: 1
	};
	window.pgn = '';
	window.ground = 0;
	window.pgnBoardBase = 0;
	window.computerGame = 1;
	window.orientationg = 'white';
	exports.default = {
	  name: 'boardVisorEvents',
	  props: {
	    board: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    }
	  },
	  computed: {
	    validBoard: function validBoard() {
	      return Array.isArray(this.board) ? null : this.board;
	    }
	  },
	  data: function data() {
	    return {
	      result: {},
	      boardShow: {},
	      history: [],
	      chess: new _chess2.default(),
	      turn: '',
	      userFrom: '',
	      fen: '',
	      times: {
	        black: 4800,
	        white: 4800,
	        incremento: 30
	      },
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      myFENValue: '',
	      myPGNValue: '',
	      myPGNTimeW: '',
	      myPGNTimeB: '',
	      userChat: _user2.default.user.name,
	      classBoard: ''
	    };
	  },
	
	  components: {
	    BoardHistory: _boardHistory2.default
	  },
	  mixins: [_vueMaterialComponents2.default],
	  events: {
	    move: function move(board) {
	      if (this.boardShow !== undefined && this.boardShow._id === board.idBoard) {
	        if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
	          document.getElementById('searchInput').value = window.pgnBoardBase.getPgn().write_pgn();
	          document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	        }
	
	        document.body.dispatchEvent(new window.Event('chessground.resize'));
	        if (board.user !== undefined) {
	          if (this.boardShow !== undefined && this.boardShow.wins && board.idBoard || board.user.username === this.user.username || board.user.username !== this.boardShow.u1) {
	            return;
	          }
	
	          this.userFrom = board.user.username;
	        }
	        this.changeStateGame(board);
	        if (board.times) {
	          this.times = board.times;
	        }
	      }
	    },
	    gameFinish: function gameFinish(dataResult) {
	      this.stateFinishGame(dataResult);
	    },
	    sendPGNtoTeacher: function sendPGNtoTeacher() {
	      var turn = this.chess.turn() === 'w' ? 'white' : 'black';
	      var data = {
	        c: 'board',
	        f: 'move',
	        data: {
	          event: 'move',
	          data: {
	            pgn: this.myPGNValue,
	            fen: this.myFENValue,
	            idBoard: this.boardShow._id,
	            turn: turn,
	            times: {},
	            user: _user2.default.getUser()
	          }
	        }
	      };
	
	      this.$socket.emit('event', data, function () {});
	      this.userFrom = this.user.username;
	    },
	    analizaPGN: function analizaPGN() {
	      this.$broadcast('modal::open', 'invitePCAnalisis');
	    }
	  },
	  methods: {
	    soundPlay: function soundPlay() {
	      var sonido = document.getElementById('sound');
	      if (sonido) {
	        sonido.play();
	      }
	    },
	    onResize: function onResize(event) {
	      if (document.getElementById('middle') && document.getElementById('pgnBoard')) {
	        var Width = document.getElementById('middle').clientWidth;
	        Width = Width > window.innerHeight - 150 ? window.innerHeight - 150 : Width;
	        var winWidth = Math.min(window.innerWidth, window.outerWidth);
	        var Left = 0;
	        var LeftAnalisis = 0;
	        if (winWidth >= 782) {
	          Width = window.innerHeight - 160 < Width ? window.innerHeight - 160 : Width;
	          if (Width < document.getElementById('middle').clientWidth) {
	            var rightMore = document.getElementById('middle').clientWidth - Width;
	
	            Left = rightMore / 2 + 'px';
	            LeftAnalisis = rightMore / 2 - 3 + 'px';
	          }
	        }
	        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	          Width = Width - 20;
	        }
	        document.getElementById('pgnBoard').style.left = Left;
	        document.getElementById('pgnBoard').style.height = Width + 'px';
	        document.getElementById('pgnBoard').style.width = Width + 'px';
	        document.getElementById('analisisVertical').style.left = LeftAnalisis;
	        document.getElementById('analisisVertical').style.height = Width + 6 + 'px';
	
	        document.body.dispatchEvent(new window.Event('chessground.resize'));
	      }
	    },
	    changeOrientation: function changeOrientation() {
	      window.orientationg = window.orientationg === 'white' ? 'black' : 'white';
	      window.ground.set({
	        orientation: window.orientationg,
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      });
	    },
	    isHumanVsAnalisis: function isHumanVsAnalisis() {
	      return this.board !== undefined && this.board.u1 === this.board.u2;
	    },
	    stateFinishGame: function stateFinishGame(state) {
	      if (state.board._id === this.board._id) {
	        this.result = {
	          wins: state.result.color,
	          motiv: state.result.motiv
	        };
	        clearInterval(timesColor.black);
	        clearInterval(timesColor.white);
	      }
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{\[%emt([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\]\}/gm, '');
	
	      return pgn;
	    },
	    changeStateGame: function changeStateGame(board) {
	      if (board === undefined || board.pgn === '' || board.pgn === 'none') {
	        return;
	      }
	
	      this.chessToColor(this.chess);
	
	
	      if (document.getElementById('pgnMovesEvents')) {
	        document.getElementById('pgnMovesEvents').textContent = '';
	      }
	      if (document.getElementById('pgnButtons')) {
	        document.getElementById('pgnButtons').textContent = '';
	      }
	      if (document.getElementById('pgnComment')) {
	        document.getElementById('pgnComment').textContent = '';
	      }
	      if (document.getElementById('pgnHeader')) {
	        document.getElementById('pgnHeader').textContent = '';
	      }
	      if (document.getElementById('pgnError')) {
	        document.getElementById('pgnError').textContent = '';
	      }
	      var Width = document.getElementById('middle').clientWidth;
	      Width = Width > window.innerHeight - 150 ? window.innerHeight - 150 : Width;
	      var winWidth = Math.min(window.innerWidth, window.outerWidth);
	      var Left = 0;
	      var LeftAnalisis = 0;
	      if (winWidth >= 782) {
	        Width = window.innerHeight - 160 < Width ? window.innerHeight - 160 : Width;
	        if (Width < document.getElementById('middle').clientWidth) {
	          var rightMore = document.getElementById('middle').clientWidth - Width;
	
	          Left = rightMore / 2 + 'px';
	          LeftAnalisis = rightMore / 2 - 3 + 'px';
	        }
	      }
	      if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	        Width = Width - 20;
	      }
	      var pgnBoard = 0;
	
	      var pos = '';
	      if (board.fen !== undefined) {
	        pos = board.fen;
	      } else {
	        pos = '';
	      }
	      if (pos === 'start') {
	        pos = '';
	      }
	
	      if (board.pgn !== 'none') {
	        pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMovesEvents', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { pgn: board.pgn, startPlay: pos, position: 'end', width: Width, locale: 'es', orientation: 'white', coordsFactor: 0.5, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal' });
	      } else {
	        pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMovesEvents', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { width: Width, position: 'start', movesWidth: '80%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: 'white', coordsFactor: 0.5, coordsInner: winWidth < 782, headers: true, timeAnnotation: 'timeNormal' });
	      }
	
	      window.pgnBoardBase = pgnBoard.boardBase;
	      window.ground = pgnBoard.board;
	
	      document.getElementById('pgnBoard').style.left = Left;
	      document.getElementById('analisisVertical').style.left = LeftAnalisis;
	      document.getElementById('analisisVertical').style.height = Width + 6 + 'px';
	    },
	    changePGN: function changePGN() {
	      var turn = this.chess.turn() === 'w' ? 'white' : 'black';
	      var data = {
	        c: 'board',
	        f: 'move',
	        data: {
	          event: 'move',
	          data: {
	            urls: this.board.urls,
	            pgn: this.myPGNValue,
	            fen: this.myFENValue,
	            idBoard: this.board._id,
	            turn: turn,
	            times: {},
	            user: _user2.default.getUser()
	          }
	        }
	      };
	
	      this.$socket.emit('event', data, function () {});
	    },
	    isOwner: function isOwner() {
	      return this.user.username === this.board.u1 || this.user.username === this.board.u2;
	    },
	    countDown: function countDown() {
	      clearInterval(timesColor[this.turn]);
	      timesColor[this.turn] = setInterval(function () {
	        this.times[this.turn] = this.times[this.turn] - 1;
	        if (this.times[this.turn] <= 0) {
	          clearInterval(timesColor.white);
	          clearInterval(timesColor.black);
	          this.times[this.turn] = 0;
	        }
	      }.bind(this), 1000);
	    },
	    chessToColor: function chessToColor(chess) {
	      var t = chess.turn();
	      this.turn = t === 'w' ? 'white' : 'black';
	    },
	    getRandomInt: function getRandomInt(min, max) {
	      min = Math.ceil(min);
	      max = Math.floor(max);
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    },
	    loadDataGame: function loadDataGame(board) {
	      clearInterval(timesColor.white);
	      clearInterval(timesColor.black);
	
	      this.boardShow = board;
	      if (board && board.wins) {
	        this.boardShow = board;
	
	        this.changeStateGame(board);
	
	        this.$nextTick(function () {
	          var buttonLast = document.getElementById('pgnButtonslast');
	          if (buttonLast) {
	            buttonLast.click();
	            if (document.getElementById('searchInput')) {
	              document.getElementById('searchInput').value = this.myFENValue;
	              if (document.getElementById('analisisModal').style.display !== 'none') {
	                document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	              }
	            }
	          }
	        });
	        return;
	      }
	
	      if (board && board.type === 'torneo') {
	        this.boardShow = board;
	        this.changeStateGame(board);
	        this.$nextTick(function () {
	          var buttonLast = document.getElementById('pgnButtonslast');
	          if (buttonLast) {
	            buttonLast.click();
	            if (document.getElementById('searchInput')) {
	              document.getElementById('searchInput').value = this.myFENValue;
	              if (document.getElementById('analisisModal').style.display !== 'none') {
	                document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	              }
	            }
	          }
	        });
	      } else {
	        var data = {
	          c: 'board',
	          f: 'getBoard',
	          data: board
	        };
	
	        this.$socket.emit('event', data, function () {
	          for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	            callbacks[_key] = arguments[_key];
	          }
	
	          if (!callbacks[0]) {
	            var board = callbacks[1].board;
	            this.boardShow = board;
	            this.times = callbacks[1].times;
	
	            this.changeStateGame(board);
	            this.$nextTick(function () {
	              var buttonLast = document.getElementById('pgnButtonslast');
	              if (buttonLast) {
	                buttonLast.click();
	              }
	            });
	            this.countDown();
	          } else {
	            return;
	          }
	        }.bind(this));
	      }
	    }
	  },
	  watch: {
	    board: function board(newVal, oldVal) {
	      if (this.boardShow !== undefined && newVal !== oldVal) {
	        this.loadDataGame(newVal);
	        this.result = {
	          wins: '',
	          motiv: ''
	        };
	      }
	    },
	    myPGNValue: function myPGNValue(val, oldVal) {
	      if (this.isOwner() && this.board.u1 === this.board.u2 && val !== oldVal) {
	        this.changePGN();
	      }
	    },
	    myPGNTimeW: function myPGNTimeW(val, oldVal) {
	      var a = val.split(':');
	      var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
	
	      this.times['white'] = seconds;
	      if (this.boardShow !== undefined && !this.boardShow.wins) {
	        this.countDown();
	      }
	    },
	    myPGNTimeB: function myPGNTimeB(val, oldVal) {
	      var a = val.split(':');
	      var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
	
	      this.times['black'] = seconds;
	      if (this.boardShow !== undefined && !this.boardShow.wins) {
	        this.countDown();
	      }
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      if (document.getElementById('searchInput')) {
	        document.getElementById('searchInput').value = val;
	
	        document.getElementById('myFENValueP').textContent = val;
	        if (document.getElementById('analisisModal').style.display !== 'none') {
	          document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	        }
	      }
	
	      if (this.boardShow !== undefined && this.board.u1 === this.board.u2 && val !== oldVal && this.userFrom !== this.boardShow.u1 && this.userFrom === this.user.username) {}
	      if (window.pgnBoardBase.chess !== undefined) {
	        this.turn = window.pgnBoardBase.chess.turn() === 'w' ? 'white' : 'black';
	      }
	    },
	    turn: function turn(newVal, oldVal) {
	      clearInterval(timesColor[oldVal]);
	      clearInterval(timesColor[newVal]);
	      if (this.boardShow !== undefined && !this.boardShow.wins) {
	        this.countDown();
	      }
	    },
	
	    immediate: true
	  },
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	    clearTimeout(window.computerGame);
	    clearInterval(timesColor.white);
	    clearInterval(timesColor.black);
	  }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  name: 'BoardVisorSmallEvents',
	  props: {
	    game: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      turnSmall: 'borderWhite'
	    };
	  },
	
	  components: {},
	  mixins: [],
	  events: {
	    updateBoard: function updateBoard(board) {
	      if (this.game._id === board._id) {
	        var diff = this.getDifference(board.pgn, this.game.pgn);
	        if (diff.length > 0) {
	          this.loadDataGame(board);
	          this.game = this.clone(board);
	        }
	      }
	    }
	  },
	  methods: {
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    getDifference: function getDifference(string1, string2) {
	      var differences = [];
	      var maxLength = Math.max(string1.length, string2.length);
	      for (var i = 0; i < maxLength; i++) {
	        var char1 = string1[i] || '';
	        var char2 = string2[i] || '';
	        if (char1 !== char2) {
	          differences.push({
	            position: i,
	            char1: char1 || '∅',
	            char2: char2 || '∅' });
	        }
	      }
	      return differences;
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{\[%emt([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\]\}/gm, '');
	      pgn = pgn.replace('\r\n\r\n', '\n');
	
	      return pgn;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    changeStateGame: function changeStateGame(pgn, id, fen) {
	      if (document.getElementById(id + '-middlesmall') !== null) {
	        if (this.game.result === undefined || this.game.result === '*' || this.game.result !== '*' || this.game.all === 'true' || this.game.broadcast === 'true') {
	          var Width = 170;
	          var pos = 'end';
	          var start = fen !== undefined ? fen : '';
	          var pgnBoard = 0;
	
	          var headers = this.parse_pgn_header(pgn);
	          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	            pos = fen !== undefined ? fen : 'end';
	            if (!this.hasBody(pgn)) {
	              start = '';
	              pos = headers['FEN'];
	            }
	            if (pos === headers['FEN']) {
	              start = '';
	            }
	          }
	          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	            start = '';
	            pos = fen;
	          }
	          if (start === headers['FEN']) {
	            start = '';
	          }
	          try {
	            if (Width > 0 && pgn !== 'none' && pgn !== '' && typeof window.pgnView === 'function' && this.hasBody(pgn)) {
	              pgnBoard = window.pgnView({ inner: id + '-boardsmall' }, { pgn: pgn, startPlay: start, position: pos, showCoords: false, width: Width });
	            } else {
	              pgnBoard = window.pgnView({ inner: id + '-boardsmall' }, { pgn: '', position: '', showCoords: false, width: Width });
	            }
	
	            if (pgnBoard && pgnBoard.chess) {
	              this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack';
	            }
	            var comments = document.querySelectorAll('.afterComment');
	            comments.forEach(function (comment) {
	              var textResource = comment.textContent.toLowerCase();
	              if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	                comment.closest('.move').classList.add('highlight-move');
	              }
	            });
	          } catch (error) {
	            console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000);
	          }
	        }
	      }
	    },
	    loadDataGame: function loadDataGame(board) {
	      this.changeStateGame(board.pgn, board._id ? board._id : board.id, 'end');
	    }
	  },
	  watch: {
	    game: function game(newVal, oldVal) {
	      if (newVal.pgn !== oldVal.pgn) {
	        this.loadDataGame(newVal);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.game !== undefined) {
	      this.game._id = this.game._id ? this.game._id : this.game.id;
	    }
	  },
	  beforeCreate: function beforeCreate() {},
	  created: function created() {
	    this.game._id = this.game._id ? this.game._id : this.game.id;
	
	    setTimeout(function () {
	      if (this.game !== undefined) {
	        this.game._id = this.game._id ? this.game._id : this.game.id;
	        this.loadDataGame(this.game);
	      }
	    }.bind(this), 50);
	  },
	  init: function init() {},
	  updated: function updated() {},
	  destroyed: function destroyed() {}
	};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _imul = __webpack_require__(338);
	
	var _imul2 = _interopRequireDefault(_imul);
	
	var _toConsumableArray2 = __webpack_require__(75);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(74);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _bodyMen = __webpack_require__(69);
	
	var _bodyMen2 = _interopRequireDefault(_bodyMen);
	
	var _boardVisorEvents = __webpack_require__(531);
	
	var _boardVisorEvents2 = _interopRequireDefault(_boardVisorEvents);
	
	var _boardVisorSmallEvents = __webpack_require__(532);
	
	var _boardVisorSmallEvents2 = _interopRequireDefault(_boardVisorSmallEvents);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var intervalTorneos1 = null;
	var boardname = '';
	
	var lastDateTorneo1 = new Date(new Date().setDate(new Date().getDate() - 1));
	var lastDateTorneo2 = new Date(new Date().setDate(new Date().getDate() - 1));
	var lastDateTorneo3 = new Date(new Date().setDate(new Date().getDate() - 1));
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    }
	  },
	  template: __webpack_require__(516),
	  data: function data() {
	    return {
	      finduser: '',
	      sendToAll: true,
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirServer: _lstorage2.default.get('serverDir'),
	      filesUpload: [],
	      hashFileBoard1: '0000000',
	      hashFileBoard2: '0000000',
	      hashFileBoard3: '0000000',
	      fileProgress: 0,
	      allFilesUploaded: true,
	      offcanvas: false,
	      active: 'boardVisorEvents',
	      activeChat: 'Visor',
	      chatRecibido: false,
	      tab: '0',
	      tabs: [],
	      chattext: '',
	      newEmoji: '',
	      user: _user2.default.user,
	      boards: [],
	      boardFiles: [],
	      boardFilesName: '',
	      boardFiles2: [],
	      boardFilesName2: '',
	      boardFiles3: [],
	      boardFilesName3: '',
	      newboard: {
	        color: 'w',
	        time: '3',
	        contrincante: '',
	        public: true,
	        broadcast: false
	      },
	      userconvert: _lstorage2.default.get('userconvert', {}),
	      mensjGame: [],
	      users: [],
	      usersLength: 0,
	      games: [],
	      board: _lstorage2.default.get('boardSeeEvents', {}),
	      srcVideo1: '',
	      srcVideo2: '',
	      srcVideo3: '',
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: '',
	      boardname: 'none',
	      iFrameSrc: _lstorage2.default.get(boardname) && _lstorage2.default.get('url' + _lstorage2.default.get(boardname)._id) ? _lstorage2.default.get('url' + _lstorage2.default.get(boardname)._id) : ''
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  events: {
	    users: function users(data) {
	      this.users = data.nicknames;
	    },
	    boards: function boards(data) {
	      this.boards = data.boards;
	    },
	    mensaje: function mensaje(data) {
	      if (data.send !== this.user.username) {
	        this.recibeMensaje(data.men, true, false);
	        if (data.men.send !== this.user.username) {
	          this.chatRecibido = true;
	        }
	      }
	    },
	    onFileClick: function onFileClick(file) {},
	    onFileChange: function onFileChange(file) {
	      this.fileProgress = 0;
	      this.allFilesUploaded = false;
	    },
	    beforeFileUpload: function beforeFileUpload(file) {
	      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000);
	    },
	    afterFileUpload: function afterFileUpload(file) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + '</span>', 2000);
	    },
	    onFileProgress: function onFileProgress(progress) {
	      this.fileProgress = parseInt(progress.percent);
	    },
	    onFileUpload: function onFileUpload(file, res) {
	      this.chattext = {
	        name: file.name,
	        size: file.size,
	        type: file.type,
	        lastModifiedDate: file.lastModifiedDate
	      };
	      this.sendMensaje('file');
	    },
	    onFileError: function onFileError(file, res) {
	      this.toast('<span>Error ' + res + '</span>', 3000);
	    },
	    onAllFilesUploaded: function onAllFilesUploaded(files) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + '</span>', 2000);
	
	      this.allFilesUploaded = true;
	    },
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    },
	    mensajeUrl: function mensajeUrl(data) {
	      if (data.men.src.length <= 0) {
	        this.iFrameSrc = '';
	      } else {
	        var initUser = data.men.src.indexOf('usuario=') + 8;
	        var finUser = data.men.src.indexOf('&', initUser);
	        var userOld = data.men.src.substring(initUser, finUser);
	        var src = data.men.src;
	        if (initUser > 0 && finUser > 0) {
	          src = data.men.src.replace(userOld, this.user.username);
	        }
	        var actual = _lstorage2.default.get(boardname) && _lstorage2.default.get('url' + _lstorage2.default.get(boardname)._id) ? _lstorage2.default.get('url' + _lstorage2.default.get(boardname)._id) : '';
	        this.iFrameSrc = src;
	        if (actual !== data.men.src && data.men.id === _lstorage2.default.get(boardname)._id) {
	          _lstorage2.default.set('url' + data.men.id, data.men.src);
	          this.iFrameSrc = src;
	        }
	      }
	    }
	  },
	  props: {},
	  computed: {},
	  components: {
	    BoardVisorEvents: _boardVisorEvents2.default,
	
	    BodyMen: _bodyMen2.default,
	    BoardVisorSmallEvents: _boardVisorSmallEvents2.default
	  },
	  watch: {
	    inmediate: true,
	    newEmoji: function newEmoji(newVal, oldVal) {
	      this.chattext += newVal;
	      document.getElementById('textChatInput').focus();
	    },
	    activeChat: function activeChat(newVal, oldVal) {
	      if (newVal === 'Visor') {
	        this.showBoard(this.board);
	        this.chatRecibido = false;
	      }
	      if (this.activeChat === 'Chat') {
	        this.chatRecibido = false;
	      }
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      document.getElementById('myFENValueP').textContent = val;
	      if (document.getElementById('searchInput')) {
	        document.getElementById('searchInput').value = val;
	        document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	      }
	    }
	  },
	  methods: {
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      return ret;
	    },
	    userScroll: function userScroll(e) {
	      var scrollTop = e.target.scrollTop;
	
	      if (scrollTop === 0) {
	        var post = this.foundTab(this.active);
	
	        var parmsLoad = {
	          user: this.active,
	          board: 'Retransmisión',
	          range: {
	            limit: 100,
	            skip: this.tabs[post].men.length
	          }
	        };
	        this.loadUserConvert(parmsLoad, true);
	      }
	    },
	    getTorneo1: function getTorneo1() {
	      var onlyNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.getTorneos(1) === true) {
	        this.getHeadersFile('../../../static/torneos/live1.pgn', 1, onlyNames);
	        this.$broadcast('modal::open', 'pgnFilesModal');
	      }
	    },
	    getTorneo2: function getTorneo2() {
	      var onlyNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.getTorneos(2) === true) {
	        this.getHeadersFile('../../../static/torneos/live2.pgn', 2, onlyNames);
	        this.$broadcast('modal::open', 'pgnFilesModal');
	      }
	    },
	    getTorneo3: function getTorneo3() {
	      var onlyNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (this.getTorneos(3) === true) {
	        this.getHeadersFile('../../../static/torneos/live3.pgn', 3, onlyNames);
	        this.$broadcast('modal::open', 'pgnFilesModal');
	      }
	    },
	    toogleOfCanvas: function toogleOfCanvas() {
	      this.offcanvas = !this.offcanvas;
	    },
	    isOwner: function isOwner() {
	      return this.user.username === this.board.u1 || this.user.username === this.board.u2;
	    },
	    getHeadersFile: function getHeadersFile(strFile, number) {
	      var onlyNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var _self = this;
	      var oReq = new window.XMLHttpRequest();
	      oReq.open('GET', strFile, true);
	      oReq.onreadystatechange = function () {
	        if (oReq.readyState === 4) {
	          if (oReq.status === 200) {
	            var fileStr = this.responseText;
	
	            var mtime = new Date(oReq.getResponseHeader('Last-Modified'));
	            if (number === 1 && mtime > _self.lastDateTorneo1) {
	              _self.lastDateTorneo1 = mtime;
	              if (onlyNames === false) {
	                _self.parsePgnFiles(fileStr, true, number);
	              } else {
	                _self.boardFilesName = _self.generateHeader(fileStr, false);
	                _self.activeBoardName = _self.boardFilesName;
	              }
	            } else if (number === 2 && mtime > _self.lastDateTorneo3) {
	              _self.lastDateTorneo2 = mtime;
	              if (onlyNames === false) {
	                _self.parsePgnFiles(fileStr, true, number);
	              } else {
	                _self.boardFilesName2 = _self.generateHeader(fileStr, false);
	                _self.activeBoardName = _self.boardFilesName2;
	              }
	            } else if (number === 3 && mtime > _self.lastDateTorneo3) {
	              _self.lastDateTorneo3 = mtime;
	              if (onlyNames === false) {
	                _self.parsePgnFiles(fileStr, true, number);
	              } else {
	                _self.boardFilesName3 = _self.generateHeader(fileStr, false);
	                _self.activeBoardName = _self.boardFilesName3;
	              }
	            }
	          }
	        }
	      };
	      oReq.send();
	    },
	    OpenTorneo: function OpenTorneo(number) {
	      var url = '../../../static/torneos/livelink' + number + '.txt';
	      fetch(url).then(function (response) {
	        if (!response.ok) {
	          return;
	        }
	        return response.text();
	      }).then(function (responseText) {
	        if (responseText) {
	          var handler = window.open(responseText);
	          if (handler) {
	            handler.focus();
	            if (window.opener !== null) {
	              setTimeout(function () {
	                window.opener.focus();
	              }, 3000);
	            }
	          }
	        }
	      }).catch(function (error) {
	        console.error('Fetch error:', error);
	      });
	    },
	    ShowTorneo: function ShowTorneo(idTorneo) {
	      var x1 = document.getElementById('idTorneo1');
	      if (x1 !== undefined && x1 !== null) {
	        x1.style.display = 'none';
	      }
	      var x2 = document.getElementById('idTorneo2');
	      if (x2 !== undefined && x2 !== null) {
	        x2.style.display = 'none';
	      }
	      var x3 = document.getElementById('idTorneo3');
	      if (x3 !== undefined && x3 !== null) {
	        x3.style.display = 'none';
	      }
	      var x = document.getElementById(idTorneo);
	      if (x !== undefined && x !== null) {
	        if (x.style.display === 'none') {
	          x.style.display = 'flex';
	        } else {
	          x.style.display = 'none';
	        }
	      }
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    isHumanVsPC: function isHumanVsPC() {
	      return this.board !== undefined && this.board.u1 === 'PC' || this.board.u2 === 'PC';
	    },
	    isHumanVsAnalisis: function isHumanVsAnalisis() {
	      return this.board !== undefined && this.board.u1 === this.board.u2;
	    },
	    imagePersona: function imagePersona(persona) {
	      var name = persona.toLowerCase();
	
	      var commaIndex = name.indexOf(',');
	      var spaceIndex = name.indexOf(' ');
	
	      var cutIndex = commaIndex > -1 ? commaIndex : spaceIndex;
	      cutIndex = cutIndex > -1 && spaceIndex > -1 ? Math.min(commaIndex, spaceIndex) : cutIndex;
	
	      if (cutIndex > -1) {
	        name = name.substring(0, cutIndex);
	      }
	      var ret = '';
	      try {
	        ret = __webpack_require__(580)("./" + name + '.jpg');
	        ret = '../../../static/images/personas/' + name + '.jpg';
	      } catch (e) {
	        ret = '../../../static/images/personas/default.png';
	      }
	      return ret;
	    },
	    generateHeader: function generateHeader(pgnFile) {
	      var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var onlyNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var retHeader = '';
	
	      var headers = this.parse_pgn_header(pgnFile);
	      if (headers !== undefined && headers['Event'] !== undefined) {
	        var appendHeader = function appendHeader(result, headers, separator) {
	          if (headers && headers.length > 0) {
	            if (result.length > 0) {
	              result += separator;
	            }
	            result += headers;
	          }
	          return result;
	        };
	        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']];
	        if (complete) {
	          retHeader = '' + headers['White'] + ' vs ' + headers['Black'];
	          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']];
	        }
	        if (onlyNames) {
	          if (headers['Round'] !== undefined) {
	            retHeader += headers['Round'] + ' ' + headers['White'] + ' vs ' + headers['Black'];
	          } else {
	            retHeader += headers['White'] + ' vs ' + headers['Black'];
	          }
	          if (headers['Result'] !== '*') {
	            retHeader += ' [' + headers['Result'] + ']';
	          }
	          hh = [];
	        }
	        if (hh.length > 1) {
	          var rest = '';
	          retHeader += ' (';
	          hh.forEach(function (headers) {
	            rest = appendHeader(rest, headers, ' | ');
	          });
	          retHeader += rest;
	          retHeader += ')';
	        }
	      }
	
	      return retHeader;
	    },
	    openTab: function openTab(user) {
	      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var tabConvert = {
	        name: user.nickname,
	        idTab: user.nickname,
	        men: []
	      };
	      if (!this.foundTab(tabConvert.idTab)) {
	        this.tabs.push(tabConvert);
	      }
	      if (active) {
	        this.active = tabConvert.idTab;
	      }
	    },
	    foundTab: function foundTab(tab) {
	      for (var i in this.tabs) {
	        if (this.tabs[i].idTab === tab) {
	          return i;
	        }
	      }
	      return false;
	    },
	    closeTab: function closeTab(tab) {
	      var post = this.foundTab(tab);
	      this.tabs.splice(post, 1);
	      if (this.tabs.length === 0) {
	        this.active = 'boardVisorEvents';
	      } else {
	        if (this.active === this.tabs[this.tabs.length - 1].idTab) {
	          this.active = 'nnn';
	        }
	        setTimeout(function () {
	          this.active = this.tabs[this.tabs.length - 1].idTab;
	        }.bind(this), 200);
	      }
	      var data = {
	        c: 'chat',
	        f: 'removeConversation',
	        data: {
	          user: _user2.default.getUser().username,
	          conver: tab
	        }
	      };
	      this.$socket.emit('event', data, function () {});
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    showBoard: function showBoard(boardParam) {
	      var bSame = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (boardParam !== undefined && (bSame === false || boardParam._id === this.board._id)) {
	        this.board = this.clone(boardParam);
	
	        _lstorage2.default.set('boardSeeEvents', boardParam);
	        this.active = 'boardVisorEvents';
	      }
	    },
	    desactiveBoard: function desactiveBoard() {
	      this.board = {};
	      setTimeout(function () {
	        this.active = 'boardVisorEvents';
	      }.bind(this), 100);
	    },
	    sendMensaje: function sendMensaje() {
	      if (this.chattext === '') {
	        return;
	      }
	      var thisUser = this.user.username;
	      var otherUser = this.board.u1 === thisUser ? this.board.u2 : this.board.u1;
	      if (this.userconvert.username || this.userconvert.nickname) {
	        otherUser = this.userconvert.username || this.userconvert.nickname;
	      }
	      if (otherUser === 'PC') {
	        return;
	      }
	
	      var men = {
	        body: this.chattext,
	        type: 'text',
	        public: this.sendToAll,
	        all: this.board.all,
	        club: this.user.club,
	        board: 'Retransmisión',
	        send: thisUser,
	        recibe: thisUser
	      };
	      var data = {
	        c: 'chat',
	        f: 'mensaje',
	        data: {
	          men: men
	        }
	      };
	
	      this.$socket.emit('event', data, function () {});
	      this.chattext = '';
	      this.isAtBottom();
	    },
	    userToSentTo: function userToSentTo(user, toSend) {
	      _user2.default.get(this, user.nickname).then(function (response) {
	        var dd = JSON.parse(response);
	        var somedata = dd;
	
	        somedata.sendtoanalyse = toSend;
	        this.usersSendTo = somedata;
	        this.$nextTick(function () {
	          this.sendSendActivate(somedata);
	        });
	      }, function (response) {});
	    },
	    userToConversation: function userToConversation(user) {
	      this.userconvert = user;
	      this.$broadcast('modal::close', 'some', 'usersConnect');
	    },
	    isAtBottom: function isAtBottom() {
	      var chatConvert = document.getElementById('chatConvertGame');
	      if (chatConvert) {
	        this.scrollBottom();
	      }
	    },
	    scrollBottom: function scrollBottom() {
	      if ((0, _jquery2.default)('#chatConvertGame')) {
	        (0, _jquery2.default)('#chatConvertGame').animate({
	          'scrollTop': (0, _jquery2.default)('#chatConvertGame')[0].scrollHeight
	        }, 'fast');
	      }
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === 'Retransmisión') {
	        this.mensjGame.push(men);
	        if (bottom) {
	          this.isAtBottom();
	        }
	      }
	      if (toast === true) {
	        if (men.send !== _user2.default.getUser().username) {
	          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000);
	        }
	      }
	    },
	    checkImage: function checkImage(url) {
	      return url.match(/\.(jpeg|jpg|gif|png)$/) !== null;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      return _lstorage2.default.get('serverDir') + '/uploads/' + name;
	    },
	    resizeBoard: function resizeBoard() {
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    },
	    loadOtherUser: function loadOtherUser(otherUser, next) {
	      if (otherUser !== 'PC') {
	        _user2.default.get(this, otherUser).then(function (response) {
	          var dd = JSON.parse(response);
	          var somedata = dd;
	          next(somedata);
	        }, function (response) {});
	      } else {
	        next({
	          image: 'Droid-Robot-512.png'
	        });
	      }
	    },
	    wellCome: function wellCome() {},
	    hasBoards: function hasBoards() {
	      var bBoards = false;
	      for (var i in this.boards) {
	        if (this.boards[i].broadcast === 'true') {
	          bBoards = true;
	          break;
	        }
	      }
	      return bBoards;
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{(?!(?:[\0-z\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*clk)(?:[\0-z\|~-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\}/gm, '');
	
	      return pgn;
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = decodeURIComponent(escape(strParam));
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    update: function update(arr, id, updatedData) {
	      return arr.map(function (item) {
	        return item.id === id ? (0, _extends3.default)({}, item, updatedData) : item;
	      });
	    },
	    parsePgnFiles: function parsePgnFiles(file) {
	      var noFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var number = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var max = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 14;
	
	      var newlineChar = '\r?\n';
	      var filesObj = [];
	      file = this.prettyPgn(file);
	      file = this.deleteComment(file);
	      var lines = file.split(new RegExp(newlineChar));
	      var pgntext = '';
	      var state = 0;
	      var board = {};
	      var headers = {};
	      var hashCode = '';
	      for (var i = 0; i < lines.length; i++) {
	        if (lines[i].length > 0) {
	          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
	            if (state === 1) {
	              headers = this.parse_pgn_header(pgntext);
	              hashCode = this.cyrb53(this.generateHeader(pgntext, true));
	              board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '', result: headers['Result'], round: headers['Round'] };
	              if (noFinish === true || headers['Result'] === '*') {
	                  if (this.hasBody(pgntext)) {
	                    filesObj.push(board);
	                  }
	                }
	              pgntext = '';
	            }
	            state = 0;
	          } else state = 1;
	          if (state === 0) pgntext += lines[i] + '\n';else pgntext += lines[i] + ' ';
	        }
	      }
	      headers = this.parse_pgn_header(pgntext);
	      hashCode = this.cyrb53(this.generateHeader(pgntext, true));
	      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '', result: headers['Result'], round: headers['Round'] };
	      if (noFinish === true || headers['Result'] === '*') filesObj.push(board);
	      if (number === 2) {
	        if (headers['Event'] && headers['Event'].length > 0 || headers['Site'] && headers['Site'].length > 0) {
	          setTimeout(function () {
	            var _this = this;
	
	            if (!this.boardFiles2 || this.boardFiles2.length <= 0) this.boardFiles2 = this.clone(filesObj);else {
	              this.boardFiles2.forEach(function (e, i) {
	                if (_this.hasBody(e.pgn) && filesObj[i] !== undefined && e._id === filesObj[i]._id) {
	                  if (_this.boardFiles2[i].pgn !== filesObj[i].pgn) {
	                    _this.boardFiles2[i].pgn = filesObj[i].pgn;
	                    _this.$broadcast('updateBoard', _this.boardFiles2[i]);
	                  }
	                }
	              });
	            }
	            this.boardFilesName2 = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date'];
	          }.bind(this), 500);
	        }
	      } else if (number === 3) {
	        if (headers['Event'] && headers['Event'].length > 0 || headers['Site'] && headers['Site'].length > 0) {
	          setTimeout(function () {
	            var _this2 = this;
	
	            if (!this.boardFiles3 || this.boardFiles3.length <= 0) this.boardFiles3 = this.clone(filesObj);else {
	              this.boardFiles3.forEach(function (e, i) {
	                if (_this2.hasBody(e.pgn) && filesObj[i] !== undefined && e._id === filesObj[i]._id) {
	                  if (_this2.boardFiles3[i].pgn !== filesObj[i].pgn) {
	                    _this2.boardFiles3 = _this2.clone(filesObj);
	                    _this2.boardFiles3[i].pgn = filesObj[i].pgn;
	                    _this2.$broadcast('updateBoard', _this2.boardFiles3[i]);
	                  }
	                }
	              });
	            }
	            this.boardFilesName3 = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date'];
	          }.bind(this), 500);
	        }
	      } else if (number === 1) {
	        if (headers['Event'] && headers['Event'].length > 0 || headers['Site'] && headers['Site'].length > 0) {
	          setTimeout(function () {
	            var _this3 = this;
	
	            if (!this.boardFiles || this.boardFiles.length <= 0) this.boardFiles = this.clone(filesObj);else {
	              this.boardFiles.forEach(function (e, i) {
	                if (_this3.hasBody(e.pgn) && filesObj[i] !== undefined && e._id === filesObj[i]._id) {
	                  if (_this3.boardFiles[i].pgn !== filesObj[i].pgn) {
	                    _this3.boardFiles = _this3.clone(filesObj);
	                    _this3.boardFiles[i].pgn = filesObj[i].pgn;
	                    _this3.$broadcast('updateBoard', _this3.boardFiles[i]);
	                  }
	                }
	              });
	            }
	            this.boardFilesName = headers['Event'] + ' | ' + headers['Site'] + ' | ' + headers['Round'] + ' | ' + headers['Date'];
	          }.bind(this), 500);
	        }
	      }
	      filesObj = [].concat((0, _toConsumableArray3.default)(filesObj)).reverse();
	      filesObj = filesObj.slice(0, max);
	      return filesObj;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    changePGNTextArea: function changePGNTextArea() {
	      var idTextArea = document.getElementById('idTextAreaPGN');
	      if (idTextArea && idTextArea.value !== 'none') {
	        var pgnAux = idTextArea.value;
	        pgnAux = this.prettyPgn(pgnAux);
	        pgnAux = this.deleteComment(pgnAux);
	        this.myPGNValue = pgnAux;
	
	        var headers = this.parse_pgn_header(idTextArea.value);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          this.myFENValue = headers['FEN'];
	        }
	
	        var data = {
	          c: 'board',
	          f: 'move',
	          data: {
	            event: 'move',
	            data: {
	              urls: this.board.urls,
	              pgn: this.myPGNValue,
	              fen: this.myFENValue,
	              idBoard: this.board._id,
	
	              times: {},
	              user: _user2.default.getUser()
	            }
	          }
	        };
	        this.$socket.emit('event', data, function () {});
	
	        idTextArea.value = '';
	        var buttonLast = document.getElementById('pgnButtonslast');
	        if (buttonLast) {
	          buttonLast.click();
	        }
	      }
	    },
	    openPGN: function openPGN(pgnText) {
	      var output = document.getElementById('idTextAreaPGN');
	      var idFEN = document.getElementById('myFENValue');
	      output.value = pgnText;
	      idFEN.value = '';
	      idFEN.textContent = '';
	      idFEN.dispatchEvent(new window.Event('input'));
	      output.dispatchEvent(new window.Event('change'));
	      this.$broadcast('modal::close', 'some', 'pgnFilesModal');
	
	      setTimeout(function () {
	        document.getElementById('pgnButtonslast').click();
	      }, 100);
	    },
	    cyrb53: function cyrb53(str) {
	      var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      var h1 = 0xdeadbeef ^ seed;
	      var h2 = 0x41c6ce57 ^ seed;
	      for (var i = 0, ch; i < str.length; i++) {
	        ch = str.charCodeAt(i);
	        h1 = (0, _imul2.default)(h1 ^ ch, 2654435761);
	        h2 = (0, _imul2.default)(h2 ^ ch, 1597334677);
	      }
	      h1 = (0, _imul2.default)(h1 ^ h1 >>> 16, 2246822507) ^ (0, _imul2.default)(h2 ^ h2 >>> 13, 3266489909);
	      h2 = (0, _imul2.default)(h2 ^ h2 >>> 16, 2246822507) ^ (0, _imul2.default)(h1 ^ h1 >>> 13, 3266489909);
	      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
	    },
	    hashCode5: function hashCode5(string) {
	      var hash = 5;
	      if (string.length === 5) {
	        return hash;
	      }
	      for (var a = 5; a < string.length; a++) {
	        var ch = string.charCodeAt(a);
	        hash = (hash << 5) - hash + ch;
	        hash = hash & hash;
	      }
	      return Math.random();
	    },
	    hashCode: function hashCode(s) {
	      var h = 0;
	      var l = s.length;
	      var i = 0;
	      if (l > 0) {
	        while (i < l) {
	          h = (h << 5) - h + s.charCodeAt(i++) | 0;
	        }
	      }
	      var hexString = h.toString(16);
	      return hexString;
	    },
	    getVideoTorneos: function getVideoTorneos(number) {
	      var _self = this;
	      var url = '../../../static/torneos/livevideo' + number + '.txt';
	      fetch(url).then(function (response) {
	        if (!response.ok) {
	          return;
	        }
	        return response.text();
	      }).then(function (responseText) {
	        if (responseText) {
	          if (number === 1) {
	            _self.srcVideo1 = responseText;
	          } else if (number === 2) {
	            _self.srcVideo2 = responseText;
	          } else if (number === 3) {
	            _self.srcVideo3 = responseText;
	          }
	        }
	      }).catch(function (error) {
	        console.error('Fetch error:', error);
	      });
	    },
	    getTorneos: function getTorneos(number) {
	      var ret = true;
	      var _self = this;
	      var url = '../../../static/torneos/live' + number + '.pgn';
	      var options = {};
	      if (number === 1 && lastDateTorneo1 !== null) {
	        options.headers = { 'If-Modified-Since': lastDateTorneo1.toString() };
	      } else if (number === 2 && lastDateTorneo2 !== null) {
	        options.headers = { 'If-Modified-Since': lastDateTorneo2.toString() };
	      } else if (number === 3 && lastDateTorneo3 !== null) {
	        options.headers = { 'If-Modified-Since': lastDateTorneo3.toString() };
	      }
	      fetch(url, options).then(function (response) {
	        if (!response.ok) {
	          ret = false;
	          return;
	        }
	        return response.text().then(function (responseText) {
	          var mtime = new Date(response.headers.get('Last-Modified'));
	          if (number === 1) {
	            lastDateTorneo1 = mtime;
	            setTimeout(function () {
	              _self.boardFiles1 = _self.parsePgnFiles(responseText, true, number);
	            }, 200);
	          } else if (number === 3) {
	            lastDateTorneo3 = mtime;
	            setTimeout(function () {
	              _self.boardFiles3 = _self.parsePgnFiles(responseText, true, number);
	            }, 200);
	          } else if (number === 2) {
	            lastDateTorneo2 = mtime;
	            setTimeout(function () {
	              _self.boardFiles1 = _self.parsePgnFiles(responseText, true, number);
	            }, 200);
	          }
	        });
	      }).catch(function (error) {
	        console.error('Fetch error:', error);
	        ret = false;
	      });
	      return ret;
	    },
	    loadAllData: function loadAllData() {
	      var data = {
	        c: 'chat',
	        f: 'getDataChat',
	        data: {
	          user: _user2.default.getUser()
	        }
	      };
	      setTimeout(function () {
	        this.$socket.emit('event', data, function () {
	          var parmsLoad = {
	            user: this.user,
	            board: 'Retransmisión',
	            range: {
	              limit: 100,
	              skip: 0
	            }
	          };
	          this.loadUserConvert(parmsLoad, false);
	
	          this.isAtBottom();
	
	          for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	            callbacks[_key] = arguments[_key];
	          }
	
	          this.boards = callbacks[1].boards;
	        }.bind(this));
	      }.bind(this), 50);
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var data = {
	        c: 'chat',
	        f: 'loadUserConvert',
	        data: parms
	      };
	
	      this.$socket.emit('event', data, function () {
	        var log = arguments.length <= 1 ? undefined : arguments[1];
	
	        var menLast = '';
	        if (log) {
	          for (var i = log.length - 1; i >= 0; i--) {
	            if (menLast !== log[i].body || menLast === '') {
	              this.recibeMensaje(log[i], false, false);
	              menLast = log[i].body;
	            }
	          }
	        }
	        if (show) {
	          this.isAtBottom();
	        }
	      }.bind(this));
	    },
	    activeWebcam: function activeWebcam() {
	      this.toast('<span>No implement yet</span>', 2000);
	    },
	    inviteChessGame: function inviteChessGame() {
	      this.$broadcast('modal::open', 'inviteGame');
	    },
	    inviteChessGameDirect: function inviteChessGameDirect(user) {
	      this.openTab(user);
	      this.$broadcast('modal::open', 'inviteGame');
	    },
	    createdInviteGame: function createdInviteGame(result) {
	      if (result) {
	        var invite = {
	          type: 'invite',
	          public: this.newboard.public,
	          broadcast: false,
	          all: false,
	          club: _user2.default.getUser().club,
	          time: this.newboard.time,
	          incremento: this.newboard.incremento,
	          recibe: this.active
	        };
	
	        var userActive = _user2.default.getUser().username;
	        var bFound = false;
	        if (this.newboard.contrincante !== '') {
	          for (var i in this.users) {
	            if (this.users[i].nickname === this.newboard.contrincante) {
	              userActive = this.users[i].nickname;
	              bFound = true;
	            }
	          }
	          if (bFound === false) {
	            this.$broadcast('modal::close', 'some', 'inviteGame');
	            return;
	          }
	        }
	        if (this.newboard.color === 'w') {
	          invite.u1 = userActive;
	          invite.u2 = this.active;
	        } else {
	          invite.u2 = userActive;
	          invite.u1 = this.active;
	        }
	        var data = {
	          c: 'board',
	          f: 'inviteGame',
	          data: {
	            event: 'inviteGame',
	            data: invite
	          }
	        };
	        this.toast('<span>' + _vue2.default.t('home.inviteSend') + '</span>', 2000);
	        this.$socket.emit('event', data, function () {});
	      }
	      this.$broadcast('modal::close', 'some', 'inviteGame');
	    }
	  },
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('events.title');
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearInterval(intervalTorneos1);
	  },
	  created: function created() {
	    window.ground = null;
	    lastDateTorneo1 = null;
	    lastDateTorneo2 = null;
	    lastDateTorneo3 = null;
	    clearInterval(intervalTorneos1);
	    intervalTorneos1 = setInterval(function () {
	      var x = document.getElementById('idTorneo1');
	      if (this.boardFilesName.length > 0 && x !== null && x.style.display !== 'none') {
	        if (this.getTorneos(1) === true) {
	          this.getVideoTorneos(1);
	        }
	      }
	      x = document.getElementById('idTorneo2');
	      if (this.boardFilesName2.length > 0 && x !== null && x.style.display !== 'none') {
	        if (this.getTorneos(2) === true) {
	          this.getVideoTorneos(2);
	        }
	      }
	      x = document.getElementById('idTorneo3');
	      if (this.boardFilesName3.length > 0 && x !== null && x.style.display !== 'none') {
	        if (this.getTorneos(3) === true) {
	          this.getVideoTorneos(3);
	        }
	      }
	    }.bind(this), 2000);
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	    this.$nextTick(function () {
	      this.active = 'boardVisorEvents';
	      this.loadAllData();
	      if (this.getTorneos(1) === true) {
	        this.getVideoTorneos(1);
	      }
	      if (this.getTorneos(2) === true) {
	        this.getVideoTorneos(2);
	      }
	      if (this.getTorneos(3) === true) {
	        this.getVideoTorneos(3);
	      }
	    });
	
	    this.$dispatch('userLoguin', 'show data');
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 311 */,
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(337);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _from = __webpack_require__(29);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _uploadFiles = __webpack_require__(537);
	
	var _uploadFiles2 = _interopRequireDefault(_uploadFiles);
	
	var _config = __webpack_require__(22);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	var _openaiutils = __webpack_require__(296);
	
	var _openaiutils2 = _interopRequireDefault(_openaiutils);
	
	var _boardVisorIa = __webpack_require__(535);
	
	var _boardVisorIa2 = _interopRequireDefault(_boardVisorIa);
	
	var _enginegame = __webpack_require__(56);
	
	var _enginegame2 = _interopRequireDefault(_enginegame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	var playEvent = 1;
	exports.default = {
	  name: 'BoardHistory',
	  props: {
	    history: {
	      type: Array
	    },
	    pgn: {
	      type: String
	    },
	    fen: {
	      type: String
	    },
	    user: {},
	    only: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    events: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    sendtoteacher: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    userchat: {
	      type: String
	    },
	    boardid: {
	      type: String,
	      required: false
	    },
	    board: {
	      type: Object,
	      'default': null
	    },
	    active: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    humanvspc: {
	      type: Function,
	      required: false,
	      'default': function _default() {
	        return false;
	      }
	    }
	  },
	  computed: {
	    validBoard: function validBoard() {
	      return Array.isArray(this.board) ? null : this.board;
	    },
	    isParamOnly: function isParamOnly() {
	      return this.only;
	    }
	  },
	  data: function data() {
	    return {
	      speech: null,
	      velo: 2,
	      select: -1,
	      played: false,
	      intervalMouth: null,
	      iframe: {
	        src: window.location.href,
	        style: null,
	        wrapperStyle: null
	      },
	      eval: 0,
	      stockfish: {},
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      classBoard: '',
	      boardView: _lstorage2.default.get('boardView', {}),
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      chess: new _chess2.default(),
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirActionUploadAudio: _lstorage2.default.get('serverDir') + '/chat/uploadaaudio',
	      value: [],
	      dirServer: _lstorage2.default.get('serverDir'),
	      fileProgress: 0,
	      filesUploadHistory: [],
	      urlLinkUpload: '',
	      allFilesUploaded: true,
	      visibleHistory: false,
	      strNameResource: '',
	      enroqueK: true,
	      enroqueQ: true,
	      enroqueq: true,
	      enroquek: true,
	      chkLesson: false,
	      typeLesson: '',
	      nameLesson: '',
	      nameCategory: '',
	      nameAnalysis: '',
	      listaclubs: [],
	      listaVoces: [],
	      myVoiceSelected: _lstorage2.default.get('selectedVoice'),
	      listaVocesSelected: _lstorage2.default.get('selectedVoice'),
	      clubActual: '',
	      clubActual1: '',
	      clubActual2: '',
	      clubs: '',
	      recording: false,
	      airesponse: '',
	      aiquestion: '',
	      timeLeft: 0,
	      mediaRecorder: null,
	      audioChunks: [],
	      audioStream: null,
	      varTextToSpeach: true
	    };
	  },
	
	  components: {
	    UploadFilesLesson: _uploadFiles2.default,
	    BoardVisorIa: _boardVisorIa2.default
	  },
	  mixins: [_vueMaterialComponents2.default],
	  events: {
	    onFileClick: function onFileClick(file) {},
	    onFileChange: function onFileChange(file) {
	      this.fileProgress = 0;
	      this.allFilesUploaded = false;
	    },
	    beforeFileUpload: function beforeFileUpload(file) {
	      this.toast('<span>' + 'Cargando archivo' + '</span>', 2000);
	    },
	    afterFileUpload: function afterFileUpload(file) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + file.name + '</span>', 2000);
	    },
	    onFileProgress: function onFileProgress(progress) {
	      this.fileProgress = parseInt(progress.percent);
	    },
	    hasResource: function hasResource() {
	      var ret = false;
	      var idFEN = document.getElementById('myFENValue');
	      if (this.board.urls !== undefined && this.board.urls.length > 0) {
	        var iFound = this.board.urls.indexOf(idFEN.value);
	        if (iFound >= 0) {
	          ret = true;
	        }
	      }
	      return ret;
	    },
	    onFileUpload: function onFileUpload(file, res) {
	      console.log('onFileUpload', file, res);
	      if (this.strNameResource.length <= 0) {
	        window.swal('Debe rellenar un nombre para el recurso', {
	          buttons: {
	            si: { text: 'Aceptar', value: 'accept' }
	          }
	        }).then(function (resultParam) {});
	        return;
	      }
	
	      var idFEN = document.getElementById('myFENValue');
	      var last = '';
	
	      if (this.board.urls !== undefined && this.board.urls.length > 0) {
	        var iFound = this.board.urls.indexOf(idFEN.value);
	        if (iFound >= 0) {
	          var nInitUrls = iFound + idFEN.value.length + 1;
	          var nFinUrls = this.board.urls.indexOf(';', nInitUrls);
	          last = this.board.urls.substring(nInitUrls, nFinUrls);
	          var nn = '{' + this.strNameResource + '=' + this.dirServer + '/uploads/' + file.name + '}';
	          var nuevo = last + nn;
	
	          this.board.urls = this.board.urls.replace(last, nuevo);
	        }
	      }
	      if (last.length <= 0) {
	        this.board.urls += idFEN.value + '={' + this.strNameResource + '=' + this.dirServer + '/uploads/' + file.name + '};';
	        this.strNameResource = '';
	      }
	
	      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
	        var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value;
	
	        document.querySelector('#pgnComment' + ' textarea.comment').value = oldVal + ' ' + 'RECURSO';
	        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'));
	      }
	    },
	    onFileError: function onFileError(file, res) {
	      this.toast('<span>Error ' + res + '</span>', 3000);
	    },
	    onAllFilesUploaded: function onAllFilesUploaded(files) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + '</span>', 2000);
	
	      this.allFilesUploaded = true;
	      this.$broadcast('modal::close', 'some', 'setResource');
	    }
	  },
	  methods: {
	    setTextToSpeach: function setTextToSpeach() {
	      this.varTextToSpeach = !this.varTextToSpeach;
	      if (this.varTextToSpeach === false) {
	        clearInterval(this.intervalMouth);
	        this.getMouthShape('a');
	        window.speechSynthesis.cancel();
	      }
	    },
	    scrollBottom: function scrollBottom() {
	      var chatContent = document.getElementById('chat-content');
	      if (chatContent) {
	        chatContent.scrollTo({
	          top: chatContent.scrollHeight,
	          behavior: 'smooth'
	        });
	      }
	    },
	    countdown: function countdown() {
	      this.timeLeft--;
	      if (this.timeLeft > 0) {
	        setTimeout(this.countdown, 1000);
	      } else {
	        this.timeLeft = 0;
	        this.mediaRecorder.stop();
	      }
	    },
	    hasComments: function hasComments() {
	      if (document.getElementById('pgnComment')) {
	        return true;
	      }
	
	      return false;
	    },
	    answerIA: function answerIA(message) {
	      var convertido = message.split('\n').join('<br>');
	      var item = '<div class="media media-chat" data-toggle="modal" data-target="#assistantModalCenter">\n                      <div class="media-body">\n                          <p>' + convertido + '</p>\n                      </div>\n                  </div>';
	      return item;
	    },
	    answerUser: function answerUser(message) {
	      var item = '<div class="media media-chat media-chat-reverse">\n                    <div class="media-body">\n                        <p>' + message + '</p>\n                    </div>\n                </div>';
	      return item;
	    },
	    getMouthShape: function getMouthShape(phoneme) {
	      if (document.getElementById('mouth1')) {
	        document.getElementById('mouth1').style.opacity = '0';
	        document.getElementById('mouth2').style.opacity = '0';
	        document.getElementById('mouth3').style.opacity = '0';
	        document.getElementById('mouth4').style.opacity = '0';
	        document.getElementById('tongue').style.opacity = '0';
	        document.getElementById('tongue4').style.opacity = '0';
	
	        var mouthId = 'mouth1';
	        if (['a', 'e'].includes(phoneme)) mouthId = 'mouth2';
	        if (['o', 'u'].includes(phoneme)) mouthId = 'mouth3';
	        if (phoneme === 'i') mouthId = 'mouth4';
	
	        document.getElementById(mouthId).style.opacity = '1';
	
	        if (mouthId === 'mouth3') document.getElementById('tongue').style.opacity = '1';
	        if (mouthId === 'mouth4') document.getElementById('tongue4').style.opacity = '1';
	      }
	    },
	    animateMouth: function animateMouth(text) {
	      var _this = this;
	
	      var index = 0;
	      this.intervalMouth = setInterval(function () {
	        if (index >= text.length) {
	          clearInterval(_this.intervalMouth);
	          _this.getMouthShape('a');
	          return;
	        }
	
	        var phoneme = text[index].toLowerCase();
	        _this.getMouthShape(phoneme);
	        index++;
	      }, 120);
	    },
	    moveHead: function moveHead() {
	      var botSVG = document.getElementById('botSVG');
	      if (botSVG) {
	        botSVG.style.transform = 'translateY(-5px)';
	        setTimeout(function () {
	          botSVG.style.transform = 'translateY(0px)';
	        }, 100);
	      }
	    },
	    animateEyes: function animateEyes() {
	      var leftPupil = document.getElementById('leftPupil');
	      if (leftPupil) {
	        var rightPupil = document.getElementById('rightPupil');
	
	        setInterval(function () {
	          leftPupil.setAttribute('r', '1');
	          rightPupil.setAttribute('r', '1');
	          setTimeout(function () {
	            leftPupil.setAttribute('r', '3');
	            rightPupil.setAttribute('r', '3');
	          }, 150);
	        }, 3000);
	      }
	    },
	    animateEyebrows: function animateEyebrows() {
	      var leftEyebrow = document.getElementById('leftEyebrow');
	      if (leftEyebrow) {
	        var rightEyebrow = document.getElementById('rightEyebrow');
	
	        setInterval(function () {
	          leftEyebrow.setAttribute('y', '65');
	          rightEyebrow.setAttribute('y', '65');
	          setTimeout(function () {
	            leftEyebrow.setAttribute('y', '60');
	            rightEyebrow.setAttribute('y', '60');
	          }, 300);
	        }, 2000);
	      }
	    },
	    startSpeakingAnimation: function startSpeakingAnimation(text) {
	      this.moveHead();
	      this.animateMouth(text);
	      this.animateEyes();
	      this.animateEyebrows();
	    },
	    textToSpeach: function textToSpeach(text) {
	      var _this2 = this;
	
	      if (this.isParamOnly === false || true) {
	        clearInterval(this.intervalMouth);
	        this.getMouthShape('a');
	        window.speechSynthesis.cancel();
	        this.speech = new SpeechSynthesisUtterance(text);
	        var voices = window.speechSynthesis.getVoices();
	        for (var i = 0; i < voices.length; i++) {
	          if (voices[i].name === this.listaVocesSelected) {
	            this.speech.voice = voices[i];
	            break;
	          }
	        }
	
	        this.speech.onstart = function () {
	          _this2.moveHead();
	          _this2.animateMouth(text);
	          _this2.animateEyes();
	          _this2.animateEyebrows();
	        };
	        this.speech.onend = function () {
	          clearInterval(_this2.intervalMouth);
	          _this2.getMouthShape('a');
	        };
	
	        if (this.varTextToSpeach === true) {
	          window.speechSynthesis.speak(this.speech);
	        }
	      }
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = decodeURIComponent(escape(strParam));
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    generateQuestion: function generateQuestion(textArg, pgn) {
	      var _this3 = this;
	
	      try {
	        var conversation = '';
	        var chatContent = document.getElementById('chat-content');
	        if (chatContent) {
	          conversation = chatContent.innerText;
	        }
	        if (chatContent) {
	          chatContent.innerHTML += this.answerUser(textArg);
	          this.scrollBottom();
	        }
	        _openaiutils2.default.generateQuestion(textArg, pgn, conversation).then(function (data) {
	          console.log('Datos recibidos: ', data);
	          var aiResponse = data.choices[0].message.content;
	
	          var match = aiResponse.match(/<<<([\s\S]*?)>>>/);
	          if (match && match[1]) {
	            _this3.pgn = match[1].trim();
	            var prettyPgn = _this3.prettyPgn(_this3.translatePieceCodesInComments(match[1].trim()));
	            _this3.$broadcast('updatePgnIA', prettyPgn);
	          }
	
	          var speechContent = aiResponse;
	          if (match && match[1]) {
	            speechContent = aiResponse.replace(match[1].trim(), '');
	          }
	          speechContent = _this3.convertMovesToSpeechOutsideMarkers(speechContent);
	          if (chatContent) {
	            chatContent.innerHTML += _this3.answerIA(aiResponse);
	            _this3.scrollBottom();
	          }
	          _this3.textToSpeach(speechContent);
	          _this3.habilitarBotones();
	        }).catch(function (error) {
	          console.error('Error al generar texto: ', error);
	          window.swal('Error: ' + error.message);
	          _this3.habilitarBotones();
	        });
	      } catch (error) {
	        console.error('Error: ' + error.message);
	        window.swal('Error: ' + error.message);
	        this.habilitarBotones();
	      }
	    },
	    convertMovesToSpeechOutsideMarkers: function convertMovesToSpeechOutsideMarkers(text) {
	      var _this4 = this;
	
	      var segments = [];
	      var lastIndex = 0;
	
	      var markerRegex = /<<<[\s\S]*?>>>/g;
	      var match = void 0;
	
	      while ((match = markerRegex.exec(text)) !== null) {
	        if (match.index > lastIndex) {
	          segments.push({
	            text: text.substring(lastIndex, match.index),
	            isInsideMarkers: false
	          });
	        }
	
	        segments.push({
	          text: match[0],
	          isInsideMarkers: true
	        });
	        lastIndex = match.index + match[0].length;
	      }
	
	      if (lastIndex < text.length) {
	        segments.push({
	          text: text.substring(lastIndex),
	          isInsideMarkers: false
	        });
	      }
	
	      var processedText = segments.map(function (segment) {
	        if (segment.isInsideMarkers) {
	          return segment.text;
	        } else {
	          return _this4.convertMovesToSpeech(segment.text);
	        }
	      }).join('');
	
	      return processedText;
	    },
	    convertMovesToSpeech: function convertMovesToSpeech(text) {
	      var moveRegex = /\b([KQRBNDTAC]?[a-h]?[1-8]?x?[a-h][1-8](=[QRBNDTAC])?[+#]?|O-O(-O)?)(?=\b|[^a-zA-Z0-9])/g;
	
	      var pieceNames = {
	        K: 'Rey',
	        Q: 'Dama',
	        R: 'Torre',
	        B: 'Alfil',
	        N: 'Caballo'
	      };
	
	      var pieceNamesSpanish = {
	        R: 'Rey',
	        D: 'Dama',
	        T: 'Torre',
	        A: 'Alfil',
	        C: 'Caballo'
	      };
	
	      var files = { a: 'a', b: 'b', c: 'c', d: 'd', e: 'e', f: 'f', g: 'g', h: 'h' };
	      var ranks = { '1': 'uno', '2': 'dos', '3': 'tres', '4': 'cuatro', '5': 'cinco', '6': 'seis', '7': 'siete', '8': 'ocho' };
	
	      var convertedText = text.replace(moveRegex, function (move) {
	        var verbalMove = '';
	
	        if (move === 'O-O') {
	          verbalMove = 'enroque corto';
	        } else if (move === 'O-O-O') {
	          verbalMove = 'enroque largo';
	        } else {
	          var capture = move.includes('x');
	          var promotion = move.includes('=');
	          var check = move.includes('+');
	          var checkmate = move.includes('#');
	
	          move = move.replace(/[+#]/g, '');
	
	          var promotionPiece = '';
	          if (promotion) {
	            var parts = move.split('=');
	            move = parts[0];
	            promotionPiece = parts[1];
	          }
	
	          var piece = '';
	
	          if (/[KQRBN]/.test(move[0])) {
	            piece = pieceNames[move[0]];
	            move = move.slice(1);
	          }
	          if (/[RDTAC]/.test(move[0])) {
	            piece = pieceNamesSpanish[move[0]];
	            move = move.slice(1);
	          }
	
	          var from = '';
	          if (move.length > 2 && !move.startsWith('x')) {
	            if (files[move[0]] || ranks[move[0]]) {
	              from = move[0];
	              move = move.slice(1);
	            }
	          }
	
	          if (capture) {
	            var _parts = move.split('x');
	            if (_parts[0]) {
	              from = _parts[0];
	            }
	            move = _parts[1];
	          }
	
	          var toFile = files[move[0]];
	          var toRank = ranks[move[1]];
	
	          if (capture) {
	            if (from) {
	              verbalMove = piece + ' desde ' + from + ' captura en ' + toFile + ' ' + toRank;
	            } else {
	              verbalMove = piece + ' captura en ' + toFile + ' ' + toRank;
	            }
	          } else {
	            if (from) {
	              verbalMove = piece + ' desde ' + from + ' a ' + toFile + ' ' + toRank;
	            } else {
	              if (piece.length <= 0) {
	                verbalMove = toFile + ' ' + toRank;
	              } else {
	                verbalMove = piece + ' a ' + toFile + ' ' + toRank;
	              }
	            }
	          }
	
	          if (promotionPiece) {
	            verbalMove += ' y se promociona a ' + pieceNames[promotionPiece];
	          }
	
	          if (check) {
	            verbalMove += ', jaque';
	          } else if (checkmate) {
	            verbalMove += ', jaque mate';
	          }
	        }
	
	        return verbalMove;
	      });
	
	      return convertedText;
	    },
	    handleSuccess: function handleSuccess(stream) {
	      this.audioStream = stream;
	      this.mediaRecorder = new MediaRecorder(stream);
	      this.mediaRecorder.addEventListener('dataavailable', this.onDataAvailable);
	      this.mediaRecorder.start();
	    },
	    startRecording: function startRecording() {
	      if (this.timeLeft === 0) {
	        this.timeLeft = 10;
	
	        if (this.timeLeft > 0) {
	          setTimeout(this.countdown, 1000);
	        }
	        this.audioChunks.length = 0;
	        navigator.mediaDevices.getUserMedia({ audio: true }).then(this.handleSuccess).catch(function (error) {
	          return console.error('Error al obtener el stream:', error);
	        });
	      } else {
	        this.stopRecording();
	      }
	    },
	    stopRecording: function stopRecording() {
	      this.timeLeft = 0;
	      if (this.mediaRecorder) {
	        this.mediaRecorder.stop();
	      }
	      if (this.audioStream) {
	        this.audioStream.getTracks().forEach(function (track) {
	          return track.stop();
	        });
	      }
	    },
	    onDataAvailable: function onDataAvailable(event) {
	      this.audioChunks.push(event.data);
	      if (this.mediaRecorder.state === 'inactive') {
	        this.sendAudio();
	      }
	    },
	    _handleUpload: function _handleUpload(file) {
	      var form = new window.FormData();
	      var xhr = new window.XMLHttpRequest();
	      try {
	        form.append('Content-Type', file.type || 'audio/wav');
	
	        form.append('file', file);
	      } catch (err) {
	        return;
	      }
	      return new _promise2.default(function (resolve, reject) {
	        xhr.upload.addEventListener('progress', this._onProgress, false);
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState < 4) {
	            return;
	          }
	          if (xhr.status < 400) {
	            var res = xhr.responseText;
	            var newFile = {
	              name: file.name,
	              size: file.size,
	              type: file.type,
	              lastModifiedDate: file.lastModifiedDate,
	              path: res.filePath
	            };
	
	            console.log('Ruta del archivo:', res.filePath);
	            resolve(newFile);
	          } else {
	            var err = xhr.responseText;
	
	            reject(err);
	          }
	        };
	        xhr.onerror = function () {
	          var err = JSON.parse(xhr.responseText);
	          this.$dispatch('onFileError', file, err);
	          reject(err);
	        }.bind(this);
	        var filename = 'audio.wav';
	        xhr.open(this.method || 'POST', this.dirActionUploadAudio + '?filename=' + filename, true);
	        if (this.headers) {
	          for (var header in this.headers) {
	            xhr.setRequestHeader(header, this.headers[header]);
	          }
	        }
	        xhr.send(form);
	        this.$dispatch('afterFileUpload', file);
	      }.bind(this));
	    },
	    blobToFile: function blobToFile(theBlob, fileName) {
	      theBlob.lastModifiedDate = new Date();
	      theBlob.name = fileName;
	      return theBlob;
	    },
	    transcribeAudio: function transcribeAudio(file) {
	      var _this5 = this;
	
	      try {
	        _openaiutils2.default.transcribeAudio(file).then(function (data) {
	          console.log('Datos recibidos: ', data);
	
	          _this5.preguntaAI(data);
	
	          _this5.habilitarBotones();
	        }).catch(function (error) {
	          console.error('Error al generar texto: ', error);
	          _this5.habilitarBotones();
	        });
	      } catch (error) {
	        console.error('Error: ' + error.message);
	      }
	    },
	    sendAudio: function sendAudio() {
	      var audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' });
	      var audioFile = this.blobToFile(audioBlob, 'audio.wav');
	
	      this._handleUpload(audioFile);
	      setTimeout(function () {
	        this.transcribeAudio(audioFile).then(function (transcription) {
	          console.log('Transcripción:', transcription);
	        }).catch(function (error) {
	          console.error('Error al transcribir audio:', error);
	        });
	      }.bind(this), 1000);
	    },
	    generateText: function generateText(textArg) {
	      var _this6 = this;
	
	      try {
	        _openaiutils2.default.generateText(textArg, this.pgn).then(function (data) {
	          console.log('Datos recibidos: ', data);
	          var textoLimpio = data.choices[0].message.content.replace(/[\n\r\t]/g, ' ');
	          textoLimpio = _this6.translatePieceCodesInComments(textoLimpio);
	
	          var speechContent = _this6.convertMovesToSpeechOutsideMarkers(textoLimpio);
	          _this6.textToSpeach(speechContent);
	          _this6.airesponse = textoLimpio;
	          var chatContent = document.getElementById('chat-content');
	          if (chatContent) {
	            chatContent.innerHTML += _this6.answerUser(textArg);
	            _this6.scrollBottom();
	          }
	          if (chatContent) {
	            chatContent.innerHTML += _this6.answerIA(_this6.airesponse);
	            _this6.scrollBottom();
	          }
	          _this6.habilitarBotones();
	        }).catch(function (error) {
	          console.error('Error al generar texto: ', error);
	          _this6.habilitarBotones();
	        });
	      } catch (error) {
	        console.error('Error: ' + error.message);
	      }
	    },
	    isValidPgn: function isValidPgn(text) {
	      var pgnRegex = /(\[Event\s".*?"\]\s*\[Site\s".*?"\]\s*\[Date\s".*?"\]\s*\[Round\s".*?"\]\s*\[White\s".*?"\]\s*\[Black\s".*?"\]\s*\[Result\s"(1-0|0-1|1\/2-1\/2|\*)"\]([\s\S]*?\[.*? ".*?"\])*)\s*((\d+\.\s*(?:[a-h][1-8]|[KQRBN][a-h1-8]|[KQRBN]x[a-h1-8]|O-O|O-O-O)(?:\s*[+#=Q=R=B=N])?(?:\s*\{[^}]*\})?\s*(?:\d+\.\.\.\s*(?:[a-h][1-8]|[KQRBN][a-h1-8]|[KQRBN]x[a-h1-8]|O-O|O-O-O)(?:\s*[+#=Q=R=B=N])?(?:\s*\{[^}]*\})?)?)*\s*(\*|1-0|0-1|1\/2-1\/2)?)?/;
	      return pgnRegex.test(text);
	    },
	    translatePieceCodesInComments: function translatePieceCodesInComments(pgnText) {
	      var translationMap = {
	        K: 'R',
	        Q: 'D',
	        R: 'T',
	        B: 'A',
	        N: 'C' };
	
	      var commentRegex = /(\{[^}]*\})|(;[^\n]*)/g;
	
	      function translateCodesInComment(comment) {
	        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, function (match, p1, p2) {
	          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2;
	        });
	      }
	
	      var translatedText = pgnText.replace(commentRegex, function (match) {
	        return translateCodesInComment(match);
	      });
	      return translatedText;
	    },
	    cleanPgnContent: function cleanPgnContent(text) {
	      var pgnRegex = /(\[Event\s".*?"\](?:.|\n)*?)(\d+\.\s.*)$/;
	
	      var matches = text.match(pgnRegex);
	      if (!matches) {
	        console.warn('No se encontró contenido PGN válido.');
	        return '';
	      }
	
	      var validTagsAndMoves = matches[0];
	      return validTagsAndMoves.trim();
	    },
	    generatePGN: function generatePGN(textArg) {
	      var _this7 = this;
	
	      var ret = true;
	      try {
	        var _self = this;
	        _openaiutils2.default.generatePGN(textArg, this.pgn).then(function (data) {
	          console.log('Datos recibidos: ', data);
	          var textoLimpio = data.choices[0].message.content.replace(/[\n\r\t]/g, ' ');
	          textoLimpio = textoLimpio.replace(/[`]/g, '');
	
	          textoLimpio = _self.cleanPgnContent(textoLimpio);
	
	          if (_self.isValidPgn(textoLimpio) === false) {}
	
	          if (_self.isValidPgn(textoLimpio)) {
	            var idTextArea = document.getElementById('idTextAreaPGN');
	            if (idTextArea) {
	              idTextArea.value = textoLimpio;
	              idTextArea.dispatchEvent(new window.Event('input'));
	              idTextArea.dispatchEvent(new window.Event('change'));
	            }
	            var chatContent = document.getElementById('chat-content');
	            if (chatContent) {
	              chatContent.innerHTML += _self.answerUser(textArg);
	              _this7.scrollBottom();
	            }
	            if (chatContent) {
	              chatContent.innerHTML += _self.answerIA(textoLimpio);
	              _this7.scrollBottom();
	            }
	          } else {
	            window.swal('Error en la generación del PGN, vuelva a intentarlo');
	            ret = false;
	          }
	          _self.habilitarBotones();
	        }).catch(function (error) {
	          console.error('Error al generar texto: ', error);
	          _this7.habilitarBotones();
	          ret = false;
	        });
	      } catch (error) {
	        console.error('Error: ' + error.message);
	        ret = false;
	      }
	      return ret;
	    },
	    analisisPGN: function analisisPGN(textArg) {
	      var _this8 = this;
	
	      try {
	        var chatContent = document.getElementById('chat-content');
	        if (chatContent) {
	          chatContent.innerHTML += this.answerUser(textArg);
	          this.scrollBottom();
	        }
	        _openaiutils2.default.analisisPGN(textArg, this.pgn).then(function (data) {
	          console.log('Datos recibidos: ', data);
	          var aiResponse = data.choices[0].message.content;
	
	          var match = aiResponse.match(/<<<([\s\S]*?)>>>/);
	          if (match && match[1]) {
	            _this8.pgn = match[1].trim();
	            var prettyPgn = _this8.prettyPgn(_this8.translatePieceCodesInComments(match[1].trim()));
	            _this8.$broadcast('updatePgnIA', prettyPgn);
	          }
	
	          var speechContent = aiResponse;
	          if (match && match[1]) {
	            speechContent = aiResponse.replace(match[1].trim(), '');
	          }
	          speechContent = _this8.convertMovesToSpeechOutsideMarkers(speechContent);
	          if (chatContent) {
	            chatContent.innerHTML += _this8.answerIA(aiResponse);
	            _this8.scrollBottom();
	          }
	          _this8.textToSpeach(speechContent);
	          _this8.habilitarBotones();
	        }).catch(function (error) {
	          console.error('Error al generar texto: ', error);
	          window.swal('Error: ' + error.message);
	          _this8.habilitarBotones();
	        });
	      } catch (error) {
	        console.error('Error: ' + error.message);
	        window.swal('Error: ' + error.message);
	        this.habilitarBotones();
	      }
	    },
	    habilitarBotones: function habilitarBotones() {
	      document.getElementById('overlay').style.display = 'none';
	      var chatQuestion = document.getElementById('aiquestion');
	      if (chatQuestion) {
	        chatQuestion.value = '';
	      }
	    },
	    deshabilitarBotones: function deshabilitarBotones() {
	      document.getElementById('overlay').style.display = 'block';
	    },
	    closeModalIA: function closeModalIA() {
	      if (this.isParamOnly === false || true) {
	        window.speechSynthesis.cancel();
	        clearInterval(this.intervalMouth);
	        this.getMouthShape('a');
	      }
	      this.$broadcast('modal::close', 'some', 'modalIA');
	    },
	    getIndexFromFen: function getIndexFromFen(fen) {
	      var fenParts = fen.split(' ');
	      if (fenParts.length !== 6) {
	        return -1;
	      }
	
	      var fullMoveNumber = fenParts[5];
	      return fullMoveNumber;
	    },
	    getTurnFromFen: function getTurnFromFen(fen) {
	      var fenParts = fen.split(' ');
	      if (fenParts.length !== 6) {
	        return -1;
	      }
	
	      var turn = fenParts[1];
	
	      return turn;
	    },
	    showInformationAI: function showInformationAI() {
	      this.deshabilitarBotones();
	
	      this.airesponse = '';
	
	      this.generateText('Comenta esta posici\xF3n ' + this.fen + ' que pertenece al moviento ' + this.getIndexFromFen(this.fen) + ' de esta partida ' + this.pgn + '.');
	    },
	    esPGNValido: function esPGNValido(pgn) {
	      var etiquetasObligatorias = ['Event', 'Site', 'Date', 'Round', 'White', 'Black', 'Result'];
	      var etiquetasPresentes = etiquetasObligatorias.every(function (etiqueta) {
	        return pgn.includes('[' + etiqueta + ' ');
	      });
	      if (!etiquetasPresentes) {
	        return false;
	      }
	      var partes = pgn.split('\n\n');
	      if (partes.length < 2) {
	        return false;
	      }
	      var movimientos = partes[1].trim();
	      var regexMovimientos = /^1\.\s*[a-h1-8NBRQKxOo0-9+=#-]+\s*[a-h1-8NBRQKxOo0-9+=#-]+/;
	      if (!regexMovimientos.test(movimientos)) {
	        return false;
	      }
	      var movimientosSeparados = movimientos.split(/\s+[0-9]+\./g).slice(1);
	      var secuenciaCorrecta = true;
	      movimientosSeparados.forEach(function (movimiento, index) {
	        if (parseInt(movimiento.split('.')[0]) !== index + 2) {
	          secuenciaCorrecta = false;
	        }
	      });
	      if (!secuenciaCorrecta) {
	        return false;
	      }
	      return true;
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    analizaAI: function analizaAI() {
	      this.deshabilitarBotones();
	      this.analisisPGN('Analiza la partida en profundiad y dame comentarios en espa\xF1ol de los momentos mas cr\xEDticos de la partida.\n        Comentarios sobre la apertura, medio juego y final, t\xE1cticas en la partida, estrategia.');
	    },
	    commentAI: function commentAI() {
	      this.deshabilitarBotones();
	      this.generatePGN('Analiza la partida en profundiad y a\xF1ade comentarios en espa\xF1ol a los principales movimientos de este PGN.\n        Comentarios sobre la apertura, medio juego y final, t\xE1cticas en la partida, estrategia.\n        Devuelve solamente el formato PGN resultante.\n        Solo texto dentro del formato PGN\n        Comprueba que el PGN sea correcto y que no haya nada mas que el formato PGN ning\xFAn otro caracter fuera de ese formato.\n        No puedes incluir ning\xFAn otro movimiento en el PGN que los que hay, solo comentarios, sin modificar nada mas del PGN');
	    },
	    preguntaAI: function preguntaAI() {
	      var mensaje = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      this.deshabilitarBotones();
	
	      var chatQuestion = document.getElementById('aiquestion');
	      var question = '';
	      if (chatQuestion) {
	        question = chatQuestion.value;
	      }
	      if (mensaje.length > 0) {
	        question = mensaje;
	      }
	
	      this.generateQuestion(question, this.pgn);
	    },
	    openChat: function openChat() {
	      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (_config2.default.debug) {
	        var handler = window.open(_config2.default.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video);
	        handler.blur();
	      } else {
	        var _handler = window.open(_config2.default.video_uri + '/?canal=' + this.board._id + '&usuario=' + this.user.username + '&video=' + video);
	        _handler.blur();
	      }
	    },
	    isVideoSaving: function isVideoSaving() {
	      return window.RECORDING_ONGOING;
	    },
	    openVideoSave: function openVideoSave() {
	      window.RECORDING_ONGOING = !window.RECORDING_ONGOING;
	      if (window.RECORDING_ONGOING) {
	        window.startRecording();
	        this.recording = true;
	      } else {
	        window.stopRecording();
	        this.recording = false;
	      }
	    },
	    openChatSala: function openChatSala() {
	      var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      if (_config2.default.debug) {
	        var handler = window.open(_config2.default.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video);
	        handler.blur();
	      } else {
	        var _handler2 = window.open(_config2.default.video_uri + '/?canal=' + this.user.club + '&usuario=' + this.user.username + '&video=' + video);
	        _handler2.blur();
	      }
	    },
	    setLinkUpload: function setLinkUpload() {
	      if (this.strNameResource.length <= 0) {
	        window.swal('Debe rellenar un nombre para el recurso', {
	          buttons: {
	            si: { text: 'Aceptar', value: 'accept' }
	          }
	        }).then(function (resultParam) {});
	        return;
	      }
	
	      var idFEN = document.getElementById('myFENValue');
	      var last = '';
	      if (this.board.urls !== undefined && this.board.urls.length > 0) {
	        var iFound = this.board.urls.indexOf(idFEN.value);
	        if (iFound >= 0) {
	          var nInitUrls = iFound + idFEN.value.length + 1;
	          var nFinUrls = this.board.urls.indexOf(';', nInitUrls);
	          last = this.board.urls.substring(nInitUrls, nFinUrls);
	          var nn = '{' + this.strNameResource + '=' + this.urlLinkUpload + '}';
	          var nuevo = last + nn;
	
	          this.board.urls = this.board.urls.replace(last, nuevo);
	        }
	      }
	      if (last.length <= 0) {
	        this.board.urls += idFEN.value + '={' + this.strNameResource + '=' + this.urlLinkUpload + '};';
	        idFEN.value = idFEN.value;
	        idFEN.textContent = idFEN.value;
	        idFEN.dispatchEvent(new window.Event('input'));
	
	        this.$broadcast('modal::close', 'some', 'setResource');
	      }
	      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
	        var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value;
	
	        document.querySelector('#pgnComment' + ' textarea.comment').value = oldVal + ' ' + 'RECURSO';
	        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'));
	      }
	      this.strNameResource = '';
	    },
	    listaDeClubs: function listaDeClubs(tipo) {
	      var parms = {
	        type: tipo
	      };
	      var _self = this;
	      _self.listaclubs = [];
	      _club2.default.get(_self, parms).then(function (response) {
	        JSON.parse(response).forEach(function (element) {
	          _self.listaclubs.push(element);
	        });
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    isSelected: function isSelected(clubName) {
	      var ret = false;
	
	      var clubList = this.clubs.split(',');
	      for (var i = 0; i < clubList.length; i++) {
	        if (clubName === clubList[i]) {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    isSelectedVoice: function isSelectedVoice(voice) {
	      var ret = false;
	      if (this.listaVocesSelected === voice.name) {
	        ret = true;
	      }
	      return ret;
	    },
	    handleSelectChange: function handleSelectChange(event) {
	      var selectedValues = (0, _from2.default)(event.target.selectedOptions).map(function (option) {
	        return option.value;
	      });
	
	      var clubActual = '';
	      var count = selectedValues.length;
	      var num = 0;
	      selectedValues.forEach(function (element) {
	        clubActual += element;
	        num++;
	        if (num < count) {
	          clubActual += ',';
	        }
	      });
	      this.clubActual = clubActual;
	    },
	    isOwner: function isOwner() {
	      if (this.board === undefined) {
	        this.board = _lstorage2.default.get('boardSee');
	      }
	
	      return this.board !== undefined && (this.user.username === this.board.u1 || this.user.username === this.board.u2);
	    },
	    urlPiece: function urlPiece(move) {
	      return '/static/images/pieces/cburnett/' + move.color + move.piece.toUpperCase() + '.svg';
	    },
	    downloadString: function downloadString(text, fileType, fileName) {
	      var blob = new window.Blob([text], { type: fileType });
	      var a = document.createElement('a');
	      a.download = fileName;
	      a.href = window.URL.createObjectURL(blob);
	      a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
	      a.style.display = 'none';
	      document.body.appendChild(a);
	      a.click();
	      document.body.removeChild(a);
	      setTimeout(function () {
	        window.URL.revokeObjectURL(a.href);
	      }, 1500);
	    },
	    sendPermisionToSend: function sendPermisionToSend() {
	      this.$dispatch('sendPermisionToSend', {});
	    },
	    sendPGNtoTeacher: function sendPGNtoTeacher() {
	      this.$dispatch('sendPGNtoTeacher', {});
	    },
	    analizaPGN: function analizaPGN() {
	      this.$dispatch('analizaPGN', {});
	    },
	    downloadPGN: function downloadPGN() {
	      var pgnChessBase = this.pgn.split('"]').join('"]\n');
	      pgnChessBase = pgnChessBase.split('$').join(' $');
	      pgnChessBase = pgnChessBase.split('{}').join('');
	
	
	      this.downloadString(pgnChessBase, 'text/pgn', 'MiPartida.pgn');
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    parsePgnMoves: function parsePgnMoves(pgn) {
	      var newlineChar = '\r?\n';
	
	      var lines = pgn.split(new RegExp(newlineChar));
	      var pgntext = '';
	      var state = 0;
	      for (var i = 0; i < lines.length; i++) {
	        if (lines[i].length > 0) {
	          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
	            if (state === 1) {}
	            state = 0;
	          } else {
	            state = 1;
	          }
	          if (state === 0) {} else {
	            pgntext += lines[i] + ' ';
	          }
	        }
	      }
	
	      return pgntext;
	    },
	    setDataFields: function setDataFields() {
	      this.board.lessontype = this.typeLesson;
	      this.board.lesson = this.nameLesson;
	      this.board.category = this.nameCategory;
	      this.board.name = this.nameAnalysis;
	      this.board.club = this.clubActual;
	
	      this.$broadcast('modal::close', 'some', 'setFields');
	    },
	    setDataPosition: function setDataPosition() {
	      var pgnInLines = this.pgn.split('"]').join('"]\n');
	      pgnInLines = pgnInLines.split('{}').join('');
	      var txtPrev = '';
	      var headers = this.parse_pgn_header(pgnInLines);
	      if (this.fenEvento !== undefined) {
	        txtPrev += '[Event "' + this.fenEvento + ' "]\r\n';
	      }
	      if (this.fenLugar !== undefined) {
	        txtPrev += '[Site "' + this.fenLugar + ' "]\r\n';
	      }
	      if (this.fenFecha !== undefined) {
	        txtPrev += '[Date "' + this.fenFecha + ' "]\r\n';
	      }
	      if (this.fenRonda !== undefined) {
	        txtPrev += '[Round "' + this.fenRonda + ' "]\r\n';
	      }
	      if (this.fenBlancas !== undefined) {
	        txtPrev += '[White "' + this.fenBlancas + ' "]\r\n';
	      }
	      if (this.fenNegras !== undefined) {
	        txtPrev += '[Black "' + this.fenNegras + ' "]\r\n';
	      }
	      if (this.fenResultado !== undefined) {
	        txtPrev += '[Result "' + this.fenResultado + ' "]\r\n';
	      }
	      var idFEN = document.getElementById('myFENValue');
	      var txtPgn = '';
	      txtPgn = txtPrev;
	      var idTextArea = document.getElementById('idTextAreaPGN');
	      var setup = '';
	      var fen = '';
	      if (headers['SetUp'] !== undefined) {
	        setup = '[SetUp "' + headers['SetUp'] + '"]';
	      }
	      if (headers['FEN'] !== undefined) {
	        fen = '[FEN "' + headers['FEN'] + '"]';
	      }
	      idTextArea.value = txtPgn + setup + fen + this.parsePgnMoves(pgnInLines);
	      idFEN.value = headers['FEN'] !== undefined ? headers['FEN'] : 'start';
	      idFEN.textContent = headers['FEN'] !== undefined ? headers['FEN'] : 'start';
	      idFEN.dispatchEvent(new window.Event('input'));
	      idTextArea.dispatchEvent(new window.Event('change'));
	      this.$broadcast('modal::close', 'some', 'setData');
	    },
	    setFenPosition: function setFenPosition() {
	      if (document.getElementById('iFramePosition')) {
	        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	        var idFEN = document.getElementById('myFENValue');
	        var txtPgn = '';
	        txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]';
	        var idTextArea = document.getElementById('idTextAreaPGN');
	        idTextArea.value = txtPgn;
	        idFEN.value = searchinput.value;
	        idFEN.textContent = searchinput.value;
	        idFEN.dispatchEvent(new window.Event('input'));
	        idTextArea.dispatchEvent(new window.Event('change'));
	      }
	      this.$broadcast('modal::close', 'some', 'setFen');
	    },
	    setFenInit: function setFenInit() {
	      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	      searchinput.value = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      searchinput.dispatchEvent(new window.Event('change'));
	      this.enroqueK = true;
	      this.enroqueQ = true;
	      this.enroquek = true;
	      this.enroqueq = true;
	    },
	    setFenEnroque: function setFenEnroque() {
	      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	      var enroque = (this.enroqueK ? 'K' : '') + (this.enroqueQ ? 'Q' : '') + (this.enroquek ? 'k' : '') + (this.enroqueq ? 'q' : '');
	      var fen = searchinput.value.split(' ');
	      var fenString = fen[0] + ' ' + fen[1] + ' ' + enroque + ' ' + fen[3] + ' ' + fen[4] + ' ' + fen[5];
	
	      searchinput.value = fenString;
	      searchinput.dispatchEvent(new window.Event('change'));
	    },
	    setFenClear: function setFenClear() {
	      var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	      searchinput.value = '4k3/8/8/8/8/8/8/4K3 b - - 1 2';
	      searchinput.dispatchEvent(new window.Event('change'));
	      this.enroqueK = false;
	      this.enroqueQ = false;
	      this.enroquek = false;
	      this.enroqueq = false;
	    },
	    showShare: function showShare() {
	      this.$broadcast('modal::open', 'modalCompartir');
	    },
	    showIA: function showIA() {
	      this.airesponse = '';
	      if (this.board._id === undefined) {
	        this.board._id = 0;
	      }
	      this.$broadcast('modal::open', 'modalIA');
	    },
	    playGame: function playGame() {
	      document.getElementById('pgnButtonsfirst').click();
	      for (var x = 0; x < 12; x++) {
	        if (document.querySelector('#pgnComment' + ' textarea.comment')) {
	          var oldVal = document.querySelector('#pgnComment' + ' textarea.comment').value;
	          var speechContent = this.convertMovesToSpeechOutsideMarkers(oldVal);
	          this.textToSpeach(speechContent);
	        }
	        document.getElementById('pgnButtonsnext').click();
	      }
	    },
	    generateBoardFromFEN: function generateBoardFromFEN(fen) {
	      var pieces = {
	        'p': '♟', 'r': '♜', 'n': '♞', 'b': '♝', 'q': '♛', 'k': '♚',
	        'P': '♙', 'R': '♖', 'N': '♘', 'B': '♗', 'Q': '♕', 'K': '♔'
	      };
	
	      var boardFEN = fen.split(' ')[0];
	      var rows = boardFEN.split('/');
	      var asciiBoard = '';
	      rows.forEach(function (row, rowIndex) {
	        var asciiRow = '|';
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(row), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var char = _step.value;
	
	            if (isNaN(char)) {
	              asciiRow += ' ' + (pieces[char] || char) + ' |';
	            } else {
	              for (var i = 0; i < parseInt(char); i++) {
	                asciiRow += '   |';
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        asciiBoard += asciiRow + '\n' + '-'.repeat(asciiRow.length) + '\n';
	      });
	      return asciiBoard;
	    },
	    moveToSan: function moveToSan(move) {
	      this.chess.load(this.fen);
	
	      var moves = this.chess.moves({ verbose: true });
	      var foundMove = moves.find(function (m) {
	        return m.from === move.from && m.to === move.to;
	      });
	      if (!foundMove) {
	        console.error('foundMove null');
	        return null;
	      }
	      var translationMap = {
	        K: 'R',
	        Q: 'D',
	        R: 'T',
	        B: 'A',
	        N: 'C' };
	
	      function translateCodesInComment(comment) {
	        return comment.replace(/\b([KQRBN])x?([a-h][1-8])\b/g, function (match, p1, p2) {
	          return translationMap[p1] + (match.includes('x') ? 'x' : '') + p2;
	        });
	      }
	      var ret = translateCodesInComment(foundMove.san);
	
	      return ret;
	    },
	    PcIngeniesMoveStockfish: function PcIngeniesMoveStockfish(move) {
	      if (this.stockfish !== null && this.stockfish !== undefined) {
	        this.stockfish.close();
	        this.stockfish = null;
	
	        var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras';
	
	        var text = 'Dame un comentario sobre la posici\xF3n ' + this.getIndexFromFen(this.fen) + ' del pgn que te adjunto.\n          Es el turno de las ' + turn + '.\n          Que movimiento recomiendas, revisa las amenazas en el tablero, pero sobretodo la usa como tuya la recomendaci\xF3n que te paso de un motor de ajedrez.\n          Tu respuesta no puede ser mayor a 200 caracteres. La notaci\xF3n algebr\xE1ica que uses tiene que ser siempre en espa\xF1ol';
	        var san = this.moveToSan(move);
	        if (san) {
	          text += 'la recomendaci\xF3n es ' + san + '. Sigue las indicaciones de la recomendaci\xF3n y usala como si fuera tuya';
	        }
	        this.generateText(text);
	      }
	    },
	    insertComments: function insertComments() {
	      this.airesponse = '';
	      this.deshabilitarBotones();
	
	      var turn = this.getTurnFromFen(this.fen) === 'w' ? 'blancas' : 'negras';
	      this.stockfish = _enginegame2.default.engineGame({ book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js' });
	
	      var skill = 20;
	      this.stockfish.reset();
	
	      this.stockfish.setSkillLevel(skill);
	      this.stockfish.setDisplayScore(true);
	
	      this.stockfish.start();
	      this.stockfish.setPlayerColor(turn);
	
	      this.stockfish.setTime(parseFloat(30000), 20);
	      this.stockfish.setDepth(10);
	      this.stockfish.setNodes(0);
	
	      this.stockfish.prepareMove(this.fen, '', this.PcIngeniesMoveStockfish, 100000, 100000, 0, 0);
	    },
	    setResource: function setResource() {
	      this.$broadcast('modal::open', 'setResource');
	    },
	    updateData: function updateData() {
	      var idPGN = document.getElementById('myPGNValue');
	      var idTextArea = document.getElementById('idTextAreaPGN');
	
	      if (idTextArea && idPGN) {}
	      setTimeout(function () {
	        var myPGNReload = document.getElementById('myPGNReload');
	        if (myPGNReload) {
	          myPGNReload.value = 'reload';
	          myPGNReload.textContent = 'reload';
	          myPGNReload.dispatchEvent(new window.Event('input'));
	          myPGNReload.dispatchEvent(new window.Event('change'));
	          myPGNReload.blur();
	        }
	        var idFEN = document.getElementById('myFENValue');
	        if (idFEN) {
	          document.getElementById('pgnButtonsfirst').click();
	          idFEN.value = idFEN.value;
	          idFEN.textContent = idFEN.value;
	          idFEN.dispatchEvent(new window.Event('input'));
	          idFEN.dispatchEvent(new window.Event('change'));
	        }
	      }, 500);
	    },
	    setFen: function setFen() {
	      this.$broadcast('modal::open', 'setFen');
	      var checkIframe = setInterval(function () {
	        var iframe = document.getElementById('iFramePosition');
	
	        if (iframe) {
	          iframe.style.height = document.documentElement.scrollHeight + 'px';
	
	          clearInterval(checkIframe);
	          setTimeout(function () {
	            var searchinput = iframe.contentWindow.document.getElementById('fenInputOutput');
	            if (searchinput) {
	              var idFEN = document.getElementById('myFENValue');
	              if (idFEN) {
	                searchinput.value = idFEN.value;
	                searchinput.textContent = idFEN.value;
	                searchinput.dispatchEvent(new window.Event('input'));
	                searchinput.dispatchEvent(new window.Event('change'));
	              }
	            }
	          }, 1000);
	        }
	      }, 100);
	    },
	    setFields: function setFields() {
	      this.$broadcast('modal::open', 'setFields');
	    },
	    setData: function setData() {
	      var pgnInLines = this.pgn.split('"]').join('"]\n');
	      pgnInLines = pgnInLines.split('{}').join('');
	      var headers = this.parse_pgn_header(pgnInLines);
	
	      this.fenEvento = headers['Event'] !== undefined ? headers['Event'] : this.fenEvento;
	      this.fenLugar = headers['Site'] !== undefined ? headers['Site'] : this.fenLugar;
	      this.fenFecha = headers['Date'] !== undefined ? headers['Date'] : this.fenFecha;
	      this.fenRonda = headers['Round'] !== undefined ? headers['Round'] : this.fenRonda;
	      this.fenBlancas = headers['White'] !== undefined ? headers['White'] : this.fenBlancas;
	      this.fenNegras = headers['Black'] !== undefined ? headers['Black'] : this.fenNegras;
	      this.fenResultado = headers['Result'] !== undefined ? headers['Result'] : this.fenResultado;
	      this.$broadcast('modal::open', 'setData');
	    },
	    setValues: function setValues() {
	      this.$broadcast('modal::open', 'setValues');
	    },
	    closeAnalisis: function closeAnalisis() {
	      this.$broadcast('modal::close', 'some', 'analisys');
	    },
	    openModalGraph: function openModalGraph() {
	      this.$broadcast('modal::open', 'analisys');
	      setTimeout(function () {
	        var searchinput = document.getElementById('iFrameAnalisys').contentWindow.document.getElementById('searchInput');
	
	        if (searchinput) {
	          searchinput.value = window.pgnBoardBase.getPgn().write_pgn();
	          searchinput.dispatchEvent(new window.Event('change'));
	          document.getElementById('iFrameAnalisys').contentWindow.dosearch();
	        }
	      }, 1000);
	    },
	    openModalGraphFEN: function openModalGraphFEN() {
	      this.$broadcast('modal::open', 'analisys');
	      setTimeout(function () {
	        var searchinput = document.getElementById('iFrameAnalisys').contentWindow.document.getElementById('searchInput');
	
	        if (searchinput) {
	          var idFEN = document.getElementById('myFENValue');
	          searchinput.value = idFEN.value;
	          searchinput.dispatchEvent(new window.Event('change'));
	          document.getElementById('iFrameAnalisys').contentWindow.dosearch();
	        }
	      }, 1000);
	    },
	    openModal: function openModal() {
	      if (document.getElementById('analisisModal') && document.getElementById('analisisVertical') && document.getElementById('searchInput')) {
	        this.visibleHistory = document.getElementById('analisisModal').style.display;
	        if (this.visibleHistory === 'none') {
	          document.getElementById('analisisModal').style = 'display:inline;z-index:-40;';
	          document.getElementById('analisisVertical').style.display = 'inline';
	          if (document.getElementById('searchInput') && document.getElementById('myFENValueP')) {
	            window.onloadsimplechessboard();
	
	            document.getElementById('searchInput').value = document.getElementById('myFENValueP').textContent;
	            document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	
	            clearInterval(window.computerGame);
	            window.computerGame = setInterval(function () {
	              this.showShapes();
	            }.bind(this), 1000);
	          }
	        } else {
	          document.getElementById('analisisModal').style = 'display:none;z-index:-40;';
	          document.getElementById('analisisVertical').style.display = 'none';
	          clearInterval(window.computerGame);
	          if (window.ground !== undefined && window.ground !== null) {
	            window.ground.setAutoShapes([{
	              orig: '-1',
	              dest: '-1',
	              brush: 'paleGrey',
	              modifiers: { lineWidth: 10 }
	            }, {
	              orig: '-1',
	              dest: '-1',
	              brush: 'paleGrey',
	              modifiers: { lineWidth: 4 }
	            }]);
	          }
	          if (window._engine !== null) {
	            window._engine.terminate();
	          }
	        }
	      }
	      window.dispatchEvent(new window.Event('resize'));
	    },
	    showShapes: function showShapes() {
	      if (window._curmoves !== undefined && window._curmoves[0] !== undefined) {
	        this.eval = window.getEvalText(window._curmoves[0].eval, false);
	        var evalfloat = parseFloat(this.eval);
	        var value = '0%';
	
	        if (isNaN(evalfloat) === false) {
	          var eval2 = evalfloat * 10;
	
	          var eval25 = 50 + eval2;
	          eval25 = eval25 < 0 ? 0 : eval25;
	
	          if (eval25 < 7) {
	            value = '7%';
	          } else if (eval25 > 100) {
	            value = '95%';
	          } else {
	            value = eval25 + '%';
	          }
	        } else {
	          if (this.eval.includes('blancas')) {
	            value = '100%';
	          }
	          if (this.eval.includes('negras')) {
	            value = '0%';
	          }
	        }
	        var elem = document.getElementById('myBar');
	        if (elem) {
	          elem.style.marginLeft = value;
	        }
	        elem = document.getElementById('myBar2');
	        if (elem) {
	          elem.style.height = value;
	        }
	      }
	      if (document.getElementById('searchInput') && window._curmoves !== undefined && window._curmoves[0] !== undefined) {
	        var sFrom0 = 'abcdefgh'[window._curmoves[0].move.from.x] + '87654321'[window._curmoves[0].move.from.y];
	        var sTo0 = 'abcdefgh'[window._curmoves[0].move.to.x] + '87654321'[window._curmoves[0].move.to.y];
	        if (window._curmoves[0].answer != null && window._curmoves[0].answer !== undefined) {
	          this.eval = window.getEvalText(window._curmoves[0].eval, false);
	          var sFrom1 = window._curmoves[0].answer[0] + window._curmoves[0].answer[1];
	          var sTo1 = window._curmoves[0].answer[2] + window._curmoves[0].answer[3];
	          window.ground.setAutoShapes([{
	            orig: sFrom0,
	            dest: sTo0,
	            brush: 'paleGrey',
	            modifiers: { lineWidth: 10 }
	          }, {
	            orig: sFrom1,
	            dest: sTo1,
	            brush: 'paleGrey',
	            modifiers: { lineWidth: 4 }
	          }]);
	        } else {
	          window.ground.setAutoShapes([{
	            orig: sFrom0,
	            dest: sTo0,
	            brush: 'paleGrey',
	            modifiers: { lineWidth: 10 }
	          }]);
	        }
	      }
	    },
	    isevents: function isevents() {
	      return this.events;
	    },
	    changeOrientation: function changeOrientation() {
	      window.orientationg = window.orientationg === 'white' ? 'black' : 'white';
	      window.ground.set({
	        orientation: window.orientationg,
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      });
	    },
	    play: function play() {
	      this.played = !this.played;
	      if (this.played) {
	        playEvent = setInterval(function () {
	          this.moveToHistory(this.select + 1);
	        }.bind(this), parseInt(this.velo) * 1000);
	      } else {
	        clearInterval(playEvent);
	      }
	    }
	  },
	  watch: {
	    listaVocesSelected: function listaVocesSelected(val, oldVal) {
	      _lstorage2.default.set('selectedVoice', val);
	      this.myVoiceSelected = val;
	    },
	    clubActual: function clubActual(val, oldVal) {
	      this.clubs = val;
	    },
	    airesponse: function airesponse(val, oldVal) {
	      if (document.querySelector('#pgnComment' + ' textarea.comment')) {
	        document.querySelector('#pgnComment' + ' textarea.comment').value = this.airesponse;
	        document.querySelector('#pgnComment' + ' textarea.comment').dispatchEvent(new window.Event('change'));
	      }
	      this.airesponse = val;
	    },
	    velo: function velo(newVal, oldVal) {
	      clearInterval(playEvent);
	      this.played = false;
	      this.play();
	    },
	    eval: function _eval(newVal, oldVal) {},
	    enroqueK: function enroqueK(newVal, oldVal) {
	      this.setFenEnroque();
	    },
	    enroqueQ: function enroqueQ(newVal, oldVal) {
	      this.setFenEnroque();
	    },
	    enroquek: function enroquek(newVal, oldVal) {
	      this.setFenEnroque();
	    },
	    enroqueq: function enroqueq(newVal, oldVal) {
	      this.setFenEnroque();
	    }
	  },
	  created: function created() {
	    if (this.$route && this.$route.name === 'game') {
	      this.listaDeClubs('Clubs');
	      if (this.board) {
	        this.clubs = this.board.club;
	        this.nameLesson = this.board.lesson;
	        this.typeLesson = this.board.lessontype;
	        this.nameCategory = this.board.category;
	        this.nameAnalysis = this.board.name;
	        this.clubActual = this.board.club;
	      }
	    }
	    if (this.isParamOnly === false || true) {
	      var voices = window.speechSynthesis.getVoices();
	      if (voices.length > 0) {
	        for (var i = 0; i < voices.length; i++) {
	          this.listaVoces.push(voices[i].name);
	        }
	        this.listaVocesSelected = _lstorage2.default.get('selectedVoice');
	        if (this.listaVocesSelected === false || this.listaVocesSelected.length <= 0 && voices.length > 0 && voices[0] !== undefined) {
	          this.listaVocesSelected = voices[0].name;
	        }
	      }
	    }
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	  },
	  mounted: function mounted() {}
	};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  name: 'BoardVisorIa',
	  props: {
	    game: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    },
	    pgn: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      turnSmall: '',
	      gameActual: []
	    };
	  },
	
	  components: {},
	  mixins: [],
	  events: {
	    updatePgnIA: function updatePgnIA(pgn) {
	      setTimeout(function () {
	        this.loadDataGame(pgn);
	      }.bind(this), 50);
	    }
	  },
	  methods: {
	    prettyPgn: function prettyPgn(texto) {
	      return texto;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var wordBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0) {
	          headerObj[key] = value;
	          if (key === wordBreak) {
	            break;
	          }
	        }
	      }
	      return headerObj;
	    },
	    changeStateGame: function changeStateGame(pgn, id, fen) {
	      pgn = this.prettyPgn(pgn);
	      if (document.getElementById('ia-boardsmall') !== null) {
	        var Width = document.getElementById('ia-middlesmall').clientWidth;
	
	        var pos = 'start';
	        var start = fen !== undefined ? fen : '';
	
	        var headers = this.parse_pgn_header(pgn, 'FEN');
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = fen !== undefined && fen !== 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1' ? fen : headers['FEN'];
	          if (!this.hasBody(pgn)) {
	            start = '';
	            pos = headers['FEN'];
	          }
	          if (pos === headers['FEN']) {
	            start = '';
	          }
	          start = '';
	          pos = headers['FEN'];
	        }
	        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	          start = '';
	          pos = fen;
	        }
	        if (document.getElementById('pgnMovesIA')) {
	          document.getElementById('pgnMovesIA').textContent = '';
	        }
	        if (document.getElementById('ia-pgnButtons')) {
	          document.getElementById('ia-pgnButtons').textContent = '';
	        }
	        if (document.getElementById('ia-pgnComment')) {
	          document.getElementById('ia-pgnComment').textContent = '';
	        }
	        if (document.getElementById('ia-pgnHeader')) {
	          document.getElementById('ia-pgnHeader').textContent = '';
	        }
	        if (document.getElementById('ia-pgnError')) {
	          document.getElementById('ia-pgnError').textContent = '';
	        }
	
	        if (Width > 0 && fen !== undefined && typeof window.pgnBoard === 'function') {
	          window.pgnEdit({ inner: 'ia-boardsmall', button: 'ia-pgnButtons', fen: 'ia-pgnFen', header: 'ia-pgnHeader', error: 'ia-pgnError', moves: 'pgnMovesIA' }, { pgn: pgn, position: pos, startPlay: start, showCoords: false, width: Width });
	        } else {
	          window.pgnEdit({ inner: 'ia-boardsmall', button: 'ia-pgnButtons', fen: 'ia-pgnFen', header: 'ia-pgnHeader', error: 'ia-pgnError', moves: 'pgnMovesIA' }, { pgn: pgn, position: 'start', showCoords: false, width: Width });
	        }
	      }
	      var comments = document.querySelectorAll('.afterComment');
	      comments.forEach(function (comment) {
	        var textResource = comment.textContent.toLowerCase();
	        if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	          comment.closest('.move').classList.add('highlight-move');
	        }
	      });
	    },
	    loadDataGame: function loadDataGame(pgn) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (pgn.length <= 0) {
	        this.pgn = pgn;
	      }
	      this.pgn = this.prettyPgn(this.pgn);
	
	      this.changeStateGame(this.pgn, this.game._id ? this.game._id : this.game.id, 'start');
	      this.$nextTick(function () {
	        var buttonFirst = document.getElementById('ia-pgnButtonsfirst');
	        if (buttonFirst) {
	          buttonFirst.click();
	        }
	      });
	      this.$nextTick(function () {
	        var buttonFirst = document.getElementById('ia-pgnButtonsprev');
	        if (buttonFirst) {
	          buttonFirst.click();
	        }
	      });
	    }
	  },
	  watch: {
	    game: function game(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.loadDataGame(this.pgn, true);
	      }
	    },
	    pgn: function pgn(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.loadDataGame(newVal, true);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.game._id = this.game._id ? this.game._id : this.game.id;
	  },
	  beforeCreate: function beforeCreate() {},
	  created: function created() {
	    setTimeout(function () {
	      if (this.game._id) {
	        this.gameActual[this.game._id] = this.game;
	      }
	      this.game._id = this.game._id ? this.game._id : this.game.id;
	      this.loadDataGame(this.game, true);
	    }.bind(this), 500);
	  },
	  init: function init() {},
	  updated: function updated() {},
	  destroyed: function destroyed() {}
	};

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  name: 'BoardVisorSmall',
	  props: {
	    game: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    }
	  },
	  data: function data() {
	    return {
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      turnSmall: '',
	      gameActual: []
	    };
	  },
	
	  components: {},
	  mixins: [],
	  events: {
	    move: function move(board) {
	      if (this.game._id === board.idBoard) {
	        board.pgn = board.pgn.split('"]').join('"]\n');
	        board.pgn = board.pgn.split('{}').join('');
	
	        this.changeStateGame(board.pgn, board.idBoard, board.fen);
	      }
	    }
	  },
	  methods: {
	    prettyPgn: function prettyPgn(strParam) {
	      return strParam;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var wordBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0) {
	          headerObj[key] = value;
	          if (key === wordBreak) {
	            break;
	          }
	        }
	      }
	      return headerObj;
	    },
	    changeStateGame: function changeStateGame(pgn, id, fen) {
	      pgn = this.prettyPgn(pgn);
	      if (document.getElementById(id + '-boardsmall') !== null) {
	        var Width = 150;
	        var pos = 'end';
	        var start = fen !== undefined ? fen : '';
	
	        var headers = this.parse_pgn_header(pgn, 'FEN');
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = fen !== undefined && fen !== 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1' ? fen : headers['FEN'];
	          if (!this.hasBody(pgn)) {
	            start = '';
	            pos = headers['FEN'];
	          }
	          if (pos === headers['FEN']) {
	            start = '';
	          }
	          start = '';
	          pos = headers['FEN'];
	        }
	        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	          start = '';
	          pos = fen;
	        }
	
	        if (Width > 0 && fen !== undefined && typeof window.pgnBoard === 'function') {
	          window.pgnView({ inner: id + '-boardsmall' }, { pgn: pgn, position: pos, startPlay: start, showCoords: false, width: Width });
	        } else {
	          window.pgnView({ inner: id + '-boardsmall' }, { pgn: pgn, position: 'start', showCoords: false, width: Width });
	        }
	        var comments = document.querySelectorAll('.afterComment');
	        comments.forEach(function (comment) {
	          var textResource = comment.textContent.toLowerCase();
	          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	            comment.closest('.move').classList.add('highlight-move');
	          }
	        });
	      }
	    },
	    loadDataGame: function loadDataGame(board) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      board.pgn = this.prettyPgn(board.pgn);
	
	      this.changeStateGame(board.pgn, board._id ? board._id : board.id, 'end');
	    }
	  },
	  watch: {
	    game: function game(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.loadDataGame(newVal, true);
	      }
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.game._id = this.game._id ? this.game._id : this.game.id;
	  },
	  beforeCreate: function beforeCreate() {},
	  created: function created() {
	    setTimeout(function () {
	      this.gameActual[this.game._id] = this.game;
	      this.game._id = this.game._id ? this.game._id : this.game.id;
	      this.loadDataGame(this.game, true);
	    }.bind(this), 600);
	  },
	  init: function init() {},
	  updated: function updated() {},
	  destroyed: function destroyed() {}
	};

/***/ }),
/* 315 */,
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _from = __webpack_require__(29);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UploadFilesLesson',
	  props: {
	    value: {
	      type: Array
	    },
	    headers: Object,
	    action: {
	      type: String,
	      required: true
	    },
	    id: String,
	    name: {
	      type: String,
	      required: true
	    },
	    multiple: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    maxsize: String,
	    pathpermit: String,
	    method: String
	  },
	  directives: {
	    bindBoolean: {
	      priority: 850,
	      update: function update(value) {
	        var arg = this.arg;
	        if (value) {
	          this.el.setAttribute(arg, arg);
	        } else {
	          this.el.removeAttribute(arg);
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      myFiles: []
	    };
	  },
	
	  methods: {
	    OpenInputFile: function OpenInputFile() {
	      document.getElementById(this.name).click();
	      this.fileInputClick();
	    },
	    fileInputClick: function fileInputClick() {
	      this.$dispatch('onFileClick', this.myFiles);
	    },
	    validateFiles: function validateFiles(files) {
	      var sumSize = 0;
	      var allOk = true;
	      Array.prototype.slice.call(files, 0).map(function (file) {
	        sumSize += parseInt(file.size);
	        var maxSize = parseInt(this.maxsize) * 1024 * 1024;
	
	        if (sumSize > maxSize) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.size_not_permit'));
	          allOk = false;
	        }
	        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	
	        if (this.pathpermit.indexOf(type) === -1) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.path_not_permit'));
	          allOk = true;
	        }
	      }.bind(this));
	      return allOk;
	    },
	    fileInputChange: function fileInputChange(event) {
	      var files = event.target.files;
	      var pgnFiles = (0, _from2.default)(files);
	      if (pgnFiles.length > 0) {
	        var ident = this.id || this.name;
	        this.myFiles = document.getElementById(ident).files;
	        this.$dispatch('onFileChange', this.myFiles);
	        if (this.validateFiles(this.myFiles)) {
	          this.fileUpload();
	        }
	      } else {}
	    },
	    _onProgress: function _onProgress(e) {
	      e.percent = e.loaded / e.total * 100;
	      this.$dispatch('onFileProgress', e);
	    },
	    _handleUpload: function _handleUpload(file) {
	      this.$dispatch('beforeFileUpload', file);
	      var form = new window.FormData();
	      var xhr = new window.XMLHttpRequest();
	      try {
	        form.append('Content-Type', file.type || 'application/octet-stream');
	
	        form.append('file', file);
	      } catch (err) {
	        this.$dispatch('onFileError', file, err);
	        return;
	      }
	      return new _promise2.default(function (resolve, reject) {
	        xhr.upload.addEventListener('progress', this._onProgress, false);
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState < 4) {
	            return;
	          }
	          if (xhr.status < 400) {
	            var res = xhr.responseText;
	            var newFile = {
	              name: res,
	              size: file.size,
	              type: file.type,
	              lastModifiedDate: file.lastModifiedDate
	            };
	            this.value.push(newFile);
	            this.$dispatch('onFileUpload', newFile, res);
	            resolve(file);
	          } else {
	            var err = xhr.responseText;
	            this.$dispatch('onFileError', file, err);
	            reject(err);
	          }
	        }.bind(this);
	
	        xhr.onerror = function () {
	          var err = JSON.parse(xhr.responseText);
	          this.$dispatch('onFileError', file, err);
	          reject(err);
	        }.bind(this);
	
	        xhr.open(this.method || 'POST', this.action, true);
	        if (this.headers) {
	          for (var header in this.headers) {
	            xhr.setRequestHeader(header, this.headers[header]);
	          }
	        }
	        xhr.send(form);
	        this.$dispatch('afterFileUpload', file);
	      }.bind(this));
	    },
	    fileUpload: function fileUpload() {
	      if (this.myFiles.length > 0) {
	        var arrayOfPromises = Array.prototype.slice.call(this.myFiles, 0).map(function (file) {
	          return this._handleUpload(file);
	        }.bind(this));
	
	        _promise2.default.all(arrayOfPromises).then(function (allFiles) {
	          this.$dispatch('onAllFilesUploaded', allFiles);
	        }.bind(this)).catch(function (err) {
	          this.$dispatch('onFileError', this.myFiles, err);
	        }.bind(this));
	      } else {
	        var err = new Error('No files to upload for this field');
	        this.$dispatch('onFileError', this.myFiles, err);
	      }
	    }
	  }
	};

/***/ }),
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(41);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _board = __webpack_require__(27);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _boardHistory = __webpack_require__(110);
	
	var _boardHistory2 = _interopRequireDefault(_boardHistory);
	
	var _bodyMen = __webpack_require__(69);
	
	var _bodyMen2 = _interopRequireDefault(_bodyMen);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _actions = __webpack_require__(57);
	
	var _getters = __webpack_require__(28);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	var timesColor = {
	  white: 1,
	  black: 1
	};
	window.pgn = '';
	window.ground = 0;
	window.pgnBoardBase = 0;
	window.computerGame = 1;
	window.orientationg = 'white';
	exports.default = {
	  name: 'BoardVisor',
	  props: {
	    sendtoteacher: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    board: {
	      type: Object,
	      'default': null
	    },
	    classboard: {
	      type: String
	    }
	  },
	  computed: {
	    validBoard: function validBoard() {
	      return Array.isArray(this.board) ? null : this.board;
	    }
	  },
	  data: function data() {
	    return {
	      result: {},
	      boardShow: {},
	      history: [],
	      chess: new _chess2.default(),
	      turn: '',
	      userFrom: '',
	      activeChat: 'Visor',
	      chatRecibido: false,
	      fen: '',
	      tokens: [],
	      chattext: '',
	      newEmoji: '',
	      mensjGame: [],
	      times: {
	        black: 300,
	        white: 300,
	        incremento: 0
	      },
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      myFENValue: '',
	      myPGNValue: '',
	      myPGNReload: '',
	      userChat: _user2.default.user.name,
	      Width: 500
	    };
	  },
	
	  components: {
	    BoardHistory: _boardHistory2.default,
	    BodyMen: _bodyMen2.default
	  },
	  mixins: [_vueMaterialComponents2.default],
	  vuex: {
	    actions: {
	      boardGameMove: _actions.boardGameMove,
	      boardGameTurn: _actions.boardGameTurn,
	      boardGameCountDown: _actions.boardGameCountDown
	    },
	    getters: {
	      fen: _getters.getGameFen,
	      pgn: _getters.getGamePgn,
	      turn: _getters.getGameTurn,
	      time: _getters.getGameTimesUsers
	    }
	  },
	  events: {
	    mensajegeneral: function mensajegeneral(data) {
	      this.recibeMensaje(data.men, true);
	      if (data.men.send !== this.user.username) {
	        this.chatRecibido = true;
	      }
	      console.log('EVENT mensajegeneral ');
	    },
	    move: function move(board) {
	      console.log('EVENT move ');
	
	      if (this.boardShow && this.boardShow._id === board.idBoard) {
	        if (document.getElementById('searchInput') && document.getElementById('analisisModal').style.display !== 'none') {
	          document.getElementById('searchInput').value = window.pgnBoardBase.chess.fen();
	          document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	        }
	
	        console.log('event move ' + board.move);
	
	        if (this.isHumanVsAnalisis() === false || board.user !== undefined && board.user.userName !== this.boardShow.u1) {
	          if (board.user !== undefined) {
	            this.userFrom = board.user.username;
	          }
	
	          this.changeStateGame(board);
	          if (board.times) {
	            this.times = board.times;
	          }
	        }
	      }
	    },
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      console.log('EVENT getLength ');
	      return ret;
	    },
	    gameFinish: function gameFinish(dataResult) {
	      this.stateFinishGame(dataResult);
	      console.log('EVENT gameFinish ');
	    },
	    sendPGNtoTeacher: function sendPGNtoTeacher() {
	      console.log('EVENT sendPGNtoTeacher ');
	
	      var turn = 'w';
	      if (window.pgnBoardBase.chess !== undefined) {
	        turn = window.pgnBoardBase.chess.turn() === 'w' ? 'white' : 'black';
	      }
	      var data = {
	        c: 'board',
	        f: 'move',
	        data: {
	          event: 'move',
	          data: {
	            pgn: this.myPGNValue,
	            fen: this.myFENValue,
	            idBoard: this.boardShow._id,
	            turn: turn,
	            times: {},
	            user: _user2.default.getUser()
	          }
	        }
	      };
	
	      if (this.$socket !== undefined) {
	        this.$socket.emit('event', data, function () {});
	      }
	      this.userFrom = this.user.username;
	    },
	    analizaPGN: function analizaPGN() {
	      this.$broadcast('modal::open', 'invitePCAnalisis');
	      console.log('EVENT sendPGNtoTeacher ');
	    }
	  },
	  methods: {
	    stateGame: function stateGame(board) {
	      if (board.wins === 'draw') {
	        var textdraw = 'Tablas' + ' ' + _vue2.default.t('visor.by');
	        textdraw += ' ';
	        textdraw += board.motiv === 'drawn_position' ? 'positión de tablas' : board.motiv === 'insufficient_material' ? 'material insuficiente' : board.motiv === 'threefold_repetition' ? 'repetición' : board.motiv === 'stalemate' ? 'ahogado' : board.motiv;
	        return textdraw;
	      } else {
	        var text = _vue2.default.t('visor.wins');
	        text += board.wins === 'white' ? ' blancas ' : ' negras ' + _vue2.default.t('visor.by');
	        text += ' ';
	        text += board.motiv === 'rendicion' ? 'rendición' : board.motiv === 'timeout' ? 'tiempo' : board.motiv === 'checkmate' ? 'jaque mate' : board.motiv;
	        return text;
	      }
	    },
	    sendMensajeGeneral: function sendMensajeGeneral() {
	      if (this.chattext === '') {
	        return;
	      }
	      var thisUser = this.user.username;
	      var otherUser = this.board.u1 === thisUser ? this.board.u2 : this.board.u1;
	      var men = {
	        body: this.chattext,
	        type: 'text',
	        public: true,
	        all: true,
	        club: this.user.club,
	        board: this.user.club,
	        send: thisUser,
	        recibe: otherUser
	      };
	      var data = {
	        c: 'chat',
	        f: 'mensajegeneral',
	        data: {
	          men: men
	        }
	      };
	      this.$socket.emit('event', data, function () {});
	      this.chattext = '';
	      this.isAtBottom();
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var historyTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      try {
	        var data = {
	          c: 'chat',
	          f: 'loadUserConvert',
	          data: parms
	        };
	        this.$socket.emit('event', data, function () {
	          var log = arguments.length <= 1 ? undefined : arguments[1];
	          this.mensjGame = [];
	          var menLast = '';
	          if (log) {
	            for (var i = log.length - 1; i >= 0; i--) {
	              if (menLast !== log[i].body || menLast === '') {
	                this.recibeMensaje(log[i], false);
	                menLast = log[i].body;
	              }
	            }
	          }
	          this.isAtBottom();
	        }.bind(this));
	      } catch (error) {}
	    },
	    userScroll: function userScroll(e) {
	      var scrollTop = e.target.scrollTop;
	
	      if (scrollTop === 0) {
	        var post = this.foundTab(this.active);
	
	        var parmsLoad = {
	          user: this.active,
	          range: {
	            limit: 100,
	            skip: this.tabs[post].men.length
	          }
	        };
	
	        this.loadUserConvert(parmsLoad, true);
	      }
	    },
	    isAtBottom: function isAtBottom() {
	      var chatConvert = document.getElementById('chatConvertGame');
	      if (chatConvert) {
	        this.scrollBottom();
	      }
	    },
	    scrollBottom: function scrollBottom() {
	      (0, _jquery2.default)('#chatConvertGame').animate({
	        'scrollTop': (0, _jquery2.default)('#chatConvertGame')[0].scrollHeight
	      }, 'fast');
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === this.user.club) {
	        this.mensjGame.push(men);
	        if (bottom) {
	          this.isAtBottom();
	        }
	      }
	    },
	    GetFilename: function GetFilename(url) {
	      var filename = url.substring(url.lastIndexOf('/') + 1);
	      return filename;
	    },
	    getViewPgnUpload: function getViewPgnUpload(url) {
	      var dirServer = _lstorage2.default.get('serverDir');
	      var fileName = dirServer + '/uploads/' + this.GetFilename(url);
	
	      return dirServer + '/#!/visor/0/0/only/' + fileName;
	    },
	    soundPlay: function soundPlay() {
	      var sonido = document.getElementById('sound');
	      if (sonido) {
	        sonido.play();
	      }
	    },
	    onResize: function onResize(event) {
	      this.resizeBoard();
	    },
	    deleteResource: function deleteResource(resource) {},
	    changeOrientation: function changeOrientation() {
	      window.orientationg = window.orientationg === 'white' ? 'black' : 'white';
	      window.ground.set({
	        orientation: window.orientationg,
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      });
	    },
	    isHumanVsAnalisis: function isHumanVsAnalisis() {
	      return this.board !== undefined && this.board.u1 === this.board.u2;
	    },
	    stateFinishGame: function stateFinishGame(state) {
	      if (state.board._id === this.board._id) {
	        this.result = {
	          wins: state.result.color,
	          motiv: state.result.motiv
	        };
	        clearInterval(timesColor.black);
	        clearInterval(timesColor.white);
	      }
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    changePGNTextArea: function changePGNTextArea() {
	      var idTextArea = document.getElementById('idTextAreaPGN');
	      if (idTextArea && idTextArea.value !== 'none') {
	        var pgnAux = idTextArea.value;
	
	        this.myPGNValue = pgnAux;
	
	        var headers = this.parse_pgn_header(idTextArea.value);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          this.myFENValue = headers['FEN'];
	        }
	
	        this.board.pgn = idTextArea.value;
	        this.changeStateGame(this.board);
	        idTextArea.value = '';
	        var buttonLast = document.getElementById('pgnButtonslast');
	        if (buttonLast) {
	          buttonLast.click();
	        }
	      }
	    },
	    changePGN: function changePGN() {
	      var turn = this.chess.turn() === 'w' ? 'white' : 'black';
	      var data = {
	        c: 'board',
	        f: 'move',
	        data: {
	          event: 'move',
	          data: {
	            urls: this.board.urls,
	            pgn: this.myPGNValue,
	            fen: this.myFENValue,
	            idBoard: this.board._id,
	            turn: turn,
	            times: {},
	            user: _user2.default.getUser()
	          }
	        }
	      };
	
	      this.$socket.emit('event', data, function () {});
	    },
	    onMove: function onMove(orig, dest) {
	      if (this.active || true) {
	        var promopiece = 'q';
	
	        this.chess.move({
	          from: orig,
	          to: dest,
	          promotion: promopiece
	        });
	        this.posiblecancel = this.chess.history().length <= 2;
	
	        var data = 0;
	        var turn = this.chess.turn() === 'w' ? 'white' : 'black';
	        var myTurn = this.user.username === this.board.u1 ? 'white' : 'black';
	        if (this.isHumanVsAnalisis()) {
	          data = {
	            c: 'board',
	            f: 'move',
	            data: {
	              event: 'move',
	              data: {
	                pgn: this.myPGNValue,
	                fen: this.myFENValue,
	                idBoard: this.board._id,
	                userTurn: myTurn,
	                turn: turn,
	                times: {},
	                move: {
	                  from: orig,
	                  to: dest
	                }
	              }
	            }
	          };
	          if (this.$socket !== undefined) {
	            this.$socket.emit('event', data, function () {});
	          }
	        } else {
	          data = {
	            c: 'board',
	            f: 'move',
	            data: {
	              event: 'move',
	              data: {
	                pgn: this.chess.pgn(),
	                fen: this.chess.fen(),
	                idBoard: this.board._id,
	                userTurn: myTurn,
	                turn: turn,
	                times: {},
	                move: {
	                  from: orig,
	                  to: dest
	                }
	              }
	            }
	          };
	          if (this.$socket !== undefined) {
	            this.$socket.emit('event', data, function () {});
	          }
	        }
	      }
	    },
	    isOwner: function isOwner() {
	      return this.user.username === this.board.u1 || this.user.username === this.board.u2;
	    },
	    isPgnFile: function isPgnFile(path) {
	      return (/\.pgn$/i.test(path)
	      );
	    },
	    changeStateGame: function changeStateGame(board) {
	      var only = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      try {
	        if (only === false && (board === undefined || board.pgn === undefined || board.pgn === '')) {
	          return;
	        }
	        if (only === false) {
	          board.pgn = board.pgn.split('"]').join('"]\n');
	
	          window.pgn = board.pgn;
	
	          if (board.move !== undefined) {
	            window.ground.move(board.move.from, board.move.to);
	          } else {
	            this.chess.load_pgn(board.pgn);
	          }
	        }
	        if (window.ground) {
	          window.ground.set({
	            fen: this.chess.fen(),
	            orientation: window.orientationg,
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          });
	        }
	
	        var pos = 'end';
	        if (this.$route.path.includes('/lesson')) {
	          pos = 'start';
	        }
	        var start = '';
	        if (only === false) {
	          start = board.fen !== undefined ? board.fen : '';
	          board.pgn = board.pgn.split('"]').join('"]\n');
	
	          var headers = this.parse_pgn_header(board.pgn);
	          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	            pos = board.fen !== undefined ? board.fen : 'end';
	            if (!this.hasBody(board.pgn)) {
	              start = '';
	              pos = headers['FEN'];
	            }
	            if (pos === headers['FEN']) {
	              start = '';
	            }
	          }
	          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	            start = '';
	            pos = board.fen;
	          }
	          console.log(pos);
	        }
	
	        if (document.getElementById('pgnMoves')) {
	          document.getElementById('pgnMoves').textContent = '';
	        }
	        if (document.getElementById('pgnButtons')) {
	          document.getElementById('pgnButtons').textContent = '';
	        }
	        if (document.getElementById('pgnComment')) {
	          document.getElementById('pgnComment').textContent = '';
	        }
	        if (document.getElementById('pgnHeader')) {
	          document.getElementById('pgnHeader').textContent = '';
	        }
	        if (document.getElementById('pgnError')) {
	          document.getElementById('pgnError').textContent = '';
	        }
	        var pgnBoard = 0;
	        window.orientationg = this.isHumanVsAnalisis() === false && this.user.username === this.board.u2 ? 'black' : 'white';
	
	        if (only === false) {
	          if (start === headers['FEN']) {
	            start = '';
	          }
	        }
	
	        var winWidth = Math.min(window.innerWidth, window.outerWidth);
	        this.resizeBoard();
	        if (this.$route.params.u2 !== '' && this.$route.params.u1 === 'only') {
	          if (this.isPgnFile(this.$route.params.u2)) {
	            var dirServer = _lstorage2.default.get('serverDir');
	
	            var ruta = dirServer + '/uploads/' + this.$route.params.u2;
	            pgnBoard = window.pgnView({ inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { pgnFile: ruta, startPlay: start, position: pos, hideMovesBefore: false, movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	          } else {
	            if (board.pgn !== 'none') {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { pgn: board.pgn, startPlay: start, position: 'end', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	            } else {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	            }
	          }
	        } else {
	          if (this.isOwner() === false || this.boardShow.wins || this.isHumanVsAnalisis()) {
	            if (board.pgn !== 'none') {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { pgn: board.pgn, startPlay: start, position: pos, hideMovesBefore: false, movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, coordsFactor: 0.6, width: this.Width, coordsInner: winWidth < 600, headers: true });
	            } else {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', moves: 'pgnMoves', comment: 'pgnComment', button: 'pgnButtons', fen: 'pgnFen', header: 'pgnHeader', error: 'pgnError' }, { position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	            }
	          } else {
	            if (board.pgn !== 'none') {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', fen: 'pgnFen', header: 'pgnHeader', comment: 'pgnComment', error: 'pgnError' }, { pgn: board.pgn, startPlay: start, position: 'end', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	            } else {
	              pgnBoard = window.pgnEdit({ inner: 'pgnBoard', fen: 'pgnFen', header: 'pgnHeader', comment: 'pgnComment', error: 'pgnError' }, { position: 'start', movesWidth: '90%', showFen: true, colorMarker: 'cm-small', locale: 'es', orientation: window.orientationg, width: this.Width, coordsFactor: 0.6, coordsInner: winWidth < 600, headers: true });
	            }
	          }
	        }
	        window.pgnBoardBase = pgnBoard.boardBase;
	        window.ground = pgnBoard.board;
	
	        this.chessToColor(window.pgnBoardBase.chess);
	
	        if (this.isHumanVsAnalisis() === false && this.isOwner()) {
	          var preMove = window.ground !== undefined && window.ground.state !== undefined && window.ground.state.premovable !== undefined ? window.ground.state.premovable.current : null;
	          var myTurn = this.user.username === this.board.u1 ? 'w' : 'b';
	
	          window.ground.set({
	            fen: this.chess.fen(),
	            turnColor: this.chess.turn() === myTurn ? this.chessToColor(this.chess) : this.chessToColorVs(this.chess),
	            movable: {
	              color: this.chessToColor(this.chess),
	              premove: true,
	              dests: this.chessToDests(this.chess)
	            },
	            disableContextMenu: true,
	            highlight: {
	              lastMove: true,
	              check: true },
	            events: {
	              move: this.onMove
	            },
	            premovable: {
	              enabled: true,
	              showDests: true,
	              current: preMove
	            },
	            drawable: {
	              enabled: true,
	              visible: true
	            },
	            resizable: true
	          });
	          window.ground.playPremove();
	        }
	        var comments = document.querySelectorAll('.afterComment');
	        comments.forEach(function (comment) {
	          var textResource = comment.textContent.toLowerCase();
	          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	            comment.closest('.move').classList.add('highlight-move');
	          }
	        });
	      } catch (error) {
	        console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000);
	      }
	    },
	    toggleOrientation: function toggleOrientation() {},
	    chessToDests: function chessToDests(chess) {
	      var dests = {};
	      chess.SQUARES.forEach(function (s) {
	        var ms = chess.moves({ square: s, verbose: true });
	        if (ms.length) dests[s] = ms.map(function (m) {
	          return m.to;
	        });
	      });
	      return dests;
	    },
	    chessToColorVs: function chessToColorVs(chess) {
	      var turn = this.chessToColor(chess) === 'black' ? 'white' : 'black';
	      return turn;
	    },
	    countDown: function countDown() {
	      clearInterval(timesColor[this.turn]);
	      timesColor[this.turn] = setInterval(function () {
	        this.times[this.turn] = this.times[this.turn] - 1;
	        if (this.times[this.turn] <= 0) {
	          clearInterval(timesColor.white);
	          clearInterval(timesColor.black);
	          this.times[this.turn] = 0;
	        }
	      }.bind(this), 1000);
	    },
	    chessToColor: function chessToColor(chess) {
	      var t = chess.turn();
	      var turn = t === 'w' ? 'white' : 'black';
	      this.boardGameTurn(turn);
	      turn = this.user.username === this.board.u2 ? 'black' : 'white';
	      return turn;
	    },
	    getRandomInt: function getRandomInt(min, max) {
	      min = Math.ceil(min);
	      max = Math.floor(max);
	      return Math.floor(Math.random() * (max - min + 1)) + min;
	    },
	    readTextFile: function readTextFile(file) {
	      var allText = '';
	      var rawFile = new window.XMLHttpRequest();
	      rawFile.open('GET', file, true);
	      rawFile.onreadystatechange = function () {
	        if (rawFile.readyState === 4) {
	          if (rawFile.status === 200 || rawFile.status === 0) {
	            allText = rawFile.responseText;
	          }
	        }
	      };
	      rawFile.send();
	      return allText;
	    },
	    loadDataGame: function loadDataGame(board) {
	      clearInterval(timesColor.white);
	      clearInterval(timesColor.black);
	      this.activeChat = 'Visor';
	      this.boardShow = board;
	      var parmsLoad = {
	        user: this.active,
	        board: this.user.club,
	        range: {
	          limit: 100,
	          skip: 0
	        }
	      };
	
	      this.loadUserConvert(parmsLoad, true);
	
	      if (board.wins) {
	        this.boardShow = board;
	
	        this.changeStateGame(board);
	
	        return;
	      }
	
	      if (board.type === 'torneo') {
	        this.boardShow = board;
	        this.changeStateGame(board);
	      } else {
	        var data = {
	          c: 'board',
	          f: 'getBoard',
	          data: board
	        };
	
	        if (this.$socket !== undefined) {
	          this.$socket.emit('event', data, function () {
	            for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	              callbacks[_key] = arguments[_key];
	            }
	
	            if (!callbacks[0] && callbacks[1].board && callbacks[1].board.pgn) {
	              this.activeChat = 'Visor';
	              var board = callbacks[1].board;
	              this.boardShow = board;
	              this.times = callbacks[1].times;
	
	              this.changeStateGame(board);
	
	              this.countDown();
	            } else {
	              this.board = [];
	              this.changeStateGame(this.board);
	            }
	          }.bind(this));
	        }
	      }
	    },
	    timerfunction: function timerfunction(fen) {},
	    resizeBoard: function resizeBoard() {
	      if (document.getElementById('middle') && document.getElementById('pgnBoard')) {
	        this.Width = document.getElementById('middle').clientWidth;
	        this.Width = this.Width > window.innerHeight - 150 ? window.innerHeight - 150 : this.Width;
	        var winWidth = Math.min(window.innerWidth, window.outerWidth);
	        var Left = 0;
	        var LeftAnalisis = 0;
	        if (winWidth >= 782) {
	          if (this.Width < document.getElementById('middle').clientWidth) {
	            var rightMore = document.getElementById('middle').clientWidth - this.Width;
	
	            Left = rightMore / 2 + 'px';
	            LeftAnalisis = rightMore / 2 - 3 + 'px';
	          }
	        }
	        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	          this.Width = this.Width - 20;
	        }
	        document.getElementById('pgnBoard').style.left = Left;
	        document.getElementById('pgnBoard').style.height = this.Width + 'px';
	        document.getElementById('pgnBoard').style.width = this.Width + 'px';
	        document.getElementById('analisisVertical').style.left = LeftAnalisis;
	        document.getElementById('analisisVertical').style.height = this.Width + 6 + 'px';
	
	        document.body.dispatchEvent(new window.Event('chessground.resize'));
	      }
	    },
	    pcVsPcInit: function pcVsPcInit() {
	      setTimeout(function () {
	        var fen = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	        this.timerfunction(fen);
	      }.bind(this), 2000);
	    },
	    checkResources: function checkResources(fen) {
	      if (this.board.urls !== undefined && this.board.urls.length > 0) {
	        var iFound = this.board.urls.indexOf(fen);
	        if (iFound >= 0) {
	          var nInitUrls = iFound + fen.length + 1;
	          var nFinUrls = this.board.urls.indexOf(';', nInitUrls);
	          var sql = this.board.urls.substring(nInitUrls, nFinUrls);
	          this.tokens.length = 0;
	          var _self = this;
	          sql.replace(/\{(.*?)}/g, function (a, b) {
	            var splitToken = b.split('=');
	            var token = {};
	            token.name = splitToken[0];
	            token.url = splitToken[1];
	            token.type = '';
	            token.type = splitToken[1].includes('http') ? 'link' : token.type;
	            token.type = splitToken[1].endsWith('pdf') ? 'pdf' : token.type;
	            token.type = splitToken[1].endsWith('pgn') ? 'pgn' : token.type;
	            token.type = splitToken[1].includes('embed') && splitToken[1].includes('youtube') ? 'youtube' : token.type;
	            token.type = splitToken[1].endsWith('png') || splitToken[1].endsWith('jpg') || splitToken[1].endsWith('jpeg') || splitToken[1].endsWith('gif') ? 'image' : token.type;
	            _self.tokens.push(token);
	          });
	
	          setTimeout(function () {
	            this.$broadcast('modal::open', 'modalRecursos');
	          }.bind(this), 300);
	        }
	      }
	    }
	  },
	  watch: {
	    newEmoji: function newEmoji(newVal, oldVal) {
	      this.chattext += newVal;
	      document.getElementById('textChatInput').focus();
	    },
	    activeChat: function activeChat(newVal, oldVal) {
	      if (newVal === 'Visor') {
	        this.changeStateGame(this.board);
	        this.chatRecibido = false;
	      }
	      if (this.activeChat === 'Chat') {
	        this.chatRecibido = false;
	        this.scrollBottom();
	      }
	    },
	    board: function board(newVal, oldVal) {
	      if (newVal !== undefined && (0, _stringify2.default)(newVal) !== (0, _stringify2.default)(oldVal)) {
	        this.loadDataGame(newVal);
	        this.result = {
	          wins: '',
	          motiv: ''
	        };
	      }
	    },
	    myPGNReload: function myPGNReload(val, oldVal) {
	      if (val === 'reload') {
	        this.historyChange = true;
	
	        this.changeStateGameSimple();
	        document.getElementById('myPGNReload').value = '';
	        document.getElementById('myPGNReload').dispatchEvent(new window.Event('change'));
	      }
	    },
	    myPGNValue: function myPGNValue(val, oldVal) {
	      if (this.isOwner() && this.board.u1 === this.board.u2 && val !== oldVal) {
	        this.changePGN();
	      }
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      if (document.getElementById('searchInput')) {
	        document.getElementById('searchInput').value = val;
	
	        document.getElementById('myFENValueP').textContent = val;
	        if (document.getElementById('analisisModal').style.display !== 'none') {
	          document.getElementById('searchInput').dispatchEvent(new window.Event('change'));
	        }
	      }
	      this.$broadcast('modal::close', 'some', 'modalRecursos');
	      this.checkResources(val);
	
	      if (this.board.u1 === this.board.u2 && val !== oldVal && this.boardShow !== undefined && this.userFrom !== this.boardShow.u1 && this.userFrom === this.user.username) {}
	      if (window.pgnBoardBase !== undefined && window.pgnBoardBase !== null && window.pgnBoardBase.chess !== undefined) {
	        this.turn = window.pgnBoardBase.chess.turn() === 'w' ? 'white' : 'black';
	      }
	    },
	    turn: function turn(newVal, oldVal) {
	      clearInterval(timesColor[oldVal]);
	      clearInterval(timesColor[newVal]);
	      if (this.boardShow !== undefined && !this.boardShow.wins) {
	        this.countDown();
	      }
	    }
	  },
	  ready: function ready() {
	    setTimeout(function () {
	      this.resizeBoard();
	    }.bind(this), 500);
	  },
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	    clearTimeout(window.computerGame);
	    clearInterval(timesColor.white);
	    clearInterval(timesColor.black);
	
	    if (this.board !== undefined) {
	      window.orientationg = this.isHumanVsAnalisis() === false && this.user.username === this.board.u2 ? 'black' : 'white';
	    }
	    setTimeout(function () {
	      this.loadDataGame(this.board);
	      this.resizeBoard();
	    }.bind(this), 200);
	
	    if (this.$route.params.u2 !== '' && this.$route.params.u1 === 'only') {
	      var _self = this;
	
	      if (this.isPgnFile(this.$route.params.u2) === false) {
	        _board2.default.filterid(_self, { id: _self.$route.params.u2 }).then(function (response) {
	          var data = JSON.parse(response);
	          _self.board = data;
	        }, function (response) {
	          _self.error = response.data;
	
	          _self.changeStateGame(null, true);
	        });
	      } else {
	        _self.changeStateGame(null, true);
	      }
	    }
	  }
	};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  name: 'BoardVisorSmall',
	  props: {
	    game: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    },
	    callbackFunction: {
	      type: Function,
	      required: false }
	  },
	  data: function data() {
	    return {
	      styleboard: true,
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      user: _user2.default.user,
	      turnSmall: 'borderWhite',
	      gameActual: []
	    };
	  },
	
	  components: {},
	  mixins: [_vueMaterialComponents2.default],
	  events: {
	    move: function move(board) {
	      if (this.game !== undefined && this.game._id === board.idBoard) {
	        this.changeStateGame(board.pgn, board.idBoard, board.fen);
	        console.log('EVENTS move small changeStateGame');
	      }
	      console.log('EVENTS move small');
	    }
	  },
	  methods: {
	    showBoard: function showBoard(board) {
	      var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var event = arguments[2];
	
	      if (event) {
	        event.stopPropagation();
	      }
	      if (this.callbackFunction) {
	        this.callbackFunction(board, open);
	      } else {
	        console.log('No hay función de callback');
	      }
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = Buffer.from(strParam, 'latin1').toString('utf8');
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    changeStateGame: function changeStateGame(pgn, id, fen) {
	      if (document.getElementById(id + '-middlesmall') !== null) {
	        var Width = 160;
	        var pgnBoard = 0;
	        var pos = 'end';
	        var start = fen !== undefined ? fen : '';
	        pgn = this.prettyPgn(pgn);
	
	        var headers = this.parse_pgn_header(pgn);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = fen !== undefined ? fen : 'end';
	          if (!this.hasBody(pgn)) {
	            start = '';
	            pos = headers['FEN'];
	          }
	          if (pos === headers['FEN']) {
	            start = '';
	          }
	        }
	        if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	          start = '';
	          pos = fen;
	        }
	        if (start === headers['FEN']) {
	          start = '';
	        }
	        try {
	          if (Width > 0 && pgn !== 'none' && pgn !== '' && typeof window.pgnView === 'function') {
	            pgnBoard = window.pgnView({ inner: id + '-boardsmall' }, { pgn: pgn, startPlay: start, position: pos, showCoords: false, width: Width });
	          } else {
	            pgnBoard = window.pgnView({ inner: id + '-boardsmall' }, { pgn: '', position: '', showCoords: false, width: Width });
	          }
	
	          if (pgnBoard && pgnBoard.chess) {
	            this.turnSmall = pgnBoard.chess.turn() === 'w' ? 'borderWhite' : 'borderBlack';
	          }
	        } catch (error) {
	          console.error('<span>' + 'Error Mainchess (changeStateGame): ' + error + '</span>', 3000);
	        }
	      }
	    },
	    loadDataGame: function loadDataGame(board) {
	      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var data = {
	        c: 'board',
	        f: 'getBoardSmall',
	        data: board
	      };
	
	      this.$socket.emit('event', data, function () {
	        for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	          callbacks[_key] = arguments[_key];
	        }
	
	        if (!callbacks[0]) {
	          var boardGet = callbacks[1].board;
	
	          if (boardGet !== undefined && this.gameActual[boardGet._id] && boardGet.pgn !== this.gameActual[boardGet._id].pgn || force) {
	            var fen = boardGet.fen !== undefined ? boardGet.fen : 'end';
	            this.changeStateGame(boardGet.pgn, boardGet._id, fen);
	            boardGet.idBoard = boardGet._id;
	            _lstorage2.default.set(boardGet._id, boardGet);
	          }
	        } else {}
	      }.bind(this));
	    }
	  },
	  watch: {
	    game: function game(newVal, oldVal) {}
	  },
	  created: function created() {
	    if (this.game && this.game._id) {
	      this.gameActual[this.game._id] = this.game;
	      this.game._id = this.game._id ? this.game._id : this.game.id;
	      this.loadDataGame(this.game, true);
	    }
	  },
	  attached: function attached() {},
	  beforeDestroy: function beforeDestroy() {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'BodyMen',
	  props: {
	    mens: {
	      type: Array
	    },
	    dirServer: {
	      type: String
	    },
	    user: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {
	      some: ''
	    };
	  },
	
	  methods: {
	    openInNewTab: function openInNewTab(name) {
	      var win = window.open(this.dirServer + '/uploads/' + name, '_blank');
	      win.focus();
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      var ret = '';
	      if (name !== undefined) {
	        ret = this.dirServer + '/uploads/' + name;
	      }
	      return ret;
	    },
	    isImage: function isImage(file) {
	      var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	      return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
	    },
	    deleteMensaje: function deleteMensaje(men, post) {
	      if (window.confirm('Desea eliminar realmente')) {
	        this.mens.splice(post, 1);
	      }
	    },
	    editMen: function editMen(men) {}
	  }
	};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _boardVisor = __webpack_require__(112);
	
	var _boardVisor2 = _interopRequireDefault(_boardVisor);
	
	var _boardVisorSmall = __webpack_require__(539);
	
	var _boardVisorSmall2 = _interopRequireDefault(_boardVisorSmall);
	
	var _uploadFiles = __webpack_require__(284);
	
	var _uploadFiles2 = _interopRequireDefault(_uploadFiles);
	
	var _bodyMen = __webpack_require__(69);
	
	var _bodyMen2 = _interopRequireDefault(_bodyMen);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _config = __webpack_require__(22);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    }
	  },
	  template: __webpack_require__(518),
	  data: function data() {
	    return {
	      finduser: '',
	      sendToAll: false,
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirServer: _lstorage2.default.get('serverDir'),
	      hashFileBoard1: '',
	      hashFileBoard2: '',
	      hashFileBoard3: '',
	      fileProgress: 0,
	      filesUpload: [],
	      allFilesUploaded: true,
	      offcanvas: false,
	      active: 'boardVisor',
	      activeChat: 'Visor',
	
	      tab: '0',
	      tabs: [],
	      chattext: '',
	      user: _user2.default.user,
	      boards: [],
	      boardFiles: [],
	      boardFilesName: '',
	      boardFiles2: [],
	      boardFilesName2: '',
	      boardFiles3: [],
	      boardFilesName3: '',
	      newboard: {
	        color: 'w',
	        time: '3',
	        incremento: 0,
	        elo: 1500,
	        contrincante: '',
	        public: 'true',
	        broadcast: 'false',
	        all: 'false',
	        club: _user2.default.user.club
	      },
	      users: [],
	      usersLength: 0,
	      games: [],
	      boardHome: _lstorage2.default.get('boardSee', {}),
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: '',
	      sendtoteacher: false
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  events: {
	    updatepermissions: function updatepermissions(dta) {
	      this.user.chat = dta.men.user.chat;
	      this.user.chattext = dta.men.user.chattext;
	      this.user.chataudio = dta.men.user.chataudio;
	      this.user.cast = dta.men.user.cast;
	      this.user.live = dta.men.user.live;
	      this.user.analyse = dta.men.user.analyse;
	      this.user.sendtoanalyse = dta.men.user.sendtoanalyse;
	      this.user.download = dta.men.user.download;
	      if (this.user.username === dta.men.user.username) {}
	      console.log('EVENT updatepermissions ');
	    },
	    mensendactivate: function mensendactivate(data) {
	      var usermen = data.men.user.username;
	      var username = this.user.username;
	      if (usermen === username) {
	        this.user.sendtoanalyse = data.men.user.sendtoanalyse;
	        this.sendtoteacher = data.men.user.sendtoanalyse;
	        var _self = this;
	        this.loadOtherUser(this.user.username, function (someUser) {
	          _self.sendtoteacher = someUser.sendtoanalyse;
	        });
	      }
	
	      console.log('EVENT mensendactivate ');
	    },
	    users: function users(data) {
	      this.users = data.nicknames;
	      console.log('EVENT users ');
	    },
	    boards: function boards(data) {
	      this.boards = data.boards;
	      console.log('EVENT boards ');
	    },
	    mensaje: function mensaje(data) {
	      if (data.send !== this.user.username) {
	        this.recibeMensaje(data.men, true, true);
	      }
	    },
	    onFileClick: function onFileClick(file) {},
	    onFileChange: function onFileChange(file) {
	      this.fileProgress = 0;
	      this.allFilesUploaded = false;
	    },
	    beforeFileUpload: function beforeFileUpload(file) {
	      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000);
	    },
	    afterFileUpload: function afterFileUpload(file) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + '</span>', 2000);
	    },
	    onFileProgress: function onFileProgress(progress) {
	      this.fileProgress = parseInt(progress.percent);
	    },
	    onFileUpload: function onFileUpload(file, res) {
	      this.chattext = {
	        name: file.name,
	        size: file.size,
	        type: file.type,
	        lastModifiedDate: file.lastModifiedDate
	      };
	      this.sendMensaje('file');
	    },
	    onFileError: function onFileError(file, res) {
	      this.toast('<span>Error ' + res + '</span>', 3000);
	    },
	    onAllFilesUploaded: function onAllFilesUploaded(files) {
	      this.toast('<span>' + _vue2.default.t('home.uploadMens.success') + '</span>', 2000);
	
	      this.allFilesUploaded = true;
	    },
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	      console.log('EVENT updateBoards ');
	    }
	  },
	  props: {},
	  computed: {},
	  components: {
	    BoardVisor: _boardVisor2.default,
	    UploadFiles: _uploadFiles2.default,
	    BodyMen: _bodyMen2.default,
	    BoardVisorSmall: _boardVisorSmall2.default
	  },
	  watch: {
	    inmediate: true,
	    newEmoji: function newEmoji(newVal, oldVal) {
	      this.chattext += newVal;
	      document.getElementById('textChatInput').focus();
	    }
	  },
	  methods: {
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      return ret;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      var ret = '';
	      if (name !== undefined) {
	        ret = this.dirServer + '/uploads/' + name;
	      }
	      return ret;
	    },
	    userScroll: function userScroll(e) {
	      var scrollTop = e.target.scrollTop;
	
	      if (scrollTop === 0) {
	        var post = this.foundTab(this.active);
	
	        var parmsLoad = {
	          user: this.active,
	          range: {
	            limit: 20,
	            skip: this.tabs[post].men.length
	          }
	        };
	        this.loadUserConvert(parmsLoad, true);
	      }
	    },
	    createGame: function createGame() {
	      this.$broadcast('modal::open', 'invitePCAnalisis');
	    },
	    userToConversationWhite: function userToConversationWhite(user) {
	      this.activeWhite = user;
	      this.active = user.nickname;
	
	      this.$broadcast('modal::close', 'some', 'usersConnectWhite');
	      this.$broadcast('modal::open', 'inviteGameVersus');
	    },
	    userToConversationBlack: function userToConversationBlack(user) {
	      this.userconvert = user;
	      this.newboard.contrincante = user.nickname;
	      this.$broadcast('modal::close', 'some', 'usersConnectBlack');
	      this.$broadcast('modal::open', 'inviteGameVersus');
	    },
	    sendReto: function sendReto() {
	      this.active = this.user.username;
	      this.userconvert = this.user;
	      this.userconvert.nickname = '-ALL-';
	      this.newboard.contrincante = '-ALL-';
	      this.$broadcast('modal::open', 'inviteGameFast');
	    },
	    userToConversationComputer: function userToConversationComputer(name) {
	      this.userconvert = this.user;
	      this.userconvert.nickname = name;
	      this.newboard.contrincante = name;
	      this.$broadcast('modal::close', 'some', 'usersConnectBlack');
	      this.$broadcast('modal::close', 'some', 'usersConnectWhite');
	      this.$broadcast('modal::open', 'inviteGameVersus');
	    },
	    selectUserToConversationWhite: function selectUserToConversationWhite() {
	      var data = {
	        c: 'chat',
	        f: 'username',
	        data: {
	          user: this.user
	        }
	      };
	      setTimeout(function () {
	        this.$socket.emit('event', data, function () {
	          this.usersConnect = arguments.length <= 1 ? undefined : arguments[1];
	          this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	          this.$broadcast('modal::open', 'usersConnectWhite');
	        }.bind(this));
	      }.bind(this), 2);
	    },
	    selectUserToConversationBlack: function selectUserToConversationBlack() {
	      var data = {
	        c: 'chat',
	        f: 'username',
	        data: {
	          user: this.user
	        }
	      };
	      setTimeout(function () {
	        this.$socket.emit('event', data, function () {
	          this.usersConnect = arguments.length <= 1 ? undefined : arguments[1];
	          this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	          this.$broadcast('modal::open', 'usersConnectBlack');
	        }.bind(this));
	      }.bind(this), 2);
	    },
	    isAtBottom: function isAtBottom() {
	      if (this.active === 'boardVisor') {
	        return;
	      }
	      var tabConvert = document.getElementById('content_' + this.active);
	      if (tabConvert) {
	        var atBottom = tabConvert.scrollTop >= tabConvert.scrollHeight - tabConvert.clientHeight;
	        if (atBottom) {
	          this.scrollBottom();
	        }
	      }
	    },
	    scrollBottom: function scrollBottom() {
	      if ((0, _jquery2.default)('#content_' + this.active) !== undefined && (0, _jquery2.default)('#content_' + this.active)[0] !== undefined) {
	        (0, _jquery2.default)('#content_' + this.active).animate({
	          'scrollTop': (0, _jquery2.default)('#content_' + this.active)[0].scrollHeight
	        }, 'slow');
	      }
	    },
	    toogleOfCanvas: function toogleOfCanvas() {
	      this.offcanvas = !this.offcanvas;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    generateHeader: function generateHeader(pgnFile) {
	      var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var retHeader = '';
	
	      var headers = this.parse_pgn_header(pgnFile);
	      if (headers !== undefined && headers['Event'] !== undefined) {
	        var appendHeader = function appendHeader(result, headers, separator) {
	          if (headers && headers.length > 0) {
	            if (result.length > 0) {
	              result += separator;
	            }
	            result += headers;
	          }
	          return result;
	        };
	        var hh = [headers['Event'], headers['Site']];
	        if (complete) {
	          retHeader = 'Blancas: ' + headers['White'] + ' Negras: ' + headers['Black'];
	          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']];
	        }
	        retHeader += ' (';
	        var rest = '';
	        hh.forEach(function (headers) {
	          rest = appendHeader(rest, headers, ' | ');
	        });
	        retHeader += rest;
	        retHeader += ')';
	      }
	      retHeader = decodeURIComponent(escape(retHeader));
	      return retHeader;
	    },
	    openTab: function openTab(user) {
	      var active = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      if (user.nickname !== _user2.default.getUser().username) {
	        var tabConvert = {
	          name: user.nickname,
	          idTab: user.nickname,
	          men: []
	        };
	        if (!this.foundTab(tabConvert.idTab)) {
	          this.tabs.push(tabConvert);
	          var parmsLoad = {
	            user: tabConvert.idTab,
	            range: {
	              limit: 30,
	              skip: 0
	            }
	          };
	          this.loadUserConvert(parmsLoad);
	        }
	        if (active) {
	          this.active = tabConvert.idTab;
	        }
	      }
	    },
	    foundTab: function foundTab(tab) {
	      for (var i in this.tabs) {
	        if (this.tabs[i].idTab === tab) {
	          return i;
	        }
	      }
	      return false;
	    },
	    closeTab: function closeTab(tab) {
	      var post = this.foundTab(tab);
	      this.tabs.splice(post, 1);
	      if (this.tabs.length === 0) {
	        this.active = 'boardVisor';
	      } else {
	        if (this.active === this.tabs[this.tabs.length - 1].idTab) {
	          this.active = 'nnn';
	        }
	        setTimeout(function () {
	          this.active = this.tabs[this.tabs.length - 1].idTab;
	        }.bind(this), 200);
	      }
	      var data = {
	        c: 'chat',
	        f: 'removeConversation',
	        data: {
	          user: _user2.default.getUser().username,
	          conver: tab
	        }
	      };
	      this.$socket.emit('event', data, function () {});
	    },
	    loadOtherUser: function loadOtherUser(otherUser, next) {
	      if (otherUser !== 'PC' && otherUser !== undefined && otherUser.length > 0) {
	        _user2.default.get(this, otherUser).then(function (response) {
	          var dd = JSON.parse(response);
	          var somedata = dd;
	          next(somedata);
	        }, function (response) {});
	      }
	    },
	    getUserClub: function getUserClub(username) {
	      this.loadOtherUser(username, function (someUser) {
	        return someUser.club;
	      });
	    },
	    showBoard: function showBoard(board) {
	      var open = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (board === undefined || this.isBoardVisible(board) === false) {
	        return;
	      }
	
	
	      var boardFound = board._id;
	
	      var boardToStore = board._id;
	
	      if (board._id === _lstorage2.default.get(boardToStore)._id) {
	        boardFound = boardToStore;
	      }
	
	      var headers = this.parse_pgn_header(board.pgn);
	      if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	        board.fen = headers['FEN'];
	      }
	      if (open === true && board.u1 === board.u2 && this.user.username !== board.u1) {
	        _lstorage2.default.set(board._id, board);
	        boardFound = boardToStore;
	      }
	
	      if (open === true && boardFound !== '' && (this.user.username === board.u1 || this.user.username === board.u2 || board.u2 === board.u1)) {
	        _lstorage2.default.set(boardFound, board);
	
	        this.$route.router.go('/game/' + boardFound);
	      } else {
	        this.boardHome = board;
	        _lstorage2.default.set('boardSee', board);
	
	        this.active = 'boardVisor';
	      }
	    },
	    desactiveBoard: function desactiveBoard() {
	      this.boardHome = {};
	      setTimeout(function () {
	        this.active = 'boardVisor';
	      }.bind(this), 200);
	    },
	    sendMensaje: function sendMensaje() {
	      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'text';
	
	      if (type === 'text') {
	        if (this.chattext.trim() === '') {
	          this.chattext = '';
	          return;
	        }
	      }
	
	      var post = this.foundTab(this.active);
	      var men = {
	        body: this.chattext,
	        type: type,
	        public: this.sendToAll,
	        club: _user2.default.getUser().club,
	        board: 'Individual',
	        send: _user2.default.getUser().username,
	        recibe: this.tabs[post].idTab
	      };
	      var data = {
	        c: 'chat',
	        f: 'mensaje',
	        data: {
	          men: men
	        }
	      };
	      this.$socket.emit('event', data, function () {});
	      this.chattext = '';
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === 'Individual') {
	        var tabUser = men.send === _user2.default.getUser().username ? men.recibe : men.send;
	        var post = this.foundTab(tabUser);
	        if (post) {
	          this.tabs[post].men.push(men);
	        } else {
	          var tabConvert = {
	            name: tabUser,
	            idTab: tabUser,
	            men: [men]
	          };
	          if (_user2.default.getUser().username !== men.send) {
	            this.tabs.push(tabConvert);
	            var active = this.active;
	            setTimeout(function () {
	              this.active = active;
	            }.bind(this), 200);
	          }
	        }
	
	        if (bottom) {
	          this.isAtBottom();
	        }
	        if (toast === true) {
	          if (men.send !== _user2.default.getUser().username) {
	            this.toast('<span>' + men.send + ': ' + men.body + '</span>', 5000);
	          }
	        }
	      }
	    },
	    isMine: function isMine(board) {
	      return this.user.username === board.u1 || this.user.username === board.u2;
	    },
	    wellCome: function wellCome() {
	      window.swal('Bienvenido', {
	        buttons: {
	          si: { text: 'Aceptar', value: 'accept' }
	        }
	      }).then(function (resultParam) {});
	    },
	    hashCode: function hashCode(s) {
	      var h = 0;
	      var l = s.length;
	      var i = 0;
	      if (l > 0) {
	        while (i < l) {
	          h = (h << 5) - h + s.charCodeAt(i++) | 0;
	        }
	      }
	      var hexString = h.toString(16);
	      return hexString;
	    },
	    loadAllData: function loadAllData() {
	      var data = {
	        c: 'chat',
	        f: 'getDataChat',
	        data: {
	          user: _user2.default.getUser()
	        }
	      };
	
	      this.$socket.emit('event', data, function () {
	        for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	          callbacks[_key] = arguments[_key];
	        }
	
	        var logUser = callbacks[1].logUser;
	        for (var i = 0; i < logUser.length; i++) {
	          if (logUser[i]) {}
	        }
	
	        this.boards = callbacks[1].boards;
	      }.bind(this));
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var historyTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var data = {
	        c: 'chat',
	        f: 'loadUserConvert',
	        data: parms
	      };
	      this.$socket.emit('event', data, function () {
	        var log = arguments.length <= 1 ? undefined : arguments[1];
	
	        var menLast = '';
	        if (log) {
	          for (var i = log.length - 1; i >= 0; i--) {
	            if (menLast !== log[i].body || menLast === '') {
	              this.recibeMensaje(log[i], true, false);
	              menLast = log[i].body;
	            }
	          }
	        }
	      }.bind(this));
	    },
	    activeWebcam: function activeWebcam() {
	      this.toast('<span>No implement yet</span>', 2000);
	    },
	    inviteChessGame: function inviteChessGame() {
	      this.$broadcast('modal::open', 'inviteGame');
	    },
	    setSendOption: function setSendOption(user) {
	      if (user.sendtoanalyse) {
	        user.sendtoanalyse = false;
	      } else {
	        user.sendtoanalyse = true;
	      }
	    },
	    isBoardVisible: function isBoardVisible(game) {
	      var isYourGame = game.u1 === this.user.username || game.u2 === this.user.username;
	      var toAll = game.all === 'true' || this.user.role === 'Admin';
	      var retValue = isYourGame || (game.public === 'true' || game.broadcast === 'true') && game.club === this.user.club || toAll;
	      return retValue;
	    },
	    inviteChessGameDirectVersus: function inviteChessGameDirectVersus() {
	      this.active = '';
	      this.activeWhite = '';
	      this.newboard.contrincante = '';
	      this.userconvert = '';
	      this.$broadcast('modal::open', 'inviteGameVersus');
	    },
	    inviteChessGameDirect: function inviteChessGameDirect(user) {
	      this.active = user.nickname;
	      this.newboard.contrincante = '';
	      this.userconvert = '';
	      this.$broadcast('modal::open', 'inviteGame');
	    },
	    inviteChessGameDirectComputer: function inviteChessGameDirectComputer(name) {
	      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      this.active = name;
	      this.newboard.contrincante = '';
	      this.userconvert = '';
	      this.newboard.elo = level;
	      this.$broadcast('modal::open', 'inviteGame');
	    },
	    isHumanVsPC: function isHumanVsPC() {
	      return this.boardHome !== undefined && this.boardHome.u1 === 'PC' || this.boardHome.u2 === 'PC';
	    },
	    InviteGameActionConfirmado: function InviteGameActionConfirmado(invite) {
	      var data = {
	        c: 'board',
	        f: 'confirmGame',
	        data: invite
	      };
	
	      if (invite.confirm || invite.vsPc) {
	        data.f = 'addBoard';
	      } else {}
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    deleteInvite: function deleteInvite(invite) {
	      var invites = _lstorage2.default.get('invitesGame', []);
	
	      var post = invites.indexOf(invite);
	
	      if (post !== -1) {
	        invites.splice(post, 1);
	        _lstorage2.default.set('invitesGame', invites);
	      } else {
	        for (var i = 0; i < invites.length; i++) {
	          if (invites[i].created === invite.created && invites[i].u1 === invite.u1 && invites[i].u2 === invite.u2) {
	            invites.splice(post, 1);
	            _lstorage2.default.set('invitesGame', invites);
	          }
	        }
	      }
	      var data = {
	        c: 'board',
	        f: 'refreshInviteGame',
	        data: invite
	      };
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    InviteGameActionClick: function InviteGameActionClick(invite) {
	      try {
	        this.deleteInvite(invite);
	        var inviteForDelete = this.clone(invite);
	
	
	        if (invite.u2 === '.ALL.') {
	          invite.u2 = _user2.default.user.username;
	          invite.recibe = invite.u2;
	        }
	        if (invite.u1 === '.ALL.') {
	          invite.u1 = _user2.default.user.username;
	          invite.recibe = invite.u1;
	        }
	        var data = {
	          c: 'board',
	          f: 'confirmGame',
	          data: invite
	        };
	
	
	        if (invite.confirm || invite.vsPc) {
	          data.f = 'addBoard';
	          this.deleteInvite(inviteForDelete);
	        } else {
	          this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded');
	        }
	        this.$socket.emit('event', data, function () {
	          if (arguments.length <= 0 ? undefined : arguments[0]) {}
	        });
	        this.deleteInvite(inviteForDelete);
	
	        var dataInvite = {
	          c: 'board',
	          f: 'deleteInviteGame',
	          data: inviteForDelete
	        };
	        this.$socket.emit('event', dataInvite, function () {
	          if (arguments.length <= 0 ? undefined : arguments[0]) {}
	        });
	      } catch (err) {
	        console.error('<span>' + 'Error (InviteGameActionClick): ' + err + '</span>', 3000);
	      }
	    },
	    createdInviteFast: function createdInviteFast(time, incremento) {
	      var invites = _lstorage2.default.get('invitesGame', []);
	
	      for (var inviteParam in invites) {
	        if (invites[inviteParam].time === time && invites[inviteParam].incremento === incremento) {
	          this.InviteGameActionClick(invites[inviteParam]);
	          this.toast('<span>' + 'Partida encontrada, iniciando...' + '</span>', 3000);
	          return;
	        }
	      }
	      this.newboard.color = Math.random() >= 0.5 ? 'w' : 'b';
	      var invite = {
	        type: 'invite',
	        public: 'true',
	        broadcast: 'false',
	        all: 'false',
	        vsPc: false,
	        confirm: false,
	        club: _user2.default.getUser().club,
	        time: time,
	        incremento: incremento,
	        recibe: this.active,
	        elo: _user2.default.getUser().elo,
	        color: this.newboard.color,
	        created: new Date().getTime()
	      };
	      if (this.active === 'PC') {
	        invite.vsPc = true;
	        invite.confirm = true;
	
	        invite.elo = this.newboard.elo;
	      }
	      var userActive = _user2.default.getUser().username;
	
	      var bFound = false;
	      if (this.newboard.contrincante !== '') {
	        if (this.newboard.contrincante === '-ALL-') {
	          invite.confirm = false;
	          bFound = true;
	          this.active = '-ALL-';
	          invite.recibe = '-ALL-';
	        } else if (this.newboard.contrincante === 'PC') {
	          invite.vsPc = true;
	          invite.elo = this.newboard.elo;
	          userActive = 'PC';
	
	          bFound = true;
	        } else {
	          for (var i in this.users) {
	            if (this.users[i].nickname === this.newboard.contrincante) {
	              userActive = this.users[i].nickname;
	              invite.confirm = true;
	
	              bFound = true;
	            }
	          }
	        }
	        if (bFound === false) {
	          this.$broadcast('modal::close', 'some', 'inviteGame');
	          this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	          this.$broadcast('modal::close', 'some', 'inviteGameFast');
	          return;
	        }
	      }
	
	      if (this.newboard.color === 'w') {
	        invite.u1 = userActive;
	        invite.u2 = this.active;
	      } else {
	        invite.u2 = userActive;
	        invite.u1 = this.active;
	      }
	      var data = {
	        c: 'board',
	        f: 'inviteGame',
	        data: {
	          event: 'inviteGame',
	          data: invite
	        }
	      };
	      if (this.active === 'PC' || invite.confirm === true) {
	        this.InviteGameActionConfirmado(invite);
	      } else {
	        this.toast('<span>' + _vue2.default.t('home.inviteSend') + '</span>', 2000);
	
	        this.$socket.emit('event', data, function () {});
	      }
	
	      this.$broadcast('modal::close', 'some', 'inviteGameFast');
	      this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	      this.$broadcast('modal::close', 'some', 'inviteGameFast');
	    },
	    createdInviteGame: function createdInviteGame(result) {
	      if (result) {
	        var invite = {
	          type: 'invite',
	          public: this.newboard.public,
	          broadcast: 'false',
	          all: 'false',
	          vsPc: false,
	          confirm: false,
	          club: _user2.default.getUser().club,
	          time: this.newboard.time,
	          incremento: this.newboard.incremento,
	          recibe: this.active,
	          elo: _user2.default.getUser().elo,
	          color: this.newboard.color,
	          created: new Date().getTime()
	        };
	        if (this.active === 'PC') {
	          invite.vsPc = true;
	          invite.confirm = true;
	
	          invite.elo = this.newboard.elo;
	        }
	        var userActive = _user2.default.getUser().username;
	
	        var bFound = false;
	
	        if (this.newboard.contrincante !== '') {
	          if (this.newboard.contrincante === '-ALL-') {
	            invite.confirm = false;
	            bFound = true;
	            this.active = '-ALL-';
	            invite.recibe = '-ALL-';
	          } else if (this.newboard.contrincante === 'PC') {
	            invite.vsPc = true;
	            invite.confirm = true;
	            invite.elo = this.newboard.elo;
	            userActive = 'PC';
	
	            bFound = true;
	          } else {
	            for (var i in this.users) {
	              if (this.users[i].nickname === this.newboard.contrincante) {
	                userActive = this.users[i].nickname;
	                invite.confirm = true;
	
	                bFound = true;
	              }
	            }
	          }
	          if (bFound === false) {
	            this.$broadcast('modal::close', 'some', 'inviteGame');
	            this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	            this.$broadcast('modal::close', 'some', 'inviteGameFast');
	            return;
	          }
	        }
	
	        if (this.newboard.color === 'w' && this.active === 'PC') {
	          invite.u2 = this.active;
	          invite.u1 = userActive;
	        } else {
	          invite.u1 = this.active;
	          invite.u2 = userActive;
	        }
	        var data = {
	          c: 'board',
	          f: 'inviteGame',
	          data: {
	            event: 'inviteGame',
	            data: invite
	          }
	        };
	        if (this.active === 'PC' || invite.confirm === true) {
	          this.InviteGameActionConfirmado(invite);
	        } else {
	          this.toast('<span>' + _vue2.default.t('home.inviteSend') + '</span>', 2000);
	
	          this.$socket.emit('event', data, function () {});
	        }
	      }
	      this.$broadcast('modal::close', 'some', 'inviteGame');
	      this.$broadcast('modal::close', 'some', 'inviteGameVersus');
	      this.$broadcast('modal::close', 'some', 'inviteGameFast');
	    }
	  },
	  ready: function ready() {
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	    this.$nextTick(function () {
	      this.active = 'boardVisor';
	      this.loadAllData();
	    });
	    this.$dispatch('userLoguin', 'show data');
	    this.$nextTick(function () {
	      this.showBoard();
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    });
	  },
	  created: function created() {
	    if (_config2.default.debug) {
	      document.title = this.user.name + ' - ' + this.$t('home.title');
	    } else {
	      document.title = 'Mainchess - ' + this.$t('home.title');
	    }
	    var _self = this;
	    this.loadOtherUser(this.user.username, function (someUser) {
	      _self.sendtoteacher = someUser.sendtoanalyse;
	    });
	
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	    this.$nextTick(function () {
	      this.active = 'boardVisor';
	      this.loadAllData();
	    });
	    this.$dispatch('userLoguin', 'show data');
	    this.$nextTick(function () {
	      this.showBoard();
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    });
	  },
	  beforeDestroy: function beforeDestroy() {}
	};

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(29);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UserInvites',
	  props: {
	    user: {}
	  },
	  data: function data() {
	    return {
	      invitesGame: _lstorage2.default.get('invitesGame', []),
	      counterInitGame: 3,
	      nameAnalisis: 'Análisis',
	      nameLesson: '',
	      nameCategory: '',
	      listaclubs: [],
	      clubActual: '',
	      clubActual1: '',
	      clubActual2: '',
	      clubs: '',
	      analisisPublic: true,
	      analisisToAll: false,
	      broadcastToAll: false,
	      chkLesson: false,
	      newboard: {
	        color: 'b',
	        time: '3',
	        incremento: 0,
	        elo: 1500,
	        public: 'true',
	        broadcast: 'false',
	        all: 'false',
	        club: ''
	      },
	      lastCreated: 0
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    initGame: function initGame(game) {
	      this.$route.router.go('/');
	
	      _lstorage2.default.set(game._id, game);
	      this.$broadcast('modal::open', 'initGame');
	      var setIn = 1;
	      this.$broadcast('modal::close', 'some', 'invitesGame');
	      clearInterval(setIn);
	      this.$broadcast('modal::close', 'some', 'initGame');
	      this.counterInitGame = 1;
	
	      this.$route.router.go('/game/' + game._id);
	    },
	    testUser: function testUser(next) {
	      _user2.default.testUser(this, {}).then(function (response) {
	        _user2.default.setUser(response.data);
	        next();
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    listaDeClubs: function listaDeClubs(tipo) {
	      var parms = {
	        type: tipo
	      };
	      var _self = this;
	      _self.listaclubs = [];
	      _club2.default.get(_self, parms).then(function (response) {
	        JSON.parse(response).forEach(function (element) {
	          _self.listaclubs.push(element);
	        });
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    isSelected: function isSelected(clubName) {
	      this.clubs = this.clubs.replace(' ,', ',');
	      this.clubs = this.clubs.replace(', ', ',');
	      var clubList = this.clubs.split(',');
	      for (var i = 0; i < clubList.length; i++) {
	        if (clubName === clubList[i]) {
	          return true;
	        }
	      }
	      return false;
	    },
	    handleSelectChange: function handleSelectChange(event) {
	      var selectedValues = (0, _from2.default)(event.target.selectedOptions).map(function (option) {
	        return option.value;
	      });
	
	      var clubActual = '';
	      var count = selectedValues.length;
	      var num = 0;
	      selectedValues.forEach(function (element) {
	        clubActual += element;
	        num++;
	        if (num < count) {
	          clubActual += ',';
	        }
	      });
	      this.clubActual = clubActual;
	    },
	    InviteGameActionClick: function InviteGameActionClick(invite) {
	      try {
	        this.deleteInvite(invite);
	        var inviteForDelete = this.clone(invite);
	
	
	        if (invite.u2 === '.ALL.') {
	          invite.u2 = _user2.default.user.username;
	          invite.recibe = invite.u2;
	        }
	        if (invite.u1 === '.ALL.') {
	          invite.u1 = _user2.default.user.username;
	          invite.recibe = invite.u1;
	        }
	        var data = {
	          c: 'board',
	          f: 'confirmGame',
	          data: invite
	        };
	
	
	        if (invite.confirm || invite.vsPc) {
	          data.f = 'addBoard';
	          this.deleteInvite(inviteForDelete);
	        } else {
	          this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded');
	        }
	        this.$socket.emit('event', data, function () {
	          if (arguments.length <= 0 ? undefined : arguments[0]) {}
	        });
	        this.deleteInvite(inviteForDelete);
	
	        var dataInvite = {
	          c: 'board',
	          f: 'deleteInviteGame',
	          data: inviteForDelete
	        };
	        this.$socket.emit('event', dataInvite, function () {
	          if (arguments.length <= 0 ? undefined : arguments[0]) {}
	        });
	      } catch (err) {
	        console.error('<span>' + 'Error (InviteGameActionClick): ' + err + '</span>', 3000);
	      }
	    },
	    analisisPublicChange: function analisisPublicChange() {
	      if (document.getElementById('idAnalisisPublic')) {
	        this.analisisPublic = document.getElementById('idAnalisisPublic').checked;
	      }
	    },
	    InviteGameAction: function InviteGameAction(invite) {
	      var data = {
	        c: 'board',
	        f: 'confirmGame',
	        data: invite
	      };
	
	      if (invite.confirm || invite.vsPc) {
	        data.f = 'addBoard';
	        this.deleteInvite(invite);
	      } else {
	        this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded');
	      }
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {
	          window.swal(arguments.length <= 0 ? undefined : arguments[0]);
	        }
	      });
	      this.deleteInvite(invite);
	    },
	    deleteInvite: function deleteInvite(invite) {
	      var post = this.invitesGame.indexOf(invite);
	
	      if (post !== -1) {
	        this.invitesGame.splice(post, 1);
	        _lstorage2.default.set('invitesGame', this.invitesGame);
	      } else {
	        for (var i = 0; i < this.invitesGame.length; i++) {
	          if (this.invitesGame[i].created === invite.created && this.invitesGame[i].u1 === invite.u1 && this.invitesGame[i].u2 === invite.u2) {
	            this.invitesGame.splice(post, 1);
	            _lstorage2.default.set('invitesGame', this.invitesGame);
	          }
	        }
	      }
	      var data = {
	        c: 'board',
	        f: 'refreshInviteGame',
	        data: invite
	      };
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    pcGameInit: function pcGameInit() {
	      this.$broadcast('modal::open', 'invitePCGame');
	      this.$broadcast('modal::close', 'some', 'invitesGame');
	    },
	    createGame: function createGame() {
	      this.$broadcast('modal::open', 'invitePCAnalisis');
	    },
	    pcGameAnalisis: function pcGameAnalisis() {
	      this.createdVsPcAnalisis(true);
	    },
	    createdVsPcGame: function createdVsPcGame(state) {
	      if (!state) {
	        this.$broadcast('modal::close', 'some', 'invitePCGame');
	        return;
	      }
	      this.$broadcast('modal::close', 'some', 'invitePCGame');
	      var invite = {
	        u1: '',
	        u2: '',
	        public: 'false',
	        broadcast: 'false',
	        all: 'false',
	        club: _user2.default.user.club,
	        vsPc: true,
	        time: '15',
	        incremento: 0,
	        elo: 1500,
	        confirm: false,
	        created: new Date().getTime(),
	        color: this.newboard.color
	      };
	      if (this.newboard.color === 'w') {
	        invite.u1 = _user2.default.user.username;
	        invite.u2 = 'PC';
	        invite.club = _user2.default.user.club;
	      } else {
	        invite.u2 = _user2.default.user.username;
	        invite.u1 = 'PC';
	        invite.club = _user2.default.user.club;
	      }
	      this.InviteGameAction(invite);
	    },
	    createdVsPcAnalisis: function createdVsPcAnalisis(state) {
	      if (document.getElementById('idAnalisisPublic')) {
	        this.analisisPublic = document.getElementById('idAnalisisPublic').checked;
	      }
	      if (this.chkLesson === true) {
	        if (this.nameLesson.length <= 0 || this.nameCategory.length <= 0) {
	          window.swal('Debe rellenar la categoría y lección', {
	            buttons: {
	              si: { text: 'Aceptar', value: 'accept' }
	            }
	          }).then(function (resultParam) {});
	          return;
	        }
	      }
	      if (!state) {
	        this.$broadcast('modal::close', 'some', 'invitePCAnalisis');
	        return;
	      }
	      this.$broadcast('modal::close', 'some', 'invitePCAnalisis');
	
	      var invite = {
	        u1: '',
	        u2: '',
	        public: this.analisisPublic,
	        broadcast: this.broadcastToAll,
	        all: this.analisisToAll,
	        club: this.chkLesson === true ? this.clubs : _user2.default.user.club,
	        name: this.nameAnalisis,
	        lesson: this.nameLesson,
	        category: this.nameCategory,
	        vsPc: false,
	        time: '120',
	        elo: 1500,
	        incremento: 0,
	        confirm: true,
	        created: new Date().getTime(),
	        color: this.newboard.color
	      };
	      if (this.newboard.color === 'w') {
	        invite.u1 = _user2.default.user.username;
	        invite.u2 = _user2.default.user.username;
	      } else {
	        invite.u2 = _user2.default.user.username;
	        invite.u1 = _user2.default.user.username;
	      }
	      this.InviteGameAction(invite);
	    },
	    isAdding: function isAdding(invite) {
	      this.invitesGame = _lstorage2.default.get('invitesGame', []);
	
	      if (invite !== undefined && this.invitesGame && this.invitesGame.length > 0) {
	        for (var i in this.invitesGame) {
	          if (this.invitesGame[i].created === invite.created) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	  },
	  ready: function ready() {
	    if (this.user !== undefined && (this.user.role === 'Admin' || this.user.role === 'Teacher')) {
	      this.analisisPublic = true;
	    } else {
	      this.analisisPublic = false;
	    }
	  },
	  created: function created() {
	    this.listaDeClubs('Clubs');
	    if (this.user !== undefined && (this.user.role === 'Admin' || this.user.role === 'Teacher')) {
	      this.analisisPublic = true;
	    } else {
	      this.analisisPublic = false;
	    }
	  },
	
	  watch: {
	    clubActual: function clubActual(val, oldVal) {
	      this.clubs = val;
	    }
	  },
	  events: {
	    inviteGame: function inviteGame(data) {
	      if (data !== undefined && data.created) {
	        this.invitesGame.push(data);
	        _lstorage2.default.set('invitesGame', this.invitesGame);
	      }
	    },
	    confirmGame: function confirmGame(data) {
	      if (data !== undefined && data.created) {
	        this.lastCreated = _lstorage2.default.get('lastCreatedGame');
	        if (this.isAdding(data) === false && this.lastCreated !== data.created) {
	          this.lastCreated = data.created;
	          _lstorage2.default.set('lastCreatedGame', this.lastCreated);
	
	          this.invitesGame.push(data);
	
	          this.InviteGameAction(data);
	        }
	
	        _lstorage2.default.set('invitesGame', this.invitesGame);
	        this.$broadcast('modal::open', 'invitesGame');
	      }
	    },
	    deleteInviteGame: function deleteInviteGame(data) {
	      if (data !== undefined) {
	        delete data.event;
	        this.deleteInvite(data);
	      }
	    },
	    initGame: function initGame(data) {
	      if (data !== undefined) {
	        if (data.u1 === _user2.default.user.username || data.u2 === _user2.default.user.username) {
	          this.initGame(data);
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'UploadFiles',
	  props: {
	    value: {
	      type: Array
	    },
	    headers: Object,
	    action: {
	      type: String,
	      required: true
	    },
	    id: String,
	    name: {
	      type: String,
	      required: true
	    },
	    multiple: {
	      type: Boolean,
	      required: false,
	      'default': false
	    },
	    maxsize: String,
	    pathpermit: String,
	    method: String
	  },
	  directives: {
	    bindBoolean: {
	      priority: 850,
	      update: function update(value) {
	        var arg = this.arg;
	        if (value) {
	          this.el.setAttribute(arg, arg);
	        } else {
	          this.el.removeAttribute(arg);
	        }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      myFiles: []
	    };
	  },
	
	  methods: {
	    OpenInputFile: function OpenInputFile() {
	      document.getElementById(this.name).click();
	      this.fileInputClick();
	    },
	    fileInputClick: function fileInputClick() {
	      this.$dispatch('onFileClick', this.myFiles);
	    },
	    validateFiles: function validateFiles(files) {
	      var sumSize = 0;
	      var allOk = true;
	      Array.prototype.slice.call(files, 0).map(function (file) {
	        sumSize += parseInt(file.size);
	        var maxSize = parseInt(this.maxsize) * 1024 * 1024;
	        if (sumSize > maxSize) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.size_not_permit'));
	          allOk = false;
	        }
	        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
	
	        if (this.pathpermit.indexOf(type) === -1) {
	          this.$dispatch('onFileError', this.myFiles, this.$t('home.uploadMens.path_not_permit'));
	          allOk = false;
	        }
	      }.bind(this));
	      return allOk;
	    },
	    fileInputChange: function fileInputChange() {
	      var ident = this.id || this.name;
	      this.myFiles = document.getElementById(ident).files;
	      this.$dispatch('onFileChange', this.myFiles);
	      if (this.validateFiles(this.myFiles)) {
	        this.fileUpload();
	      }
	    },
	    _onProgress: function _onProgress(e) {
	      e.percent = e.loaded / e.total * 100;
	      this.$dispatch('onFileProgress', e);
	    },
	    _handleUpload: function _handleUpload(file) {
	      this.$dispatch('beforeFileUpload', file);
	      var form = new window.FormData();
	      var xhr = new window.XMLHttpRequest();
	      try {
	        form.append('Content-Type', file.type || 'application/octet-stream');
	
	        form.append('file', file);
	      } catch (err) {
	        this.$dispatch('onFileError', file, err);
	        return;
	      }
	      return new _promise2.default(function (resolve, reject) {
	        xhr.upload.addEventListener('progress', this._onProgress, false);
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState < 4) {
	            return;
	          }
	          if (xhr.status < 400) {
	            var res = xhr.responseText;
	            var newFile = {
	              name: res,
	              size: file.size,
	              type: file.type,
	              lastModifiedDate: file.lastModifiedDate
	            };
	            this.value.push(newFile);
	            this.$dispatch('onFileUpload', newFile, res);
	            resolve(file);
	          } else {
	            var err = xhr.responseText;
	            this.$dispatch('onFileError', file, err);
	            reject(err);
	          }
	        }.bind(this);
	
	        xhr.onerror = function () {
	          var err = JSON.parse(xhr.responseText);
	          this.$dispatch('onFileError', file, err);
	          reject(err);
	        }.bind(this);
	
	        xhr.open(this.method || 'POST', this.action, true);
	        if (this.headers) {
	          for (var header in this.headers) {
	            xhr.setRequestHeader(header, this.headers[header]);
	          }
	        }
	        xhr.send(form);
	        this.$dispatch('afterFileUpload', file);
	      }.bind(this));
	    },
	    fileUpload: function fileUpload() {
	      if (this.myFiles.length > 0) {
	        var arrayOfPromises = Array.prototype.slice.call(this.myFiles, 0).map(function (file) {
	          return this._handleUpload(file);
	        }.bind(this));
	
	        _promise2.default.all(arrayOfPromises).then(function (allFiles) {
	          this.$dispatch('onAllFilesUploaded', allFiles);
	        }.bind(this)).catch(function (err) {
	          this.$dispatch('onFileError', this.myFiles, err);
	        }.bind(this));
	      } else {
	        var err = new Error('No files to upload for this field');
	        this.$dispatch('onFileError', this.myFiles, err);
	      }
	    }
	  }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(29);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _puzzle = __webpack_require__(543);
	
	var _puzzle2 = _interopRequireDefault(_puzzle);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _puzzle3 = __webpack_require__(118);
	
	var _puzzle4 = _interopRequireDefault(_puzzle3);
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _boardVisorSmall = __webpack_require__(111);
	
	var _boardVisorSmall2 = _interopRequireDefault(_boardVisorSmall);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groundInit = 1;
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    },
	    data: function data(transition) {
	      return _promise2.default.all([_puzzle4.default.count(this)]).then(function (data) {
	        var theD = JSON.parse(data);
	
	        return {
	          counts: theD
	        };
	      }, function (response) {});
	    }
	  },
	  template: __webpack_require__(519),
	  data: function data() {
	    return {
	      listaclubs: [],
	      clubActual: '',
	      clubActual1: '',
	      clubActual2: '',
	      user: _user2.default.getUser(),
	      mode: 'add',
	      fenInit: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      fenFinish: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      pgn: '',
	      startPlay: 0,
	      club: '',
	      numMoves: 1,
	      timeMove: 60,
	      tituloFen: 'Ejercicio',
	      clubs: _user2.default.getUser().club,
	      myPGNValue: '',
	      myFENValue: '',
	      pgnFiles: [],
	      item: {
	        num: 0
	      },
	      counts: [],
	      chess: new _chess2.default(),
	      puzzleType: {},
	      puzzlesType: [{
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Iniciacion',
	        description: 'Iniciación al ajedrez.',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Aperturas',
	        description: 'Una de las piezas no está bien defendida.',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Tactic',
	        description: 'Buscar el mejor movimiento',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Estrategia',
	        description: 'Encuentra el mejor movimiento',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Finales',
	        description: 'Las blancas ganan en 3 movimientos',
	        position: true
	      }, {
	        numMoves: 1,
	        timeMove: 120,
	        type: 'MateIn',
	        description: 'Las blancas ganan en x movimientos',
	        position: false
	      }, {
	        numMoves: 1,
	        timeMove: 120,
	        type: 'Practica',
	        description: 'Practica contra el ordenador',
	        position: false
	      }, {
	        numMoves: 1,
	        timeMove: 120,
	        type: 'Test',
	        description: 'Prueba tu nivel con estos ejercicios',
	        position: false
	      }],
	      puzzles: [],
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: '',
	      showFenPosition: false
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  components: {
	    PuzzleChess: _puzzle2.default,
	    BoardVisorSmall: _boardVisorSmall2.default
	  },
	  events: {
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    },
	    mensaje: function mensaje(data) {
	      this.recibeMensaje(data.men, true, true);
	    }
	  },
	  methods: {
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (toast === true) {
	        if (men.send !== _user2.default.getUser().username) {
	          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000);
	        }
	      }
	    },
	    isUserClub: function isUserClub(club) {
	      var ret = false;
	      var clubList = club.split(',');
	      for (var i = 0; i < clubList.length; i++) {
	        if (this.user.club === clubList[i]) {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    selectItm: function selectItm(item) {
	      this.item = item;
	    },
	    nextPuzzle: function nextPuzzle() {
	      var post = this.puzzles.indexOf(this.item);
	      if (post !== -1 && post + 1 < this.puzzles.length) {
	        this.selectItm(this.puzzles[post + 1]);
	      } else {
	        if (post + 1 >= this.puzzles.length && this.puzzlesType.indexOf(this.puzzleType) + 1 < this.puzzlesType.length) {
	          this.selectPuzzleType(this.puzzlesType[this.puzzlesType.indexOf(this.puzzleType) + 1]);
	        } else {
	          this.toast('<span>Ya no hay mas</span>', 2000);
	        }
	      }
	    },
	    selectPuzzleType: function selectPuzzleType(puzzle) {
	      this.puzzleType = puzzle;
	      var parms = {
	        type: puzzle.type
	      };
	      _puzzle4.default.get(this, parms).then(function (response) {
	        var theD = JSON.parse(response);
	        this.puzzles = theD;
	
	        var clubDeseado = this.user.club;
	
	        this.puzzles = this.puzzles.filter(function (puzzle) {
	          var clubs = puzzle.club.split(',').map(function (c) {
	            return c.trim();
	          });
	          return clubs.includes(clubDeseado);
	        });
	        setTimeout(function () {
	          if (this.puzzles.length > 0) {
	            this.selectItm(this.puzzles[0]);
	          }
	          (0, _jquery2.default)('#listSomePuzzles').animate({
	            'scrollTop': 0
	          }, 'slow');
	        }.bind(this), 400);
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    updateFenInit: function updateFenInit(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	
	      this.fenInit = groundInit.getFen();
	    },
	    updateFenFinish: function updateFenFinish(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	    },
	    addPuzzle: function addPuzzle(mode) {
	      this.showFenPosition = false;
	      this.mode = mode;
	      if (!this.puzzleType.type) {
	        this.toast('<span>Selecciona un tipo de puzzle</span>', 2000);
	        return;
	      }
	      this.tituloFen = this.titlefen;
	
	      this.$broadcast('modal::open', 'modalCreatePuzzle');
	
	      setTimeout(function () {
	        var pgnBoardInit = 0;
	        if (document.getElementById('pgnMoves')) {
	          document.getElementById('pgnMoves').textContent = '';
	        }
	        if (document.getElementById('pgnButtons')) {
	          document.getElementById('pgnButtons').textContent = '';
	        }
	        if (document.getElementById('pgnHeader')) {
	          document.getElementById('pgnHeader').textContent = '';
	        }
	        var pos = 'start';
	        var start = 'start';
	
	        var headers = this.parse_pgn_header(this.pgn);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = headers['FEN'];
	        } else {}
	        if (start === pos) {
	          start = 0;
	        }
	
	        if (this.fenInit !== '' && this.fenInit !== undefined) {
	          start = this.fenInit;
	        }
	        try {
	          pgnBoardInit = window.pgnEdit({ inner: 'puzzleGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader' }, { pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: false, headers: true });
	          groundInit = pgnBoardInit.board;
	          window.pgnBoardBase = pgnBoardInit.boardBase;
	          window.ground = pgnBoardInit.board;
	          var options = {
	            animation: {
	              enabled: true,
	              duration: 600
	            }
	          };
	
	          window.ground.set(options);
	        } catch (error) {
	          console.error('<span>' + 'Error (AddPuzzle): ' + error + '</span>', 3000);
	        }
	
	        if (document.getElementById('iFramePosition')) {
	          var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	          if (searchinput) {
	            var idFEN = this.fenInit;
	            if (idFEN) {
	              searchinput.value = idFEN;
	              searchinput.textContent = idFEN;
	            }
	            searchinput.dispatchEvent(new window.Event('input'));
	            searchinput.dispatchEvent(new window.Event('change'));
	          }
	        }
	      }.bind(this), 1000);
	    },
	    generateHeader: function generateHeader(pgnFile) {
	      var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var onlyNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var retHeader = '';
	
	      var headers = this.parse_pgn_header(pgnFile);
	      if (headers !== undefined && headers['Event'] !== undefined) {
	        var appendHeader = function appendHeader(result, headers, separator) {
	          if (headers && headers.length > 0) {
	            if (result.length > 0) {
	              result += separator;
	            }
	            result += headers;
	          }
	          return result;
	        };
	        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']];
	        if (complete) {
	          retHeader = headers['White'] + ' vs ' + headers['Black'];
	          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']];
	        }
	        if (onlyNames) {
	          retHeader = headers['White'] + ' (' + headers['WhiteElo'] + ')' + ' vs ' + headers['Black'] + ' (' + headers['BlackElo'] + ')';
	          hh = [];
	        }
	        if (hh.length > 1) {
	          var rest = '';
	          retHeader += ' (';
	          hh.forEach(function (headers) {
	            rest = appendHeader(rest, headers, ' | ');
	          });
	          retHeader += rest;
	          retHeader += ')';
	        }
	      }
	
	      return retHeader;
	    },
	    readTextFile: function readTextFile(file, callback, encoding) {
	      var reader = new window.FileReader();
	      reader.addEventListener('load', function (e) {
	        callback(this.result);
	      });
	      if (encoding) {
	        reader.readAsText(file, encoding);
	      } else {
	        reader.readAsText(file);
	      }
	    },
	    isListFiles: function isListFiles() {
	      var input = document.getElementById('files');
	      if (input.files && input.files[0] && input.files[0].length > 0) {
	        return true;
	      }
	      return false;
	    },
	    listFiles: function listFiles() {
	      this.fileChosen();
	    },
	    hashCode: function hashCode(s) {
	      var h = 0;
	      var l = s.length;
	      var i = 0;
	      if (l > 0) {
	        while (i < l) {
	          h = (h << 5) - h + s.charCodeAt(i++) | 0;
	        }
	      }
	      var hexString = h.toString(16);
	      return hexString;
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\}/gm, '');
	      pgn = pgn.replace(/\{\[%emt([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\]\}/gm, '');
	      pgn = pgn.replace(/\{([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}/gm, '');
	      return pgn;
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = Buffer.from(strParam, 'latin1').toString('utf8');
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    parsePgnFiles: function parsePgnFiles(file, number) {
	      this.pgnFiles = '';
	      var newlineChar = '\r?\n';
	      var filesObj = {};
	      file = this.prettyPgn(file);
	
	      var lines = file.split(new RegExp(newlineChar));
	      var pgntext = '';
	      var state = 0;
	      var index = 0;
	      for (var i = 0; i < lines.length; i++) {
	        if (lines[i].length > 0) {
	          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
	            if (state === 1) {
	              index = index + 1;
	              var headers = this.parse_pgn_header(pgntext);
	              var hashCode = this.hashCode(pgntext);
	              var board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' };
	              filesObj[index] = board;
	
	              pgntext = '';
	            }
	            state = 0;
	          } else {
	            state = 1;
	          }
	          if (state === 0) {
	            pgntext += lines[i] + '\r\n';
	          } else {
	            pgntext += lines[i] + ' ';
	          }
	        }
	      }
	      headers = this.parse_pgn_header(pgntext);
	      hashCode = this.hashCode(pgntext);
	      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' };
	      index = index + 1;
	      filesObj[index] = board;
	
	      this.pgnFiles = filesObj;
	
	      return filesObj;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    openPGN: function openPGN(pgnText) {
	      var pgnAux = pgnText;
	      pgnAux = pgnAux.replace('0-0', 'O-O');
	      pgnAux = pgnAux.replace('0-0-0', 'O-O-O');
	
	      this.myPGNValue = pgnAux;
	    },
	    fileChosen: function fileChosen() {
	      var output = document.getElementById('idTextAreaPGN');
	      var input = document.getElementById('files');
	      var _self = this;
	      if (input.files && input.files[0]) {
	        this.readTextFile(input.files[0], function (str) {
	          if (output !== undefined) {
	            output.value = '';
	            output.dispatchEvent(new window.Event('change'));
	          }
	          _self.parsePgnFiles(str);
	        }, 'ISO-8859-1');
	      }
	    },
	    changePGNTextArea: function changePGNTextArea() {
	      var idTextArea = document.getElementById('idTextAreaPGN');
	      if (idTextArea && idTextArea.value !== 'none') {
	        var pgnAux = idTextArea.value;
	        pgnAux = pgnAux.replace('0-0', 'O-O');
	        pgnAux = pgnAux.replace('0-0-0', 'O-O-O');
	
	        this.myPGNValue = pgnAux;
	        var headers = this.parse_pgn_header(idTextArea.value);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          this.myFENValue = headers['FEN'];
	        }
	
	        idTextArea.value = '';
	      }
	    },
	    setFenPosition: function setFenPosition() {
	      if (document.getElementById('iFramePosition')) {
	        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	        if (searchinput !== undefined && searchinput !== null) {
	          var txtPgn = '';
	          txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]';
	
	          this.fenInit = searchinput.value;
	          this.fenFinish = searchinput.value;
	          this.pgn = txtPgn;
	          this.myPGNValue = txtPgn;
	          setTimeout(function () {
	            document.getElementById('pgnButtonsfirst').click();
	          }, 2000);
	        }
	      }
	    },
	    listaDeClubs: function listaDeClubs(tipo) {
	      var parms = {
	        type: tipo
	      };
	      var _self = this;
	      _self.listaclubs = [];
	      _club2.default.get(_self, parms).then(function (response) {
	        JSON.parse(response).forEach(function (element) {
	          _self.listaclubs.push(element);
	        });
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    subirPuzzle: function subirPuzzle(id) {
	      _puzzle4.default.incpos(this, id).then(function (response) {
	        this.selectPuzzleType(this.puzzleType);
	      }, function (response) {});
	    },
	    bajarPuzzle: function bajarPuzzle(id) {
	      _puzzle4.default.decpos(this, id).then(function (response) {
	        this.selectPuzzleType(this.puzzleType);
	      }, function (response) {});
	    },
	    putPosPuzzle: function putPosPuzzle(idParam, posParam) {
	      var _self = this;
	
	      _puzzle4.default.putpuzzle(_self, {
	        id: idParam,
	        pos: posParam
	      }).then(function (response) {
	        _self.selectPuzzleType(_self.puzzleType);
	      }, function (response) {
	        self.error = response.data;
	      });
	    },
	    addClubToGeneralPuzzles: function addClubToGeneralPuzzles(clubParam) {
	      var _self = this;
	      window.swal('¿Quiere importar todos los ejercicios de General?', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          _puzzle4.default.addclubtogeneralpuzzles(_self, {
	            club: clubParam }).then(function (response) {
	            _self.selectPuzzleType(_self.puzzleType);
	          }, function (response) {
	            _self.error = response.data;
	          });
	        }
	      });
	    },
	    isSelected: function isSelected(clubName) {
	      var ret = false;
	      this.clubs = this.clubs.replace(' ,', ',');
	      this.clubs = this.clubs.replace(', ', ',');
	      var clubList = this.clubs.split(',');
	      for (var i = 0; i < clubList.length; i++) {
	        if (clubName === clubList[i]) {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    handleSelectChange: function handleSelectChange(event) {
	      var selectedValues = (0, _from2.default)(event.target.selectedOptions).map(function (option) {
	        return option.value;
	      });
	
	      var clubActual = '';
	      var count = selectedValues.length;
	      var num = 0;
	      selectedValues.forEach(function (element) {
	        clubActual += element;
	        num++;
	        if (num < count) {
	          clubActual += ',';
	        }
	      });
	      this.clubActual = clubActual;
	    },
	    createPuzzle: function createPuzzle(action) {
	      if (action) {
	        this.clubs = this.clubs.replace(' ,', ',');
	        this.clubs = this.clubs.replace(', ', ',');
	
	        if (this.puzzleType.type === 'Practica') {
	          this.setFenPosition();
	        }
	
	        var newPuzzle = {
	          type: this.puzzleType.type,
	          createby: _user2.default.getUser().username,
	          club: this.clubs,
	          feninit: this.fenInit,
	          fenfinish: this.fenFinish,
	          startPlay: this.startPlay,
	          pgn: this.pgn,
	          nummoves: this.numMoves,
	          timemove: this.timeMove,
	          titlefen: this.tituloFen,
	          mode: this.mode
	        };
	
	        _puzzle4.default.add(this, newPuzzle).then(function (response) {
	          this.toast('<span>Creado correctamente</span>', 3000);
	
	          if (this.mode === 'add') {
	            this.selectItm(this.item);
	          } else {}
	
	          this.$broadcast('modal::close', 'some', 'modalCreatePuzzle');
	
	          this.selectPuzzleType(this.puzzleType);
	        }, function (response) {
	          this.error = response.data;
	        });
	      } else {
	        this.$broadcast('modal::close', 'some', 'modalCreatePuzzle');
	      }
	    },
	    resizeBoard: function resizeBoard() {
	      if (document.getElementById('middle') && document.getElementById('puzzleBoard')) {
	        var Width = document.getElementById('middle').clientWidth;
	
	        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	          Width = Width - 20;
	        }
	        if (document.getElementById('puzzleBoard')) {
	          document.getElementById('puzzleBoard').style.height = Width + 'px';
	          document.getElementById('puzzleBoard').style.width = Width + 'px';
	        }
	
	        document.body.dispatchEvent(new window.Event('chessground.resize'));
	      }
	    },
	    onResize: function onResize(event) {
	      this.resizeBoard();
	    },
	    editPuzzle: function editPuzzle() {
	      this.showFenPosition = false;
	      if (this.item) {
	        this.pgn = this.item.pgn;
	        this.fenInit = this.item.feninit;
	        this.numMoves = this.item.nummoves;
	        this.timeMove = this.item.timemove;
	        this.timeFen = this.item.timefen;
	        this.titlefen = this.item.titlefen;
	        this.clubs = this.item.club;
	
	        this.addPuzzle(this.item._id);
	      }
	    },
	    delPuzzle: function delPuzzle() {
	      var _self = this;
	      window.swal('¿Está seguro de eliminar el ejercicio?', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          _puzzle4.default.del(_self, _self.item._id).then(function (response) {
	            _self.selectPuzzleType(_self.puzzleType);
	          }, function (response) {
	            _self.error = response.data;
	          });
	        }
	      });
	    }
	  },
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('puzzles.title');
	    this.resizeBoard();
	  },
	  created: function created() {
	    this.listaDeClubs('Clubs');
	    window.addEventListener('resize', this.onResize);
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	
	    this.resizeBoard();
	  },
	
	  watch: {
	    clubActual: function clubActual(val, oldVal) {
	      this.clubs = val;
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      this.fenInit = val;
	    },
	    myPGNValue: function myPGNValue(val, oldVal) {
	      this.pgn = val;
	
	      setTimeout(function () {
	        var pgnBoardInit = 0;
	        if (document.getElementById('pgnMoves')) {
	          document.getElementById('pgnMoves').textContent = '';
	        }
	        if (document.getElementById('pgnButtons')) {
	          document.getElementById('pgnButtons').textContent = '';
	        }
	        if (document.getElementById('pgnHeader')) {
	          document.getElementById('pgnHeader').textContent = '';
	        }
	        var pos = 'start';
	        var start = 'start';
	        var pgnNew = this.pgn.split('"]').join('"]\n');
	
	        var headers = this.parse_pgn_header(pgnNew);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = headers['FEN'];
	        } else {}
	        if (start === pos) {
	          start = 0;
	        }
	        if (this.fenInit !== '' && this.fenInit !== undefined) {
	          start = this.fenInit;
	        }
	        try {
	          pgnBoardInit = window.pgnEdit({ inner: 'puzzleGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader' }, { pgn: this.pgn, fen: pos, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: false, headers: true });
	          groundInit = pgnBoardInit.board;
	          window.pgnBoardBase = pgnBoardInit.boardBase;
	          window.ground = pgnBoardInit.board;
	          var options = {
	            orientation: this.orientation,
	            movable: {
	              free: false,
	              color: 'both',
	              dests: this.chessToDests(this.chess),
	              dropOff: 'revert',
	              showDests: true,
	              events: {
	                after: this.onMove
	              }
	            },
	            animation: {
	              enabled: true,
	              duration: 600
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          };
	
	          this.ground.set(options);
	
	          var comments = document.querySelectorAll('.afterComment');
	          comments.forEach(function (comment) {
	            var textResource = comment.textContent.toLowerCase();
	            if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	              comment.closest('.move').classList.add('highlight-move');
	            }
	          });
	        } catch (error) {
	          console.error('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000);
	        }
	      }.bind(this), 50);
	    },
	    fenInit: function fenInit(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    },
	    fenFinish: function fenFinish(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _enginegame = __webpack_require__(56);
	
	var _enginegame2 = _interopRequireDefault(_enginegame);
	
	var _puzzle = __webpack_require__(118);
	
	var _puzzle2 = _interopRequireDefault(_puzzle);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	window.pgnBoardBase = 0;
	var timesColor = 0;
	
	exports.default = {
	  name: 'puzzleChess',
	  props: {
	    puzzle: {
	      type: Object
	    },
	    classboard: {
	      type: String
	    },
	    titlefen: {
	      type: String
	    },
	    nextPuzzle: {
	      type: Function,
	      required: false,
	      'default': function _default() {
	        return false;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      mate: false,
	      numMoves: 1000,
	      timeMove: 120,
	      handMoves: 0,
	      userColor: 'white',
	      ground: 1,
	      turn: 'white',
	      stockfish: this.ChessEngine(),
	      chess: new _chess2.default(),
	      chessPgn: new _chess2.default(),
	      stylesBoard: stylesBoard,
	      times: 120,
	      resultPractica: '',
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      })
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    ChessEngine: function ChessEngine() {
	      return _enginegame2.default.engineGame({ book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js' });
	    },
	    onResize: function onResize(event) {
	      document.body.dispatchEvent(new window.Event('chessground.resize'));
	    },
	    chessToDests: function chessToDests(chess) {
	      var dests = {};
	      chess.SQUARES.forEach(function (s) {
	        var ms = chess.moves({ square: s, verbose: true });
	        if (ms.length) dests[s] = ms.map(function (m) {
	          return m.to;
	        });
	      });
	      return dests;
	    },
	    resolvePuzzle: function resolvePuzzle(parms) {
	      _puzzle2.default.resolve(this, parms).then(function (response) {}, function (response) {});
	    },
	    chessToColor: function chessToColor(chess) {
	      var t = chess.turn();
	      var turn = t === 'w' ? 'white' : 'black';
	      this.turn = turn;
	      return turn;
	    },
	    countDown: function countDown() {
	      if (isNaN(this.timeMove) === false) {
	        this.times = this.timeMove;
	      } else {
	        this.times = 120;
	      }
	      clearInterval(timesColor);
	      timesColor = setInterval(function () {
	        this.times = this.times - 1;
	        if (this.times <= 0) {
	          clearInterval(timesColor);
	          this.times = 0;
	          this.onMove(-1, -1);
	          this.mate = false;
	          this.numMoves = 0;
	        }
	      }.bind(this), 1000);
	    },
	    pistaNext: function pistaNext() {
	      this.puzzle.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (fen === this.puzzle.feninit) {
	          break;
	        }
	        this.puzzle.startPlay++;
	      }
	      if (this.puzzle.startPlay > moves.length) {
	        this.puzzle.startPlay = 0;
	      }
	      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
	        var numGetMove = this.puzzle.startPlay + this.handMoves;
	
	        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
	          this.ground.setAutoShapes({
	            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
	
	            brush: 'green',
	            modifiers: { lineWidth: 10 }
	          });
	        }
	      }
	    },
	    resultadoNext: function resultadoNext() {
	      this.countDown();
	      this.puzzle.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (fen === this.puzzle.feninit) {
	          break;
	        }
	        this.puzzle.startPlay++;
	      }
	      if (this.puzzle.startPlay > moves.length) {
	        this.puzzle.startPlay = 0;
	      }
	      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
	        var numGetMove = this.puzzle.startPlay + this.handMoves;
	
	        this.onMove(window.pgnBoardBase.getPgn().getMove(numGetMove).from, window.pgnBoardBase.getPgn().getMove(numGetMove).from);
	        if (window.pgnBoardBase.getPgn().getMove(numGetMove) !== undefined) {
	          this.ground.setAutoShapes({
	            orig: window.pgnBoardBase.getPgn().getMove(numGetMove).from,
	            dest: window.pgnBoardBase.getPgn().getMove(numGetMove).to,
	            brush: 'yellow',
	            modifiers: { lineWidth: 10 }
	          });
	        }
	      }
	    },
	    onMoveFinal: function onMoveFinal(orig, dest, promopiece) {
	      this.ground.setAutoShapes({
	        orig: '-1',
	        dest: '-1',
	        brush: 'yellow',
	        modifiers: { lineWidth: 10 }
	      });
	      this.numMoves--;
	      this.chess.move({
	        from: orig,
	        to: dest,
	        promotion: promopiece
	      });
	      this.ground.move(orig, dest);
	      this.ground.set({
	        fen: this.chess.fen(),
	        turnColor: this.chessToColor(this.chess),
	        movable: {
	          color: this.chessToColor(this.chess),
	          dests: this.chessToDests(this.chess)
	        },
	        animation: {
	          enabled: true,
	          duration: 600
	        },
	        highlight: {
	          lastMove: true,
	          check: true },
	        drawable: {
	          enabled: true,
	          visible: true
	        }
	      });
	      this.puzzle.startPlay = 1;
	      var moves = window.pgnBoardBase.getPgn().getMoves();
	
	      for (var i = 0; i < moves.length; i++) {
	        var fen = moves[i].fen;
	        if (this.puzzle.feninit !== undefined && fen === this.puzzle.feninit) {
	          break;
	        }
	        this.puzzle.startPlay++;
	      }
	      if (this.puzzle.startPlay > moves.length) {
	        this.puzzle.startPlay = 0;
	      }
	      if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0 && this.puzzle.type !== 'Practica') {
	        var numGetMove = this.puzzle.startPlay + this.handMoves;
	
	        var equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).notation.notation;
	        if (equal === false) {
	          for (var v = 0; v < window.pgnBoardBase.getPgn().getMove(numGetMove).variations.length; v++) {
	            equal = this.chess.history()[this.handMoves] === window.pgnBoardBase.getPgn().getMove(numGetMove).variations[v].notation.notation;
	            if (equal === true) {
	              break;
	            }
	          }
	        }
	        if (equal === false) {
	            this.numMoves = 0;
	            this.mate = false;
	
	            this.resolvePuzzle({ _id: this.puzzle._id, resolve: this.mate ? 1 : 0 });
	            clearInterval(timesColor);
	          } else if (this.numMoves <= 0) {
	          this.mate = equal;
	          this.resolvePuzzle({ _id: this.puzzle._id, resolve: this.mate ? 1 : 0 });
	          this.loadPuzzle(this.chess.fen(), false);
	          clearInterval(timesColor);
	        } else {
	          orig = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).from;
	          dest = window.pgnBoardBase.getPgn().getMove(numGetMove + 1).to;
	
	          this.numMoves--;
	          this.chess.move({
	            from: orig,
	            to: dest,
	            promotion: promopiece
	          });
	          this.ground.move(orig, dest);
	          this.ground.set({
	            fen: this.chess.fen(),
	            turnColor: this.chessToColor(this.chess),
	            movable: {
	              color: this.chessToColor(this.chess),
	              dests: this.chessToDests(this.chess)
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            animation: {
	              enabled: true,
	              duration: 600
	            },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          });
	          this.loadPuzzle(this.chess.fen(), false);
	          this.handMoves++;
	        }
	      } else {
	        this.resultPractica = '';
	        this.movePC(this.turn);
	        this.numMoves = 1;
	        if (this.isFinish(this.chess)) {
	          clearInterval(timesColor);
	          if (this.chess.in_checkmate()) {
	            this.resultPractica = 'Jaque mate';
	            this.toast('Jaque mate', 2000);
	            this.mate = this.chess.turn() === this.turn;
	          } else if (this.chess.in_draw()) {
	            this.toast('Tablas', 2000);
	            this.resultPractica = 'Tablas';
	          } else {
	            this.mate = true;
	          }
	          this.numMoves = 0;
	        }
	      }
	      this.handMoves++;
	    },
	    onMove: function onMove(orig, dest) {
	      var _this = this;
	
	      var _self = this;
	      if (this.chess) {
	        var turn = this.chess.turn() === 'w' ? 'white' : 'black';
	        var piece = void 0;
	        if (_self.chess && _self.chess.get(orig)) {
	          piece = _self.chess.get(orig).type;
	        }
	        if (turn === _self.userColor && piece === 'p' && (dest.substring(1, 2) === '8' || dest.substring(1, 2) === '1')) {
	          window.swal('¿A que pieza promociona?', {
	            buttons: {
	              queen: { text: '♕', value: 'q' },
	              rook: { text: '♖', value: 'r' },
	              bishop: { text: '♝', value: 'b' },
	              knight: { text: '♞', value: 'n' }
	            }
	          }).then(function (result) {
	            setTimeout(function () {
	              _self.onMoveFinal(orig, dest, result);
	            }, 500);
	          });
	        } else {
	          setTimeout(function () {
	            _this.onMoveFinal(orig, dest, 'q');
	          }, 500);
	        }
	      } else {
	        setTimeout(function () {
	          _this.onMoveFinal(orig, dest, 'q');
	        }, 500);
	      }
	    },
	    PcIngeniesMoveStockfish: function PcIngeniesMoveStockfish(move) {
	      var from = move.from;
	      var to = move.to;
	
	      this.onMove(from, to);
	    },
	    movePC: function movePC(turn) {
	      if (turn !== this.userColor) {
	        setTimeout(function () {
	          this.pcMove(this.chess.fen());
	        }.bind(this), 200);
	      }
	    },
	    pcMove: function pcMove(fen) {
	      if (this.stockfish !== null && this.stockfish !== undefined) {
	        this.stockfish.setPlayerColor(this.orientation);
	
	        this.stockfish.setDepth(10);
	        this.stockfish.setNodes(0);
	
	        this.stockfish.prepareMove(fen, '', this.PcIngeniesMoveStockfish, 1000, 1000, 0, 0);
	      }
	    },
	    makeRandomMove: function makeRandomMove() {
	      var possibleMoves = this.chess.moves({
	        verbose: true
	      });
	      var randomIndex = Math.floor(Math.random() * possibleMoves.length);
	      var move = possibleMoves[randomIndex];
	      var from = move.from;
	      var to = move.to;
	      this.onMove(from, to);
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    loadPuzzle: function loadPuzzle(fen, init) {
	      try {
	        if (init === true) {
	          if (this.puzzle.timemove === undefined) {
	            this.puzzle.timemove = 120;
	          }
	          if (this.puzzle.nummoves === undefined) {
	            this.puzzle.nummoves = 1;
	          }
	          this.numMoves = parseInt(this.puzzle.nummoves);
	          this.timeMove = parseInt(this.puzzle.timemove);
	          this.titlefen = this.puzzle.titlefen;
	          this.handMoves = 0;
	        }
	        if (this.puzzle.pgn !== undefined && this.puzzle.pgn.length > 0) {
	          var Width = 500;
	          if (document.getElementById('puzzleBoard') !== undefined) {
	            Width = document.getElementById('puzzleBoard').clientWidth;
	          }
	          var pgnBoard = 0;
	          var pos = 'end';
	          var start = fen !== undefined ? fen : '';
	          if (init === true) {
	            this.puzzle.pgn = this.puzzle.pgn.split('"]').join('"]\n');
	            this.puzzle.pgn = this.puzzle.pgn.split('{}').join('');
	          }
	          var headers = this.parse_pgn_header(this.puzzle.pgn);
	          if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	            pos = fen !== undefined ? fen : 'end';
	            if (!this.hasBody(this.puzzle.pgn)) {
	              start = '';
	              pos = headers['FEN'];
	            }
	            if (pos === headers['FEN']) {
	              start = '';
	            }
	          }
	          if (start === 'start' || start === 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1') {
	            start = '';
	            pos = fen;
	          }
	          if (fen === headers['FEN']) {
	            pos = headers['FEN'];
	          }
	
	          if (document.getElementById('pgnComment')) {
	            document.getElementById('pgnComment').textContent = '';
	          }
	
	          pgnBoard = window.pgnEdit({ inner: 'puzzleBoard', comment: 'pgnComment' }, { pgn: this.puzzle.pgn, position: pos, startPlay: start, width: Width, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true });
	          this.ground = pgnBoard.board;
	          if (init === true) {
	            this.chess = pgnBoard.chess;
	          }
	          window.pgnBoardBase = pgnBoard.boardBase;
	          if (document.getElementById('puzzleBoard') !== undefined) {
	            document.getElementById('puzzleBoard').style.height = Width + 'px';
	            document.getElementById('puzzleBoard').style.width = Width + 'px';
	          }
	
	          if (init === true) {
	            this.userColor = this.chess.turn() === 'w' ? 'white' : 'black';
	            this.orientation = this.userColor;
	          }
	          var options = {
	            orientation: this.orientation,
	            movable: {
	              free: false,
	              color: 'both',
	              dests: this.chessToDests(this.chess),
	              dropOff: 'revert',
	              showDests: true,
	              events: {
	                after: this.onMove
	              }
	            },
	            animation: {
	              enabled: true,
	              duration: 600
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: false,
	              visible: false
	            }
	          };
	
	          this.ground.set(options);
	          this.chessToColor(this.chess);
	        } else {
	          if (fen) {
	            this.chess.load(fen);
	          } else {
	            this.chess.load('8/2k5/8/8/6P1/8/8/4K3 w - - 0 1');
	          }
	          this.ground.set({
	            fen: this.chess.fen(),
	            turnColor: this.chessToColor(this.chess),
	            movable: {
	              color: this.chessToColor(this.chess),
	              dests: this.chessToDests(this.chess)
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          });
	          this.userColor = this.chess.turn() === 'w' ? 'white' : 'black';
	          this.movePC(this.turn);
	        }
	        this.countDown();
	        var comments = document.querySelectorAll('.afterComment');
	        comments.forEach(function (comment) {
	          var textResource = comment.textContent.toLowerCase();
	          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	            comment.closest('.move').classList.add('highlight-move');
	          }
	        });
	      } catch (error) {
	        console.error('<span>' + 'Error LoadPuzzle: ' + error + '</span>', 3000);
	      }
	    },
	    resultado: function resultado() {
	      this.resultadoNext();
	    },
	    pista: function pista() {
	      this.pistaNext();
	    },
	    isFinish: function isFinish(chess) {
	      return chess.game_over();
	    },
	    reintent: function reintent() {
	      clearInterval(timesColor);
	      this.mate = false;
	      this.loadPuzzle(this.puzzle.feninit, true);
	    }
	  },
	  beforeDestroy: function beforeDestroy() {
	    if (this.stockfish !== null && this.stockfish !== undefined) {
	      this.stockfish.close();
	      this.stockfish = null;
	    }
	  },
	  ready: function ready() {
	    try {
	      var skill = 20;
	      this.stockfish = _enginegame2.default.engineGame({ book: 'static/libs/book.bin', stockfishjs: 'static/libs/stockfish.js' });
	
	      if (this.stockfish !== null && this.stockfish !== undefined) {
	        this.stockfish.reset();
	
	        this.stockfish.setSkillLevel(skill);
	        this.stockfish.setPlayerColor(this.orientation);
	        this.stockfish.setDisplayScore(true);
	        this.stockfish.setOwnBook(false);
	        this.stockfish.start();
	      }
	      window.addEventListener('resize', this.onResize);
	
	      setTimeout(function () {
	        var pgnBoard = 0;
	
	        if (document.getElementById('pgnComment')) {
	          document.getElementById('pgnComment').textContent = '';
	        }
	
	        pgnBoard = window.pgnEdit({ inner: 'puzzleBoard', comment: 'pgnComment' }, { showCoords: true, width: Width, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: true, headers: true });
	        if (pgnBoard.board !== undefined && pgnBoard.board !== null) {
	          this.ground = pgnBoard.board;
	          window.pgnBoardBase = pgnBoard.boardBase;
	
	          var options = {
	            orientation: 'white',
	            movable: {
	              free: false,
	              color: 'both',
	              dests: this.chessToDests(this.chess),
	              dropOff: 'revert',
	              showDests: true,
	              events: {
	                after: this.onMove
	              }
	            },
	            animation: {
	              enabled: true,
	              duration: 600
	            },
	            highlight: {
	              lastMove: true,
	              check: true },
	            drawable: {
	              enabled: true,
	              visible: true
	            }
	          };
	          this.ground.set(options);
	          if (document.getElementById('puzzleBoard')) {
	            var Width = document.getElementById('puzzleBoard').clientWidth - 20;
	            if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	              Width = Width - 35;
	            }
	            document.getElementById('puzzleBoard').style.height = Width + 'px';
	            document.getElementById('puzzleBoard').style.width = Width + 'px';
	          }
	
	          this.loadPuzzle('', true);
	        }
	        var comments = document.querySelectorAll('.afterComment');
	        comments.forEach(function (comment) {
	          var textResource = comment.textContent.toLowerCase();
	          if (textResource.includes('🎥') || textResource.includes('vídeo') || textResource.includes('recurso') || textResource.includes('video')) {
	            comment.closest('.move').classList.add('highlight-move');
	          }
	        });
	      }.bind(this), 10);
	    } catch (error) {
	      console.error('<span>' + 'Error (ready puzzle): ' + error + '</span>', 3000);
	    }
	  },
	
	  watch: {
	    puzzle: function puzzle(newVal, oldVal) {
	      if (newVal !== oldVal) {
	        this.loadPuzzle(newVal.feninit, true);
	      }
	    }
	  }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(16);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(41);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(74);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _board = __webpack_require__(27);
	
	var _board2 = _interopRequireDefault(_board);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _torneo = __webpack_require__(297);
	
	var _torneo2 = _interopRequireDefault(_torneo);
	
	var _chess = __webpack_require__(17);
	
	var _chess2 = _interopRequireDefault(_chess);
	
	var _swiss = __webpack_require__(119);
	
	var _swiss2 = _interopRequireDefault(_swiss);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _jquery = __webpack_require__(25);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _boardVisorSmall = __webpack_require__(111);
	
	var _boardVisorSmall2 = _interopRequireDefault(_boardVisorSmall);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var groundInit = 1;
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    },
	    data: function data(transition) {
	      return _promise2.default.all([_torneo2.default.count(this)]).then(function (data) {
	        var theD = JSON.parse(data);
	
	        return {
	          counts: theD
	        };
	      }, function (response) {});
	    }
	  },
	  template: __webpack_require__(520),
	  data: function data() {
	    return {
	      user: _user2.default.getUser(),
	      mode: 'add',
	      fenInit: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      fenFinish: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1',
	      pgn: '',
	      startPlay: 0,
	      club: '',
	      numMoves: 1,
	      timeMove: 60,
	      titleFen: 'Torneo',
	      myPGNValue: '',
	      myFENValue: '',
	      results: {},
	      pgnFiles: [],
	      item: {
	        num: 0
	      },
	      counts: [],
	      foundList: [],
	      chess: new _chess2.default(),
	      torneoType: {},
	      torneosType: [{
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Liga',
	        description: 'Torneo todos contra todos.',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Simultanea',
	        description: 'Un jugador contra muchos otros.',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Suizo',
	        description: 'Sistema suizo a varias rondas',
	        position: true
	      }, {
	        numMoves: 0,
	        timeMove: 120,
	        type: 'Aleatorio',
	        description: 'Cada ronda es aleatoria',
	        position: true
	      }],
	      torneos: [],
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: '',
	      finduser: '',
	      bGuardar: false,
	      sendToAll: false,
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirServer: _lstorage2.default.get('serverDir'),
	      filesUpload: [],
	      hashFileBoard1: '',
	      hashFileBoard2: '',
	      hashFileBoard3: '',
	      fileProgress: 0,
	      allFilesUploaded: true,
	      offcanvas: false,
	      active: 'boardVisor',
	      tab: '0',
	      tabs: [],
	      chattext: '',
	      boards: [],
	      boardFiles: [],
	      boardFilesName: '',
	      boardFiles2: [],
	      boardFilesName2: '',
	      boardFiles3: [],
	      boardFilesName3: '',
	      rondas: 1,
	      rondaactual: 1,
	      nombretorneo: 'Torneo 1',
	      nombreTorneoResult: 'Torneo 1',
	      newboard: {
	        color: 'w',
	        time: '3',
	        incremento: 0,
	        elo: 1500,
	        contrincante: '',
	        public: true,
	        broadcast: false,
	        all: true,
	        club: ''
	      },
	      todosCheck: false,
	      users: [],
	      usersConnected: [],
	      players: [],
	      playersResult: [],
	      round1: {
	        rounds: []
	      },
	      bSimultanea: false,
	      bRandColor: false,
	      bOneRound: true,
	      usersLength: 0,
	      games: [],
	      board: _lstorage2.default.get('boardSee', {}),
	      totalRecords: 0,
	      limit: 100,
	      filters: {
	        torneo: 'Primera liga',
	        ronda: '1'
	      }
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  components: {
	    BoardVisorSmall: _boardVisorSmall2.default
	  },
	  events: {
	    boards: function boards(data) {
	      this.boards = data.boards;
	    },
	    mensaje: function mensaje(data) {
	      this.recibeMensaje(data.men, true, true);
	      if (data.men.send !== this.user.username) {
	        this.chatRecibido = true;
	      }
	    },
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    },
	    users: function users(data) {
	      this.usersConnected = data.nicknames;
	      var dataSend = {
	        club: this.user.club
	      };
	      var _self = this;
	      _user2.default.getAll(this, dataSend).then(function (response) {
	        var dd = JSON.parse(response);
	        var updatedUsers = dd.filter(function (user) {
	          var existingUser = _self.users.find(function (u) {
	            return u.username === user.username;
	          });
	          return !existingUser || existingUser.elo !== user.elo;
	        });
	        if (updatedUsers.length > 0) {
	          _self.users = dd;
	          var playersParam = (0, _extends3.default)({}, _self.players);
	          updatedUsers.forEach(function (user) {
	            if (true) {
	              var nombre = user.username;
	
	              if (!playersParam[nombre]) {
	                playersParam[nombre] = {};
	              }
	              playersParam[nombre] = {
	                name: nombre,
	                juega: _self.isConnected(nombre),
	                user: user._id || null,
	                score: playersParam[nombre].score || 0,
	                buchholz: playersParam[nombre].buchholz || 1,
	                elo: user.elo
	              };
	            }
	          });
	          playersParam['PC'] = playersParam['PC'] || {
	            name: 'PC',
	            juega: false,
	            user: null,
	            score: 0,
	            buchholz: 1,
	            elo: 1500
	          };
	
	          _self.players = playersParam;
	        }
	      }, function (response) {
	        console.error('Error al obtener datos de usuarios:', response);
	      });
	    }
	  },
	  methods: {
	    createGuid: function createGuid() {
	      function _p8(s) {
	        var p = (Math.random().toString(16) + '000000000').substr(2, 8);
	        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
	      }
	      return _p8();
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === 'Retransmisión') {
	        this.mensjGame.push(men);
	        if (bottom) {
	          this.isAtBottom();
	        }
	      }
	      if (toast === true) {
	        if (men.send !== _user2.default.getUser().username) {
	          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000);
	        }
	      }
	    },
	    allAreConnected: function allAreConnected(round) {
	      var ret = true;
	      if (this.item !== undefined && this.item.round1 !== undefined) {
	        for (var play in this.item.round1[round].rounds) {
	          if (this.item.round1[round].rounds[play].white !== 'PC' && this.item.round1[round].rounds[play].black !== 'PC') {
	            if (this.isConnected(this.item.round1[round].rounds[play].white) === false) {
	              ret = false;
	              break;
	            }
	            if (this.isConnected(this.item.round1[round].rounds[play].black) === false) {
	              ret = false;
	              break;
	            }
	          }
	        }
	      }
	      return ret;
	    },
	    isBeginRonda: function isBeginRonda(rondaParam) {
	      var ret = false;
	      var nRonda = 0;
	      for (var ronda in this.item.round1) {
	        if (nRonda + 1 === rondaParam) {
	          for (var partida in this.item.round1[ronda].rounds) {
	            if (this.item.round1[ronda].rounds[partida].wins !== '') {
	              ret = true;
	            }
	          }
	        }
	        nRonda++;
	      }
	      return ret;
	    },
	    isBegin: function isBegin() {
	      var ret = false;
	      for (var ronda in this.item.round1) {
	        for (var partida in this.item.round1[ronda].rounds) {
	          if (this.item.round1[ronda].rounds[partida].wins !== '') {
	            ret = true;
	          }
	        }
	      }
	      return ret;
	    },
	    isConnected: function isConnected(userName) {
	      var ret = false;
	      if (userName === 'PC') {
	        ret = true;
	      } else {
	        for (var i in this.usersConnected) {
	          if (this.usersConnected[i].club === this.user.club) {
	            var nombre = this.usersConnected[i].username;
	            if (nombre === userName) {
	              ret = true;
	              break;
	            }
	          }
	        }
	      }
	      return ret;
	    },
	    FilterTorneo: function FilterTorneo(torneo, ronda) {
	      var filters = {
	        filters: this.filters,
	        torneo: torneo.titlefen,
	        ronda: ronda.toString()
	      };
	      var self = this;
	      _board2.default.filtertorneo(self, filters).then(function (response) {
	        var data = JSON.parse(response);
	        self.totalRecords = 0;
	
	        var number = 0;
	        var bRet = true;
	        for (var i in torneo.round1) {
	          for (var play in torneo.round1[i].rounds) {
	            if (torneo.round1[i].rounds[play].white === 'PC' && torneo.round1[i].rounds[play].black === 'PC' && torneo.round1[i].rounds[play].wins === '') {
	              torneo.round1[i].rounds[play].wins = Math.random() % 2 ? 'white' : 'black';
	              var result = Math.floor(Math.random() * (1 - -1 + 1)) + -1;
	              if (result === 1) {
	                torneo.round1[i].rounds[play].wins = 'white';
	              }
	              if (result === -1) {
	                torneo.round1[i].rounds[play].wins = 'black';
	              }
	              if (result === 0) {
	                torneo.round1[i].rounds[play].wins = 'draw';
	              }
	              number++;
	
	              bRet = true;
	            }
	          }
	        }
	        self.foundList = data.documents.filter(function (a) {
	          if (torneo !== undefined && torneo.round1 !== undefined && torneo.titlefen === a.torneo) {
	            for (var i in torneo.round1) {
	              for (var play in torneo.round1[i].rounds) {
	                if (parseInt(i) === a.ronda && torneo.round1[i].rounds[play].white === a.u1 && torneo.round1[i].rounds[play].black === a.u2) {
	                  torneo.round1[i].rounds[play].wins = a.wins;
	                  number++;
	                  bRet = true;
	                }
	              }
	            }
	          }
	          return bRet;
	        });
	        self.totalRecords = number;
	      }, function (response) {
	        self.error = response.data;
	      });
	    },
	    selectItm: function selectItm(item) {
	      this.totalRecords = 0;
	      this.item = item;
	      this.FilterTorneo(this.item, 0);
	      if (this.item !== undefined && this.item.round1 !== undefined) {
	        this.item.round1 = JSON.parse(item.round1);
	      }
	    },
	    nextTorneo: function nextTorneo() {
	      var post = this.torneos.indexOf(this.item);
	      if (post !== -1 && post + 1 < this.torneos.length && this.torneos[post + 1]) {
	        this.selectItm(this.torneos[post + 1]);
	      } else {
	        if (post + 1 >= this.torneos.length && this.torneosType.indexOf(this.torneoType) + 1 < this.torneosType.length) {
	          this.selectTorneoType(this.torneosType[this.torneosType.indexOf(this.torneoType) + 1]);
	        } else {
	          this.toast('<span>Ya no hay mas</span>', 2000);
	        }
	      }
	    },
	    selectTorneoType: function selectTorneoType(torneo) {
	      this.torneoType = torneo;
	      var parms = {
	        type: torneo.type, club: this.user.club
	      };
	      if (torneo.type === 'Simultanea') {
	        this.bSimultanea = true;
	      } else {
	        this.bSimultanea = false;
	      }
	      this.item.round1 = [];
	      var _self = this;
	      _torneo2.default.get(_self, parms).then(function (response) {
	        var theD = JSON.parse(response);
	        _self.torneos = theD;
	        setTimeout(function () {
	          if (_self.torneos.length > 0 && _self.torneos[0]) {
	            _self.selectItm(_self.torneos[0]);
	          }
	          (0, _jquery2.default)('#listSomeTorneos').animate({
	            'scrollTop': 0
	          }, 'slow');
	        }, 50);
	      }, function (response) {
	        this.error = response.data;
	      });
	    },
	    updateFenInit: function updateFenInit(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	
	      this.fenInit = groundInit.getFen();
	    },
	    updateFenFinish: function updateFenFinish(orig, dest) {
	      this.chess.move({
	        from: orig,
	        to: dest
	      });
	    },
	    addTorneo: function addTorneo(mode) {
	      this.mode = mode;
	
	      if (!this.torneoType.type) {
	        this.toast('<span>Selecciona un tipo de torneo</span>', 2000);
	        return;
	      }
	      if (mode === 'add') {
	        this.round1 = {};
	        this.nombretorneo = 'T_' + this.createGuid();
	      }
	
	      this.$broadcast('modal::open', 'modalCreateTorneo');
	    },
	    generateHeader: function generateHeader(pgnFile) {
	      var complete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var onlyNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	      var retHeader = '';
	      var pgnInLines = pgnFile.split('"]').join('"]\n');
	      var headers = this.parse_pgn_header(pgnInLines);
	      if (headers !== undefined && headers['Event'] !== undefined) {
	        var appendHeader = function appendHeader(result, headers, separator) {
	          if (headers && headers.length > 0) {
	            if (result.length > 0) {
	              result += separator;
	            }
	            result += headers;
	          }
	          return result;
	        };
	        var hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date']];
	        if (complete) {
	          retHeader = headers['White'] + ' vs ' + headers['Black'];
	          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']];
	        }
	        if (onlyNames) {
	          retHeader = headers['White'] + ' (' + headers['WhiteElo'] + ')' + ' vs ' + headers['Black'] + ' (' + headers['BlackElo'] + ')';
	          hh = [];
	        }
	        if (hh.length > 1) {
	          var rest = '';
	          retHeader += ' (';
	          hh.forEach(function (headers) {
	            rest = appendHeader(rest, headers, ' | ');
	          });
	          retHeader += rest;
	          retHeader += ')';
	        }
	      }
	
	      return retHeader;
	    },
	    readTextFile: function readTextFile(file, callback, encoding) {
	      var reader = new window.FileReader();
	      reader.addEventListener('load', function (e) {
	        callback(this.result);
	      });
	      if (encoding) {
	        reader.readAsText(file, encoding);
	      } else {
	        reader.readAsText(file);
	      }
	    },
	    isListFiles: function isListFiles() {
	      var input = document.getElementById('files');
	      if (input.files && input.files[0] && input.files[0].length > 0) {
	        return true;
	      }
	      return false;
	    },
	    listFiles: function listFiles() {
	      this.fileChosen();
	    },
	    hashCode: function hashCode(s) {
	      var h = 0;
	      var l = s.length;
	      var i = 0;
	      if (l > 0) {
	        while (i < l) {
	          h = (h << 5) - h + s.charCodeAt(i++) | 0;
	        }
	      }
	      var hexString = h.toString(16);
	      return hexString;
	    },
	    parsePgnFiles: function parsePgnFiles(file, number) {
	      this.pgnFiles = '';
	      var newlineChar = '\r?\n';
	      var filesObj = {};
	
	      var lines = file.split(new RegExp(newlineChar));
	      var pgntext = '';
	      var state = 0;
	      var index = 0;
	      for (var i = 0; i < lines.length; i++) {
	        if (lines[i].length > 0) {
	          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
	            if (state === 1) {
	              index = index + 1;
	              var headers = this.parse_pgn_header(pgntext);
	              var hashCode = this.hashCode(pgntext);
	              var board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' };
	              filesObj[index] = board;
	
	              pgntext = '';
	            }
	            state = 0;
	          } else {
	            state = 1;
	          }
	          if (state === 0) {
	            pgntext += lines[i] + '\r\n';
	          } else {
	            pgntext += lines[i] + ' ';
	          }
	        }
	      }
	      headers = this.parse_pgn_header(pgntext);
	      hashCode = this.hashCode(pgntext);
	      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' };
	      index = index + 1;
	      filesObj[index] = board;
	
	      this.pgnFiles = filesObj;
	
	      return filesObj;
	    },
	    hasBody: function hasBody(pgn) {
	      var ret = false;
	      var newlineChar = '\r?\n';
	      var lines = pgn.split(new RegExp(newlineChar));
	      for (var i = 0; i < lines.length; i++) {
	        var linea = lines[i].trim();
	        if (linea.length > 0 && linea[0] !== '[' && linea[0] !== '*') {
	          ret = true;
	          break;
	        }
	      }
	      return ret;
	    },
	    parse_pgn_header: function parse_pgn_header(header) {
	      var newlineChar = '\r?\n';
	      var headerObj = {};
	      var headers = header.split(new RegExp(newlineChar));
	      var key = '';
	      var value = '';
	      for (var i = 0; i < headers.length; i++) {
	        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1');
	        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1');
	        if (key.length > 0 && value.length > 0 && key !== value) {
	          headerObj[key] = value;
	        }
	      }
	      return headerObj;
	    },
	    deleteComment: function deleteComment(pgn) {
	      pgn = pgn.replace(/\{((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\}/gm, '');
	      pgn = pgn.replace(/\{\[%emt([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\]\}/gm, '');
	      pgn = pgn.replace(/\{([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF](?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?)\}/gm, '');
	      return pgn;
	    },
	    cleanPGNContent: function cleanPGNContent(str) {
	      return str.replace(/(\r?\n){2,}/g, '\n\n').replace(/\r?\n/g, function (match, offset, string) {
	        var prevChar = string[offset - 1];
	        var nextChar = string[offset + 1];
	
	        if (prevChar === '\n') {
	          return match;
	        }
	
	        if (prevChar === ']' || nextChar === '[') {
	          return match;
	        }
	        return ' ';
	      }).replace(/ {2,}/g, ' ');
	    },
	    prettyPgn: function prettyPgn(strParam) {
	      var str = strParam;
	      try {
	        str = Buffer.from(strParam, 'latin1').toString('utf8');
	      } catch (e) {
	        str = strParam;
	      }
	      str = str.replace(/0-0-0/g, 'O-O-O').replace(/0-0/g, 'O-O');
	      str = this.cleanPGNContent(str);
	      return str;
	    },
	    openPGN: function openPGN(pgnText) {
	      var pgnAux = pgnText;
	      pgnAux = this.prettyPgn(pgnAux);
	
	      this.myPGNValue = pgnAux;
	    },
	    fileChosen: function fileChosen() {
	      var output = document.getElementById('idTextAreaPGN');
	      var input = document.getElementById('files');
	      var _self = this;
	      if (input.files && input.files[0]) {
	        this.readTextFile(input.files[0], function (str) {
	          if (output !== undefined) {
	            output.value = '';
	            output.dispatchEvent(new window.Event('change'));
	          }
	          _self.parsePgnFiles(str);
	        }, 'ISO-8859-1');
	      }
	    },
	    changePGNTextArea: function changePGNTextArea() {
	      var idTextArea = document.getElementById('idTextAreaPGN');
	      if (idTextArea && idTextArea.value !== 'none') {
	        var pgnAux = idTextArea.value;
	        pgnAux = pgnAux.replace('0-0', 'O-O');
	        pgnAux = pgnAux.replace('0-0-0', 'O-O-O');
	
	        this.myPGNValue = pgnAux;
	        var headers = this.parse_pgn_header(idTextArea.value);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          this.myFENValue = headers['FEN'];
	        }
	
	        idTextArea.value = '';
	      }
	    },
	    setFenPosition: function setFenPosition() {
	      if (document.getElementById('iFramePosition')) {
	        var searchinput = document.getElementById('iFramePosition').contentWindow.document.getElementById('fenInputOutput');
	        if (searchinput !== undefined && searchinput !== null) {
	          var txtPgn = '';
	          txtPgn = '[SetUp "1"]\r\n[FEN "' + searchinput.value + '"]';
	
	          this.fenInit = searchinput.value;
	          this.fenFinish = searchinput.value;
	          this.pgn = txtPgn;
	        }
	      }
	    },
	    createTorneo: function createTorneo(action) {
	      if (action) {
	        var newTorneo = {
	          type: this.torneoType.type,
	          createby: _user2.default.getUser().username,
	          club: _user2.default.getUser().club,
	          incremento: this.newboard.incremento,
	          time: this.newboard.time,
	          rounds: this.rondas,
	          round1: (0, _stringify2.default)(this.round1),
	          titlefen: this.nombretorneo,
	          mode: this.mode
	        };
	
	        this.$broadcast('modal::close', 'some', 'modalCreateTorneo');
	        _torneo2.default.add(this, newTorneo).then(function (response) {
	          this.toast('<span>Creado correctamente</span>', 3000);
	
	          if (this.mode === 'add' && newTorneo) {
	            this.selectItm(newTorneo);
	          } else {}
	
	          this.selectTorneoType(this.torneoType);
	        }, function (response) {
	          this.error = response.data;
	          this.toast('<span>' + this.error + '</span>', 3000);
	        });
	      } else {
	        this.$broadcast('modal::close', 'some', 'modalCreateTorneo');
	      }
	    },
	    onResize: function onResize(event) {
	      if (document.getElementById('middle') && document.getElementById('torneoBoard')) {
	        var Width = document.getElementById('middle').clientWidth;
	        Width = Width > window.innerHeight - 100 ? window.innerHeight - 100 : Width;
	        if (document.getElementById('analisisVertical') && document.getElementById('analisisVertical').style.display !== 'none') {
	          Width = Width - 35;
	        }
	        document.getElementById('torneoBoard').style.height = Width + 'px';
	        document.getElementById('torneoBoard').style.width = Width + 'px';
	
	        document.body.dispatchEvent(new window.Event('chessground.resize'));
	      }
	    },
	    editTorneo: function editTorneo() {
	      this.pgn = this.item.pgn;
	      this.fenInit = this.item.feninit;
	      this.numMoves = this.item.nummoves;
	      this.timeMove = this.item.timemove;
	      this.timeFen = this.item.timefen;
	      this.round1 = this.item.round1;
	      this.nombretorneo = this.item.titlefen;
	      this.rondas = this.item.rounds;
	      this.newboard.time = this.item.time;
	      this.newboard.incremento = this.item.incremento;
	      this.timePersonal = true;
	
	      this.addTorneo(this.item._id);
	    },
	    delTorneo: function delTorneo() {
	      var _self = this;
	      window.swal('¿Está seguro de eliminar el torneo?', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          _torneo2.default.del(_self, _self.item._id).then(function (response) {
	            _self.selectTorneoType(_self.torneoType);
	          }, function (response) {
	            _self.error = response.data;
	          });
	        }
	      });
	    },
	    createAllTournament: function createAllTournament() {
	      this.rondas = 1;
	      this.round1 = {};
	      for (var x = 0; x < this.rondas; x++) {
	        this.createTournament(x);
	      }
	      this.bGuardar = true;
	    },
	    addPlayersInRound: function addPlayersInRound(round1) {
	      for (var ronda in round1) {
	        for (var partida in round1[ronda].rounds) {
	          var nameBlack = round1[ronda].rounds[partida].black;
	          var nameWhite = round1[ronda].rounds[partida].white;
	          var elo = round1[ronda].rounds[partida].elo;
	
	          if (nameBlack !== undefined) {
	            this.players[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo };
	          }
	          if (nameWhite !== undefined) {
	            this.players[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo };
	          }
	        }
	      }
	    },
	    clone: function clone(obj) {
	      var dupe = obj instanceof Array ? [] : {};
	      for (var property in obj) {
	        if ((typeof property === 'undefined' ? 'undefined' : (0, _typeof3.default)(property)) === 'object') {
	          dupe[property] = this.clone(obj[property]);
	        } else {
	          dupe[property] = obj[property];
	        }
	      }
	      return dupe;
	    },
	    refresh: function refresh() {
	      this.selectItm(this.item);
	    },
	    showResults: function showResults(round1, title) {
	      this.nombreTorneoResult = title;
	      this.playersResult = {};
	
	      for (var ronda in round1) {
	        for (var partida in round1[ronda].rounds) {
	          var nameBlack = round1[ronda].rounds[partida].black;
	          var nameWhite = round1[ronda].rounds[partida].white;
	          var elo = round1[ronda].rounds[partida].elo;
	          if (nameBlack !== undefined && this.playersResult[nameBlack] === undefined) {
	            this.playersResult[nameBlack] = { name: nameBlack, juega: false, user: nameBlack, score: 0, buchholz: 1, elo: elo };
	          }
	          if (nameWhite !== undefined && this.playersResult[nameWhite] === undefined) {
	            this.playersResult[nameWhite] = { name: nameWhite, juega: false, user: nameWhite, score: 0, buchholz: 1, elo: elo };
	          }
	          if (round1[ronda] !== undefined && round1[ronda].rounds[partida].wins !== '') {
	            if (round1[ronda].rounds[partida].wins === 'white') {
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score += 1;
	              }
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score -= 0;
	              }
	            } else if (round1[ronda].rounds[partida].wins === 'black') {
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score -= 0;
	              }
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score += 1;
	              }
	            } else if (round1[ronda].rounds[partida].wins === 'draw') {
	              if (this.playersResult[nameBlack] !== undefined) {
	                this.playersResult[nameBlack].score += 0.5;
	              }
	              if (this.playersResult[nameWhite] !== undefined) {
	                this.playersResult[nameWhite].score += 0.5;
	              }
	            }
	          }
	        }
	      }
	      for (ronda in round1) {
	        for (partida in round1[ronda].rounds) {
	          nameBlack = round1[ronda].rounds[partida].black;
	          nameWhite = round1[ronda].rounds[partida].white;
	          if (this.playersResult[nameWhite] !== undefined) {
	            this.playersResult[nameWhite].buchholz = 0;
	          }
	          if (this.playersResult[nameBlack] !== undefined) {
	            this.playersResult[nameBlack].buchholz = 0;
	          }
	        }
	      }
	      for (ronda in round1) {
	        for (partida in round1[ronda].rounds) {
	          nameBlack = round1[ronda].rounds[partida].black;
	          nameWhite = round1[ronda].rounds[partida].white;
	
	          if (this.playersResult[nameWhite] !== undefined && this.playersResult[nameBlack] !== undefined) {
	            this.playersResult[nameWhite].buchholz += this.playersResult[nameBlack].score;
	            this.playersResult[nameBlack].buchholz += this.playersResult[nameWhite].score;
	          }
	        }
	      }
	      var ordered = {};
	      var _self = this;
	      (0, _keys2.default)(_self.playersResult).sort(function (a, b) {
	        if (_self.playersResult[b].score === _self.playersResult[a].score) {
	          return _self.playersResult[b].buchholz - _self.playersResult[a].buchholz;
	        } else {
	          return _self.playersResult[b].score - _self.playersResult[a].score;
	        }
	      }).forEach(function (key) {
	        ordered[key] = _self.playersResult[key];
	      });
	      this.playersResult = ordered;
	      this.$broadcast('modal::open', 'modalResultados');
	    },
	    roundRobin: function roundRobin(teams) {
	      var schedule = [];
	      var league = [];
	      var rondaRoundRobin = {};
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          league.push(this.players[i].name);
	        }
	      }
	
	      if (league.length % 2) {
	        league.push('None');
	      }
	      var rounds = league.length;
	
	      this.rondas = rounds;
	      var totalRondas = this.bOneRound === true ? rounds - 1 : (rounds - 1) * 2;
	      for (var j = 0; j < totalRondas; j++) {
	        schedule[j] = [];
	        var round = {};
	        for (var _i = 0; _i < rounds / 2; _i++) {
	          if (league[_i] !== 'None' && league[rounds - 1 - _i] !== 'None') {
	            var white = '';
	            var black = '';
	            if (j % 2 === 1) {
	              schedule[j].push([league[_i], league[rounds - 1 - _i]]);
	              white = league[_i];
	              black = league[rounds - 1 - _i];
	            } else {
	              schedule[j].push([league[rounds - 1 - _i], league[_i]]);
	              white = league[rounds - 1 - _i];
	              black = league[_i];
	            }
	            var partida = { white: white, black: black, wins: '' };
	            round[_i] = partida;
	          }
	        }
	
	        var roundaux = { rounds: round };
	        rondaRoundRobin[j] = roundaux;
	        league.splice(1, 0, league.pop());
	      }
	
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 };
	      }
	      this.round1 = rondaRoundRobin;
	
	      return schedule;
	    },
	    saveTournament: function saveTournament() {},
	    createRoundRobin: function createRoundRobin() {
	      var ret = this.randomArrayShuffle(this.players);
	      this.players = ret;
	      this.roundRobin(this.players);
	      this.bGuardar = true;
	    },
	    createSwiss: function createSwiss() {
	      var retP = this.randomArrayShuffle(this.players);
	      this.players = retP;
	      this.rondas = 1;
	
	      var ret = {};
	      var param = this.round1;
	      this.round1 = {};
	      ret = _swiss2.default.createSwiss(this.players, param, 0);
	
	      for (var k in ret) {
	        _vue2.default.set(this.round1, k, ret[k]);
	      }
	
	      this.bGuardar = false;
	    },
	    createTournament: function createTournament(ronda) {
	      var jugadores = '';
	      var partidas = 0;
	      var white = '';
	      var black = '';
	      var round = {};
	
	      var ret = this.randomArrayShuffle(this.players);
	      this.players = ret;
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          jugadores += '(' + i + ') ' + this.players[i].name + ': ' + this.players[i].juega + '\n';
	          if (this.bSimultanea === true) {
	            if (_user2.default.getUser().username !== this.players[i].name) {
	              if (this.bRandColor === true && Math.random() * 10 > 4) {
	                black = _user2.default.getUser().username;
	                white = this.players[i].name;
	              } else {
	                white = _user2.default.getUser().username;
	                black = this.players[i].name;
	              }
	              var partida = { white: white, black: black, wins: '' };
	              round[partidas] = partida;
	            }
	          } else {
	            if (partidas % 2 === 0) {
	              white = this.players[i].name;
	            } else {
	              black = this.players[i].name;
	              partida = { white: white, black: black, wins: '' };
	              round[partidas] = partida;
	            }
	          }
	          partidas++;
	        }
	      }
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null, score: 0, buchholz: 1, elo: 1500 };
	      }
	
	      var roundaux = { rounds: round };
	      this.round1[ronda] = roundaux;
	    },
	    randomArrayShuffle: function randomArrayShuffle(arrayParam) {
	      var array = [];
	      var arrayRet = {};
	      var index = 0;
	      for (var ii in arrayParam) {
	        array.push(arrayParam[ii].name);
	        index++;
	      }
	      var currentIndex = this.getLength(array) - 1;
	
	      while (currentIndex > 0) {
	        var randomIndex = Math.floor(Math.random() * currentIndex);
	        currentIndex -= 1;
	        var temporaryValue = array[currentIndex];
	        array[currentIndex] = array[randomIndex];
	        array[randomIndex] = temporaryValue;
	      }
	      for (var i = this.getLength(array) - 1; i >= 0; i--) {
	        arrayRet[array[i]] = arrayParam[array[i]];
	      }
	      return arrayRet;
	    },
	    createInvites: function createInvites(rondaParam, round1, torneo) {
	      this.rondaactual = rondaParam - 1;
	
	      var _self = this;
	      window.swal(torneo + '\n¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          var rondaInvites = round1[_self.rondaactual];
	          _self.nombretorneo = torneo;
	
	          for (var i in rondaInvites.rounds) {
	            _self.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black);
	          }
	        }
	      });
	    },
	    createInvitesNextSwiss: function createInvitesNextSwiss(round1, torneo) {
	      this.rondas = 1;
	      this.nombretorneo = torneo;
	
	      _swiss2.default.createSwiss(this.players, round1, 1);
	
	      this.createTorneo(true);
	      this.bGuardar = true;
	      this.rondaactual = 2;
	      this.bGuardar = true;
	    },
	    createdInviteGame: function createdInviteGame(userNameWhite, userNameBlack) {
	      var invite = {
	        type: 'invite',
	        public: this.item.public,
	        broadcast: false,
	        all: true,
	        vsPc: false,
	        torneo: this.nombretorneo,
	        ronda: this.rondaactual,
	        confirm: false,
	        club: _user2.default.getUser().club,
	        time: this.item.time,
	        incremento: this.item.incremento,
	        recibe: this.active,
	        elo: _user2.default.getUser().elo
	      };
	      if (userNameWhite === 'PC') {
	        invite.vsPc = true;
	        invite.confirm = true;
	
	        invite.elo = this.item.elo;
	      }
	
	      if (userNameBlack !== '') {
	        invite.confirm = true;
	        if (userNameBlack === 'PC') {
	          invite.vsPc = true;
	          invite.elo = this.item.elo;
	        }
	      }
	      if (this.newboard.color === 'w') {
	        invite.u1 = userNameWhite;
	        invite.u2 = userNameBlack;
	      } else {
	        invite.u2 = userNameWhite;
	        invite.u1 = userNameBlack;
	      }
	
	      if (invite.confirm === true) {
	        this.InviteGameActionConfirmado(invite);
	      }
	    },
	    InviteGameActionConfirmado: function InviteGameActionConfirmado(invite) {
	      var data = {
	        c: 'board',
	        f: 'confirmGame',
	        data: invite
	      };
	
	      if (invite.confirm || invite.vsPc) {
	        data.f = 'addBoard';
	      } else {}
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      return ret;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      var ret = '';
	      if (name !== undefined) {
	        ret = this.dirServer + '/uploads/' + name;
	      }
	      return ret;
	    },
	    loadAllData: function loadAllData() {
	      var data = {
	        c: 'chat',
	        f: 'getDataChat',
	        data: {
	          user: _user2.default.getUser()
	        }
	      };
	
	      this.$socket.emit('event', data, function () {
	        for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	          callbacks[_key] = arguments[_key];
	        }
	
	        var logUser = callbacks[1].logUser;
	        for (var i = 0; i < logUser.length; i++) {
	          if (logUser[i]) {}
	        }
	
	        this.boards = callbacks[1].boards;
	      }.bind(this));
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var historyTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var data = {
	        c: 'chat',
	        f: 'loadUserConvert',
	        data: parms
	      };
	      this.$socket.emit('event', data, function () {
	        var log = arguments.length <= 1 ? undefined : arguments[1];
	
	        var menLast = '';
	        if (log) {
	          for (var i = log.length - 1; i >= 0; i--) {
	            if (menLast !== log[i].body && log[i].board === this.board._id) {
	              this.recibeMensaje(log[i], true, false);
	              menLast = log[i].body;
	            }
	          }
	        }
	      }.bind(this));
	    }
	  },
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('tournament.title');
	  },
	  created: function created() {
	    window.addEventListener('resize', this.onResize);
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	
	    this.$nextTick(function () {
	      this.active = 'boardVisor';
	      this.loadAllData();
	    });
	    this.$dispatch('userLoguin', 'show data');
	    this.bGuardar = false;
	  },
	
	  computed: {
	    filteredAndOrderedUsers: function filteredAndOrderedUsers() {
	      var _this = this;
	
	      if (!this.users) return [];
	
	      var filtered = this.users.filter(function (user) {
	        return user.username.toLowerCase().includes(_this.finduser.toLowerCase());
	      });
	
	      filtered.sort(function (a, b) {
	        return a.username.localeCompare(b.username);
	      });
	      return filtered;
	    }
	  },
	  watch: {
	    round1: function round1(val, oldVal) {
	      this.round1 = val;
	    },
	    myFENValue: function myFENValue(val, oldVal) {
	      this.fenInit = val;
	    },
	    myPGNValue: function myPGNValue(val, oldVal) {
	      this.pgn = val;
	
	      setTimeout(function () {
	        var pgnBoardInit = 0;
	        if (document.getElementById('pgnMoves')) {
	          document.getElementById('pgnMoves').textContent = '';
	        }
	        if (document.getElementById('pgnButtons')) {
	          document.getElementById('pgnButtons').textContent = '';
	        }
	        if (document.getElementById('pgnHeader')) {
	          document.getElementById('pgnHeader').textContent = '';
	        }
	        var pos = 'start';
	        var start = 'start';
	        var pgnNew = this.pgn.split('"]').join('"]\n');
	        pgnNew = pgnNew.split('{}').join('');
	        var headers = this.parse_pgn_header(pgnNew);
	        if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
	          pos = headers['FEN'];
	        } else {}
	        if (start === pos) {
	          start = 0;
	        }
	        if (this.fenInit !== '' && this.fenInit !== undefined) {
	          start = this.fenInit;
	        }
	        try {
	          var winWidth = Math.min(window.innerWidth, window.outerWidth);
	          pgnBoardInit = window.pgnEdit({ inner: 'torneoGenerateFenInit', comment: 'pgnComment', moves: 'pgnMoves', button: 'pgnButtons', header: 'pgnHeader' }, { pgn: this.pgn, position: pos, startPlay: start, showCoords: true, locale: 'es', orientation: this.orientation, coordsFactor: 0.8, coordsInner: winWidth < 782, headers: true });
	          groundInit = pgnBoardInit.board;
	          window.pgnBoardBase = pgnBoardInit.boardBase;
	          window.ground = pgnBoardInit.board;
	        } catch (error) {
	          console.error('<span>' + 'Error (myPGNValue): ' + error + '</span>', 3000);
	        }
	      }.bind(this), 50);
	    },
	    fenInit: function fenInit(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    },
	    fenFinish: function fenFinish(newVal, oldVal) {
	      if (newVal === '') {
	        newVal = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(33).Buffer))

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(15);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(13);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stylesBoard = {
	  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
	  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
	};
	
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    }
	  },
	  template: __webpack_require__(521),
	  data: function data() {
	    return {
	      finduser: '',
	      bGuardar: false,
	      sendToAll: false,
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      dirServer: _lstorage2.default.get('serverDir'),
	      filesUpload: [],
	      hashFileBoard1: '',
	      hashFileBoard2: '',
	      hashFileBoard3: '',
	      fileProgress: 0,
	      allFilesUploaded: true,
	      offcanvas: false,
	      active: 'boardVisor',
	      tab: '0',
	      tabs: [],
	      chattext: '',
	      user: _user2.default.user,
	      boards: [],
	      boardFiles: [],
	      boardFilesName: '',
	      boardFiles2: [],
	      boardFilesName2: '',
	      boardFiles3: [],
	      boardFilesName3: '',
	      rondas: 1,
	      rondaactual: 1,
	      nombretorneo: 'Torneo 1',
	      newboard: {
	        color: 'w',
	        time: '3',
	        incremento: 0,
	        elo: 1500,
	        contrincante: '',
	        public: true,
	        broadcast: false,
	        all: false,
	        club: ''
	      },
	      todosCheck: false,
	      users: [],
	      players: [],
	      round1: {
	        rounds: []
	      },
	      bSimultanea: true,
	      bRandColor: false,
	      usersLength: 0,
	      games: [],
	      board: _lstorage2.default.get('boardSee', {}),
	      stylesBoard: stylesBoard,
	      styles: _lstorage2.default.get('styleBoard', {
	        board: 0,
	        pieces: 0
	      }),
	      classBoard: ''
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  watch: {},
	  events: {
	    users: function users(data) {
	      this.users = data.nicknames;
	
	      var playersParam = {};
	      for (var i in this.users) {
	        if (this.users[i].club === this.user.club) {
	          var nombre = this.users[i].nickname;
	          playersParam[nombre] = { name: nombre, juega: true, user: i };
	        }
	      }
	      playersParam['PC'] = { name: 'PC', juega: false, user: null };
	      this.players = playersParam;
	    },
	    boards: function boards(data) {
	      this.boards = data.boards;
	    },
	    mensaje: function mensaje(data) {
	      this.recibeMensaje(data.men, true, true);
	      if (data.men.send !== this.user.username) {
	        this.chatRecibido = true;
	      }
	    },
	    updateBoards: function updateBoards(classBoard) {
	      this.classBoard = classBoard;
	    }
	  },
	  props: {},
	  computed: {},
	  components: {},
	  methods: {
	    createAllTournament: function createAllTournament() {
	      this.round1 = {};
	      for (var x = 0; x < this.rondas; x++) {
	        this.createTournament(x);
	      }
	      this.bGuardar = true;
	    },
	    recibeMensaje: function recibeMensaje(men) {
	      var bottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var toast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      if (men.board === 'Retransmisión') {
	        this.mensjGame.push(men);
	        if (bottom) {
	          this.isAtBottom();
	        }
	      }
	      if (toast === true) {
	        if (men.send !== _user2.default.getUser().username) {
	          this.toast('<span>' + men.send + ': ' + men.body + '</span>', 1000);
	        }
	      }
	    },
	    roundRobin: function roundRobin(teams) {
	      var schedule = [];
	      var league = [];
	      var rondaRoundRobin = {};
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          league.push(this.players[i].name);
	        }
	      }
	
	      if (league.length % 2) {
	        league.push('None');
	      }
	      var rounds = league.length;
	
	      this.rondas = rounds;
	      for (var j = 0; j < (rounds - 1) * 2; j++) {
	        schedule[j] = [];
	        var round = {};
	        for (var _i = 0; _i < rounds / 2; _i++) {
	          if (league[_i] !== 'None' && league[rounds - 1 - _i] !== 'None') {
	            var white = '';
	            var black = '';
	            if (j % 2 === 1) {
	              schedule[j].push([league[_i], league[rounds - 1 - _i]]);
	              white = league[_i];
	              black = league[rounds - 1 - _i];
	            } else {
	              schedule[j].push([league[rounds - 1 - _i], league[_i]]);
	              white = league[rounds - 1 - _i];
	              black = league[_i];
	            }
	            var partida = { white: white, black: black };
	            round[_i] = partida;
	          }
	        }
	
	        var roundaux = { rounds: round };
	        rondaRoundRobin[j] = roundaux;
	        league.splice(1, 0, league.pop());
	      }
	
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null };
	      }
	      this.round1 = rondaRoundRobin;
	
	      return schedule;
	    },
	    saveTournament: function saveTournament() {},
	    createRoundRobin: function createRoundRobin() {
	      this.shuffleVueArray(this.players);
	      this.roundRobin(this.players);
	      this.bGuardar = true;
	    },
	    createTournament: function createTournament(ronda) {
	      var jugadores = '';
	      var partidas = 0;
	      var white = '';
	      var black = '';
	      var round = {};
	      this.shuffleVueArray(this.players);
	      for (var i in this.players) {
	        if (this.players[i].juega === true) {
	          jugadores += '(' + i + ') ' + this.players[i].name + ': ' + this.players[i].juega + '\n';
	          if (this.bSimultanea === true) {
	            if (_user2.default.getUser().username !== this.players[i].name) {
	              if (this.bRandColor === true && Math.random() * 10 > 4) {
	                black = _user2.default.getUser().username;
	                white = this.players[i].name;
	              } else {
	                white = _user2.default.getUser().username;
	                black = this.players[i].name;
	              }
	              var partida = { white: white, black: black };
	              round[partidas] = partida;
	            }
	          } else {
	            if (partidas % 2 === 0) {
	              white = this.players[i].name;
	            } else {
	              black = this.players[i].name;
	              partida = { white: white, black: black };
	              round[partidas] = partida;
	            }
	          }
	          partidas++;
	        }
	      }
	      if (this.players['PC'] === undefined) {
	        this.players['PC'] = { name: 'PC', juega: false, user: null };
	      }
	
	      var roundaux = { rounds: round };
	      this.round1[ronda] = roundaux;
	    },
	    shuffleVueArray: function shuffleVueArray(arrayParam) {
	      var array = [];
	      var index = 0;
	      for (var ii in arrayParam) {
	        array.push(arrayParam[ii].name);
	        index++;
	      }
	      for (var i = this.getLength(array) - 1; i > 0; i--) {
	        var j = Math.floor(Math.random() * (i + 1));
	        var temp = array[i];
	        _vue2.default.set(array, i, array[j]);
	        _vue2.default.set(array, j, temp);
	        var temp2 = arrayParam[array[i]];
	        _vue2.default.set(arrayParam, array[i], arrayParam[array[j]]);
	        _vue2.default.set(arrayParam, array[j], temp2);
	      }
	    },
	    createInvites: function createInvites(rondaParam) {
	      this.rondaactual = rondaParam - 1;
	      var _self = this;
	      window.swal('¿Desea lanzar partidas de la ronda ' + (this.rondaactual + 1) + '?', {
	        buttons: {
	          si: { text: 'Sí', value: 's' },
	          no: { text: 'No', value: 'n' }
	        }
	      }).then(function (resultParam) {
	        if (resultParam === 's') {
	          var rondaInvites = _self.round1[_self.rondaactual];
	          for (var i in rondaInvites.rounds) {
	            _self.createdInviteGame(rondaInvites.rounds[i].white, rondaInvites.rounds[i].black);
	          }
	        }
	      });
	    },
	    createdInviteGame: function createdInviteGame(userNameWhite, userNameBlack) {
	      var invite = {
	        type: 'invite',
	        public: this.newboard.public,
	        broadcast: false,
	        all: false,
	        vsPc: false,
	        torneo: this.nombretorneo,
	        ronda: this.rondaactual,
	        confirm: false,
	        club: _user2.default.getUser().club,
	        time: this.newboard.time,
	        incremento: this.newboard.incremento,
	        recibe: this.active,
	        elo: _user2.default.getUser().elo
	      };
	      if (userNameWhite === 'PC') {
	        invite.vsPc = true;
	        invite.confirm = true;
	
	        invite.elo = this.newboard.elo;
	      }
	
	      if (userNameBlack !== '') {
	        invite.confirm = true;
	        if (userNameBlack === 'PC') {
	          invite.vsPc = true;
	          invite.elo = this.newboard.elo;
	        }
	      }
	      if (this.newboard.color === 'w') {
	        invite.u1 = userNameWhite;
	        invite.u2 = userNameBlack;
	      } else {
	        invite.u2 = userNameWhite;
	        invite.u1 = userNameBlack;
	      }
	
	      if (invite.confirm === true) {
	        this.InviteGameActionConfirmado(invite);
	      }
	    },
	    InviteGameActionConfirmado: function InviteGameActionConfirmado(invite) {
	      var data = {
	        c: 'board',
	        f: 'confirmGame',
	        data: invite
	      };
	
	      if (invite.confirm || invite.vsPc) {
	        data.f = 'addBoard';
	      } else {}
	      this.$socket.emit('event', data, function () {
	        if (arguments.length <= 0 ? undefined : arguments[0]) {}
	      });
	    },
	    getLength: function getLength(param) {
	      var ret = 0;
	      if (param !== undefined && (0, _keys2.default)(param) !== undefined) {
	        ret = (0, _keys2.default)(param).length;
	      }
	      return ret;
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      return this.dirServer + '/uploads/' + name;
	    },
	    loadAllData: function loadAllData() {
	      var data = {
	        c: 'chat',
	        f: 'getDataChat',
	        data: {
	          user: _user2.default.getUser()
	        }
	      };
	
	      this.$socket.emit('event', data, function () {
	        for (var _len = arguments.length, callbacks = Array(_len), _key = 0; _key < _len; _key++) {
	          callbacks[_key] = arguments[_key];
	        }
	
	        var logUser = callbacks[1].logUser;
	        for (var i = 0; i < logUser.length; i++) {
	          if (logUser[i]) {}
	        }
	
	        this.boards = callbacks[1].boards;
	      }.bind(this));
	    },
	    loadUserConvert: function loadUserConvert(parms) {
	      var historyTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var data = {
	        c: 'chat',
	        f: 'loadUserConvert',
	        data: parms
	      };
	      this.$socket.emit('event', data, function () {
	        var log = arguments.length <= 1 ? undefined : arguments[1];
	
	        var isToday = function isToday(someDate) {
	          var today = new Date();
	          return someDate.getDate() === today.getDate() && someDate.getMonth() === today.getMonth() && someDate.getFullYear() === today.getFullYear();
	        };
	        var menLast = '';
	        if (log) {
	          for (var i = log.length - 1; i >= 0; i--) {
	            if (menLast !== log[i].body && isToday(new Date(log[i].created)) && log[i].board === this.board._id) {
	              this.recibeMensaje(log[i], true, false);
	              menLast = log[i].body;
	            }
	          }
	        }
	      }.bind(this));
	    }
	  },
	  attached: function attached() {},
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('tournament.title');
	  },
	  created: function created() {
	    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']];
	    this.$nextTick(function () {
	      this.active = 'boardVisor';
	      this.loadAllData();
	    });
	    this.$dispatch('userLoguin', 'show data');
	    this.bGuardar = false;
	  }
	};

/***/ }),
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _personalData = __webpack_require__(54);
	
	var _personalData2 = _interopRequireDefault(_personalData);
	
	var _getters = __webpack_require__(28);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  vuex: {
	    getters: {
	      user: _getters.getUser
	    }
	  },
	  data: function data() {
	    return {
	      thisuser: _user2.default.user
	    };
	  },
	
	  components: {
	    PersonalData: _personalData2.default
	  },
	  events: {}
	};

/***/ }),
/* 331 */,
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(11);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _actions = __webpack_require__(57);
	
	var _uploadFiles = __webpack_require__(284);
	
	var _uploadFiles2 = _interopRequireDefault(_uploadFiles);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  template: __webpack_require__(522),
	  route: {
	    canActivate: function canActivate(transition) {
	      return _user2.default.user_acces('authenticate') ? true : transition.redirect('user/loguin');
	    },
	    data: function data(transition) {
	      return _promise2.default.all([_user2.default.get(this, this.$route.params.username)]).then(function (data) {
	        var dd = JSON.parse(data);
	        var somedata = dd;
	
	        this.setUser(somedata);
	        return {
	          user: somedata
	        };
	      }.bind(this), function (response) {
	        transition.redirect(_user2.default.getUser().username);
	      });
	    }
	  },
	  vuex: {
	    actions: {
	      setUser: _actions.setUser
	    }
	  },
	  data: function data() {
	    return {
	      user: {},
	      dirActionUpload: _lstorage2.default.get('serverDir') + '/chat/upload',
	      filesUpload: [],
	      fileProgress: 0,
	      allFilesUploaded: true
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      if (name !== undefined) {
	        return _lstorage2.default.get('serverDir') + '/uploads/' + name;
	      } else {
	        return;
	      }
	    }
	  },
	  components: {
	    UploadFiles: _uploadFiles2.default
	  },
	  events: {
	    mensendactivate: function mensendactivate(data) {
	      var usermen = data.men.user.username;
	      var username = this.user.username;
	      if (usermen === username) {
	        this.user.sendtoanalyse = data.men.user.sendtoanalyse;
	      }
	    },
	    updatepermissions: function updatepermissions(dta) {
	      this.user.chat = dta.men.user.chat;
	      this.user.chattext = dta.men.user.chattext;
	      this.user.chataudio = dta.men.user.chataudio;
	      this.user.cast = dta.men.user.cast;
	      this.user.live = dta.men.user.live;
	      this.user.analyse = dta.men.user.analyse;
	      this.user.sendtoanalyse = dta.men.user.sendtoanalyse;
	      this.user.download = dta.men.user.download;
	
	      if (this.user.username === dta.men.user.username) {}
	    },
	    onFileClick: function onFileClick(file) {},
	    onFileChange: function onFileChange(file) {
	      this.fileProgress = 0;
	      this.allFilesUploaded = false;
	    },
	    beforeFileUpload: function beforeFileUpload(file) {
	      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000);
	    },
	    afterFileUpload: function afterFileUpload(file) {
	      this.toast('<span>' + 'Imagen cargada' + '</span>', 2000);
	    },
	    onFileProgress: function onFileProgress(progress) {
	      this.fileProgress = parseInt(progress.percent);
	    },
	    onFileUpload: function onFileUpload(file, res) {
	      if (this.user.image !== '50x50defaultAvatar.png') {
	        _user2.default.deleteImage(this, { name: this.user.image }).then(function (response) {
	          console.log('eliminado correctamente');
	        }, function (response) {});
	      }
	      this.setUser(file.name, 'image');
	      _user2.default.setUser(this.user);
	      _user2.default.signin(this, { _id: this.user._id, image: this.user.image, password: '' }).then(function (response) {}, function (response) {});
	      this.$route.router.go(this.user._id ? './user/' + this.user.username : './');
	    },
	    onFileError: function onFileError(file, res) {},
	    onAllFilesUploaded: function onAllFilesUploaded(files) {
	      this.allFilesUploaded = true;
	    }
	  },
	  ready: function ready() {
	    document.title = 'Mainchess - ' + this.$t('account.title');
	  }
	};

/***/ }),
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'PersonalData',
	  props: {
	    user: {
	      type: Object
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    formatTime: function formatTime(seconds) {
	      var duration = _moment2.default.duration(seconds, 'seconds');
	      var months = Math.floor(duration.asMonths());
	      var days = duration.days();
	
	      var formattedTime = '';
	      if (months > 0) {
	        formattedTime += months + ' meses ';
	      }
	      if (days > 0) {
	        formattedTime += days + ' d\xEDas ';
	      }
	      formattedTime += _moment2.default.utc(duration.asMilliseconds()).format('HH:mm:ss');
	      return formattedTime.trim();
	    },
	    updateData: function updateData() {
	      this.$forceUpdate();
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultAvatar.png';
	    },
	    imageUrl: function imageUrl(name) {
	      if (name !== undefined) {
	        return this.dirServer + '/uploads/' + name;
	      } else {
	        return;
	      }
	    }
	  },
	  events: {}
	};

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _user = __webpack_require__(3);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _lstorage = __webpack_require__(2);
	
	var _lstorage2 = _interopRequireDefault(_lstorage);
	
	var _vueMaterialComponents = __webpack_require__(4);
	
	var _vueMaterialComponents2 = _interopRequireDefault(_vueMaterialComponents);
	
	var _config = __webpack_require__(22);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _club = __webpack_require__(23);
	
	var _club2 = _interopRequireDefault(_club);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  route: {
	    canActivate: function canActivate(transition) {
	      if (_user2.default.user_acces('authenticate')) {
	        return transition.redirect('/home');
	      } else {
	        return true;
	      }
	    }
	  },
	  data: function data() {
	    return {
	      countUsers: 0,
	      countBoards: 0,
	      countPuzles: 0,
	      countClubs: 0,
	      usertests: ['admin', 'user1', 'user2', 'user3', 'user4', 'user5', 'user6', 'user7', 'user8', 'user9', 'teacher', 'user10', 'user11', 'user12', 'user13', 'user14', 'user15', 'user16', 'user17', 'user18', 'user19'],
	      user: {
	        username: '',
	        password: '',
	        club: '',
	        club1: '',
	        club2: '',
	        imagesclub: [],
	        passwordclub: [],
	        descripcionclub: [],
	        linkclub: []
	      },
	      noticias: {},
	      buildDate: ("2025-01-13T17:16:22.535Z"),
	      debug: _config2.default.debug,
	      data: {},
	      error: '',
	      fechaActual: new Date().toLocaleDateString(),
	      newClub: '',
	      code: '',
	      captaText: ''
	    };
	  },
	
	  mixins: [_vueMaterialComponents2.default],
	  methods: {
	    fetchNoticias: function fetchNoticias() {
	      var _this = this;
	
	      fetch('../../../static/data/noticias.json').then(function (response) {
	        if (!response.ok) {
	          throw new Error('Error al cargar las noticias');
	        }
	        return response.json();
	      }).then(function (data) {
	        _this.noticias = data;
	      }).catch(function (error) {
	        console.error('Hubo un error al cargar las noticias: ', error);
	      });
	    },
	    addCommas: function addCommas(nStr) {
	      nStr += '';
	      var x = nStr.split('.');
	      var x1 = x[0];
	      var x2 = x.length > 1 ? '.' + x[1] : '';
	      var rgx = /(\d+)(\d{3})/;
	      while (rgx.test(x1)) {
	        x1 = x1.replace(rgx, '$1' + '.' + '$2');
	      }
	      return x1 + x2;
	    },
	    getNum: function getNum() {
	      var data = {
	        _id: this.user._id
	      };
	      var _self = this;
	      _user2.default.getNum(this, data).then(function (response) {
	        var dd = JSON.parse(response);
	        _self.countUsers = this.addCommas(dd.counts.countUser);
	        _self.countBoards = this.addCommas(dd.counts.countBoard);
	        _self.countPuzles = this.addCommas(dd.counts.countPuzle);
	        _self.countClubs = this.addCommas(dd.counts.countClub);
	      }, function (response) {
	        _self.countUsers = 2000;
	      });
	      var counts = {
	        countUsers: this.countUsers,
	        countBoards: this.countBoards,
	        countPuzles: this.countPuzles,
	        countClubs: this.countClubs
	      };
	      return counts;
	    },
	    wellcome: function wellcome(data) {
	      this.user.club2 = data.club2;
	      this.user.club1 = data.club1;
	      this.user.club = data.club;
	
	      this.getDataClub(data.club, 0);
	      this.getDataClub(data.club1, 1);
	      this.getDataClub(data.club2, 2);
	      var eventoLanzadoKey = 'retoLanzado';
	      localStorage.setItem(eventoLanzadoKey, 'false');
	      setTimeout(function () {
	        this.$broadcast('modal::open', 'loadClub');
	      }.bind(this), 500);
	    },
	    convertirFechaAVersion: function convertirFechaAVersion(fecha) {
	      var fechaObj = new Date(fecha);
	      var anio = fechaObj.getFullYear().toString().slice(-2);
	      var mes = fechaObj.getMonth() + 1;
	      var dia = fechaObj.getDate();
	
	      var mesConCeros = mes.toString().padStart(2, '0');
	      var diaConCeros = dia.toString().padStart(2, '0');
	
	      var version = anio + '.' + mesConCeros + '.' + diaConCeros;
	      return version;
	    },
	    acceptClub: function acceptClub() {
	      this.$broadcast('modal::close', 'some', 'loadClub');
	
	      var club1 = this.data.data.club1;
	      var club2 = this.data.data.club2;
	      var club = this.data.data.club;
	
	      if (this.newClub === club1) {
	        this.data.data.club = club1;
	        this.data.data.club1 = club;
	      } else if (this.newClub === club2) {
	        this.data.data.club = club2;
	        this.data.data.club2 = club;
	      } else {}
	
	      _lstorage2.default.set('token', this.data.token);
	
	      _user2.default.setUser(this.data.data);
	
	      this.$dispatch('userLoguin', 'user loguin');
	
	      window.location.reload();
	    },
	    imageUrlAlt: function imageUrlAlt(event) {
	      event.target.src = '../../../static/images/50x50defaultClub.png';
	    },
	    getDataClub: function getDataClub(clubName, number) {
	      var parms = {
	        name: clubName
	      };
	      var _self = this;
	      _club2.default.get(_self, parms).then(function (response) {
	        var theD = JSON.parse(response);
	        _self.clubs = theD;
	        if (_self.clubs.length > 0 && _self.clubs[0]) {
	          _self.user.imagesclub[number] = _lstorage2.default.get('serverDir') + '/uploads/' + _self.clubs[0].image;
	          _self.user.passwordclub[number] = _self.clubs[0].password;
	          _self.user.descripcionclub[number] = _self.clubs[0].description;
	          _self.user.linkclub[number] = _self.clubs[0].link;
	        } else {
	          _self.user.imagesclub[number] = '';
	          _self.user.passwordclub[number] = '';
	          _self.user.descripcionclub[number] = '';
	          _self.user.linkclub[number] = '';
	        }
	      });
	    },
	    createCaptcha: function createCaptcha() {
	      document.getElementById('captcha').innerHTML = '';
	
	      var charsArray = '0123456789abcdefghijklmnopqrstuvwxyz';
	      var lengthOtp = 3;
	      var captcha = [];
	      for (var i = 0; i < lengthOtp; i++) {
	        var index = Math.floor(Math.random() * charsArray.length + 1);
	        if (captcha.indexOf(charsArray[index]) === -1) {
	          captcha.push(charsArray[index]);
	        } else {
	          i--;
	        }
	      }
	      var canv = document.createElement('canvas');
	      canv.id = 'captcha';
	      canv.width = 100;
	      canv.height = 30;
	      var ctx = canv.getContext('2d');
	      ctx.font = '25px Georgia';
	      ctx.textAlign = 'start';
	      ctx.textBaseline = 'bottom';
	      ctx.fillStyle = '#5c005c';
	      ctx.fillText(captcha.join(''), 0, 30);
	
	      this.code = captcha.join('');
	      document.getElementById('captcha').appendChild(canv);
	    },
	    validateCaptcha: function validateCaptcha() {
	      var ret = false;
	      window.event.preventDefault();
	
	      if (this.cpatchaTextBox === this.code) {
	        ret = true;
	      } else {
	        this.toast('<span><h4>Capcha inválido, inténtelo de nuevo</h4>', 3000, 'rounded');
	
	        this.createCaptcha();
	        ret = false;
	      }
	      return ret;
	    },
	    newaccount: function newaccount() {
	      if (this.validateCaptcha()) {
	        this.$route.router.go('/user/register');
	      }
	    },
	    guest: function guest() {
	      if (this.validateCaptcha()) {
	        this.$route.router.go('/user/guest');
	      }
	    },
	    userloguin: function userloguin() {
	      var _this2 = this;
	
	      if (this.validateCaptcha() === true) {
	        this.error = 'consultando';
	        this.user.login = new Date().getTime();
	        _user2.default.authenticate(this, this.user).then(function (r) {
	          if (r.status === 200) {
	            return r.text();
	          } else {
	            return r.text().then(function (d) {
	              throw d;
	            });
	          }
	        }).then(function (json) {
	          var data = JSON.parse(json);
	          _this2.data = data;
	          _this2.wellcome(data.data);
	        }).catch(function (err) {
	          _this2.error = err.text();
	        });
	      }
	    },
	    userloguinTest: function userloguinTest(user) {
	      var _this3 = this;
	
	      this.error = 'consultando';
	      if (user.username === 'admin') {
	        user.password = 'ChessPlaza2020';
	      }
	      _user2.default.authenticate(this, user).then(function (r) {
	        if (r.status === 200) {
	          return r.text();
	        } else {
	          return r.text().then(function (d) {
	            throw d;
	          });
	        }
	      }).then(function (json) {
	        var eventoLanzadoKey = 'retoLanzado';
	        localStorage.setItem(eventoLanzadoKey, 'false');
	        var data = JSON.parse(json);
	        _this3.data = data;
	
	        _lstorage2.default.set('token', _this3.data.token);
	        _user2.default.setUser(_this3.data.data);
	
	        _this3.$dispatch('userLoguin', 'user loguin');
	        window.location.reload();
	      }).catch(function (err) {
	        _this3.error = err.text();
	      });
	    }
	  },
	  ready: function ready() {
	    this.createCaptcha();
	    this.fetchNoticias();
	    var bannerScript = document.createElement('script');
	    bannerScript.setAttribute('src', '../../../static/js/cookiebanner.min.js');
	    document.head.appendChild(bannerScript);
	
	    document.title = 'Mainchess - ' + this.$t('login.title');
	    var logo1 = document.getElementById('logo');
	    if (logo1) {
	      logo1.style += 'animation-play-state: running;';
	    }
	  }
	};

/***/ }),
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */,
/* 410 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 140,
		"./af.js": 140,
		"./ar": 148,
		"./ar-dz": 141,
		"./ar-dz.js": 141,
		"./ar-kw": 142,
		"./ar-kw.js": 142,
		"./ar-ly": 143,
		"./ar-ly.js": 143,
		"./ar-ma": 144,
		"./ar-ma.js": 144,
		"./ar-ps": 145,
		"./ar-ps.js": 145,
		"./ar-sa": 146,
		"./ar-sa.js": 146,
		"./ar-tn": 147,
		"./ar-tn.js": 147,
		"./ar.js": 148,
		"./az": 149,
		"./az.js": 149,
		"./be": 150,
		"./be.js": 150,
		"./bg": 151,
		"./bg.js": 151,
		"./bm": 152,
		"./bm.js": 152,
		"./bn": 154,
		"./bn-bd": 153,
		"./bn-bd.js": 153,
		"./bn.js": 154,
		"./bo": 155,
		"./bo.js": 155,
		"./br": 156,
		"./br.js": 156,
		"./bs": 157,
		"./bs.js": 157,
		"./ca": 158,
		"./ca.js": 158,
		"./cs": 159,
		"./cs.js": 159,
		"./cv": 160,
		"./cv.js": 160,
		"./cy": 161,
		"./cy.js": 161,
		"./da": 162,
		"./da.js": 162,
		"./de": 165,
		"./de-at": 163,
		"./de-at.js": 163,
		"./de-ch": 164,
		"./de-ch.js": 164,
		"./de.js": 165,
		"./dv": 166,
		"./dv.js": 166,
		"./el": 167,
		"./el.js": 167,
		"./en-au": 168,
		"./en-au.js": 168,
		"./en-ca": 169,
		"./en-ca.js": 169,
		"./en-gb": 170,
		"./en-gb.js": 170,
		"./en-ie": 171,
		"./en-ie.js": 171,
		"./en-il": 172,
		"./en-il.js": 172,
		"./en-in": 173,
		"./en-in.js": 173,
		"./en-nz": 174,
		"./en-nz.js": 174,
		"./en-sg": 175,
		"./en-sg.js": 175,
		"./eo": 176,
		"./eo.js": 176,
		"./es": 180,
		"./es-do": 177,
		"./es-do.js": 177,
		"./es-mx": 178,
		"./es-mx.js": 178,
		"./es-us": 179,
		"./es-us.js": 179,
		"./es.js": 180,
		"./et": 181,
		"./et.js": 181,
		"./eu": 182,
		"./eu.js": 182,
		"./fa": 183,
		"./fa.js": 183,
		"./fi": 184,
		"./fi.js": 184,
		"./fil": 185,
		"./fil.js": 185,
		"./fo": 186,
		"./fo.js": 186,
		"./fr": 189,
		"./fr-ca": 187,
		"./fr-ca.js": 187,
		"./fr-ch": 188,
		"./fr-ch.js": 188,
		"./fr.js": 189,
		"./fy": 190,
		"./fy.js": 190,
		"./ga": 191,
		"./ga.js": 191,
		"./gd": 192,
		"./gd.js": 192,
		"./gl": 193,
		"./gl.js": 193,
		"./gom-deva": 194,
		"./gom-deva.js": 194,
		"./gom-latn": 195,
		"./gom-latn.js": 195,
		"./gu": 196,
		"./gu.js": 196,
		"./he": 197,
		"./he.js": 197,
		"./hi": 198,
		"./hi.js": 198,
		"./hr": 199,
		"./hr.js": 199,
		"./hu": 200,
		"./hu.js": 200,
		"./hy-am": 201,
		"./hy-am.js": 201,
		"./id": 202,
		"./id.js": 202,
		"./is": 203,
		"./is.js": 203,
		"./it": 205,
		"./it-ch": 204,
		"./it-ch.js": 204,
		"./it.js": 205,
		"./ja": 206,
		"./ja.js": 206,
		"./jv": 207,
		"./jv.js": 207,
		"./ka": 208,
		"./ka.js": 208,
		"./kk": 209,
		"./kk.js": 209,
		"./km": 210,
		"./km.js": 210,
		"./kn": 211,
		"./kn.js": 211,
		"./ko": 212,
		"./ko.js": 212,
		"./ku": 214,
		"./ku-kmr": 213,
		"./ku-kmr.js": 213,
		"./ku.js": 214,
		"./ky": 215,
		"./ky.js": 215,
		"./lb": 216,
		"./lb.js": 216,
		"./lo": 217,
		"./lo.js": 217,
		"./lt": 218,
		"./lt.js": 218,
		"./lv": 219,
		"./lv.js": 219,
		"./me": 220,
		"./me.js": 220,
		"./mi": 221,
		"./mi.js": 221,
		"./mk": 222,
		"./mk.js": 222,
		"./ml": 223,
		"./ml.js": 223,
		"./mn": 224,
		"./mn.js": 224,
		"./mr": 225,
		"./mr.js": 225,
		"./ms": 227,
		"./ms-my": 226,
		"./ms-my.js": 226,
		"./ms.js": 227,
		"./mt": 228,
		"./mt.js": 228,
		"./my": 229,
		"./my.js": 229,
		"./nb": 230,
		"./nb.js": 230,
		"./ne": 231,
		"./ne.js": 231,
		"./nl": 233,
		"./nl-be": 232,
		"./nl-be.js": 232,
		"./nl.js": 233,
		"./nn": 234,
		"./nn.js": 234,
		"./oc-lnc": 235,
		"./oc-lnc.js": 235,
		"./pa-in": 236,
		"./pa-in.js": 236,
		"./pl": 237,
		"./pl.js": 237,
		"./pt": 239,
		"./pt-br": 238,
		"./pt-br.js": 238,
		"./pt.js": 239,
		"./ro": 240,
		"./ro.js": 240,
		"./ru": 241,
		"./ru.js": 241,
		"./sd": 242,
		"./sd.js": 242,
		"./se": 243,
		"./se.js": 243,
		"./si": 244,
		"./si.js": 244,
		"./sk": 245,
		"./sk.js": 245,
		"./sl": 246,
		"./sl.js": 246,
		"./sq": 247,
		"./sq.js": 247,
		"./sr": 249,
		"./sr-cyrl": 248,
		"./sr-cyrl.js": 248,
		"./sr.js": 249,
		"./ss": 250,
		"./ss.js": 250,
		"./sv": 251,
		"./sv.js": 251,
		"./sw": 252,
		"./sw.js": 252,
		"./ta": 253,
		"./ta.js": 253,
		"./te": 254,
		"./te.js": 254,
		"./tet": 255,
		"./tet.js": 255,
		"./tg": 256,
		"./tg.js": 256,
		"./th": 257,
		"./th.js": 257,
		"./tk": 258,
		"./tk.js": 258,
		"./tl-ph": 259,
		"./tl-ph.js": 259,
		"./tlh": 260,
		"./tlh.js": 260,
		"./tr": 261,
		"./tr.js": 261,
		"./tzl": 262,
		"./tzl.js": 262,
		"./tzm": 264,
		"./tzm-latn": 263,
		"./tzm-latn.js": 263,
		"./tzm.js": 264,
		"./ug-cn": 265,
		"./ug-cn.js": 265,
		"./uk": 266,
		"./uk.js": 266,
		"./ur": 267,
		"./ur.js": 267,
		"./uz": 269,
		"./uz-latn": 268,
		"./uz-latn.js": 268,
		"./uz.js": 269,
		"./vi": 270,
		"./vi.js": 270,
		"./x-pseudo": 271,
		"./x-pseudo.js": 271,
		"./yo": 272,
		"./yo.js": 272,
		"./zh-cn": 273,
		"./zh-cn.js": 273,
		"./zh-hk": 274,
		"./zh-hk.js": 274,
		"./zh-mo": 275,
		"./zh-mo.js": 275,
		"./zh-tw": 276,
		"./zh-tw.js": 276
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 425;


/***/ }),
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/initboard.d55bbaa.jpg";

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/adams.50af35e.jpg";

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/alekseenko.fa8275b.jpg";

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/calzetta.ced2cc6.jpg";

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ding.a271e43.jpg";

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBUVFRgVFRYZGRgaHBgcGhocGBgaGhkZGBgZGhgaGBwcIS4lHB4rIRoYJjgmKy8xNTU1GiQ7QDs0Py40NTEBDAwMEA8QHBISHjQhISE0NDQxNDQ0NDQ0MTQ0MTQxNDE0NDE0NDQ0NDQ0NDQxNDQ0NDQ0NDQ0PzQ/ND8xND80NP/AABEIAPsAyQMBIgACEQEDEQH/xAAcAAABBQEBAQAAAAAAAAAAAAAFAQIDBAYHAAj/xAA/EAACAQIEAwUECAYBAwUAAAABAgADEQQSITEFQVEGEyJhcYGRobEHFDJCcsHR8BUjUoKS4WIzU/EWJDSisv/EABkBAAMBAQEAAAAAAAAAAAAAAAABAgMEBf/EACMRAAMBAAICAQQDAAAAAAAAAAABAhEDIRIxQQQiMlETI5H/2gAMAwEAAhEDEQA/AOdWi2ki0W3sY3IeksQgEW0lFBuhiii3SAEYEW0kFBuhijDv0MAIgItpJ3DdDF7huhgBFaLJO4bpFWgx5GAEVpYwuCep9kGw3PIeskoYMk3fwqNz+Q85DjuL5VyU/CoOlt/UnrAAmnCaYuXcm2+UbfkY1cfSQ2F9NL21vyOszb45jrtz30P+5G7sxBOltxr6gx4gDVfjzBjY2FraHmP/ADJKXFDbU3v8tzaBWq+V7nYgG/rPOdtLeQ+zF4oNNHTdXGpseUqYxCpsZQw1YjXX0Fzt5GH8PaogDa6b63F/y84eIGcqRhlrG4Yo1jKxiAjMUTxiiAFzDGWW2lTDy8ouImALxDkGQ5zCNajIfq8EwNYnDbi1oqcIFttZo+8UaDpIFcc5RIGHD+gkycKvqRCtPEptLNKquWAAj+DjQ2njwoXtaaEV1sJGcQuaAAJ+FW5SReDi20OVa6xy4hcsAM8nBxzEa/DPKHvrCyti8UoRvQ++0AOecY4iSxRPCo05a25mZ99dBe94TxtPxG/W5P5CV6VPUhb8h8oyiui+LxDTYj3x1Nr/AGRtpr57D4SWphyranz9si2v8IANve4I9n6T3eWGmvK9/n5xrjS2x0/WKiaWv57/AB9YAT0GJNrWPlfoeUOcHqqwXUZtR68tj+9IBDEFSRy01hGiQAfDzGux2FrRgG61Naq5SDmFxboRy1MzVVCpIO4mkweKzmx+3e1zoSQLg+0fpB3aFBnVxYZ1uQBbxDQ3ipABzPCKwnhJAs4cS/TWUcPCNIRMBrJG5ZYYRtpIBOpxS2t4wcWDbGZ+emgGgXiCjnJU4vyvpM3FtADTjjHnHHivO8y4noAaf+Lf8rxRxkdZl56AGk/jFtzJKGOzh7bBSd+sy8IcLNlc35KPjGgBOKS77HnudpYwNEn7Aub6H0lnEIDrb9+k0/ZHAqykkfr5xVXii4nyeGWxGAP3gQdOXwgrEpvOtcQ4cjrsfd+kwnHeAkMchuOkib0uuJr0Zequmvl7+cjIIYW5ybEYZ1Nj++siFdQdddPfcaGXumTTRLSUtpsRv7dpc4e9wVbcgEHzGn5fCUFqgC69bHzlvC09iNxuORU7iPRFrLmtrZhv/bcAj4S3xurnSkx3IN/YRKeJOVvPl8JNxNrpTHKzH4xNhgMaeEcREgBZw8J0RBuHhSgImArCMtJnEhk4APAi2noolgJaLaLFEYCT1os9ABLT0WJAC/wbhFXFP3dIAsBmJY5VUdSfhLlXhNXDtUpVVAYKGFjmVlvupG4hLsXhQyuzGyhgWOxsi+EX8y8J4jE94jowViQwRjqy33APnaZO8rDoXBsKtMVRQsZsezKFEN9BBfZrC5mNxtNQlG2m371it/Acc52TMjEaKetw9j7jAvEFJPM/iAv7xb5RmJ7VYek5XxNbQkEWvGtxlKxunTY7zNppGqpNgnFYENoQD66fGB6/Z0E3sfhNVUXN5ieTCKdmYeV4lTRVQmZrD9n1JGhNvLeajhXZ2mNGU69QZbw2AYcr/wBxHyhGlTZd7rboxPwMHdEqJRj+2vD0TIUFjtp+/SZjFtdgOSgD8z8TNN2wZmqKACdLgAE33J2mRLXm0fic3J+R4ietPExs0My1h4SoPBVDeGcLQvEwGu8ZfyhJMJvHfVfKLAARosOUZaa+vw4ZZm8dQymWLSqJIlBjylnhmGztczWYDhqkQDTFvQYcpFNtj+HKsy3EcNkOkA0pASVcMxlrh2HzGaOlgRaAil2fdhRr0lHjYowHUC4b5CFOz+F7yoobwhMxIOl20AH76QdXpd2wcC/UbXB3E1T4hahSqilgFUZ1I2ta1Qf1CY3H3Kjv4Ob+twQdn8AUL33v+ct48KFKE6GXcK2plXi2Dzre5HpJb7IS6wylfh1EX290HVMKovkNuf8A4knGeBoyMFdixKnMxJK2Oot/SZVoYPulRFcudcx1A11tr02jb63QS7zArgKmlm36yd6ypreVqGGa17SrX3AO5NgOp5TNrs13EWK3abL9lGboZPwXtC9V+7cWDfZuOfSAuHYms7sncZcoJNyRtyJtoTyml7PU1qMCUswOoIsV9ZbSXtGWt9plh8YaGJauB/0qVh0DOSSD7FA9s57iUao7uQAXZmIGwLEkgeWs2XHs16i7d46+1aYtf0vaDkwOkuF0Zcz7SMycKYz6s3SayjgATJTgFvtNDAzGEwpuJqMBhdIz6iFaGcJT0gNCYXB3Jlz6gOklpG0T6xEGFDEVAFmT4o4Jk1biJIgyq5Y3MsQS4NUA0mu4diFtYmc/pOVOkKUMY9ucANRxPEA7TJcWqgmwjsTjng12JNzEAU4VUAImmSspG8xGHZr+EEnoNYWpVKlrZT8j8Y0mNl7itcWgjh2KqB8qFsrEZlB0IvqT09ZfThzPrVbIOg1Y/kIT7P8ADkr4juguWhSCvVsTmqMWApoW6FtT5AxuOtr0JV30arG/y3IGwg/E4++nKEeNMGfTnr8IFajrOakdsFHE080r0aIDa/7MI1mAFhIeFYdCWeqTodFva4GszXs1wL4bChwNJm8fhRmKnkTb3zYYLi9FT4RYesGcWwYNYspurjMOo5EH984V+xpAjhudWAB09flNU+JSlSaoQPCpJ89NB74ENEJtA/ajiJyLSB+14m9AfCPfr7IQnTM+VqVoKqY0uxZzck39PKXqeLAFuszIxFt48Y206jhfZp8Pi1Bkj4gXmT+uEazx4i0BGqrYtYRwuI0mFpY4k6w9hcbpAA5iMVYGDf4j5yCtXuJVyjzgUPq4cDlBmIp2mqbAHd1so3s3KVa2NRCCiKvIm1z5amaqGyPID4Dh7vqEa3Uiw95hhcCFHiZB7bn4StiOIMfvH3yhUxB5mX4ShawpVp0OZZvSwkaVaC7UlP4mJgzvLxjGPpfAuwy3FDayBEHRQBKorC+YgX5W+cGh4uck3j0ML9fFHe81/YUhMGap+1WxD/40kKqPeGM57iKx2m57PVLcMwh6Yiure0VTrMuZ7JpxL7kEKmKubHl+xIK7yHFtZjaQtV5zk07V0SOUQXc7wZj6KVeZHobe8c5Fi6RqHxOQPLf3yunAKz60nOUG2Z35jfS3KSkUtHUMM58Idgt7Da5982FKiFRbNmsLXvreDMD2UYrd8ZZ+YCKVHlq1z6zQcM7L5Qf/AHBYna6i3wbSS1pTrChUQEXOwBufTec+4zi+8dnG2y/hGgmz7bUq2Hp5CpyvoXGqH/jfkT0M5u7zWJzs5eWvJ4Qu+saHkNV5GHmpiXM8YzyEPGO8AJlqWMK4PFQAXl7CtATNPQcHeWMywVhgbXk/eQwFQZfH/wArMT9o6DqB/v5QFiagsbSXioNgijSmAvrbf4wUta410nVudGaRbNXSRM95WDkiKrSdKJc8lR7ysYmY7CAErsVOux59PWPZwNt5C7aG5v5RqbwAkyk6zZdmHzcKr21NDEq/9rBA3wZpjaj2E2/0UUhWo4/DHZ1+LKy3+Uz5PxKh40yNsRmH72it9m8EcMrErZtxofWX3e4tORHaxrpzvKdUup8DspOuh0PqI9weX+pSxRZRcke+DX6Kms9mk4Ng6uIIVHu3mdNN7zRrwbG0LMq951Cuvv8AFaBvo/w9Xu81O2eqSwLaKlNTa/8Acfym3p08ag8So/4W1/8AsBDMFV76aRXwuPZ1NPEUmswsVZCVI91jM12i+jinVUvhGKNvkbVT5Azf4Ku7faRlPn+snqVbWBFr7GVLwwvKfr/D5h4pwmtQYrVQrqRfdTbzlC06v22xXc410Iujqj2IupzDK2nqpmar8Aw9cZqLim/9B1Qny5rOlTq1GDePGY60aRLeNwT0XKVFKt57EdQeYlZpDWDIiJfwnKUwhMuYZDppEJhygfDGxcMdI7LKwzK9fiPjY+e0q18SG1EZjKH3l3+cqFxbbWatlJFmkdBJbyrhamksloIBbxpiZ54uIAKEMeiGI1aKjkwAV06zdfQubYiuOqD4EfrMKzTZfRLikp16r1HVFynVjYX8Omsi/Q0M7R4HuMbXQaKWzr+F/F8yR7JAr6TS9va1CuyV6LZivgcgEC2rJqd/ve+ZenTuQJyV0zth7KY5nAG0EUsJUxuIXD0wTc+Ij7q/eJhTHYZxZEBZ3IVVA1JJsJuewOFwuDY0C+bEvbvH+7m/7aN5fEypn5I5Kzoe2D+pOlGk2XOKSIeSqq+InyuSfZNVTS9itbN6gEH3TlnaHtGzY7EkEFabZE15BMlS3tufbBmG7WVqRzK+YaWB9dQfZKcvRLtbp3KmrbEj1F/kZFUuLgm4Ox5j1mIwva96qB1Ngem9xoQZo+F8RFZLk6j5yKedApfsx30q4S6Ua9tVZqbejDMvxVv8pzujWsZ3DtHwwYrDVKN/Ewup6OhDL8QB7TOBhjz0PTp5Gb8NdZ+jLlns0y4paiZKqh05X3XzVtwZnuKcEKEMhLof8l/Fb5yxh6htLeBxzKzkHS2W3zm7Sr2Y+gXhsL1ELUsMANpLgqWp00mhwVBG3ExZokAFpjSLkE0mLwSAaCCe4WCJqezCpxHkRaVsS43EXFUwwzDeUcxEptgkW8JV5QgrwPQazQghjl9DZOTG3iAxbRiHBpIhkSjeSJBCJKh0hTskmY1B5j5QQ8MdjHs7/iHyk36HPs6J2XwCVQ9Gqt1YAW2ItswPUG0E8Z4C+FfxeJL+F+o6N0aH8AXQ5k0NiL6QvQJK58ZUGXdaZt4rahioFzrtMalUjWbcsAcK4ayI+KZTcI2QEWtcWz68+kzlVWvpv19Oc2PHu0aVENOkrAHRmOmg5ATLY9wlJ36Kx9wNpcr4Jqm3rMGz53dj952PvJ1njcDTWR4c6SYGbGZoeyWJBV0HIq1vXwt8l986FwS17qd5yDhuI7usrDY+Fvwt19ND7JveG8QZSNdt5zc096dXFWzh0RLg35H4GcT7d8M+r42oALJUPeJ0s+rAejZvhOy8IxauN9ZQ7Y9l6eNRVZijpfu3AB8TC2Vgd1JynTpI46xhyLUcOR7D4xMNVslzubn3ytjsygowKtfKwO4INmB8xqJKlPOVTlznVpzGlwz2Rb9Br7IRw/FEUgEwazhUQeQgbEPcmZ0ipo1fE+MIBowmc/jY6wBi3JJF5UuYIdPsVKltIysnMSaogfbR/g3+5UZjsf8AcpkoZsby+rQfY8jLlFvCIkDLCMZOhlVGkqNKETjeOWQh5NKQhHMK9kT439V/OCXh7sNhy9SqoF7Kh+LSL9FSdG4SWZSwO2g9esu0+EtWZvEzWNs3X2mFOzvCVFHxbliflDtDDhBlWZp4DOevwcq1gpPnfzgjtthTSwjsxALFUAHmdfgDOkVOHEXNxOZ/SrXISlS5l2c/2gKP/wBfCaLCdenPaTaSQvK9JpK4tLQHnf37C3WbzC4R0RFc5nsA2mzf03+8QLAnqDMj2cZPrmHzi6d4lxa+pPhNvJsp9k6hjeDu7ZVdF875iGBvey3v7xvM+Tvo0ivF6VeE4ko4JJAE6Hgqgqqr20H2SRudriBOGcGpKczDOf8Al9keifreGsZxGlQpmpVYIii5J025Acz5CYKGuzS+RPpHIfpe7PrTrriEIAqm7p0ZRZnHkfDfzJmEXGEeEc7C81XaDtAcZiHqsP5dsqIeSefmdz5mZ6j3dN8ri40IJ5ry/fkZ0ysSMGyzjsUQ+U6WAt6W0jE11juKVlrOHQaWA908UsJF+xyB641MhtLlVN5UyQn0Mu1cKjajQ+UpYikD9rQ9f16yWlUI0kOKqXmjwlFKpTK+fmJJhr2MYzmOotofWQvZRMGkitIQYoMokshpMr31lMNJaTaRpgTM01/0XsBiat/6F+D/AO5jLzXfRpRL4moo37piPVXT9Yq9Ad6wY8AliU+Fgikl98ovLkxfspCEThH0r4rNjCg2RFHtbxn5rO7mfM/a3Hd9jK9S+jVHt+EHKvwAlx8ktdgi8mStprIM0iesAZe4GB7s3jloV0qPoLMM39GZSA3xt6EzqeE41TyAZwOlv3rOGnEBgVPMEfpC9Djb06Sru40zE3OUbaH84AdV4l2upYZczPcnZQLs3s/MzmvaLtPVxz5nOVF+xTvoP+R6t5+6ZuviGdizkknmYlGpYxatHgVw1extLHE8OKiZtbpc6blfvD8/ZBV7QlgsQRKT3oTRUwFEL4rtqOZ0PshH6xpIsRVsO7AAUHMP7tdPj7pSqv0kUuxo9Xqbyv3kelMme+q+skYjiVqktVBKrnWaMSKzxUbSJUiIZHyMmBkiyCPV49AmEdTPKRq8craxkkwmn+j/ABnd41SD9pGX3sh/KZdTC3ZkE4gW5Ix9xWFPoaPpqkbqPSPO0pcHqlqFNjuVF5bqGwPoZkP4A/azif1fCV6t9VRgv428KfEifMrvrOxfTRxbLQTDjd3DMP8AioNviR7pxYtNF0iUPZ7SqzXN46o0ZE2UeViNQZJmkV4qmAEhM9eeYjcX9togMAJ0qSQVSJVBkzGUmAawdZHRkcAm10bmCPPoekjGHlbAuAwv+zCrgZbjaFCRUw6C5lvuoITE2ciXvrMgsp1BpB9Q3il3eNFB+d5bekIhZYxDrHulpGsgZLeeES8WMB6mSCQXihowLQaaDsTlOLUMbXRwPW62+UzCPLmAe1RWG41FuukG+hI+p8CAlJBsAokGMx4VWOwAJ12mUwXaUfVaOY3bIpOvzma7T9pS9KoqPdipGUXuAdL7RTKB6Yrt7xo4nEu5N1HhW22UaaTLkyTEtdj7vdK7mNsEeAJ21iEzQYbgzCkjmrS8d2yh1LqBYDOOV+kocc4YKDLaqlQOoa6G4UndG8xFgwZHICT6RohGhTAQgjXc+0RICkD5xxB5/l8ojoVNjuPT2bRIALePUzZdm+yi1qRdt7X9JmeKYM0ajJrYRTcttL4KctLSFj4dOsK4WtdLX8x+fx19sENsJYRyFFtwb/r8LzT2SVsSbOYnfGexBu1+sblkYGlqpiEXQC58pWqYxjytJkZGOosYleitrhhp6y22JFNnvIxJq9HLbUG/SRqJAy1gcE9U2WwH9THKvpfrInQqSDyNvL2QgaoyhFFgANjueZPUyT6mWTxI4zW7typCnyvtAATeT4PDNUdUUgFjYFjlUepO0hrUWRirCxG4nqOrAddIwNVxvsulKmalOuj5Al1AsxL77Ei4MAcNYZxm2Nx7f2IT4bwLE4hHakhYKPES1vdfea3gf0fI9P8Am3V7X3NxIu5ldlTLr0Dq3FrqqKwUKoF/MDT2QSnaPEqbrVKkHTKqjz0FrW8onG+DVMJUyt4kvodfcZXw7d5VUIigkgAE6e0mOaTWpic48YNrO9Z2Y+JiSSdBrz2lWqjKbMLGd27MdmsPSF3VCx1JXUG8C/SR2Yw/dmrTAVxrp8jMnzLy8TT+L7dOX0abZQSpF+dt4ziFF1YBlt0PI384lCs1rEnTzmi4fwrCVFRq+KZWN/CoBC6XGp85sjJss9jOxjYh1d2AQG+W1y1vynRcZ2Rpoy1AA+SxsVFrja45jymO7JYpwWRHJAOhB5cpqqvehGOZ768zOXk5XNpHRETU6c97b4lHYJ3ao9MuAUAAZWa4B8hsN4F7OYSnUrKtU+HS46685f8A5DV3OKNQi7WCixvyJJ5RvEqVF3pnAo6GwDKSWuwP2vKdL1zu9mCxUdowWOwdBFVALWGwmR+kTG4apTBRR12k+D4S3drnYX0gjtdwTKgctdV1Kj7w6X5Ti42/PDqtJRpgMRl+6fDyvPUalip5QxxDitF8P3K4dEs2ZXFi4NtQW3N4FwlB3IRFLHooJPwnoaceCvRVn8LjXkA2hPIaa6wr/wCl8R/Sf8W/SLwKgaOJQVaZUqbgMPcZ1j+PL/SJjfL4vDWY1HHFRDraJg6ipVDhA+U5srHQ2+cbU0WTcGphibi9hN6MkS8c4nTxALdwlNib3TQeekz6aEesMPTGVtBBdL7afiX5iQPDZ8D7JM6h6l1Bm3ocJfKtPvQUXQKQLDS0mwv/AMdfQR/Dz4p5/JzXvTOuOOWuzmXa/s+MM2YNcE/nM5QchgV35TpPb/VdeswFJBmGnMTr4bdRrMOSUqxHVOxPBclPPUcktuMxyj0EPLigj3XbaZrhVVu6AuYYw04eTkdVjOmeNKdKXbNFq0yxGoE5jwTA97iEpk5QW1PQCdP7Rf8ASac34YbVwRp41m/07fhSMuVLUdcqcNFGmoQknTmZnO1j1Bh28JOhmqNQ92DflAXaaoe4bXkZzLvkR0UvsOOURO39iOAYJKCvURXdgGJYA7jl0nG8Dq/sf5GdX7FLfDpe/wBkczO76inM6jk4ZVPGaDiaYeiQ1JFBPIAC8oni5VGJS4icTorcG3PqZFiB/Kf98pw6202dWJJpHL+L4xa1V3ZSBmy6Hb1nXuyP1ShQQIi3tqbAknqTOM8Q0dhyLLp7J13s5hU7hPCOU6vqW5hYYcKVU9H9octRrobehmN7VV8lNUY/euSSTfTQW6TecVpKALCc+7f/AGF9RMeBvyRpy/iY9cVlzNkRrgjxLcC/MDrOifR5iqFCjmyKXIuxtrOdUR4D6GdF7D4dO4PhGwnV9Q2p6MeBJ12e7V4iniHpsLIQwudtL6yx9Xo/9wf5CVe19JRRuAN1+cC5B0mfHDqU2zS6U01h/9k="

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/esipenko.d94b577.jpg";

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/firouzja.f449c1c.jpg";

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/gara.2dcff59.jpg";

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCABLADwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD4g+Fq/wDFy/D2R/y9xD9K+zr6LqMV8afC/H/CyfDpz/y9w19rXyDc3FeXDY+kxHxngv7SUP8AxQeccC5j/rXyox8p+ep4Az1r64/aSjA+H8mBn/SIz+teB/Bfwr4c8VfEfT4fFmoQ6boMMbTTyzsVVsEBU45OSeg9K2i1FXZhG7i7dTz25vLWPBBLsRzt7flx+ppiSLcKCp4xx/j7V+o6aB8BPA/hiLULa70xtNkH+ts7IXZlJGNoVFLfmD+FfKv7Tnhfwo0OleKfA9jEdGkL21/HDbNB5RJzG7RsAVB+bDdDjr6XTq+2duWxnVw88Oud1L+R80BCVGeKkWEsop+D5mByASM09Pu0HVE9C+GEmPiJ4dz/AM/kP8xX2/fL1r4a+G/y/EDw0f8Ap8g/mK+5brqfpXLHYrEfEeMftJIf+FdXBI4E8Z/WvKf2YfCOleNPF2r2GstJBZLYGX7RCSGVw6gJwQcMGPcdBXrf7R6n/hW96B/z2i/9Cr5b8H+KL7wf4gttU099txA33T92RSCGUjuCCR+NXK7i+XcrD8vMnLa59zWt98P7jwOfC114bWS4juZryW+vZYoI237CQTuHybUUBecEA4xxWr4k8L/DtvCceoJYw6NbTGIyXF4FZY9jM/zAAZXcvzZGCCfXNcz4T8deFY7G1v0S+tUuo0u5NLhgZlaVl+bHJUgnJ57nmtjxx4B1r4ofC3xYLVl0+/uLCW6t7WXJAigIndPZnWPaD0yQO+aww0pSVr+R6+JdGEVomt/Q+I/ixrFh4i+I2v6jpfz2E9yxikGcOOBvGecMQWGefmrlBwAKnuLS506UxXMTwyruBV1wQQcH9RVYvg9K6rOK5WeY5KfvLqdz8OpA3jrw2+cj7Xb/APoYr7quTtyfavgv4cN/xWnh0k/8vkH/AKGtfWvxp+KUfw10e3MMYm1S83Lbq33IwuMuw6kAkYHc/jRTpupJRj1ObFVI0488tkjzX4/fEbRtS0y78MWkj3N6si+bLGAYoypyVznk9uOn4Gof2JPhRp3xM+K2oW9/aw6gljpEl5HbzIrqW+0QQs+GBGUjmkccfeVT2r57huvtdxcfNvLfMX9Sckn8811nw0+Il/8ADLxfFqVqWeKSN7W7t1kMYurWQbZoCw5XehIyOhweoFfTU8HShBStqfJTxtaUmr2R7n8Fb1dPur7RRKNVTRrj7La3EaB2uoC7CB1AzycEcdxivt7wbY2V98HfFmow3MN1qk1hfadMglVRaMiurwk87DnDEnsVYjaBXxho/gHR7K3bxx4D8a6bpHgePAur3VpHi1DQSGWRbaSFT/pB3D9zjdnkDeBtrxvx18bo7zR9R8KeBhfaP4ZviF1S9upS1/rrKQwe4IO1FBBwi8KDgsw4Hm4bBKhWlU6vbyPVr5g61CFK+i38yP4seOrHW4NC8NaTN9s8P+GYZbeK/cn/AE65kYNc3XPIDsowP7qg4BYgeZ/bLNgC1vkkdh/9cVHeKYYY4VGDIfugcAdxUUbR7flieTsWRcgn645r1XGKtGyPDVSV27v5G94Pvhp2vaVfOhaO1mjmYA44Ug4z+FanxI8YSeMPEM+sakStxIAqKqtsjQDCome3X6kk96+h/hP+yppOufEXxL4U1vVNQ0XT9NvZNOS8xBG11Mn8KSksCxA3bUjYKpXcwyFbufiJ+yv8DPCeq6Nbr458RzWd8GW5tLea1lubVQdvn4W3BkUsGAQIGOM/d5HmYeph6GjleZ7WKp4nGNNK0EfBOj3EX9oyxqMBl4z0/CtSdfmGFG/tmvrXxZ+xX4F8O+PLHwrD8RLjSobvTk1ez1LUNHaW6nkkkMYtDbpImw7ULZOCSpGMg4ueGPgP8OfGngfxHY+EvDWveKfGFm9rbQajq1+ljYI1wZCJjhlChEj5Vyfm45799LER5bM8qthZ8yaPjvzkmjCMAXA2lsdPWv0S+BXgi2+EPhbwHf6LY6Qm5Y5fF9rqsCf2hLG+GcIJUyCEDKqow5PT5Sx8b0H9k/wVdfDrxTrmseKdW0G+8O6vJo97NHp4ubUSxxRtMFXKOcM0ig5GdgOK8T+IEHhbS7GG28H/ABA8R67FcMwu7e6sjZQKmM7dvmsXYsWPIxz61TrRqNRjqyfq9SlHnnpEqfHyOwvPjd4qksYLWy0v7QWtobOdJ49hAyQyMRkkEkE5BJBAOQOJMidsAfWs2OzS0BaKQSHOcMCCPbg1eW+SRQcYOORk8e1bU7pe8c9RXtY/Xvw/4R8XeE9H8WL4n0sxQ6h4mW6tZkgibfDiNYnDKxYfKm0hsEY44NXIPhLr2h+H20nR7Wa+0l9ZGqQSzGNHjUyB5W3dXwNy44bDdOOcX4r+MNXvoozNdAvFcxFZEiRH6H+IKCfxNdh4R8W6t/wjMchu8yZ2+Z5absc8bsZr8sVP965XZ+j8zVKNrHLfHLwP4v8AG3gvUPDlnpyzQ3uoJHFcrbxPMkBVQ8kYZl+YLuT7wOCcYrwfw7+z/wDGTw/4XbS5PDl7cW0q2007RCznAmsnZ7UL5c5ZSSWDFgMFzw1fR/xE8ea9pukpc2movbXKElZokRXXjsQM18v+Pvjd47urOVJvE99IvHDOD6+1e9hXy0/edzz6icp3WhX0D4T/ABl8K6ER4l0g3G6/j1u0gvpreTN5HJJLmWMSqRvaU7nkHONtcBdfs4+G0028tfEnneGdThkJh1SLV7N/PUgHElqJJEypyPkkTIIyM5NZun+KtZ1q8Vb7Vby6Q7iY5J2KnCt1XODX1X+zX8GvBnxQuobzxNoUOp3AgiTPmyRKQI1xlY2UH8RXdSnKUW4uxwVJRUowmuZf5n5xeIvhbqOnao9ppd9BrkMjbYWtkcSSE8BQg3DJOBgMeTVT/hTvxAXj/hCPEme//EpuP/iK/YPVPhr4U8F/E7w1peh+HNL02zubeV5VhtUDMwIAO/G4fga9u0fwLoIsxnTIWJZuWyx6+pNehTqVWrOxxVMNTvpof//Z"

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/gukesh d.607845b.jpg";

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/gukesh.607845b.jpg";

/***/ }),
/* 456 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/iturrizaga.9810b09.jpg";

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ivanchuk.07f2d25.jpg";

/***/ }),
/* 460 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAB4AKADASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDk/wBo24H/AAgMGTkrqNuR+ZrnvBPwp8H+L/h/o1/c6UqXElsPNmjeRCzDgnIOCcjn8au/tGXX/FAoxOFW8hYn2DVX/Zx8SWd94Gt9F+0B7+xz5igHAQuxBz3+8elflGBTjhOeLtr+h+nYibi7JnyZeWK6H8TL2y+YLa3skI3HnCvgfyr6j/ao1Dzm0EBuFtZ1/IRV87fFqy/sr47a/E3G67E2f+uiK/8A7NXtf7RTG+vPD8IZVaRZ0y7BVGRHySeg969vMI+0xOFk+z/I4stquMKr/vHyZqdz9puJCVA5IwKl0OFl85sffQYx/vCtPWPC8dhfXMc91Iksb7GVYwQTgHg7vQ+lQ262kK+QHkTI272w3fPSvrVUjKFonyMqM4VLz/MljVjJDwScscfjWzpcxhWQqSreoJqpp+jyf2rb20U6zSyRtKm0gAgcnnPt0qTTY/tV5PEj4kizuVyF5zjGSetctS0kdtHmg9dyxot9NZ+IUvIpXjuYnEqyqxDBgSQwI5ByOtdTpvjrULrx03iTVJZdTv8AA3yTzyF3CoEALhg/CgD73auS0+P/AImU1tnbORn5xjaMEkn8DWvb2cQkP3tgHzSL8pb3AOa56sIyvddLfI7qPMrO+iY+/v8A+1NQvrsptNxcyTbd5bbuYnGWJJ69yT7mqV1wvQ0t54isNNvBH5c0jfxbgGyPw61rQpYanbmeMsbdu8Q+ZPqKwcXTSbWh1Q5asnGMtUctq3huKS8eeO5+aQBzGiliGwM5P1Ndb4T0u8uLGSWC0lEEc6sXfgKAjgDJ4zyOKxG0T7Hq1u7SGbT3YFm5B+h+vTIrvIYVZow0yzrgFVUDEY7BR0HaoxNSXJGCdztpUqPNOrCNu+v4/wDDG3Zxz2NqqXETRMwyAwxkeop9lJu8WaCB189z+SGsrXPE9vZ2c0UaMzxvlRu4+v5dfoKxvBOqXGseKtLSSdxKrSESAkY+RumDxXjxoTalUlpv+R0+1irRjqd78Rs/bLK5SYo9qJX2cZYlsD6YwOlUNOaw1rTm3XENzE3DJncAapeO9YgN1dvIhjaL5Q8i7fMDZYbCeozkHHcVznhG1FvZwPlgCgfBPG484/WvTwVHlw8W3qebisQ5VuW2iv8AmdRa6Ppi3ADxKDbnqqDPXgj14H61ieMro6sXS0V2lt5EMeF+YFsAjGM9cdK7bxTH4eXwxbXOl6pJNqhYLNaSIylRhtzBumAQMY5+avMtD1N47i6ZpWa480ks36fpXTTl7WlKok7q++m36GHuyxFOk9E2rteZ3P7T3xHF9er4NEIiSPy7qS9L5wT/AAhR7etcj4B+IU/g97yXQZIWvEtzhpotwcAZORnrgV5PrWr3mtatdahOqrJeO7mNfmxk5PTnP5VDo2tNo94LkORJGQQhHD88qeeOM+ta0srhTwsaK3Wvk2cCzSSxEpyXuvTz5f6dzc8TeL7/AMb+NZda1RoXvpyokMKbAdqhRx9AB+FfQnxyhl1bUvCtrED5tyZY0AGeT5Yr5w1K305pDdW0rCKT544pVz1xxwex3Dn0Hrx2Xhv4o67od5I/2wBLiNlSzjX91CpX+H+50HCn65rLGYaVV06tLTkT09Vb8DbBV40XKlU1Tad/67mD4raJPEt1FEd0SyOoZuCeep/Ku18A+BRqEN9qYijuOohh6/LgfN/OvNpDLrWvQ4AxKwJbHGT1r2b4Y+IF8IzJFeRqYj0fbyG6E47c+lZ46VSjh1Gn8Vj0Mrp0sRiJTqr3U9H5/wBM8v8AFXh/UfBuublRmbaZYvLG75Soz26ZLD8Kw7XTbu8nMrsIJrh9/Pp1JIGcdfSvdvipbXjasmpWIiW1nUOV4+8CMgDoc5B/OuH1mxltobeS7sDb6mwBXIKtycAnPPTpn1FVhcdKtThdK7+/7jPFZdSp1ZtN2Wtnt96/ApStB58cVpBslkCRyOp3NIVGABnt/k16ZonwJ8U+MNLje1g8mN13AshPB9Til/Zu8BweMPGMtzOnm21pHgL2LE8c/gfyr9FvBfhm203TYkEKggZ4FOtUdJqEdzajFVIuclp2R+b19+yT40s7Z520/wA0K2Q8ZB+UZ5AzXNXng3WPAt5E19bGIyjCPj5ZB3DD8RX61TaOHt2AiLD+LaOma+Z/2nfhzbS+C764hijBj/eqG42Y64PpjNYwxNSpLlqrcHh6MFzUtGfH1rawSKHEO+FlLojDIHcityH7DJazXPkxRSsgU/LgDAxxz1rG0tfLjlRxtVlBUnoGxkA/UZ/GjwsBqGvT200iq8ZJAb2OP8BSxVJqHO3t+R14LEJT5Er835mFNOL2W7tY4i14VJVcZLHBwB3yaX4ewzaf44tYrmGS3miEm+ORSrL8jdQeRXXXvhWOw1ybVk0yTWFRBvhWfyQpJ7MASDgHnB6dK6zVPBDatqB1ea6uW1OHTdkn9oxiNyqxNk5QkO23aM9Dx0zgRKd6PND4ZJ+t7fkcqahivY1NGn8rM8y8cXUl1qd6wtppvs1onyKCQenfHGc4/CuQ034nw7fKubUQRjhTGC2Pqc/0roPGOnpY+GbuWMLGxi4I98d68ZY+9ehlihWpN220/AOJcO8rr06VOfNdN/8AkzVvwPTL/wCIVpFCwj3SS9NpU/jTtPvhLItxsCGQ5XJ55UEDP415huHbiuptdSNr4fs5AQXVyGU9xkgH/wAdFd+Io80OWPXQ8TK8Wqdf2tT7Opze2LghCPx4q9p+oJazK9zbR30K4zHNnoPRgQR+eKqzW09t/rYWjH+0pFQ7TIwXqWIFdzSkjwIylB6bnqFt4A0+9t7Z49Qji3xK4ViTyZCSPu8fIQevXNdfr3wvXQ9Fj8m5aVpsebEQANoHVeOCKb8IvCM19djU70SJaW+PJjckBzjrj0A/zxXba5fed4s0pSxaBidixgnJB24/z618RPFVXi1RjUuldv8AyP0qODowwTrOnaUrJflc4Dwn8OZNmbkCKS3bMbKMbhkcn3/wr0Sw8O28kguS52Y7jG7/AD/Wt+S3RlLQBT0yvqP/ANVMhkSFREcSNg/IOpq60/by5pHNRcqFPkpdfIkfR9L1zwy1td2hliKSqnltskjYZIKN/Cff3xz0r5l1jVru4mKz3Ut3JH8olk+83oSfXn9K+jrK4K+FblCdroZPunPrnBr548L6YNW8X6Da3A3R3N9ErqR/CWGf0NXlOkqyeyd1+Is2jZUna0mrP8D6X+Bem6X4B8KXD6/ZXLTyWw1C4niLo1rCWCq4Kkc5I4XLZPSvrX4Q+Lp2mstPl1OPXbS6iWeyvGXbJJEQCN3A5wRnIB5qO1+CujeKdLs7q6tI2kiiCjAxhSOg9uaXw7o8Om+Jry6tyRDpdt5Me49GIAwPoAB+FbyrRceaS95sccO1Lli/dSO88WfFzTvDcklmmk3l/KW2hLIIWznH8TCvBf2lfGki/CfVb19Hv9OZjEFW6CNu3SqCDsdscE9cVu+IPB2rahb317amR5ruCSNLhZWDQStwsigHnGRx7duteafEzw74xm+D/iO0113uIIbONhPcfLJI8bBnYgAADgY7jnJPWtIyjJRm+5zSpyjdR7HyLc60Fa/mSTbs8r5fVDk/mMCq+j6vHp/iqzvmbMci/vMc/L0J+oH/AKCK5PVLqSFpE3H5guQD1wD/AI0ml32Lq0DHIR/0r1qlONSGuzPFp1ZU6nu7o+sdFhFx4bjhjjzc39yUVeBuVUwp9PvMfyro47ix1N9S1Ezk21rp8Fi5C/xuCG69wGx/WvMvAOvCLR9LE9zEr2cuOv3lXdxye+7NdbqGsJHa3z28xijvJRLJGpBXIUAYBB4AHSvmq1fDYf8Ad07v5f5+R6tLLswxk3Wq2Tet21022PBfGmiXS6HfRBbiZymEiWNietcH4f8AAt0t1ai+sGc3EgRI2fA5LA5AGc5Vu4/w9ih+KviLxVeNptpFpcf7tyoa3WPKhT8pdBubj16+9UNUbVvCE9oJ/sjXFrOWXy8yIrxscH5uvJPscmujC1a+FjKnKK18z1s1qRzqrDETdnFW203v566nlNr4I1KHXJVuNDultn8zylaBtpAPY47cfnWFfWd7ZtsuLae2iLnakkbKO/Az6Zr6R/4aV8ZqQDNZvxtO60j6Hr2qG++PGs+IbGew1PSdFvbedWjYTWKHhhgkeh9+tdUcfik/fpJ/P/gHgyyui1aFS3yPGUm3NhGKp6Mc1Zi1K1sbW6tXtrfbdp5bTrEpkjIIIYH04xj3NYV5ctFCQhIZuOOoqjbqVZtzEkj617Toqa12PD+sOm7R3PdfCviK9h8P2EcN3CkFvdRxNKZAN6NvYjBHygY/Q10Vr4skvta0sPZQPDNZ/aFZnUbZQHYgH327cjvXguj6gbfEJb5H6A8813NjcW95DFPJqU8UzJsK/ZkbaOmAcj09q+VxmXRhJy736d/Q+3wGZyxEFDZq3VdPU9Qt/GCx+G4bx7NXuDci2aOKYpGuTw2SeTjt7Vo+JryeHRr37GUtbpioQ7AxdeAc546HjGen5eVLHaG3W3OrymESeaFazU/NjGc7vSvQvh54y8L+H7z7Z4khvPElzG26JDtiiTHQlcEsfqce3evIqYZpqcNbO9rP9dPU9iNbRqStdW0a/R3ObtdYvofD+pW9vbyXssUbNuzgD13E9+vArg/AE0cPxG8NSXJCot5FG5P8JJCg/gTX2dqHjzTJ9Hvo4vhrqEUwgYq0sGFXg9SV/rmvkHXrWHSdQtdTsYfsU8LwyRwXCCQF0UEsVIwykjoRjmvbyuc5yqKrDlv/AF5Hz2ZtONOUJX5fQ/SO78ct4f8ADVitzdLZxXCKonzgEnoM9qj0PU2XwvPZQWkl7c3EzSG9t3BR09eT1/wrxz4TePH+MPwrihl2PqVi6ieNl+VZAchsehwG9s+1eo2kdmujl2sbiDU3Yb4rCeSIO+D8x+XAHT+I9Kbg3Jxl0PQw9qlLnT39P1aPSfBd/Gka2d3EYJ1DeVI/zfKWGQRnBOAK5r49alZ2/gvVLQkTRz2skO08nawIx+oFUtBsb+3P2nUtTkkQ8x27hWaL0G8AE8etfP8A+1x8YrXQvD7aFpNx5urXn+scNu8pO/PY+n19qulDnkqaPPxFRU7zZ8R6hC7sJHzk8flWbuKTK68c4INeofEC0GreLLC+hntblb22jvLuO0ICxSNkPnBIywUN0Xhvur0rkJPC95JqEdnBaS3FwQ0yxQoXYLjccgAngDNfQxl7tmfLzXNK8TpNGvNE+yWYF/HJc8q8E+VVmI4wWwOOnofWul1Dw14oSMQWcsbid2jgeKffHJ8hb5fQ9PSvMNW0C801wmpafNYu3TzYjGTwD3xngg8+or0H4GfETU9OW98PebbmGH/SoHuGxt5wyg++4H8PrXk42hUo03Xo2duj/roezg8Z7aosNVvG+zWjNTwZ8FfG3hnxFpl5rGhtZ2cpMbSSeRdKMoeSmW74AyODg9a9Qv7efUf+EiW9vG02WxlYvbtGVYB7khCAI8c/UnAPFdHqHxbl8Ti2t72LTNOhWUSm4hu95QqDjClecnj2zUiav4La31B7i7hlvbjyF8zzBgiJywHtkk5x1r5fEZi3WvUjdW6Lrr6nv4fL5QopRdmn16rQ+VtcsLyz1i5hvraW0uN5Zopk2MMnI4qpGhT5j0FfRnxkh8OeNtJF7Z3VjDrFpF+6WKTmdRyUOSeT27Z9MmvmFfF1veKfKtp1UHB4HH1r1cBiJ42lzKNmtGjDGQp4Oa5pb7f15HLXEnmyE9QOlNjX95kCm8hjwPfpUkOfM454r7Z6RPzjeV2WVbbGrdwa7LRpvOs0JP8AEev51xhH7sc5rp/DDN9my3G18D9K8zFK9O57mXSca1u6On0XS7vWtRt7Cwga5u7hxHHEg5Ymvrn4f/s2aD4Vs7a58QW/9r6m6bm38wxsOcKv8WP9rOfSsz9mH4Tw6LpMXijUYmTUbxSLbzEBEMZ+6wHq2Ovpgd+febhRcW8kbjDgfMoPKnsR7d/euSjh1P3pHfi8Y4+5BnmuteMfD9n9qt5760szEGR1nYIFxxgKe3APtyOwFfCnxH1eyvvHV8mmTm50uOUxW8nIDIM4P05xnvjNfUvxq+Eup6rJd6np0trIspLTQSRhnDnA4yDnJxj6gelfIN9oF4muTwSBl8uQK7SLsIyRjjtn0r0FHX3keVzK14vc9x/ZX8Y6h4T8b3BtLdb61u4THPZbthkCkMpU9Nw5xnA5PIr7j0z4naPqWmEpouoLcpx5K2xOT6Fhlf1r8/8AwrY3/hC8i16yjZ/seJ5oe/lAqCfxUk/jX2D4F8SFoI9S0u4jNnep5qpMMoc9wR0NeVirc90e5hW/ZWNHUpvEniy4kiaL+xbHqTn59voPf3r45/aM0dYfGIjhQmCLbGTnJJ69T3OK+25NSmSGe5mn8yYjCbfugn0FfLv7QWiGy0eXU3i2mScbWOd3BGM+5/xrDDy5KisXXjz02meMR6/LfQi7vUhW48tLdTFEsY8tFCgYUDJx1J5PvX03+zz8NZLSxbxNfxq+qasP3e/rFEcEAj3ADe/C8ZNfGWsak1uqKCQccqp+6cnoa+2v2ZfFz+LPh8Dc3kl3OkxWVpUVGXIVQAFz/CDzxkg8V7lGC+Jnz+KqWShE9h8YfDPw98VNAtrDxDZm9gJL27F2V04wHBBHOCevFfGXxE/Zn1L4H+MLvUUmbUPDd2nl2l02PMRicmOTGOQF4YcEenIH3dp8xkZHXqeRt7DipvFnhzTvG/hjUNKvgr29xGYwW5KsfusvuDg/hWNenLklGL3LwtWMKsJzV7H5z7sJkVBbSZjfLdGP863fGXhq88F+IL/R73b9otXKll6OOoYfUYP41ybTeTZyOSBkk182o30PuOdK0lsU9U1RpLrCsSA6ouPrXnEsn9k69fIoJCzMjoeMjceP5V1VvMbq8h77p8/kP/r1z3jCz+z+J7wrw0kgYZ6cjn9a9zCxUJezfVHzWPlKpTVVdH+hlMx3nGetPjba3r6c0xiGwQadGV3+9e59k+T6lpXyoIPt1r2X4C/DW8+IOvaZbR2zy6akytfTAfKq8ttJ9W2kCvItM06fVry2sLSBri6uZFiiijGWdicACv0i/Z7+Cq/CPwaIrhjcapdbZ70xt8oYD5VTjsCee+T7Vw1o86Ubnq4Wbptz8j023s4rSKC2RQsSjGwKMADjp7CqWoPJa3kYeM7Cuzf6jPyn8Pz5HrWlHeKLoQzIY3UcNkfOvPI/L9azPF14LXR55tysI4zIj5xtwOCfb/CtoR5VY5KknLUwtUs4tQhureVmKSKpyrYONwJ59eDXxF8ZvBcnhjxNdkRGy05L+ABck+YHQsZMnqBwP+BV9heGfFFt4gmuGjk8yGMKkchxhsHP8iat/Ej4N6P8RtIe0vwYJ5F2rcRgbhg5XHrjPQ+tXKN1oTTqcktTjPC1v4f0TUo57po/stxbyQIjp5hnYIp2qgyW+UEAAZyp9a6j4L+B7mx8M6lbS20ljYtfzT6fbTkGSG3Y5VGA+6Qcnb2BAPIrkfA/wP8AEHhnUrb7Xq1tJDZMq280KYfbu5HIJUeqjjjGQK950Gzm0WIxM5kZmJJ2456dPoBXhYxcs723Pp8DNSp2vdoow+G1YLvG5U7ds14d+05aza1pMGlw26xW9vbNeSyO+2NMbiG92Gwgf75r6NWZ1DAD5WznPGK+f/2gtlvDPqckqy6c5jinhzgvsfIUeoznI9h+OeFinO5pip8sLdWz4NvrV52WUKXDue2MYzx+lfdH7Pvw1s/AfgOC9tJftEmrOk0khh2kIUIVevbcTmvC/Dvwm/4Srx14c0m6tnRboyalf268fZ7csSqsR0YjA/EV9jTLF4f0lbeKNUS3CjygOFVcnAGOmAPyr36a01PmsRLXTqaWn3BKxqrZLk8A/wAC+/uf5101jl5VMi7Y1HyK3GOK4Hwz4gs7rUJIDMm+DCrED19G+n+PtXdQ3KKw3NjPTBOKqSME+h4T+2P8PBcaLaeL7KIebb7ba82d4yfkc/RuP+BV8Za9dfZdPK/dO2v1N1Czg8RaZLpl9bx3NpcKUlimIYOp6jHb9a/On9rTwDb/AA18fT2dkiw6feQJd20SsSI1JZWXJ7bkbHsRXizw9qt1sz6TD4z9w4PdI8t8Pr5l3adz8zfmR/hUfjaxV9e8zJB2g4z9at+FVWS6iKkMFVQcdq0fEkRe/XC79y9hms5VPZ17+R6uGw8cRQUJdWecKsPXy8+xY1PBEZ5Ehgh3zSMEVEXczEnAAGMkmorW0LqQ91sI5GcDPt9a+kP2L/hVJrnjCfxVqFuLjTNMXZaGZPvXPB3KOh2DP0LA9Rx77qR1R8PGjLR9D3z9n39nPRvhbpNrreoWv2/xLLCjyz3Q4tGK5ZIhjA64LE5OO3SvbV1SSX5oJNo6iNjkH6Hn+n1qFlk8sM0DRqB/EAOfwPHbqRWVKyWdxvEohlkwC3JUn0ce/ryfc9KwSvqzaUuiNvzoL61kif8Ad7eik4ZfcH19Pp1rm9L0e98WeJJzqEgh8O6aN88xOGndR8yY6FM/ez7j6T61Le6i1pp+lxRf2tcSLGqSvhVXgs+R1AXJ/wDr8Vg/GjVpvAfwJ1+K2nc3d0IdMSfozNNIEdvYkMxpPVqPQ6KFP3XVav29Ty/4d3cW4yW0yfYmTzUaMgB19cfnX0qqpJZRMjfJjO7r+H0r4c+BevO2nzaUWZpIZmMe4BWVGGSDz3YMfzr7F8M6q17oVtkfvFX5ueRXXL3XY8+Xfua025pCAR2ww+n+fyq8tw7Rhj8zLwSB1NZskgjkAKkEn0/HtXYfDzXtI0+8ktNet47nSboZMkiFjAwGAwxyARwce3pXDiKPt426nXha/wBWldq6Zy2oX832WbyY1eTHCs2AfxxxXzz4o+APiDxRrkd/b6jaQSNJvEdwWmWI56quBu69Cvbr2r6s+JWseHVu4tM8N2kJtsF5rxQW3N2UMxJwO/qcenPJxsBnyyqhR83PU8HjmssNhfYpuTu2dGJxrqtKCsjkPAfw2s/h/bTP9qfUdWvCpu7+blpSM/L7KOeBVbx/Myxzskm0hd3TpnPP5V2c1w0sqnk7M8c5+vtXCeNBJcSXBRQQVIG49T6V6J5TvJ3e55v4fs7wa1aXemRfaLyNhiOJctIP4l45PGT9QD2r6B0bWFvtNjlhbAKhix6f/X5rD/Zp0u1uvHE8hg2PZWruEZfuuWVQc+pBf9a1fE1mvg/xxeaUZoxbXLm6toYFOFRmJ2Nxxg5FYudppPZnb7O9O63X5HR2OqRLgA7pm4Cr0H1Nct8ZPgzoPxq8Lf2frKNDJC/m291bY82BwCuRkcgjqp4PHoCJpNW+x4WLmTblY4wePx/yPzrXh1TUCIxHHsVRhtpG78BwPTvUyjfUyjKx+aF74Tk+G3irUtHvpPMks7p4TMqnDgMcMB1wRg/jSXmqfY7wXdvOVG0jdCAx+nPTnvX1p+1f8K7TUPCdz4qstOH9q2zLJdzRqA00Z+UlgpI+U7Tk84B5r5K8PaFFrE00c9/DZuqZTzMfN14Gf6eteFioxi3UqH22WVufkhHbzPKLjUFuGIEIVc8YGDX6Lfsc6Xd23wS0Oe6UJ5hnlh65KGVyCfXPX6Yoor35JJI+KjJuLZ7nGJJZB5ksiKRj5Sf5f41BN4dt7hCoRtucjn16/wCfxooqWKysZHh3RI/CfjS48RX1zNeW/wBiSygg8sE25EhLyD1LAqvbAXjqa5H4wSWPjrwiPDIuATqouxHuRvluI7eSW33DqMyRqASOpHeiiuB4iUcSqVtGj2qVJTwcqjeq/wCH/M+b/hf4fstW8Qa5dafcBb5vKubWLjAEiLLsJ79Sv/ASfWvffAnjiPyRb3LCGSMkOjcEEZ49sUUV693KzfY8atFRm4ro3+Z2i+I4Fw5lD/7PrRD4ttN3Mvz+uMHBooosjncmi03iC1kHmCRdpLZCtmk/4SCMBSu1Vyfl/DviiiotYplXUfEMFrHIxdFb72c8Hj0rzrXPFH9pXSWloGklc4VU6miimET2H9neCPT9Y1V5GYTfZV3sQdh+bnB77eOfc11XxYs9K8SaDPNbtb3GrW5DwtCVMjAHBTcOcYJ4z1AoorjqaxaPUov3eY4i30zUFVfKs2T5cuwILH0XBP8A9b2OavWH2tpvLEYhIPIkXLL25bOAPaiitVNy3OKUeV6FvX4LrUNHudPuljubS6iaGTYhBCspUnqc8H0/GvzZ8aeG7jwb4s1PR5ZgZrGdoWkVeWweGA7ZGDn360UVw4xJR5kfQZHJ/WYw6H//2Q=="

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/kamsky.dc80bdd.jpg";

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/keymer.c76332d.jpg";

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/khademalsharieh.4be89ee.jpg";

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/kosteniuk.898555b.jpg";

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/mammadzada.8905f3f.jpg";

/***/ }),
/* 466 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/muzychuk.25bd5c1.jpg";

/***/ }),
/* 468 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 469 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 470 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/paehtz.20c30a3.jpg";

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ponomariov.a6336a8.jpg";

/***/ }),
/* 473 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 474 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 475 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 476 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gA8Q1JFQVRPUjogZ2QtanBlZyB2MS4wICh1c2luZyBJSkcgSlBFRyB2NjIpLCBxdWFsaXR5ID0gODIKAP/bAEMAAwICAwICAwMDAwQDAwQFCAUFBAQFCgcHBggMCgwMCwoLCw0OEhANDhEOCwsQFhARExQVFRUMDxcYFhQYEhQVFP/bAEMBAwQEBQQFCQUFCRQNCw0UFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFP/AABEIAEsASwMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJCgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8CQzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4eLj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFiQ04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5ufo6ery8/T19vf4+fr/2gAMAwEAAhEDEQA/APjXxRq0d9dE78kr/WuE1BVMxOB+Fat/cb5lOSeMYNZlyoZTwSa+Qw0fZpH32Kl7RtnuH7HPh/8AtDxtrmpsuUsNOKA46PIwAP8A3yj/AJ1yf7REZtPjj4lKDh/s7j/vwlexfskwr4b+FPjTxL5W/NxsCnjeIIt+M/8AbXFeGfF7xNH428eNqttC0T3lrb74SM7ZAoUqPUccGve9nP2PtLaHzUasfrTp31sc9YtJOwCoWf8AugZNdBHpV3ZMhuIvLLdj1H1HUfjXYfCe18O+GdWjl1qV7rUFbeiWzZVGAbj5ck89cDt1Fdrqnw5134halfajexyaW3MyzSDeCuMru98dfb368McRGnK0tjqnzTXuq5wGmWwaMElVHemX9ukLZ3gg9Oan0GVbie5hDp5sD+W6pgjI4yPrj9aTWIDt+c7R6AV7zUJU+ZHkxlJT2Obvo0aT7649jVLy4/73+fyq3dRpkg5x61VMaDsa8Oa1Peg21qc1eb/MXjt/WoHWQqRujA/66L/jV3VWSWVBGMDbzzWe0JHGOPrXLT5bJs65KV2fR2678J/sv+EbeCeS3OtX01xcLGdpeMysoU46gqin8q8es7XTZPEUA1Sd7ZTp7CBgpKmcH5Q2Occnp3A7V9DfHTTY/D/w9+HOgyLh7PTYldQ20+Z5K5P/AH0Wr5w122hk1fTknd0i8jJaIBj94+pAr7mrCH9irl6PX+vQ/O6NSUs7afVOx638D9HttEZrvVbeU6leP5lu1xC5DLjIIYjHOc9a93j8fwaddxxXVzFbyzLsSMr95cYwAB0xXE6n4L0hr60v/JMV1tXyJVkIKoQMY54GK0Nf8L6L4g16zeWa4jaJVMTQ3DxgkDBwVYcg1+XzlCpU5mz9Xo0p06Sgo69DwbVdCGj/ABo1+00x/LsZI1uQ7Z2YcAgDt1zj6Gr+qafLyDcKxxziP/7Kur+MK6Zpfi6EQTg6ncW6iZd5LCNM7Sc+u9v++a5ATeb1JP8AwKvp6OKj9XSe583UwkvbtruZP9lySN99T/wD/wCvTl0Hj/WH/vkVuRwheMf+PVOsAYA7f/Hq8qpWu9D1oUEl7x4zcybpAQQRjspFafgrQX8VeMtD0cKzf2hfQ2pH++4U/oaqapzPjA6cEdKk8M+INR8Ja/Y6zpkwg1CylE0MhjDhWHfawIP4iqg1pcJc0rpbn1d+1FDdeIvHWi2NhZyXMyhn/dnhVIkG3H/AQfbb+Xzl8SPB+qeFbnRP7StxbvcRSlV3Kx4Zc9CcH5hXrngP4nal8TPGGhXupW1vb3ccVwZZLZSokwpRTyTj7x79zXafFDwnoHiK/wBA1HxFNILHT0mK2sWB9pkkKrGjNvXaCYpf4lz5bDI4NejWzbH1MdDI6VJezlFTb62to+y1t06nyGGwGGpSeZzqPmg3G3S/buYHgLxdpnjSzsbAySNf6bFGkckihDcKI8H5AcHBD8egB+nctpNq11DKVBmTHlxxkqnXPKg4JyByareF/HGj+HtJv9BsvCllY3l3HHPbXlvaBBHaqCWBy7kSO7IN4ZlYBgG4KjXklQqLiIjDLnivnsww7wdX2f8AXy8j7bA4xYinzHlPjr4UeKPE/jmwv9Ltl1Ezs1uyFgsm7Pyoqk7SNpGMfMSxGDxXCeKdD1TwTrZ07VNPvtOmBI2X9sYXJB+YbT6fyIPevYviX8YD8PbPS/stv9p1CNRdF5pBHBFK2GG5u52hPkXLHa3Aq7Y+P7T4o2c95rVrDqUt7M73M1xIsq+c7E/utqvjc7uyoFlYZOzGZGT3MBgKmMj7z5VZWPCxOOhhKnu63bueDw6mD/y15/3at/b0/vN+Qq98UfCll4X1xJNPRorO5Xd9nlkjMkDjqrKrEoPQNgjkYGK5D/PBNeViabw9V057o97D1FiKaqx2ZzV3b/vuQemaqyRrHGxxjArT1iQfaORzsFZ3EkTZIOR3ojeybKukmj6c+C3h21sfh34fu7e2D6le28heTGXYm4cKo9BgDgV7X+038LYfC/gfw5e2sdw81qkcGoLaEiUvv3iRCMkMrklcdi6j5nWm/sn+BH1PSvCmozwFtN0rTYblsDIMjZdMj6ndn2967f8Aan8TQWvgXWRcLHJbzW7xlZQpXkHkgkD8yPqK+cynE16eZzxrbbcnHX+W9rf5ehy4vC0qmG9ilZWv8z4msNfH27xJqwjiiNlpH/HxbxFQshvLYEDKjt/CVRyM7+T5h2dI+LNx4jfS9L0mFXvL6domVpIy0KgAmTCs/Qbj0P3ecVzVvp5t7zxHD5arcTeHpCIpY2Evlho5FGyVvNIAj7NKnowHFUPC+oyeHfC/iPVrueaIG3XS7P7ZI25GmBVhskMMZAhSX+HPzDk9D+o4mjTrVOapG7R8dQrVKMeWnKyZynijUJLvWJby5aa3vZZmkP2iZY5lySwA3Zfbyf4Il/vEivsj9kX4T2ninwrZ+ItZLSaeylYkWRyZyfvqGPzCPOQ38T8oflVg/wAWTTLJaSJaSjAUtLDalHQrj7xjgjWLP/XSRgB2Pf8ATH9mnTW0f4UeGbK6GyeGyiR4sNlZSgaQHdzkMSCT3BzyDXlZpi6mEoKNF2ctPl5Hbl+HWIqudRXUdfmfOH7bVlaWPiPw4lnBDaQKJkWKCMIFXC9AB0/+tXzwGXHMn6V9J/t1WxhvdBuAP+Wkqk59QDj9K+WlumCjj9a+Yi5ThG/Q+1oQUU7dTNvmEkx+XBx0Uk1RcMFIAx26Vq31tHFptrcKCJmOC24nt6U7SbeO71mzt5V3QyXCIy5IyCwB6e1em3y7HHFKSP0g+BMui6TpnhPR5J107Wk061ETSQyWtyw8pc7G3Ok6HaDtIAx6GtL9rv4D+Ivil4DMngie3luInEl1p91J5PmoOSY3OFB9mIHJ57Hxq0+K/i3TPFH2GDXLgWluFjhikCyCNQwUBdwOOOK9d+F/j3X9e+KnirTr/U5bqwtW01obZwvloWt5HYhQMcsAfqBXgfwGpRW2prUpyulfc+KP7B1bwh4ofTNY0m70yOTSb2Hyri1eGKZjaygMBtkgcZ2jcAmccqeh4bUNebTvD+jaXYzKrHzL+4t7V0jzJKQEyIJYycRxxsMIfvnjOa/Yvxr4b0vxr4VuYtc0+31NIlLx+fGCUbkZU9Rx6V+en7UXwh8I+GXsrrTtIWCWZF3hriWROAAMI7FRx6AV9bg80WJ1nGzPla2B5Itwehwv7OfgqDxb4vfXfElvDP4c0EicT38t2IhPkFQRK3zAAEkBeOOR1r7L+HN3c+ItbOrWwuv7HhgYWgkQW6vuIO5IF6IeTuclmPPSvJvhToWnaL8GLyWysoIXt3V4vkDBWKsScHIzkA57EZr6L+G9rFD8P7C6VP8ASry2S4uJ2JZ5ZGVSWZjyTyfoOBxXzeZYx16z8tD6XL6EaGGut3ufNf7ZU2kP4Nu7nVoJJ72J449N8ubyxHOzcs3B3ARrJ8vHJHpXw8NS/wBpfyr6l/buuJPsGkJvOxr7JX3CNj+Zr4+8xv7xr6XLsNTq4aMprXU8PHYyvh8RKFOWmh//2Q=="

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/salimova.5a11723.jpg";

/***/ }),
/* 478 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 479 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 480 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 482 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/tari.dd06bb0.jpg";

/***/ }),
/* 484 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/topalov.043b823.jpg";

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/ushenina.b5d2315.jpg";

/***/ }),
/* 487 */
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 488 */,
/* 489 */
/***/ (function(module, exports) {

	module.exports = " <div v-on:click=OpenInputFile> <slot></slot> </div> <input style=\"display: none\" id=\"{{ id || name }}\" type=file name=\"{{ name }}\" v-bind-boolean:multiple=multiple @change=fileInputChange> ";

/***/ }),
/* 490 */,
/* 491 */
/***/ (function(module, exports) {

	module.exports = " <div v-on:click=OpenInputFile> <slot></slot> </div> <input style=\"display: none\" id=\"{{ id || name }}\" type=file name=\"{{ name }}\" v-bind-boolean:multiple=multiple @change=fileInputChange accept=.*> ";

/***/ }),
/* 492 */,
/* 493 */
/***/ (function(module, exports) {

	module.exports = " <div> <div v-for=\"men in mens\" track-by=$index v-bind:key=men._id> <span style=\"font-size: medium\" v-if=\"men.type==='text'\"><b> {{ men.send }} :</b> {{ men.body }}</span> <span class=right style=\"font-size: small; color:#aaa\">{{ men.created | moment 'h:mm:ss'}}</span> </div> </div> ";

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"col s12 m12 l12\"> <md-modal id=initGame> <h4 style=\"text-align: center\">{{ $t(\"invites.initgame\") }}</h4> <div class=\"col s12 m12 l12\" style=\"text-align: center\"> <h1>{{ counterInitGame }}</h1> </div> </md-modal> <md-modal bottom id=invitesGame class=modal-fixed-footer> <p class=flat-text-header>{{ $t(\"invites.numIn\") }} {{ invitesGame.length }}</p> <md-collection class=\"row s6 m6 l6\"> <md-collection-item class=\"s6 m6 l6\" v-for=\"invite in invitesGame\"> <span class=chip> <img style=\"\" src=" + __webpack_require__(434) + " alt=\"\" class=circle> <b>{{ invite.u1 }}</b> vs <b>{{ invite.u2 }}</b> </span> ELO: {{invite.elo}} // Tiempo: {{ invite.time }} + {{ invite.incremento }} minutos {{[invite.event === 'confirmGame'? 'confirmando Iniciar ...': '']}} // Creado: {{ invite.created | moment ('DD/MM/YYYY hh:mm:ss') }} <div class=\"secondary-content right\"> <a class=\"md-button waves-effect waves-light btn purple darken-4\" @click=InviteGameActionClick(invite)>Aceptar</a> <a class=\"md-button waves-effect waves-light btn red darken-4\" @click=deleteInvite(invite)>{{ $t(\"puzzles.create.delete\") }}</a> </div> </md-collection-item> </md-collection> </md-modal> <md-modal id=invitePCGame class=modal-fixed-footer> <h4 style=\"text-align: center\">HUMANO VS PC</h4> <div class=\"col s12 m12 l12\"> <div class=\"col s6 m4 l4\"> <p class=\"flat-text-header hello\">Color</p> <md-radio-group group=color class=\"col s6\"> <md-radio :value.sync=newboard.color radio-value=w class=with-gap> {{ $t(\"home.createPart.white\") }} </md-radio> <md-radio :value.sync=newboard.color radio-value=b class=with-gap> {{ $t(\"home.createPart.black\") }} </md-radio> </md-radio-group> </div> </div> <span slot=footer> <md-button href=# class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=createdVsPcGame(true)> {{ $t(\"home.createPart.create\") }} </md-button> <md-button href=# class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=createdVsPcGame(false)> {{ $t(\"home.createPart.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=invitePCAnalisis class=modal-fixed-footer> <h4 style=\"text-align: center\">{{$t(\"game.createClass\")}}</h4> <div class=\"col s12 m12 l12\"> <div class=\"col s6 m4 l4\"> <md-input name=nameAnalisis :value.sync=nameAnalisis> {{$t(\"game.nameClass\")}} </md-input> <div class=\"col s6 m4 l4\" v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.publicAnalisis\") }}</p> <div class=switch> <label> {{ $t(\"home.createPart.private\") }} <input id=idAnalisisPublic :checked=true @init=analisisPublicChange type=checkbox> <span class=lever></span> {{ $t(\"home.createPart.public\") }} </label> </div> </div> <div class=\"col s6 m4 l4\" v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.typeAnalisis\") }}</p> <md-switch :value.sync=analisisToAll> <span slot=on>{{ $t(\"home.createPart.public\") }}</span> <span slot=off>{{ $t(\"home.createPart.private\") }}</span> </md-switch> </div> <div class=\"col s6 m4 l4\" v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.typeBroadcast\") }}</p> <md-switch :value.sync=broadcastToAll> <span slot=on>{{ $t(\"home.createPart.broadcast\") }}</span> <span slot=off>{{ $t(\"home.createPart.private\") }}</span> </md-switch> </div> <br/> <br/> <fieldset v-if=chkLesson> <legend>Datos de la lección</legend> <md-input name=nameCategory :value.sync=nameCategory v-if=chkLesson> Nombre de la categoría </md-input> <md-input name=nameLesson :value.sync=nameLesson v-if=chkLesson> Nombre de la lección </md-input> <div class=\"col s12 m4 l4 input-field\"> <select :multiple=true class=\"\" v-on:change=handleSelectChange style=display:inline;width:100%;height:auto> <option v-for=\"club in listaclubs\" :selected=isSelected(club.name)>{{ club.name }}</option> </select> </div> </fieldset> </div> </div> <span slot=footer> <div v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <md-switch class=\"left large\" :value.sync=chkLesson> <span slot=on></span> <span slot=off></span> </md-switch> <h6 class=left>{{ $t('lesson.option') }} </h6> </div> <md-button href=# :class=\"nameAnalisis.length > 0 ? 'waves-effect waves-light purple darken-4' : 'waves-effect waves-light purple darken-4 disabled'\" style=\"margin-right: 10px\" @click=createdVsPcAnalisis(true)> {{ $t(\"home.createPart.create\") }} </md-button> <span slot=footer> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'invitePCAnalisis')\"> {{ $t(\"about.close\") }} <md-icon right>cancel</md-icon> </md-button> </span> </span> </md-modal> <style scoped> .confirmInvite {  \n      background-color: #658c8c !important;\n    } </style> </div> ";

/***/ }),
/* 495 */
/***/ (function(module, exports) {

	module.exports = " <div v-on:click=OpenInputFile> <slot></slot> </div> <input style=\"display: none\" id=\"{{ id || name }}\" type=file name=\"{{ name }}\" v-bind-boolean:multiple=multiple @change=fileInputChange> ";

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */
/***/ (function(module, exports) {

	module.exports = " <div> <personal-data :user=thisuser></personal-data> </div> ";

/***/ }),
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=\"col s12 m12\"> <md-collection :key=user.name> <md-collection-item href=javascript:void(0)>{{ $t(\"account.personalData.name\") }} <md-badge>{{ user.name }} {{ user.firstName }} {{ user.lastName }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{ $t(\"account.personalData.username\") }} <md-badge class=\"\">{{ user.username }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Tipo <md-badge class=\"\">{{ user.role }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Club <md-badge class=\"\">{{ user.club }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Club1 <md-badge class=\"\">{{ user.club1 }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Club2 <md-badge class=\"\">{{ user.club2 }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>ELO <md-badge class=\"\">{{ user.elo }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Chatear <md-badge class=\"\">{{ user.chattext ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Chatear con vídeo <md-badge class=\"\">{{ user.chat ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Chatear audio <md-badge class=\"\">{{ user.chataudio ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{$t(\"game.createClass\")}} <md-badge class=\"\">{{ user.cast ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{$t(\"events.title\")}} <md-badge class=\"\">{{ user.live ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Analizar <md-badge class=\"\">{{ user.analyse ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Enviar análisis <md-badge class=\"\">{{ user.sendtoanalyse ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Descargar <md-badge class=\"\">{{ user.download ? '[x]' : '[ ]'}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{ $t(\"account.personalData.email\") }} <md-badge>{{user.email}}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{ $t(\"account.personalData.created\") }} <md-badge>{{ user.created | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{ $t(\"user.login\") }} <md-badge>{{ user.login | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>{{ $t(\"user.logout\") }} <md-badge>{{ user.logout | moment ('DD/MM/YYYY hh:mm:ss') }}</md-badge> </md-collection-item> <md-collection-item href=javascript:void(0)>Tiempo de uso <md-badge>{{ formatTime(user.time) }}</md-badge> </md-collection-item> </md-collection> </div> </div> ";

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12\" v-cloak=\"\" _v-2df52fb4=\"\"> <div class=\"col s12 m12 l8\" _v-2df52fb4=\"\"> <div class=\"col s12 m12 l12\" _v-2df52fb4=\"\"> <audio id=sound style=\"display: none\" allow=audio preload=auto controls=none _v-2df52fb4=\"\"> <source src=../../../static/sound/move.mp3 type=audio/mpeg _v-2df52fb4=\"\"> </audio> <div v-if=!isHumanVsAnalisis() _v-2df52fb4=\"\"> <blockquote class=\"chip pulse col s5 m5 l5\" style=\"text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis\" v-bind:class=\"[turn === 'white' &amp; times.white > 0 ? 'purple darken-4 userTurn' : '']\" _v-2df52fb4=\"\"> <span class=\"float: right\" _v-2df52fb4=\"\">{{ times.white | timeBoard }}</span> <b class=\"\" v-if=\"boardShow !== undefined\" _v-2df52fb4=\"\">{{ boardShow.u1 }}</b> </blockquote> <div class=\"col s2 m2 l2\" style=\"text-align: center\" _v-2df52fb4=\"\"> <h5 class=flat-text-header style=\"position: relative; top: 15px\" _v-2df52fb4=\"\">vs</h5> </div> <blockquote class=\"chip pulse col s5 m5 l5\" style=\"text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis\" v-bind:class=\"[turn === 'black' &amp; times.white > 0 ? 'purple darken-4 userTurn' : '']\" _v-2df52fb4=\"\"> <span class=\"\" style=float:right _v-2df52fb4=\"\">{{ times.black | timeBoard}}</span> <b class=\"\" _v-2df52fb4=\"\">{{ boardShow !== undefined ? boardShow.u2 : '' }}</b> </blockquote> </div> <div v-else=\"\" _v-2df52fb4=\"\"> <blockquote class=\"chip pulse col s12 m12 l12\" style=\"text-align: right\" _v-2df52fb4=\"\"> <b class=\"\" v-if=\"boardShow !== undefined &amp;&amp; boardShow.u1\" _v-2df52fb4=\"\">ANALISIS de {{ boardShow.u1 }}</b> </blockquote> </div> </div> <div class=\"col s12 m12 l12\" _v-2df52fb4=\"\"> <div id=middle class=boardmiddle _v-2df52fb4=\"\"> <div class=loadbar id=analisisVertical style=display:none _v-2df52fb4=\"\"> <strong id=myBar2 class=bar _v-2df52fb4=\"\"></strong> </div> <div id=pgnBoard style=\"width: 100%;height: 460px;float:left\" :class=classboard _v-2df52fb4=\"\"> </div> </div> </div> </div> <div class=\"col s12 m12 l4\" id=history _v-2df52fb4=\"\"> <blockquote v-if=\"!isHumanVsAnalisis() &amp;&amp; (board &amp;&amp; board.wins) || (result &amp;&amp; result.wins)\" _v-2df52fb4=\"\"> <b v-if=\"board.wins || result.wins\" _v-2df52fb4=\"\">{{ $t(\"visor.result\") }}: </b> <div class=chip _v-2df52fb4=\"\"> {{ $t(\"game.wins\") }} {{ (board.wins==='white')? 'blancas': 'negras'}} {{ $t(\"visor.by\") }} {{ (board.motiv==='rendicion')? 'rendición': ((board.motiv==='timeout')? 'tiempo': ((board.motiv==='checkmate')? 'jaque mate': board.motiv)) }} </div> </blockquote> <div id=pgnHeader _v-2df52fb4=\"\"></div> <div id=pgnComment style=display:none _v-2df52fb4=\"\"></div> <div id=pgnButtons _v-2df52fb4=\"\"></div> <div id=pgnError _v-2df52fb4=\"\"></div> <div id=pgnMovesEvents _v-2df52fb4=\"\"></div> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">PGN: </b><input id=myPGNValue v-model.lazy=myPGNValue _v-2df52fb4=\"\"></blockquote> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">PGN: </b><input id=myPGNReload v-model.lazy=myPGNReload _v-2df52fb4=\"\"></blockquote> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">TimeW: </b><input id=myPGNTimeW v-model.lazy=myPGNTimeW _v-2df52fb4=\"\"></blockquote> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">TimeB: </b><input id=myPGNTimeB v-model.lazy=myPGNTimeB _v-2df52fb4=\"\"></blockquote> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">FEN: </b><input id=myFENValue v-model.lazy=myFENValue _v-2df52fb4=\"\"></blockquote> <blockquote style=display:none _v-2df52fb4=\"\"><b class=flat-text-header _v-2df52fb4=\"\">FEN: </b><span id=myFENValueP _v-2df52fb4=\"\"></span></blockquote> <board-history v-if=validBoard :pgn=myPGNValue :fen=myFENValue :history=history :userchat=userChat :user=user :humanvspc=isHumanVsAnalisis :board=board :events=true _v-2df52fb4=\"\"></board-history> </div> </div> ";

/***/ }),
/* 503 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12\" _v-3cc9c308=\"\"> <p _v-3cc9c308=\"\"></p> <div class=\"col s12 m12 l9\" id=middle _v-3cc9c308=\"\"> <div id=puzzleBoard style=\"width: auto; height: auto\" :class=classboard _v-3cc9c308=\"\"></div> </div> <div class=\"col s12 m12 l3\" style=\"text-align: center; padding-left: 20px\" v-if=puzzle.createby _v-3cc9c308=\"\"> <div class=\"\" _v-3cc9c308=\"\"> <blockquote _v-3cc9c308=\"\"><h6 v-if=\"puzzle.type === 'Practica'\" id=eval class=\"flat-text-header hello\" style=\"text-align: center\" _v-3cc9c308=\"\"></h6></blockquote> <div id=pgnComment style=\"display: none\" _v-3cc9c308=\"\"></div> <h5 class=flat-text-header _v-3cc9c308=\"\">{{ $t(\"puzzles.played\") }}: {{ $t(\"puzzles.color.\" + turn) }}</h5> <div v-if=\"puzzle.type !== 'Practica'\" _v-3cc9c308=\"\"> <h6 class=flat-text-header _v-3cc9c308=\"\">{{ $t(\"puzzles.movs\") }}</h6> <blockquote class=\"chip pulse\" _v-3cc9c308=\"\">{{numMoves}}</blockquote> </div> <blockquote class=\"chip pulse purple darken-4\" style=\"text-align: center; font-size: small;overflow: hidden; text-overflow:ellipsis;color:white\" _v-3cc9c308=\"\"> <span class=\"\" style=\"text-align: center\" _v-3cc9c308=\"\">Faltan <b _v-3cc9c308=\"\">{{ times | timeBoard}}</b> de {{timeMove | timeBoard }}</span> </blockquote> <div v-if=\"mate &amp;&amp; numMoves===0 &amp;&amp; puzzle.type !== 'Practica'\" style=\"text-align: center\" _v-3cc9c308=\"\"> <span _v-3cc9c308=\"\"> <h3 _v-3cc9c308=\"\">{{ $t(\"puzzles.wins\") }}</h3> </span> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=nextPuzzle() _v-3cc9c308=\"\"> Siguiente </a> </div> <div v-else=\"\" _v-3cc9c308=\"\"> <span _v-3cc9c308=\"\"> <h3 _v-3cc9c308=\"\">{{ resultPractica }}</h3> </span> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=nextPuzzle() _v-3cc9c308=\"\"> Siguiente </a> </div> <div v-if=\"!mate &amp;&amp; numMoves===0 &amp;&amp; puzzle.type !== 'Practica'\" _v-3cc9c308=\"\"> <h3 _v-3cc9c308=\"\">{{ $t(\"puzzles.lost\") }}</h3> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=reintent() _v-3cc9c308=\"\"> {{ $t(\"puzzles.reintent\") }} </a> </div> <div slot=actions v-if=\"puzzle.type !== 'Practica'\" _v-3cc9c308=\"\"> Difultad: <blockquote class=\"chip pulse\" _v-3cc9c308=\"\">{{ 100 - Math.round(puzzle.corrects * 100 / puzzle.intents) }}%</blockquote> </div> <div v-if=\"numMoves !== 0 &amp;&amp; puzzle.type !== 'Practica'\" _v-3cc9c308=\"\"> <div class=row _v-3cc9c308=\"\"> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=pista() _v-3cc9c308=\"\">pista</a> </div> <div class=row _v-3cc9c308=\"\"> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=resultado() _v-3cc9c308=\"\">resultado</a> </div> </div> </div> </div> </div> ";

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	module.exports = " <div id=ia-middlesmall style=\"margin-bottom: 5px\" _v-3f36baac=\"\"> <div id=ia-pgnHeader _v-3f36baac=\"\"></div> <div id=ia-pgnButtons _v-3f36baac=\"\"></div> <div id=ia-pgnError _v-3f36baac=\"\"></div> <p _v-3f36baac=\"\"></p> <div id=ia-boardsmall style=\"width:100%; height:60px\" :class=classboard _v-3f36baac=\"\"> </div> <div id=pgnMovesIA _v-3f36baac=\"\"></div> </div> ";

/***/ }),
/* 505 */
/***/ (function(module, exports) {

	module.exports = " <div id=\"{{game._id ? game._id:game.id}}-middlesmall\" style=\"margin-bottom: 5px\" _v-6356f3a3=\"\"> <div id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:60px\" :class=classboard _v-6356f3a3=\"\"> </div> </div> ";

/***/ }),
/* 506 */
/***/ (function(module, exports) {

	module.exports = " <div _v-6a9def76=\"\"> <div class=\"s12 m12 l12\" _v-6a9def76=\"\"> <div id=overlay style=\"display:none; position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); z-index:5000; justify-content: center; align-items: center\" _v-6a9def76=\"\"> <div style=\"text-align: center; font-size: 24px; color: white\" _v-6a9def76=\"\">Consultando a la IA...</div> </div> </div> <md-modal id=modalCompartir class=modal-fixed-footer _v-6a9def76=\"\"> <h4 style=\"text-align: center\" _v-6a9def76=\"\">Compartir</h4> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div style=\"text-align: left\" _v-6a9def76=\"\"> <blockquote class=chip _v-6a9def76=\"\">PGN</blockquote> <p _v-6a9def76=\"\"> <span _v-6a9def76=\"\">{{ pgn }}</span> </p> <blockquote class=chip _v-6a9def76=\"\">FEN</blockquote> <p _v-6a9def76=\"\"> <span _v-6a9def76=\"\">{{ fen }}</span> </p> <blockquote class=chip _v-6a9def76=\"\">IFRAME</blockquote> <p _v-6a9def76=\"\"> <span _v-6a9def76=\"\">&lt;iframe src=\"{{ dirServer + '/#!/visor/0/0/only/' + board._id }}\" allow=\"camera;microphone;\" style=\"width: 1024px; height: 768px; transform: scale(0.5); transform-origin: 0 0; border: 0;\"&gt;&lt;/iframe&gt;</span> </p> <p _v-6a9def76=\"\"> <span _v-6a9def76=\"\"><iframe :src=\"dirServer + '/#!/visor/0/0/only/' + board._id\" allow=camera;microphone; style=\"width: 1024px; height: 768px; transform: scale(0.5); transform-origin: 0 0; border: 0\" _v-6a9def76=\"\"></iframe></span> </p> </div> </div> <span slot=footer left=\"\" _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'modalCompartir')\" _v-6a9def76=\"\"> Cerrar </md-button> </span> </md-modal> <md-modal id=modalIA class=modal-fixed-footer _v-6a9def76=\"\"> <select class=\"\" style=display:inline;width:100% v-model.lazy=listaVocesSelected _v-6a9def76=\"\"> <option v-for=\"voz in listaVoces\" :selected=isSelectedVoice(voz) v-bind:key=isSelectedVoice(voz) _v-6a9def76=\"\">{{ voz }}</option> </select> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div class=\"col s2 m10 l2\" _v-6a9def76=\"\"> <div class=bot-container _v-6a9def76=\"\"> <svg id=botSVG class=bot viewBox=\"0 0 300 500\" _v-6a9def76=\"\"> <rect x=50 y=50 width=100 height=100 rx=20 ry=20 fill=#c0c0c0 stroke=#5c005c stroke-width=2 _v-6a9def76=\"\"></rect> <line x1=100 y1=35 x2=100 y2=50 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <circle cx=100 cy=30 r=5 fill=#5c005c stroke=#000 stroke-width=2 _v-6a9def76=\"\"></circle> <rect id=leftEyebrow x=65 y=65 width=20 height=5 fill=#5c005c _v-6a9def76=\"\"></rect> <rect id=rightEyebrow x=115 y=65 width=20 height=5 fill=#5c005c _v-6a9def76=\"\"></rect> <circle id=leftEye cx=75 cy=85 r=8 fill=#fff stroke=#000 stroke-width=2 _v-6a9def76=\"\"></circle> <circle id=rightEye cx=125 cy=85 r=8 fill=#fff stroke=#000 stroke-width=2 _v-6a9def76=\"\"></circle> <circle id=leftPupil cx=75 cy=85 r=3 fill=#5c005c _v-6a9def76=\"\"></circle> <circle id=rightPupil cx=125 cy=85 r=3 fill=#5c005c _v-6a9def76=\"\"></circle> <rect x=40 y=80 width=10 height=30 fill=#c0c0c0 stroke=#5c005c stroke-width=2 _v-6a9def76=\"\"></rect> <rect x=150 y=80 width=10 height=30 fill=#c0c0c0 stroke=#5c005c stroke-width=2 _v-6a9def76=\"\"></rect> <rect x=90 y=150 width=20 height=15 fill=#5c005c _v-6a9def76=\"\"></rect> <rect x=60 y=165 width=80 height=100 fill=#d3d3d3 stroke=#5c005c stroke-width=2 _v-6a9def76=\"\"></rect> <rect x=80 y=185 width=40 height=50 fill=#9ec7e1 stroke=#5c005c stroke-width=2 _v-6a9def76=\"\"></rect> <line id=leftUpperArm x1=60 y1=180 x2=30 y2=210 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <line id=leftLowerArm x1=30 y1=210 x2=15 y2=250 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <line id=rightUpperArm x1=140 y1=180 x2=170 y2=210 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <line id=rightLowerArm x1=170 y1=210 x2=185 y2=250 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <circle cx=15 cy=250 r=8 fill=#5c005c stroke=#000 stroke-width=2 _v-6a9def76=\"\"></circle> <circle cx=185 cy=250 r=8 fill=#5c005c stroke=#000 stroke-width=2 _v-6a9def76=\"\"></circle> <line x1=90 y1=265 x2=90 y2=320 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <line x1=110 y1=265 x2=110 y2=320 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <circle cx=90 cy=320 r=5 fill=#000 _v-6a9def76=\"\"></circle> <circle cx=110 cy=320 r=5 fill=#000 _v-6a9def76=\"\"></circle> <line x1=90 y1=320 x2=90 y2=360 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <line x1=110 y1=320 x2=110 y2=360 stroke=#5c005c stroke-width=3 _v-6a9def76=\"\"></line> <rect x=80 y=360 width=20 height=10 fill=#5c005c _v-6a9def76=\"\"></rect> <rect x=100 y=360 width=20 height=10 fill=#5c005c _v-6a9def76=\"\"></rect> <path id=mouth1 d=\"M 80 120 Q 100 135 120 120\" fill=none stroke=#000 stroke-width=3 _v-6a9def76=\"\"></path> <path id=mouth2 d=\"M 80 120 Q 100 145 120 120 Q 100 135 80 120 Z\" fill=#000 style=\"opacity: 0\" _v-6a9def76=\"\"></path> <ellipse id=mouth3 cx=100 cy=130 rx=15 ry=10 fill=#000 style=\"opacity: 0\" _v-6a9def76=\"\"></ellipse> <ellipse id=tongue cx=100 cy=135 rx=8 ry=4 fill=#5c005c style=\"opacity: 0\" _v-6a9def76=\"\"></ellipse> <path id=mouth4 d=\"M 70 120 Q 100 155 130 120 Q 100 135 70 120 Z\" fill=#000 style=\"opacity: 0\" _v-6a9def76=\"\"></path> <path id=tongue4 d=\"M 85 130 Q 100 150 115 130\" fill=#5c005c style=\"opacity: 0\" _v-6a9def76=\"\"></path> </svg> </div> </div> <div class=\"col s10 m10 l7\" _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div class=\"ps-container ps-theme-default ps-active-y\" id=chat-content style=\"overflow-y:auto !important; height: 50vh !important\" _v-6a9def76=\"\"> <div class=ps-scrollbar-x-rail style=\"left: 0px; bottom: 0px\" _v-6a9def76=\"\"> <div class=ps-scrollbar-x tabindex=0 style=\"left: 0px; width: 0px\" _v-6a9def76=\"\"></div> </div> <div class=ps-scrollbar-y-rail style=\"top: 0px; height: 0px; right: 2px\" _v-6a9def76=\"\"> <div class=ps-scrollbar-y tabindex=0 style=\"top: 0px; height: 2px\" _v-6a9def76=\"\"></div> </div> </div> </div> <div class=row _v-6a9def76=\"\"> <div class=\"border col s12 m12 l9\" _v-6a9def76=\"\"> <div style=\"text-align: left\" _v-6a9def76=\"\"> <textarea style=\"\" id=aiquestion @keydown.enter=preguntaAI() _v-6a9def76=\"\"></textarea> </div> </div> <div class=\"col s12 m12 l1\" _v-6a9def76=\"\"> <div style=\"text-align: right\" _v-6a9def76=\"\"> <md-button class=\"btn-floating waves-effect waves-light purple darken-4\" style=\"margin-top: 20px\" @click=preguntaAI() _v-6a9def76=\"\"> <span class=material-symbols-outlined _v-6a9def76=\"\">question_mark</span> </md-button> </div> </div> <div class=\"col s12 m12 l1\" _v-6a9def76=\"\"> <div style=\"text-align: right\" _v-6a9def76=\"\"> <md-button class=\"btn-floating waves-effect waves-light purple darken-4\" style=\"margin-top: 20px\" @click=setTextToSpeach() _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\"> {{ varTextToSpeach === true? 'volume_up' : 'volume_off' }} </md-icon> </md-button> </div> </div> </div> </div> <div class=\"col s12 m12 l3\" _v-6a9def76=\"\"> <p _v-6a9def76=\"\"></p> <board-visor-ia :game=board id=ia-board :classboard=classBoard :pgn=pgn _v-6a9def76=\"\"></board-visor-ia> </div> </div> <span slot=footer left=\"\" _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=closeModalIA() _v-6a9def76=\"\"> Cerrar </md-button> <md-button class=\"waves-effect waves-light purple darken-3\" style=\"margin-right: 10px\" @click=analizaAI() _v-6a9def76=\"\"> Analisis profundo </md-button> <md-button id=btnStart class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=startRecording() _v-6a9def76=\"\"> <span id=counterDown v-if=\"timeLeft > 0\" _v-6a9def76=\"\">{{timeLeft}}&nbsp;&nbsp;</span><i class=\"fa fa-microphone\" _v-6a9def76=\"\"></i> </md-button> </span> </md-modal> <md-modal id=analisys class=modal-fixed-footer _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div style=\"text-align: center\" _v-6a9def76=\"\"> <iframe id=iFrameAnalisys width=600px src=./static/analisys/analisys.html sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" frameborder=0 onload=\"this.style.height=(this.contentWindow.document.body.scrollHeight+40)+'px';\" _v-6a9def76=\"\"></iframe> </div> </div> <span slot=footer left=\"\" _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=closeAnalisis() _v-6a9def76=\"\"> Cerrar </md-button> </span> </md-modal> <md-modal id=setFen class=modal-fixed-footer _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div style=\"text-align: center\" _v-6a9def76=\"\"> <iframe id=iFramePosition sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" width=100% src=./static/libs/cm-fen-editor-main/index.html frameborder=0 _v-6a9def76=\"\"></iframe> </div> </div> <span slot=footer left=\"\" _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'setFen')\" _v-6a9def76=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-6a9def76=\"\">cancel</md-icon> </md-button> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=setFenPosition() _v-6a9def76=\"\"> {{ $t(\"game.accept\") }} </md-button> </span> </md-modal> <md-modal id=setResource class=modal-fixed-footer _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <div class=row _v-6a9def76=\"\"> <div class=section _v-6a9def76=\"\"> <md-input name=search :value.sync=strNameResource _v-6a9def76=\"\"> Nombre </md-input> </div> <legend _v-6a9def76=\"\">Opciones:</legend> <fieldset _v-6a9def76=\"\"> <md-input name=search :value.sync=urlLinkUpload _v-6a9def76=\"\"> URL completa (https://...) </md-input> <md-button :class=\"urlLinkUpload.length > 0 &amp;&amp; strNameResource.length > 0  ? 'purple darken-4' : 'disabled purple darken-4'\" style=\"margin-right: 10px\" @click=setLinkUpload() _v-6a9def76=\"\"> Añadir URL </md-button> <p _v-6a9def76=\"\">Subir un archivo (PGN, JPG, PGN, PDF, ...)</p> <div style=\"text-align: center\" _v-6a9def76=\"\"> <label style=\"position: relative;float: right\" v-if=!allFilesUploaded _v-6a9def76=\"\">{{ fileProgress }}</label> <upload-files-lesson :value.sync=filesUploadHistory name=filesLesson multiple=\"\" :action=dirActionUpload maxsize=110MB pathpermit=|jpeg|mp4|zip|rar|png|pgn|pdf|doc|docx|ppt|pptx|webm|txt _v-6a9def76=\"\"> <a :class=\"strNameResource.length > 0  ? 'btn waves-effect waves-light col s3 m3 l3 purple darken-4' : 'disabled btn waves-effect waves-light col s3 m3 l3 purple darken-4'\" data-tooltip=\"Compartir archivo\" _v-6a9def76=\"\"> {{ $t(\"home.upload\") }} </a> </upload-files-lesson> </div> </fieldset> </div> </div> <span slot=footer _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'setResource')\" _v-6a9def76=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-6a9def76=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=setData class=modal-fixed-footer _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <form id=insertValues style=\"text-align: left\" _v-6a9def76=\"\"> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <md-input name=eventoFen :value.sync=fenEvento placeholder=\"Festival de Salamanca\" _v-6a9def76=\"\">Evento</md-input> <md-input name=lugarFen :value.sync=fenLugar placeholder=Salamanca _v-6a9def76=\"\">Lugar</md-input> <md-input name=fechaFen :value.sync=fenFecha placeholder=13.10.2020 _v-6a9def76=\"\">Fecha</md-input> <md-input name=rondaFen :value.sync=fenRonda placeholder=1 _v-6a9def76=\"\">Ronda</md-input> <md-input name=resultadoFen :value.sync=fenResultado placeholder=1/2-1/2 _v-6a9def76=\"\">Resultado</md-input> <md-input name=blancasFen :value.sync=fenBlancas placeholder=Iturrizaga _v-6a9def76=\"\">Blancas</md-input> <md-input name=negrasFen :value.sync=fenNegras placeholder=Topalov _v-6a9def76=\"\">Negras</md-input> </div> </form> </div> <span slot=footer _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=setDataPosition() _v-6a9def76=\"\"> Aceptar </md-button> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'setData')\" _v-6a9def76=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-6a9def76=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=setFields class=modal-fixed-footer _v-6a9def76=\"\"> <h4 style=\"text-align: center\" _v-6a9def76=\"\">Modificar campos de la partida</h4> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <form id=insertValues style=\"text-align: left\" _v-6a9def76=\"\"> <md-input name=nameAnalysis :value.sync=nameAnalysis _v-6a9def76=\"\"> Nombre del aula </md-input> <fieldset _v-6a9def76=\"\"> <legend _v-6a9def76=\"\">Datos de la lección</legend> <md-input name=typeLesson :value.sync=typeLesson _v-6a9def76=\"\"> Tipo de la lección </md-input> <md-input name=nameCategory :value.sync=nameCategory _v-6a9def76=\"\"> Nombre de la categoría </md-input> <md-input name=nameLesson :value.sync=nameLesson _v-6a9def76=\"\"> Nombre de la lección </md-input> <div class=\"col s12 m12 l12 input-field\" _v-6a9def76=\"\"> <select multiple=\"\" class=\"\" v-on:change=handleSelectChange style=display:inline;width:100%;height:200px _v-6a9def76=\"\"> <option v-for=\"club in listaclubs\" :selected=isSelected(club.name) v-bind:key=isSelected(club.name) _v-6a9def76=\"\">{{ club.name }}</option> </select> </div> </fieldset> </form> </div> <span slot=footer _v-6a9def76=\"\"> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=setDataFields() _v-6a9def76=\"\"> Aceptar </md-button> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'setFields')\" _v-6a9def76=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-6a9def76=\"\">cancel</md-icon> </md-button> </span> </md-modal> <div class=\"col s12 m12 l12\" _v-6a9def76=\"\"> <md-button data-tooltip=Analizar v-if=\"!active &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher' || user.analyse) || ($route &amp;&amp; $route.name === 'visor')\" class=\"btn-floating purple darken-4\" @click=openModal(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">computer</md-icon> </md-button> <md-button data-tooltip=\"Analizar partida\" v-if=\"!active &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher' || user.analyse)\" class=\"btn-floating purple darken-4\" @click=openModalGraph(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">show_chart</md-icon> </md-button> <md-button data-tooltip=\"Analizar posición\" v-if=\"!active &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher' || user.analyse)\" class=\"btn-floating purple darken-4\" @click=openModalGraphFEN(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">explore</md-icon> </md-button> <md-button data-tooltip=Descargar v-if=\"isParamOnly === false &amp;&amp; (!active &amp;&amp; (user.download || ($route &amp;&amp; $route.name === 'visor')))\" class=\"btn-floating btn-flat purple darken-4\" @click=downloadPGN(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">file_download</md-icon> </md-button> <md-button data-tooltip=\"Crear posición\" v-if=\"humanvspc() &amp;&amp; isOwner() &amp;&amp; ($route &amp;&amp; $route.name === 'game')\" class=\"btn-floating btn-flat purple darken-4\" @click=setFen(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">build</md-icon> </md-button> <md-button data-tooltip=\"Editar datos de la partida\" v-if=\"humanvspc() &amp;&amp; isOwner() &amp;&amp; ($route &amp;&amp; $route.name === 'game')\" class=\"btn-floating btn-flat purple darken-4\" @click=setData(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">mode_edit</md-icon> </md-button> <md-button data-tooltip=\"Editar campos\" v-if=\"humanvspc() &amp;&amp; isOwner() &amp;&amp; ($route &amp;&amp; $route.name === 'game') &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" class=\"btn-floating btn-flat purple darken-4\" @click=setFields() _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">text_fields</md-icon> </md-button> <md-button data-tooltip=\"Cambiar permisos\" v-if=\"($route &amp;&amp; $route.name === 'game') &amp;&amp; humanvspc() &amp;&amp; isOwner() &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" class=\"btn-floating btn-flat purple darken-4\" @click=sendPermisionToSend() _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">send</md-icon> </md-button> <md-button data-tooltip=\"Enviar línea\" v-if=\"(sendtoteacher) &amp;&amp; humanvspc() &amp;&amp; !isOwner() &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" class=\"btn-floating btn-flat purple darken-4\" @click=sendPGNtoTeacher() _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">send</md-icon> </md-button> <md-button v-if=\"humanvspc() &amp;&amp; isOwner() &amp;&amp; ($route &amp;&amp; $route.name === 'game')\" data-tooltip=\"Añadir recurso a la posición\" class=\"btn-floating btn-flat purple darken-4\" @click=setResource(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">attach_file</md-icon> </md-button> <md-button data-tooltip=\"Compartir datos de la partida\" class=\"btn-floating btn-flat purple darken-4\" v-if=\"isParamOnly === false &amp;&amp; (fen.length &amp;&amp; !active)\" @click=showShare(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">share</md-icon> </md-button> <md-button data-tooltip=\"Inteligencia Artificial\" v-if=\"isParamOnly || (fen.length &amp;&amp; pgn.length &amp;&amp; !active)\" class=\"btn-floating btn-flat purple darken-3\" @click=showIA(); _v-6a9def76=\"\"> <span class=spanAsIcon _v-6a9def76=\"\">IA</span> </md-button> <md-button data-tooltip=\"Insertar comentarios en la posición (IA)\" class=\"btn-floating btn-flat purple darken-3\" v-if=\"isParamOnly || (fen.length &amp;&amp; pgn.length &amp;&amp; !active)\" @click=insertComments(); _v-6a9def76=\"\"> <i class=\"fa fa-comment\" aria-hidden=true _v-6a9def76=\"\"></i> </md-button> <md-button data-tooltip=\"Insertar comentarios en la partida (IA)\" v-if=\"(user.role === 'Admin' || user.role === 'Teacher') &amp;&amp; isevents() === false &amp;&amp; (isParamOnly || (fen.length &amp;&amp; pgn.length &amp;&amp; !active))\" class=\"btn-floating btn-flat purple darken-3\" @click=commentAI(); _v-6a9def76=\"\"> <i class=\"fa fa-comments\" aria-hidden=true _v-6a9def76=\"\"></i> </md-button> <div style=display:none _v-6a9def76=\"\"><b class=flat-text-header _v-6a9def76=\"\">Voz: </b><input id=myVoiceSelected v-model.lazy=myVoiceSelected _v-6a9def76=\"\"></div> <md-button data-tooltip=\"Actualizar datos de la partida\" class=\"btn-floating btn-flat purple darken-4\" v-if=\"(user.role === 'Admin' || user.role === 'Teacher') &amp;&amp; humanvspc() &amp;&amp; isOwner() &amp;&amp; ($route &amp;&amp; $route.name === 'game')\" @click=updateData(); _v-6a9def76=\"\"> <md-icon _v-6a9def76=\"\">update</md-icon> </md-button> </div> <div _v-6a9def76=\"\"> <div id=analisisModal style=display:none;z-index:-100 _v-6a9def76=\"\"> <div id=fen style=display:none _v-6a9def76=\"\">{{ fen }}</div> <div id=container style=z-index:-100 _v-6a9def76=\"\"> <div id=searchWrapper style=display:none _v-6a9def76=\"\"> <form id=simpleSearch _v-6a9def76=\"\"> <input name=search placeholder=\"Enter FEN, PGN or command\" id=searchInput type=search value=\"{{ pgn }}\" _v-6a9def76=\"\"> <div id=buttonGo data-tooltip=\"Load FEN, PGN or command\" style=display:none _v-6a9def76=\"\"></div> </form> </div> <div id=buttonBack style=display:none class=off data-tooltip=\"Go back\" _v-6a9def76=\"\"></div> <div id=buttonForward style=display:none class=off data-tooltip=\"Go forward\" _v-6a9def76=\"\"></div> <div id=buttonRefresh style=display:none class=off data-tooltip=Refresh _v-6a9def76=\"\"></div> <div id=buttonRevert style=display:none class=off data-tooltip=\"Revert changes\" _v-6a9def76=\"\"></div> <div id=buttonWindow style=display:none class=off data-tooltip=\"Open in new window\" _v-6a9def76=\"\"></div> <div id=buttonEdit style=display:none class=on data-tooltip=\"Edit mode\" _v-6a9def76=\"\"></div> <div id=buttonMenu style=display:none class=on data-tooltip=Menu _v-6a9def76=\"\"></div> <div id=buttonInfo style=display:none class=on data-tooltip=Info _v-6a9def76=\"\"></div> <div id=boardWrapper style=display:none _v-6a9def76=\"\"> <table id=cbTable _v-6a9def76=\"\"><tbody _v-6a9def76=\"\"> <tr _v-6a9def76=\"\"><td _v-6a9def76=\"\"></td><td _v-6a9def76=\"\">a</td><td _v-6a9def76=\"\">b</td><td _v-6a9def76=\"\">c</td><td _v-6a9def76=\"\">d</td><td _v-6a9def76=\"\">e</td><td _v-6a9def76=\"\">f</td><td _v-6a9def76=\"\">g</td><td _v-6a9def76=\"\">h</td><td _v-6a9def76=\"\"><div id=buttonStm class=white data-tooltip=\"Change side to move\" _v-6a9def76=\"\"><div _v-6a9def76=\"\"></div></div></td></tr> <tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">8</td><td colspan=8 rowspan=8 class=cbCell _v-6a9def76=\"\"><div id=chessboard1 class=cb _v-6a9def76=\"\"></div></td><td _v-6a9def76=\"\">8</td></tr> <tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">7</td><td _v-6a9def76=\"\">7</td></tr><tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">6</td><td _v-6a9def76=\"\">6</td></tr><tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">5</td><td _v-6a9def76=\"\">5</td></tr><tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">4</td><td _v-6a9def76=\"\">4</td></tr> <tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">3</td><td _v-6a9def76=\"\">3</td></tr><tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">2</td><td _v-6a9def76=\"\">2</td></tr><tr _v-6a9def76=\"\"><td _v-6a9def76=\"\">1</td><td _v-6a9def76=\"\">1</td></tr> <tr _v-6a9def76=\"\"><td _v-6a9def76=\"\"></td><td _v-6a9def76=\"\">a</td><td _v-6a9def76=\"\">b</td><td _v-6a9def76=\"\">c</td><td _v-6a9def76=\"\">d</td><td _v-6a9def76=\"\">e</td><td _v-6a9def76=\"\">f</td><td _v-6a9def76=\"\">g</td><td _v-6a9def76=\"\">h</td><td _v-6a9def76=\"\"><div id=buttonFlip data-tooltip=\"Flip board\" _v-6a9def76=\"\"></div></td></tr> </tbody></table> </div> <div id=moves _v-6a9def76=\"\"></div> <div id=infoWrapper style=display:none _v-6a9def76=\"\"><div _v-6a9def76=\"\"> <div id=infoBtn1 class=\"infoIcon selected\" style=\"display:none;right: 22px;bottom:0px\" _v-6a9def76=\"\"></div> <div id=infoBtn2 class=infoIcon style=\"display:none;right: 0px;bottom:0px\" _v-6a9def76=\"\"></div> <div id=infoContent style=display:none _v-6a9def76=\"\"></div> </div> </div> <div id=graphWrapper style=display:none _v-6a9def76=\"\"><canvas id=graph _v-6a9def76=\"\">Your browser does not support the HTML5 canvas tag.</canvas></div> <div id=menu style=display:none _v-6a9def76=\"\"></div> <div id=status style=display:none _v-6a9def76=\"\"></div> </div> <div class=\"col s12 m12 l12\" style=\"display: inline-flex;margin-top: 20px\" _v-6a9def76=\"\"> <div class=negras style=\"background: black;padding: 10px;flex: auto;margin-right: 5px\" _v-6a9def76=\"\"></div> <div id=myProgress class=\"\" _v-6a9def76=\"\"> <div id=myBar _v-6a9def76=\"\">{{ eval }}</div> </div> <div class=blancas style=\"background: white;padding: 10px;flex: auto;margin-left: 5px\" _v-6a9def76=\"\"></div> </div> </div> </div> </div> ";

/***/ }),
/* 507 */
/***/ (function(module, exports) {

	module.exports = " <div v-if=\"game.result === undefined || game.result === '*' || game.all === 'true' || game.broadcast === 'true'\" id={{game._id}}-middlesmall :class=turnSmall _v-6d38887a=\"\"> <div id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:170px\" :class=classboard _v-6d38887a=\"\"> </div> </div> <div v-else=\"\" id=\"{{game._id ? game._id:game.id}}-middlesmall\" style=\"\" :class=turnSmall _v-6d38887a=\"\"> <div id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:170px\" :class=classboard _v-6d38887a=\"\"> </div> <div class=resultevents id=\"{{game._id ? game._id:game.id}}-imagesmall\" style=\"width:170px; height:70px\" _v-6d38887a=\"\"> <span class=\"\" _v-6d38887a=\"\">{{ game.result }}</span> </div> </div> ";

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = " <div class=containersmall _v-6e0ee410=\"\"> <div id=\"{{game._id ? game._id:game.id}}-middlesmall\" :class=turnSmall _v-6e0ee410=\"\"> <div @click=\"showBoard(game, true)\" id=\"{{game._id ? game._id:game.id}}-boardsmall\" style=\"width:100%; height:170px\" :class=classboard _v-6e0ee410=\"\"></div> </div> <div class=overlay @click=\"showBoard(game, false)\" _v-6e0ee410=\"\"> <span class=\"col s12 m12 l12 valign-wrapper\" v-if=\"game.u1 !== game.u2\" _v-6e0ee410=\"\"> <md-icon _v-6e0ee410=\"\">people</md-icon> &nbsp;{{ game.u1 }} <b _v-6e0ee410=\"\">&nbsp;VS&nbsp;</b> {{ game.u2 }}&nbsp; <span v-if=\"game.torneo &amp;&amp; game.torneo.length > 0\" _v-6e0ee410=\"\">{{ game.torneo }} ({{ game.ronda }})</span> </span> <span class=\"col s12 m12 l12 valign-wrapper\" v-if=\"game.u1 === game.u2\" _v-6e0ee410=\"\"> <md-icon _v-6e0ee410=\"\">cast</md-icon> &nbsp;<b _v-6e0ee410=\"\">{{ game.name }}</b>&nbsp;({{ game.u1 }})&nbsp; </span> </div> </div> ";

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	module.exports = " <div _v-7b8e6bca=\"\"> <div style=\"top: 30px; left:10px !important;bottom: auto !important\" class=\"fixed-action-btn vertical\" _v-7b8e6bca=\"\"> <div _v-7b8e6bca=\"\"> <a class=\"btn-large blue darken-4\" @click=\"this.$broadcast('modal::open', 'events')\" _v-7b8e6bca=\"\"> <span style=\"vertical-align: top\" _v-7b8e6bca=\"\">Noticias</span> <i class=material-icons _v-7b8e6bca=\"\">menu</i> </a> </div> </div> <div style=\"top: 30px; right: 10px; bottom: auto !important\" class=\"fixed-action-btn vertical\" _v-7b8e6bca=\"\"> <div _v-7b8e6bca=\"\"> <a class=\"btn-large green darken-4\" _v-7b8e6bca=\"\"> <span style=\"vertical-align: top\" _v-7b8e6bca=\"\">{{ $t(\"login.links\") }}</span> <i class=material-icons _v-7b8e6bca=\"\">menu</i> </a> </div> <ul style=\"bottom: auto !important\" _v-7b8e6bca=\"\"> <li _v-7b8e6bca=\"\"><a href=https://academiadeajedrez.es target=_blank class=\"btn-floating btn-large blue darken-4\" style=\"right: 20px; vertical-align: top;width: 160px; height: 25px\" _v-7b8e6bca=\"\"><span style=\"vertical-align: top\" _v-7b8e6bca=\"\">Academia de ajedrez</span></a></li> <li _v-7b8e6bca=\"\"><a href=https://festival.mainchess.com target=_blank class=\"btn-floating btn-large purple darken-4\" style=\"right: 20px; vertical-align: top;width: 160px; height: 25px\" @click=openVideoSave() _v-7b8e6bca=\"\"><span style=\"vertical-align: top\" _v-7b8e6bca=\"\">Festival</span></a></li> <li _v-7b8e6bca=\"\"><a href=https://salamancaajedrez.com target=_blank class=\"btn-floating btn-large green darken-4\" style=\"right: 20px; vertical-align: top;width: 160px; height: 25px\" @click=openVideoSave() _v-7b8e6bca=\"\"><span style=\"vertical-align: top\" _v-7b8e6bca=\"\">Salamanca ajedrez</span></a></li> </ul> </div> <div class=\"loguinForm center\" _v-7b8e6bca=\"\"> <div class=\"col s12 m12 l12 card-panel center\" _v-7b8e6bca=\"\"> <p class=version _v-7b8e6bca=\"\">V. {{ convertirFechaAVersion(buildDate) }}</p> <p _v-7b8e6bca=\"\"></p> <div id=stripped class=\"\" _v-7b8e6bca=\"\"> <svg xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 971 1069\" _v-7b8e6bca=\"\"> <polyline points=\"0,154 131,0 0,348 269,0 0,562 437,0 \n                0,766 565,14 0,1062 719,0 289,1062 843,0 543,1062 995,0 729,1062 1161,0 947,1062 1307,0 1143,1062 1500,162 1299,1062 1500,830\" _v-7b8e6bca=\"\"></polyline> </svg> </div> <form id=loginForm v-on:submit.prevent=userloguin() _v-7b8e6bca=\"\"> <b v-if=\"error!==''\" _v-7b8e6bca=\"\">{{ $t(\"login.errors.\"+error) }}</b> <div class=row _v-7b8e6bca=\"\"> <md-input style=\"z-index: 9\" class=\"input-field col s11 l12\" name=username :value.sync=user.username _v-7b8e6bca=\"\"> {{ $t(\"login.username\") }} <template slot=icon-name>account_circle</template> </md-input> <md-input style=\"z-index: 9\" class=\"input-field col s11 l12\" type=password name=password :value.sync=user.password _v-7b8e6bca=\"\"> {{ $t(\"login.password\") }} <template slot=icon-name>lock</template> </md-input> <md-input style=\"z-index: 9\" class=\"input-field col s9 l10 m9\" name=cpatchaTextBox :value.sync=cpatchaTextBox _v-7b8e6bca=\"\"> Capcha <template slot=icon-name>spellcheck</template> </md-input> <span id=captcha class=\"input-field col s2 l2 m2\" _v-7b8e6bca=\"\"></span> <div class=\"input-field col s12 l12\" _v-7b8e6bca=\"\"> <md-btn id=loginbtn class=\"btn waves-effect waves-light col s12 l12 purple darken-4 middle\" type=submit _v-7b8e6bca=\"\"> {{ $t(\"login.title\") }} </md-btn> </div> </div> <div class=\"input-field col s12\" style=\"margin-top: auto\" _v-7b8e6bca=\"\"> <a style=\"font-size: small; color: #5c005c !important\" @click.prevent=newaccount() v-link=\"{name: 'register'}\" _v-7b8e6bca=\"\">{{ $t(\"login.createaccount\") }}</a> </div> <div class=\"input-field col s12\" style=\"margin-top: auto;padding: 10px\" _v-7b8e6bca=\"\"> <a style=\"font-size: small; color: #5c005c !important\" @click.prevent=guest() v-link=\"{name: 'guest'}\" _v-7b8e6bca=\"\">{{ $t(\"login.createguest\") }}</a> </div> <div v-if=\"debug === true\" _v-7b8e6bca=\"\"> <md-button v-for=\"usertest in usertests\" class=\"waves-effect waves-light purple darken-4\" v-bind:key=usertest style=\"margin-right: 10px\" @click=\"userloguinTest({username: usertest, password: 'password', club:'General'})\" _v-7b8e6bca=\"\"> {{ usertest }} </md-button> </div> </form> <blockquote class=chip _v-7b8e6bca=\"\"> <a class=\"\" href=mailto:info@mainchess.com _v-7b8e6bca=\"\"> info@mainchess.com </a> </blockquote> <hr style=height:2px;border-width:0;color:gray;background-color:#5c005c;margin:0 _v-7b8e6bca=\"\"> <div style=\"height: auto\" _v-7b8e6bca=\"\"> <span style=\"font-size: small\" _v-7b8e6bca=\"\"><b _v-7b8e6bca=\"\">{{ getNum().countUsers }}</b> usuarios, </span> <span style=\"font-size: small\" _v-7b8e6bca=\"\"><b _v-7b8e6bca=\"\">{{ getNum().countBoards }}</b> partidas y lecciones, </span> <span style=\"font-size: small\" _v-7b8e6bca=\"\"><b _v-7b8e6bca=\"\">{{ getNum().countPuzles }}</b> ejercicios y </span> <span style=\"font-size: small\" _v-7b8e6bca=\"\"><b _v-7b8e6bca=\"\">{{ getNum().countClubs }}</b> clubs en la plataforma </span> </div> </div> </div> <md-modal id=events bottom=\"\" class=\"\" _v-7b8e6bca=\"\"> <h3 class=header _v-7b8e6bca=\"\">Noticias</h3> <ul class=collection _v-7b8e6bca=\"\"> <li v-for=\"noticia in noticias\" :key=noticia.titulo class=\"center-align hoverable collection-item avatar\" _v-7b8e6bca=\"\"> <img v-if=noticia.imagen :src=noticia.imagen alt=img-responsive class=responsive-img style=\"max-width: 600px\" _v-7b8e6bca=\"\"> <i v-else=\"\" class=material-icons _v-7b8e6bca=\"\">info</i> <p _v-7b8e6bca=\"\"></p> <span class=title _v-7b8e6bca=\"\">{{ noticia.titulo }}</span> <p _v-7b8e6bca=\"\"> {{ noticia.descripcion }} <br _v-7b8e6bca=\"\"> <a v-if=noticia.link :href=noticia.link target=_blank class=\"btn waves-effect waves-light btn-small\" _v-7b8e6bca=\"\">ENLACE</a> </p> <a href=#! class=secondary-content _v-7b8e6bca=\"\"> <i class=material-icons _v-7b8e6bca=\"\">grade</i> </a> </li> </ul> </md-modal> <md-modal id=loadClub class=modal-fixed-footer _v-7b8e6bca=\"\"> <blockquote _v-7b8e6bca=\"\"><h4 _v-7b8e6bca=\"\">Seleccione la sala en la que quiere participar:</h4></blockquote> <md-radio-group group=rolegroup _v-7b8e6bca=\"\"> <div class=\"col s12 m4 l4\" _v-7b8e6bca=\"\"> <md-radio v-if=user.club :value.sync=newClub class=\"with-gap col\" :radio-value=user.club style=\"float: inherit; padding:20px\" _v-7b8e6bca=\"\"> <div class=row style=\"display: inline-table\" _v-7b8e6bca=\"\"> <div class=\"col s12 m12\" _v-7b8e6bca=\"\"> <div class=card _v-7b8e6bca=\"\"> <div class=card-image _v-7b8e6bca=\"\"> <img class=img-responsive v-bind:src=user.imagesclub[0] alt=\"\" @error=imageUrlAlt _v-7b8e6bca=\"\"> </div> <div class=card-content _v-7b8e6bca=\"\"> <span class=card-title _v-7b8e6bca=\"\">{{ user.club }}</span> <a v-show=user.linkclub[0] class=\"right btn-floating halfway-fab waves-effect waves-light red\" :href=user.linkclub[0] target=_blank _v-7b8e6bca=\"\"><i class=material-icons _v-7b8e6bca=\"\">add</i></a> <p _v-7b8e6bca=\"\">{{ user.descripcionclub[0] }}</p> </div> </div> </div> </div> </md-radio> </div> <div class=\"col s12 m4 l4\" _v-7b8e6bca=\"\"> <md-radio v-if=user.club1 :value.sync=newClub class=\"with-gap col\" :radio-value=user.club1 style=\"float: inherit; padding:20px\" _v-7b8e6bca=\"\"> <div class=row style=\"display: inline-table\" _v-7b8e6bca=\"\"> <div class=\"col s12 m12\" _v-7b8e6bca=\"\"> <div class=card _v-7b8e6bca=\"\"> <div class=card-image _v-7b8e6bca=\"\"> <img class=\"\" v-bind:src=user.imagesclub[1] alt=\"\" @error=imageUrlAlt _v-7b8e6bca=\"\"> </div> <div class=card-content _v-7b8e6bca=\"\"> <span class=card-title _v-7b8e6bca=\"\">{{ user.club1 }}</span> <a v-show=user.linkclub[1] class=\"right btn-floating halfway-fab waves-effect waves-light red\" :href=user.linkclub[1] target=_blank _v-7b8e6bca=\"\"><i class=material-icons _v-7b8e6bca=\"\">add</i></a> <p _v-7b8e6bca=\"\">{{ user.descripcionclub[1] }}</p> </div> </div> </div> </div> </md-radio> </div> <div class=\"col s12 m4 l4\" _v-7b8e6bca=\"\"> <md-radio v-if=user.club2 :value.sync=newClub class=\"with-gap col\" :radio-value=user.club2 style=\"float: inherit; padding:20px\" _v-7b8e6bca=\"\"> <div class=row style=\"display: inline-table\" _v-7b8e6bca=\"\"> <div class=\"col s12 m12\" _v-7b8e6bca=\"\"> <div class=card _v-7b8e6bca=\"\"> <div class=card-image _v-7b8e6bca=\"\"> <img class=img-responsive v-bind:src=user.imagesclub[2] alt=\"\" @error=imageUrlAlt _v-7b8e6bca=\"\"> </div> <div class=card-content _v-7b8e6bca=\"\"> <span class=card-title _v-7b8e6bca=\"\">{{ user.club2 }}</span> <a v-show=user.linkclub[2] class=\"right btn-floating halfway-fab waves-effect waves-light red\" :href=user.linkclub[2] target=_blank _v-7b8e6bca=\"\"><i class=material-icons _v-7b8e6bca=\"\">add</i></a> <p _v-7b8e6bca=\"\">{{ user.descripcionclub[2] }}</p> </div> </div> </div> </div> </md-radio> </div> </md-radio-group> <span slot=footer style=\"height: 20%\" _v-7b8e6bca=\"\"> <md-button v-if=\"newClub.length > 0\" class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=acceptClub() _v-7b8e6bca=\"\"> {{ $t(\"game.accept\") }} </md-button> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'loadClub')\" _v-7b8e6bca=\"\"> {{ $t(\"home.createPart.cancel\") }} <md-icon right=\"\" _v-7b8e6bca=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=termsModal class=modal-fixed-footer _v-7b8e6bca=\"\"> <blockquote _v-7b8e6bca=\"\"><h5 _v-7b8e6bca=\"\">Términos, condiciones y políticas de privacidad</h5></blockquote> <p _v-7b8e6bca=\"\">Fecha de última actualización: 26 de julio de 2023</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">1. Uso del sitio web</h6> <ul _v-7b8e6bca=\"\"> <li _v-7b8e6bca=\"\">Mainchess.com es una plataforma de ajedrez en línea y está destinada únicamente para fines recreativos y de entretenimiento.</li> <li _v-7b8e6bca=\"\">Al utilizar el sitio web, garantizas que tienes la edad legal para participar en juegos en línea en tu país de residencia.</li> </ul> <h6 style=color:#5c005c _v-7b8e6bca=\"\">2. Responsabilidad del usuario</h6> <ul _v-7b8e6bca=\"\"> <li _v-7b8e6bca=\"\">Eres responsable de mantener la confidencialidad de tu cuenta y contraseña en Mainchess.com.</li> <li _v-7b8e6bca=\"\">Te comprometes a no utilizar Mainchess.com para actividades ilegales o que violen los derechos de terceros.</li> <li _v-7b8e6bca=\"\">No puedes utilizar ningún tipo de software o herramientas que otorguen una ventaja injusta durante las partidas.</li> </ul> <h6 style=color:#5c005c _v-7b8e6bca=\"\">3. Propiedad intelectual</h6> <p _v-7b8e6bca=\"\">Todo el contenido presente en Mainchess.com, incluyendo pero no limitado a logotipos, imágenes, texto y software, está protegido por leyes de propiedad intelectual y derechos de autor.</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">4. Limitación de responsabilidad</h6> <p _v-7b8e6bca=\"\">Mainchess.com no se hace responsable de los daños directos, indirectos, incidentales o consecuenciales que puedan surgir del uso o la imposibilidad de uso del sitio web.</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">5. Política de privacidad</h6> <p _v-7b8e6bca=\"\">Mainchess.com recopilará y almacenará cierta información personal con el fin de mejorar tu experiencia en el sitio web. Esta información será tratada de acuerdo con nuestra Política de Privacidad.</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">6. Suspensión o terminación de la cuenta</h6> <p _v-7b8e6bca=\"\">Mainchess.com se reserva el derecho de suspender o terminar tu cuenta en caso de violación de nuestros Términos y Condiciones, o si se sospecha de un uso indebido del sitio web.</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">7. Modificaciones en los términos y condiciones</h6> <p _v-7b8e6bca=\"\">Mainchess.com se reserva el derecho de modificar estos Términos y Condiciones en cualquier momento y sin previo aviso. Las modificaciones serán efectivas a partir de su publicación en el sitio web.</p> <h6 style=color:#5c005c _v-7b8e6bca=\"\">8. Ley aplicable y jurisdicción</h6> <p _v-7b8e6bca=\"\">Estos términos y condiciones se regirán e interpretarán de acuerdo con las leyes de España, y cualquier disputa que surja en relación con Mainchess.com estará sujeta a la jurisdicción exclusiva de los tribunales de Salamanca.</p> <p _v-7b8e6bca=\"\">Gracias por leer nuestros términos, condiciones y políticas de privacidad. Esperamos que disfrutes tu experiencia en Mainchess.com y te diviertas jugando al ajedrez en línea. ¡Buena suerte!</p> <span slot=footer style=\"height: 20%\" _v-7b8e6bca=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'termsModal')\" _v-7b8e6bca=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-7b8e6bca=\"\">close</md-icon> </md-button> </span> </md-modal> <div class=cookies-infobar _v-7b8e6bca=\"\"> {{ $t(\"login.terms_text\") }}<br _v-7b8e6bca=\"\"> <a href=# style=\"color:#5c005c; text-decoration: underline;margin-right: 10px\" @click=\"this.$broadcast('modal::open', 'termsModal')\" _v-7b8e6bca=\"\"> {{ $t(\"login.terms\") }} </a> <div class=cookies-infobar_wrapper _v-7b8e6bca=\"\"> <a href=# id=cookies-infobar-close class=\"waves-effect waves-light purple darken-4 cookies-infobar_btn\" _v-7b8e6bca=\"\">{{ $t(\"game.accept\") }}</a> <a href=about:blank class=\"waves-effect waves-light purple darken-4 cookies-infobar_btn\" _v-7b8e6bca=\"\">{{ $t(\"register.cancel\") }}</a> </div> </div> </div> ";

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=\"s12 m12 l12\" _v-ae05bf84=\"\"> <div v-if=user class=\"fixed-action-btn horizontal\" _v-ae05bf84=\"\"> <div v-if=\"connectedFlag === true\" _v-ae05bf84=\"\"> <a class=\"btn-floating btn-large\" _v-ae05bf84=\"\"> <i class=material-icons _v-ae05bf84=\"\">menu</i> </a> </div> <div v-else=\"\" _v-ae05bf84=\"\"> <a data-tooltip=\"Error de conexión\" class=\"btn-floating btn-large red darken-4\" _v-ae05bf84=\"\"> <i class=material-icons _v-ae05bf84=\"\">error_outline</i> </a> </div> <ul _v-ae05bf84=\"\"> <li v-if=\"this.$route.params.u1 !== 'only' &amp;&amp; isVideoSaving() &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" _v-ae05bf84=\"\"><a class=\"btn-floating blue darken-4\" @click=openVideoSave() _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">stop_screen_share</md-icon></a></li> <li v-if=\"this.$route.params.u1 !== 'only' &amp;&amp; !isVideoSaving() &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" _v-ae05bf84=\"\"><a class=\"btn-floating blue darken-4\" @click=openVideoSave() _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">screen_share</md-icon></a></li> <li v-if=\"this.$route.params.u1 !== 'only' &amp;&amp; user.chataudio\" _v-ae05bf84=\"\"><a class=\"btn-floating purple darken-4\" @click=openChatSala(false) _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">mic</md-icon></a></li> <li v-if=\"this.$route.params.u1 !== 'only' &amp;&amp; user.chat\" _v-ae05bf84=\"\"><a class=\"btn-floating purple darken-4\" @click=openChatSala() _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">videocam</md-icon></a></li> <li _v-ae05bf84=\"\"><a class=\"btn-floating orange darken-4\" @click=\"changeStyle('board')\" _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">grid_on</md-icon></a></li> <li _v-ae05bf84=\"\"><a class=\"btn-floating green darken-4\" @click=\"changeStyle('pieces')\" _v-ae05bf84=\"\"><md-icon _v-ae05bf84=\"\">grain</md-icon></a></li> </ul> </div> <div _v-ae05bf84=\"\"> <md-navbar v-if=\"this.$route.params.u1 !== 'only'\" href=openModal data-tooltip=\"\" hamburger=\"\" mode=hide-on-med-and-down nav-class=\"purple darken-4\" _v-ae05bf84=\"\"> <div class=\"left left-nav\" _v-ae05bf84=\"\"> <md-nav-item class=tooltip-bottom data-tooltip=Jugar v-link=\"{name: 'home', activeClass: 'active'}\" v-if=user _v-ae05bf84=\"\"> <span class=notoolbarnav _v-ae05bf84=\"\"><md-icon class=notoolbarnav left=\"\" _v-ae05bf84=\"\">play_circle_outline</md-icon></span> <md-icon left=\"\" _v-ae05bf84=\"\"> <img left=\"\" class=\"responsive-img noinsidenav\" width=25px :src=imageUrl(userClub.image) alt=\"\" @error=imageUrlAlt _v-ae05bf84=\"\"></md-icon> <span class=\"inithome noinsidenav\" _v-ae05bf84=\"\">{{ user.club }}</span> <span class=notoolbarnav _v-ae05bf84=\"\">{{$t(\"game.play\")}} </span> </md-nav-item> <md-nav-item @click=pcGameAnalisis() v-if=\"user &amp;&amp; (user.role === 'Admin' || user.role === 'Teacher')\" _v-ae05bf84=\"\"> {{$t(\"game.class\")}} <md-icon left=\"\" _v-ae05bf84=\"\">cast</md-icon> </md-nav-item> <md-nav-item @click=pcGameAnalisis() v-else=\"\" _v-ae05bf84=\"\"> <span v-if=user _v-ae05bf84=\"\"> Analizar <md-icon left=\"\" _v-ae05bf84=\"\">cast</md-icon> </span> </md-nav-item> <md-nav-item v-link=\"{name: 'torneo',activeClass: 'active'}\" v-if=\"user &amp;&amp; user.firstName !== 'Guest'\" _v-ae05bf84=\"\"> {{ $t(\"torneos.title\") }} <md-icon left=\"\" _v-ae05bf84=\"\">grid_on</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'club',activeClass: 'active'}\" v-if=\"user &amp;&amp; (user.role === 'Admin')\" _v-ae05bf84=\"\"> {{ $t(\"clubs.title\") }} <md-icon left=\"\" _v-ae05bf84=\"\">people_outline</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'visor', activeClass: 'active', params: board.boardParms}\" v-if=\"user &amp;&amp; user.firstName !== 'Guest'\" _v-ae05bf84=\"\"> {{$t(\"visor.title\")}} <md-icon left=\"\" _v-ae05bf84=\"\">folder_open</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'lesson', activeClass: 'active', params: board.boardParms}\" v-if=user _v-ae05bf84=\"\"> {{$t(\"lesson.title\")}} <md-icon left=\"\" _v-ae05bf84=\"\">library_books</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'user',activeClass: 'active', params: {username: user.username}}\" v-if=\"user &amp;&amp; user.firstName !== 'Guest'\" _v-ae05bf84=\"\"> {{user.username}} <span class=\"badge green darken-4\" style=color:white _v-ae05bf84=\"\">{{user.elo }}</span> <md-icon left=\"\" _v-ae05bf84=\"\">person_outline</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'puzzle',activeClass: 'active'}\" v-if=user _v-ae05bf84=\"\"> {{ $t(\"puzzles.title\") }} <md-icon left=\"\" _v-ae05bf84=\"\">create</md-icon> </md-nav-item> <md-nav-item v-link=\"{name: 'loguin',activeClass: 'active'}\" v-if=!user _v-ae05bf84=\"\"> {{ $t(\"user.login\") }} <md-icon left=\"\" _v-ae05bf84=\"\">person_outline</md-icon> </md-nav-item> <md-nav-item v-if=!user @click=changeLenguaje(lenguajes[lenIndex].value) _v-ae05bf84=\"\"><md-icon left=\"\" _v-ae05bf84=\"\">flag</md-icon>{{ lenguajes[lenIndex].label }}</md-nav-item> <md-nav-item class=tooltip-bottom data-tooltip=Salir @click=logout() v-if=user _v-ae05bf84=\"\"><md-icon left=\"\" class=\"red darken-4\" _v-ae05bf84=\"\">exit_to_app</md-icon> <span class=\"\" _v-ae05bf84=\"\">{{ $t(\"user.logout\") }}</span> </md-nav-item> </div> <div class=\"right right-nav\" _v-ae05bf84=\"\"> <md-nav-item data-tooltip=Menú class=\"noinsidenav tooltip-bottom\" v-if=user _v-ae05bf84=\"\"> <a v-if=user class=\"noinsidenav dropdown-button\" data-activates=dropdown1 _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">ondemand_video</md-icon>Vídeos<md-icon right=\"\" _v-ae05bf84=\"\">arrow_drop_down</md-icon> </a> <ul id=dropdown1 class=dropdown-content _v-ae05bf84=\"\"> <li v-if=userClub.menu1_title @click=openModalMenu1() _v-ae05bf84=\"\"><a style=\"display: flex\" _v-ae05bf84=\"\"><md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon><span style=\"white-space: nowrap\" _v-ae05bf84=\"\">{{ userClub.menu1_title }}</span></a></li> <li v-if=userClub.menu2_title @click=openModalMenu2() _v-ae05bf84=\"\"><a style=\"display: flex\" _v-ae05bf84=\"\"><md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon><span style=\"white-space: nowrap\" _v-ae05bf84=\"\">{{ userClub.menu2_title }}</span></a></li> <li v-if=userClub.menu3_title @click=openModalMenu3() _v-ae05bf84=\"\"><a style=\"display: flex\" _v-ae05bf84=\"\"><md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon><span style=\"white-space: nowrap\" _v-ae05bf84=\"\">{{ userClub.menu3_title }}</span></a></li> <li class=divider tabindex=-1 _v-ae05bf84=\"\"></li> <li @click=openModal() _v-ae05bf84=\"\"><a style=\"display: flex\" _v-ae05bf84=\"\"><md-icon left=\"\" _v-ae05bf84=\"\">help_outline</md-icon>Acerca de</a></li> </ul> </md-nav-item> <md-nav-item class=notoolbarnav v-if=user @click=openModal() _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">help_outline</md-icon> <span style=\"white-space: nowrap\" _v-ae05bf84=\"\">Acerca de</span> </md-nav-item> <md-nav-item v-if=\"user &amp;&amp; userClub.menu1_title\" @click=openModalMenu1() class=\"tooltip-bottom notoolbarnav\" data-tooltip=\"{{ userClub.menu1_title }}\" _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon> <span style=\"white-space: wrap\" _v-ae05bf84=\"\">{{ userClub.menu1_title }}</span> </md-nav-item> <md-nav-item v-if=\"user &amp;&amp; userClub.menu2_title\" @click=openModalMenu2() class=\"tooltip-bottom notoolbarnav\" data-tooltip=\"{{ userClub.menu1_title }}\" _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon> <span style=\"white-space: nowrap\" _v-ae05bf84=\"\">{{ userClub.menu1_title }}</span> </md-nav-item> <md-nav-item v-if=\"user &amp;&amp; userClub.menu3_title\" @click=openModalMenu3() class=\"tooltip-bottom notoolbarnav\" data-tooltip=\"{{ userClub.menu1_title }}\" _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">school</md-icon> <span style=\"white-space: nowrap\" _v-ae05bf84=\"\">{{ userClub.menu1_title }}</span> </md-nav-item> <md-nav-item class=tooltip-bottom data-tooltip=Retransmisión v-link=\"{name: 'events',activeClass: 'active'}\" v-if=\"user &amp;&amp; user.live === true\" _v-ae05bf84=\"\"> <span _v-ae05bf84=\"\">{{$t(\"events.title\")}}</span> <md-icon left=\"\" _v-ae05bf84=\"\">live_tv</md-icon> </md-nav-item> <md-nav-item class=\"tooltip-bottom left\" data-tooltip=Retos style=\"padding-left: 0px\" v-if=user @click=showInvitesGame() _v-ae05bf84=\"\"> <md-icon left=\"\" _v-ae05bf84=\"\">bookmark_border</md-icon> <span class=\"\" _v-ae05bf84=\"\">Retos</span> <span v-if=\"invitesLength > 0\" class=\"badge green darken-4\" style=color:white _v-ae05bf84=\"\"> {{invitesLength}}</span> </md-nav-item> </div> </md-navbar> <md-modal id=aboutModalMenu1 class=modal-fixed-footer _v-ae05bf84=\"\"> <ul class=\"collection with-header\" _v-ae05bf84=\"\"> <li class=collection-header _v-ae05bf84=\"\"><h4 _v-ae05bf84=\"\">{{ userClub.menu1_title }}</h4> <div v-html=userClub.menu1_text _v-ae05bf84=\"\"></div> </li> <div style=\"text-align: center\" _v-ae05bf84=\"\"> <h5 _v-ae05bf84=\"\"><a :href=userClub.menu1_link target=_blank _v-ae05bf84=\"\"><u _v-ae05bf84=\"\">{{ userClub.menu1_title }}</u></a></h5> <iframe width=560 height=315 :src=userClub.menu1_video sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" data-tooltip=\"YouTube video player\" frameborder=0 allow=\"\" allowfullscreen=\"\" _v-ae05bf84=\"\"></iframe> </div> </ul> <span slot=footer _v-ae05bf84=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'aboutModalMenu1')\" _v-ae05bf84=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-ae05bf84=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=aboutModalMenu2 class=modal-fixed-footer _v-ae05bf84=\"\"> <ul class=\"collection with-header\" _v-ae05bf84=\"\"> <li class=collection-header _v-ae05bf84=\"\"><h4 _v-ae05bf84=\"\">{{ userClub.menu2_title }}</h4> <div v-html=userClub.menu2_text _v-ae05bf84=\"\"></div> </li> <div style=\"text-align: center\" _v-ae05bf84=\"\"> <h5 _v-ae05bf84=\"\"><a :href=userClub.menu2_link target=_blank _v-ae05bf84=\"\"><u _v-ae05bf84=\"\">{{ userClub.menu2_title }}</u></a></h5> <iframe width=560 height=315 :src=userClub.menu2_video sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" data-tooltip=\"YouTube video player\" frameborder=0 allow=\"\" allowfullscreen=\"\" _v-ae05bf84=\"\"></iframe> </div> </ul> <span slot=footer _v-ae05bf84=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'aboutModalMenu2')\" _v-ae05bf84=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-ae05bf84=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=aboutModalMenu3 class=modal-fixed-footer _v-ae05bf84=\"\"> <ul class=\"collection with-header\" _v-ae05bf84=\"\"> <li class=collection-header _v-ae05bf84=\"\"><h4 _v-ae05bf84=\"\">{{ userClub.menu3_title }}</h4> <div v-html=userClub.menu3_text _v-ae05bf84=\"\"></div> </li> <div style=\"text-align: center\" _v-ae05bf84=\"\"> <h5 _v-ae05bf84=\"\"><a :href=userClub.menu3_link target=_blank _v-ae05bf84=\"\"><u _v-ae05bf84=\"\">{{ userClub.menu3_title }}</u></a></h5> <iframe width=560 height=315 :src=userClub.menu3_video sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" data-tooltip=\"YouTube video player\" frameborder=0 allow=\"\" allowfullscreen=\"\" _v-ae05bf84=\"\"></iframe> </div> </ul> <span slot=footer _v-ae05bf84=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'aboutModalMenu3')\" _v-ae05bf84=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-ae05bf84=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=aboutModalResources class=modal-fixed-footer _v-ae05bf84=\"\"> <ul class=\"collection with-header\" _v-ae05bf84=\"\"> <li class=collection-header _v-ae05bf84=\"\"><h4 _v-ae05bf84=\"\">Canal de radio<md-icon right=\"\" _v-ae05bf84=\"\">queue_music</md-icon></h4> <p _v-ae05bf84=\"\"> Se inaugura una sección de ajedrez dentro del programa de radio divulgativo Eureka perteneciente a Radio USAL. Esta sección se emitirá una vez al mes y en ella abordaremos noticias de interés tanto del panorama internacional, nacional y muy especialmente local, tratando así de fomentar la afición por nuestro deporte dentro de la población de Salamanca, así como dentro de la comunidad universitaria. Agradecemos a la dirección de Eureka esta oportunidad que nos brinda </p> </li> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa junio 2021. Historia del Ajedrez. Spassky vs Fischer 1972 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa mayo 2021. Historia del Ajedrez. La Escuela Soviética </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa de radio abril 2021. Historia del ajedrez -Capablanca y Alekhine- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa noviembre 2020. Historia del ajedrez -Steinitz y Lasker- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa octubre 2020. Historia del Ajedrez. Siglo XIX </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa julio 2020. Historia del Ajedrez. Siglos XVI y XVII </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa junio 2020. Historia del Ajedrez. Siglo XVI -Ruy López- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa mayo 2020. Historia del Ajedrez. Capítulo III -El Renacimiento. En Salamanca se publican las nuevas reglas del ajedrez- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa abril 2020. Historia del Ajedrez. Capítulo II -Época árabe y Europa medieval- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa marzo 2020 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa febrero 2020. Historia del Ajedrez. Capítulo I -Orígenes del juego- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa diciembre 2019 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa noviembre 2019 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa Mayo 2019 -El ajedrez en el desarrollo de la inteligencia artificial- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa Abril 2019 -Ajedrez y Música- </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa Marzo 2019 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa Febrero 2019 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Programa Enero 2019 </a> <a href=http://radio.usal.es/wp-content/uploads/2015/02/Eureka-22-11-2018.mp3 target=_blank class=collection-item _v-ae05bf84=\"\">Entrevista Noviembre 2018 </a> </ul> <span slot=footer _v-ae05bf84=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'aboutModalResources')\" _v-ae05bf84=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-ae05bf84=\"\">cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=aboutModal class=modal-fixed-footer _v-ae05bf84=\"\"> <h4 _v-ae05bf84=\"\">{{ $t(\"about.description\") }}</h4> <md-card _v-ae05bf84=\"\"> <span slot=title class=activator _v-ae05bf84=\"\"> {{ $t(\"about.namegame\") }}<md-icon right=\"\" _v-ae05bf84=\"\">info</md-icon> </span> <p _v-ae05bf84=\"\"> {{ $t(\"about.des\") }} </p> <div slot=image class=\"\" _v-ae05bf84=\"\"> <p _v-ae05bf84=\"\"></p> <img style=\"width: 30%;left: 33%\" class=\"imagedropshadow activator\" src=" + __webpack_require__(435) + " alt=\"\" _v-ae05bf84=\"\"> </div> <div slot=reveal _v-ae05bf84=\"\"> <span class=\"card-title grey-text text-darken-4\" _v-ae05bf84=\"\"> {{ $t(\"about.namegame\") }} </span> <h5 class=\"flat-text-header hello\" _v-ae05bf84=\"\">{{ $t(\"about.tecn\") }}</h5> <p _v-ae05bf84=\"\"> Vuejs, Nodejs, SocketIO, MongoDb, Materialize, Express, Cheessground, PgnViewerJS, SimpleChessBoard, Stockfish, LcZero, adminMongo, Webpack, ... </p> <h5 class=\"flat-text-header hello\" _v-ae05bf84=\"\">{{ $t(\"about.licenses\") }}</h5> <p _v-ae05bf84=\"\"> <a target=_blank rel=\"noopener noreferrer\" href=../../../static/licenses.html _v-ae05bf84=\"\">{{ $t(\"about.seemore\") }}</a> </p> </div> </md-card> <span slot=footer _v-ae05bf84=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'aboutModal')\" _v-ae05bf84=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-ae05bf84=\"\">cancel</md-icon> </md-button> </span> </md-modal> <div _v-ae05bf84=\"\"> <user-invites :user=user _v-ae05bf84=\"\"></user-invites> </div> <div class=row _v-ae05bf84=\"\"> <router-view _v-ae05bf84=\"\"></router-view> </div> </div> </div> ";

/***/ }),
/* 511 */
/***/ (function(module, exports) {

	module.exports = " <div id=boardvisor _v-c8f85832=\"\"> <md-modal id=modalRecursos v-if=\"/* this.$route.params.u1 !== 'only' &amp;&amp; */tokens.length > 0\" class=modal-fixed-footer _v-c8f85832=\"\"> <ul class=\"collection with-header\" _v-c8f85832=\"\"> <li class=collection-header _v-c8f85832=\"\"> <h4 _v-c8f85832=\"\">Recursos<md-icon v-if=this.isOwner() class=right @click=deleteResource() _v-c8f85832=\"\">delete</md-icon></h4> </li> <div v-for=\"u in tokens\" :key=u.url _v-c8f85832=\"\"> <div v-if=\"u.type === 'youtube'\" _v-c8f85832=\"\"> <div class=video-container _v-c8f85832=\"\"> <iframe sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" :src=u.url frameborder=0 allowfullscreen=\"\" style=\"text-align: center; max-height: 400px\" _v-c8f85832=\"\"></iframe> </div> <div class=collection-item _v-c8f85832=\"\"> <a target=_blank href=\"{{ u.url }}\" _v-c8f85832=\"\"><md-icon left=\"\" _v-c8f85832=\"\">ondemand_video</md-icon><span _v-c8f85832=\"\">{{ u.name }}</span><span _v-c8f85832=\"\"> ( {{ u.url }} )</span></a> </div> </div> <div v-else=\"\" _v-c8f85832=\"\"> <div v-if=\"u.type === 'image'\" _v-c8f85832=\"\"> <img class=responsive-img style=\"text-align: center; max-height: 400px\" :src=u.url alt=\"\" _v-c8f85832=\"\"> <div class=collection-item _v-c8f85832=\"\"> <a target=_blank href=\"{{ u.url }}\" _v-c8f85832=\"\"><md-icon left=\"\" _v-c8f85832=\"\">image</md-icon><span _v-c8f85832=\"\">{{ u.name }}</span><span _v-c8f85832=\"\"> ( {{ u.url }} )</span></a> </div> </div> <div v-else=\"\" _v-c8f85832=\"\"> <div v-if=\"u.type === 'pdf'\" _v-c8f85832=\"\"> <div class=video-container _v-c8f85832=\"\"> <iframe sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" :src=u.url loading=lazy frameborder=0 allowfullscreen=\"\" _v-c8f85832=\"\"></iframe> </div> <div class=collection-item _v-c8f85832=\"\"> <a target=_blank href=\"{{ u.url }}\" _v-c8f85832=\"\"><md-icon left=\"\" _v-c8f85832=\"\">picture_as_pdf</md-icon><span _v-c8f85832=\"\">{{ u.name }}</span><span _v-c8f85832=\"\"> ( {{ u.url }} )</span></a> </div> </div> <div v-else=\"\" _v-c8f85832=\"\"> <div v-if=\"u.type === 'pgn'\" _v-c8f85832=\"\"> <div class=\"\" _v-c8f85832=\"\"> <iframe sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" :src=getViewPgnUpload(u.url) frameborder=0 height=340px autoplay=true allowfullscreen=true scrolling=no width=100% allow=\"camera; microphone\" _v-c8f85832=\"\"></iframe> </div> <div class=collection-item _v-c8f85832=\"\"> <a target=_blank href=\"{{ u.url }}\" _v-c8f85832=\"\"><md-icon left=\"\" _v-c8f85832=\"\">grid_on</md-icon><span _v-c8f85832=\"\">{{ u.name }}</span><span _v-c8f85832=\"\"> ( {{ u.url }} )</span></a> </div> </div> <div v-else=\"\" _v-c8f85832=\"\"> <div class=collection-item _v-c8f85832=\"\"> <a target=_blank href=\"{{ u.url }}\" _v-c8f85832=\"\"><span _v-c8f85832=\"\">{{ u.type }} - {{ u.name }}</span><span _v-c8f85832=\"\"> ( {{ u.url }} )</span></a> </div> </div> </div> </div> </div> </div> </ul> <span slot=footer _v-c8f85832=\"\"> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'modalRecursos')\" _v-c8f85832=\"\"> {{ $t(\"about.close\") }} <md-icon right=\"\" _v-c8f85832=\"\">cancel</md-icon> </md-button> </span> </md-modal> <div class=\"col s12\" v-cloak=\"\" _v-c8f85832=\"\"> <md-tabs :active.sync=activeChat class=\"\" _v-c8f85832=\"\"> <md-tab name=Visor class=s8 swipeable=\"\" _v-c8f85832=\"\"> <a :class=\"activeChat === 'Visor' ? 'indicatorTab' : ''\" @click=resizeBoard() _v-c8f85832=\"\">{{ $t(\"home.viewer\") }}</a> </md-tab> <md-tab name=Chat class=s4 swipeable=\"\" :disabled=\"this.$route.params.u1 === 'only'\" _v-c8f85832=\"\"> <a :class=\"activeChat === 'Chat' ? 'indicatorTab' : ''\" _v-c8f85832=\"\">{{ $t(\"home.chattext\") }} {{ user.club }} <span v-if=\"chatRecibido === true\" class=\"badge green darken-4\" style=color:white _v-c8f85832=\"\">{{ chatRecibido === true ? 'Check' : '' }}</span> </a> </md-tab> <div slot=contents _v-c8f85832=\"\"> <div id=content_Visor v-if=\"activeChat === 'Visor'\" class=scrollpurple v-on:scroll=userScroll _v-c8f85832=\"\"> <div class=\"col s12 m12 l8\" _v-c8f85832=\"\"> <div class=\"col s12 m12 l12\" _v-c8f85832=\"\"> <audio id=sound style=\"display: none\" allow=audio preload=auto controls=none _v-c8f85832=\"\"> <source src=../../../static/sound/move.mp3 type=audio/mpeg _v-c8f85832=\"\"> </audio> <div v-if=!isHumanVsAnalisis() style=width:100% _v-c8f85832=\"\"> <blockquote v-if=\"board !== undefined &amp;&amp; board.u1 !== undefined\" class=\"chip pulse col s5 m5 l5\" style=\"text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis\" v-bind:class=\"[turn === 'white' &amp; times.white > 0 ? 'purple darken-4 userTurn' : '']\" _v-c8f85832=\"\"> <b class=\"\" _v-c8f85832=\"\">{{ board !== undefined ? board.u1: '' }}</b> <span class=\"float: right\" _v-c8f85832=\"\">{{ times.white | timeBoard }}</span> </blockquote> <div class=\"col s2 m2 l2\" style=\"text-align: center\" _v-c8f85832=\"\"> <h5 class=flat-text-header style=\"position: relative; top: 15px\" _v-c8f85832=\"\">vs</h5> </div> <blockquote v-if=\"board !== undefined &amp;&amp; board.u2 !== undefined\" class=\"chip pulse col s5 m5 l5\" style=\"text-align: left; overflow: hidden; white-space:nowrap; text-overflow:ellipsis\" v-bind:class=\"[turn === 'black' &amp; times.white > 0 ? 'purple darken-4 userTurn' : '']\" _v-c8f85832=\"\"> <b class=\"\" _v-c8f85832=\"\">{{ board !== undefined ? board.u2 : '' }}</b> <span class=\"\" style=float:right _v-c8f85832=\"\">{{ times.black | timeBoard}}</span> </blockquote> </div> <div v-else=\"\" _v-c8f85832=\"\"> <blockquote v-if=\"board !== undefined &amp;&amp; board.u1 !== undefined\" class=\"chip pulse col s12 m12 l12\" style=\"text-align: right\" _v-c8f85832=\"\"> <div v-if=\"turn === 'black'\" _v-c8f85832=\"\"> <b class=\"\" _v-c8f85832=\"\"> ANALISIS de {{ board !== undefined ? board.u1: '' }}</b> <span :value.sync=times.black _v-c8f85832=\"\"> {{ times.black | timeBoard}} </span> </div> <div v-else=\"\" _v-c8f85832=\"\"> <b class=\"\" v-if=\"board !== undefined &amp;&amp; board.u1 !== undefined\" _v-c8f85832=\"\"> ANALISIS de {{ board !== undefined ? board.u1: '' }}</b> <span :value.sync=times.black _v-c8f85832=\"\">{{ times.white | timeBoard}}</span> </div> </blockquote> </div> </div> <div class=\"col s12 m12 l12\" _v-c8f85832=\"\"> <div id=middle :class=\"(board === undefined || board.pgn === undefined || board.pgn === '') ? 'noboardmiddle' : 'boardmiddle'\" :value-sync=board._id _v-c8f85832=\"\"> <div class=loadbar id=analisisVertical style=display:none _v-c8f85832=\"\"> <strong id=myBar2 class=bar _v-c8f85832=\"\"></strong> </div> <div id=pgnBoard class=\"\" style=\"width: 100%; height: 460px;float:left\" :class=classboard _v-c8f85832=\"\"></div> </div> </div> </div> <div class=\"col s12 m12 l4\" _v-c8f85832=\"\"> <blockquote class=\"chip purple darken-4 userTurn\" v-if=\"board !== undefined &amp;&amp; board.torneo !== undefined\" _v-c8f85832=\"\">Torneo: {{ board.torneo }} (Ronda: {{boardShow.ronda + 1}})</blockquote> <blockquote v-if=\"!isHumanVsAnalisis() &amp;&amp; board.wins || result.wins\" _v-c8f85832=\"\"><b v-if=\"board.wins || result.wins\" _v-c8f85832=\"\">{{ $t(\"visor.result\") }}: </b> <div class=chip _v-c8f85832=\"\"> <span _v-c8f85832=\"\">{{ stateGame(board) }}</span> </div> </blockquote> <div id=pgnHeader style=\"max-height: 80px\" _v-c8f85832=\"\"></div> <div id=pgnComment style=display:none _v-c8f85832=\"\"></div> <div id=pgnButtons _v-c8f85832=\"\"></div> <div id=pgnError _v-c8f85832=\"\"></div> <div id=pgnMoves class=\"{{!isHumanVsAnalisis() ? '':'comments'}}\" _v-c8f85832=\"\"></div> <textarea style=display:none id=idTextAreaPGN @change=changePGNTextArea() _v-c8f85832=\"\"></textarea> <blockquote style=display:none _v-c8f85832=\"\"><b class=flat-text-header _v-c8f85832=\"\">PGN: </b><input id=myPGNValue v-model.lazy=myPGNValue _v-c8f85832=\"\"></blockquote> <blockquote style=display:none _v-c8f85832=\"\"><b class=flat-text-header _v-c8f85832=\"\">PGN: </b><input id=myPGNReload v-model.lazy=myPGNReload _v-c8f85832=\"\"></blockquote> <blockquote style=display:none _v-c8f85832=\"\"><b class=flat-text-header _v-c8f85832=\"\">FEN: </b><input id=myFENValue v-model.lazy=myFENValue _v-c8f85832=\"\"></blockquote> <blockquote style=display:none _v-c8f85832=\"\"><b class=flat-text-header _v-c8f85832=\"\">FEN: </b><span id=myFENValueP _v-c8f85832=\"\"></span></blockquote> <board-history v-if=validBoard :active=active :pgn=myPGNValue :fen=myFENValue :history=history :sendtoteacher=sendtoteacher :userchat=userChat :user=user :boardid=board._id :board=board :humanvspc=isHumanVsAnalisis :only=\"this.$route.params.u1 === 'only'\" _v-c8f85832=\"\"></board-history> </div> </div> <div id=content_Chat v-if=\"activeChat == 'Chat'\" class=scrollpurple v-on:scroll=userScroll _v-c8f85832=\"\"> <div class=\"col s12 m12 l12\" _v-c8f85832=\"\"> <p style=\"height: 10px\" _v-c8f85832=\"\"></p> <div class=\"scrollpurple borderround\" style=\"height: 10vh;overflow: auto;border: 1px solid #5c005c\" id=chatConvertGame _v-c8f85832=\"\"> <body-men :mens=mensjGame :dir-server=dirServer :user=user _v-c8f85832=\"\"></body-men> </div> <form v-if=\"user.chattext === undefined || user.chattext === true\" v-on:submit.prevent=sendMensajeGeneral() _v-c8f85832=\"\"> <div class=\"col s9 m9 l9\" _v-c8f85832=\"\"> <input class=left name=text id=textChatInput v-model.lazy=chattext _v-c8f85832=\"\"> </div> <div class=\"col s3 m3 l3\" _v-c8f85832=\"\"> <select class=emojiclass v-model.lazy=newEmoji style=display:inline;width:auto _v-c8f85832=\"\"> <option value=😀 _v-c8f85832=\"\">😀</option> <option value=😁 _v-c8f85832=\"\">😁</option> <option value=😂 _v-c8f85832=\"\">😂</option> <option value=😃 _v-c8f85832=\"\">😃</option> <option value=😄 _v-c8f85832=\"\">😄</option> <option value=😅 _v-c8f85832=\"\">😅</option> <option value=😆 _v-c8f85832=\"\">😆</option> <option value=😇 _v-c8f85832=\"\">😇</option> <option value=😈 _v-c8f85832=\"\">😈</option> <option value=😉 _v-c8f85832=\"\">😉</option> <option value=😊 _v-c8f85832=\"\">😊</option> <option value=😋 _v-c8f85832=\"\">😋</option> <option value=😌 _v-c8f85832=\"\">😌</option> <option value=😍 _v-c8f85832=\"\">😍</option> <option value=😎 _v-c8f85832=\"\">😎</option> <option value=😏 _v-c8f85832=\"\">😏</option> <option value=😐 _v-c8f85832=\"\">😐</option> <option value=😑 _v-c8f85832=\"\">😑</option> <option value=😒 _v-c8f85832=\"\">😒</option> <option value=😓 _v-c8f85832=\"\">😓</option> <option value=😔 _v-c8f85832=\"\">😔</option> <option value=😕 _v-c8f85832=\"\">😕</option> <option value=😖 _v-c8f85832=\"\">😖</option> </select> <md-btn style=float:right class=\"right md-button btn-floating btn-flat purple darken-4 btn\" _v-c8f85832=\"\"> <i class=\"material-icons small\" _v-c8f85832=\"\">navigate_next</i> </md-btn> </div> </form> </div> </div> </div> </md-tabs> </div> </div> ";

/***/ }),
/* 512 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12 change-order\" _v-faab6590=\"\"> <p _v-faab6590=\"\"></p> <div class=\"col s12 m12 l8\" style=\"\" id=middle _v-faab6590=\"\"> <div id=clubBoard style=\"Width: auto; height: 300px\" :class=classboard _v-faab6590=\"\"></div> </div> <div class=\"col s12 m12 l4\" style=\"text-align: center\" v-if=club.createby _v-faab6590=\"\"> <div class=\"\" _v-faab6590=\"\"> <blockquote _v-faab6590=\"\"><h6 id=eval class=\"flat-text-header hello\" style=\"text-align: center\" _v-faab6590=\"\"></h6></blockquote> <div id=pgnComment style=\"display: none\" _v-faab6590=\"\"></div> <h5 class=flat-text-header _v-faab6590=\"\">{{ $t(\"clubs.played\") }}: {{ $t(\"clubs.color.\" + turn) }}</h5> <div _v-faab6590=\"\"> <h6 class=flat-text-header _v-faab6590=\"\">{{ $t(\"clubs.movs\") }}</h6> <blockquote class=\"chip pulse\" _v-faab6590=\"\">{{numMoves}}</blockquote> </div> <blockquote class=\"chip pulse purple darken-4\" style=\"text-align: left; font-size: large;overflow: hidden; white-space:nowrap; text-overflow:ellipsis;color:white\" _v-faab6590=\"\"> Faltan <span class=\"\" style=\"\" _v-faab6590=\"\"><b _v-faab6590=\"\">{{ times | timeBoard}}</b> de {{timeMove | timeBoard }}</span> </blockquote> <div _v-faab6590=\"\"> <h3 _v-faab6590=\"\">{{ $t(\"clubs.lost\") }}</h3> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=reintent() _v-faab6590=\"\"> {{ $t(\"clubs.reintent\") }} </a> </div> <div slot=actions _v-faab6590=\"\"> Difultad: <blockquote class=\"chip pulse\" _v-faab6590=\"\">{{ 100 - Math.round(club.corrects * 100 / club.intents) }}%</blockquote> </div> <div _v-faab6590=\"\"> <div class=row _v-faab6590=\"\"> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=pista() _v-faab6590=\"\">pista</a> </div> <div class=row _v-faab6590=\"\"> <a class=\"btn waves-effect waves-light col s12 m12 l12 purple darken-4\" @click=resultado() _v-faab6590=\"\">resultado</a> </div> </div> </div> </div> </div> ";

/***/ }),
/* 513 */,
/* 514 */,
/* 515 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12\"> <div class=\"col s12 m12 l3\"> <md-collection> <md-collection-item v-for=\"clubT in clubsType\" @click=selectClubType(clubT) :class=\"clubT.type === clubType.type?'active hightlight':'hightlight'\"> <span v-if=\"clubT.type === 'Clubs'\">Clubs<md-badge v-if=\"this.clubType === clubT\">{{ clubs.length }}</md-badge></span> <span v-else>{{ this.clubType }}<md-badge v-if=\"this.clubType === clubT\">{{ clubs.length }}</md-badge></span> <md-badge class=\"purple darken-4\">{{ counts[clubT.type] }}</md-badge> </md-collection-item> </md-collection> <md-card class=\"purple darken-4\" content-class=white-text v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <span slot=title> {{ $t(\"clubs.create.title\") }} </span> <p> {{ $t(\"clubs.create.description\") }} </p> <div slot=actions> <a @click=\"addClub('add')\">{{ $t(\"clubs.create.create\") }}</a> <a @click=editClub() v-if=\"(user.username === item.createby || user.role === 'Admin')\">{{ $t(\"clubs.create.edit\") }}</a> <a @click=delClub() v-if=\"(user.username === item.createby || user.role === 'Admin')\">{{ $t(\"clubs.create.delete\") }}</a> </div> </md-card> </div> <div class=\"col s12 m12 l9\"> <div class=\"col s12 m12 l12\"> <div class=\"col s12 m12\" v-if=\"clubs.length === 0\"> <div class=\"card-panel red lighten-2 light center promo\"> <md-icon>info</md-icon> <p class=promo-caption>{{ $t(\"clubs.attention\") }}</p> <p class=\"light center\"> {{ $t(\"clubs.attMen\") }} </p> </div> </div> <md-collection v-if=\"clubs.length > 0\" id=listSomeClubs style=\"max-height: 80vh;overflow: auto\" class=scrollpurple> <md-collection-item v-for=\"club in clubs\" :class=\"item._id === club._id?'active':''\" v-show=club @click=selectItm(club)> <img v-bind:src=imageUrl(club.image) @error=imageUrlAlt alt=\"\" style=\"width: 25px; margin-right: 10px\" class=img-responsive> <span class=title>{{ $index + 1 }}. {{ club.name }} | {{ club.description }} | {{ club.link }} || {{ club.email }}</span> <md-badge>{{club.results}}</md-badge> </md-collection-item> </md-collection> </div> <div class=\"col s12 m12 l9\"> <div class=\"col s12 m12 l4\"> </div> <div class=\"col s12 m12 l8\" v-if=\"item.round1 !== undefined && getLength(item.round1) > 0\"> </div> </div> </div> <md-modal id=modalCreateClub class=modal-fixed-footer> <h4 style=\"text-align: center\">{{ $t(\"clubs.create.title\") }} {{ clubType.type }}</h4> <div class=\"col s12\"> <div class=\"col s2 m2 l2\"> <md-card> <span slot=title> {{ clubType.name }} </span> <div slot=image> <img style=\"width: 100%\" v-bind:src=imageUrl(this.imagenClub) alt=\"\" @error=imageUrlAlt> <upload-files :value.sync=filesUpload name=files :action=dirActionUpload maxsize=100 pathpermit=|jpeg|png|gif> <md-icon right>edit</md-icon> </upload-files> </div> </md-card> </div> <div class=\"col s9 m9 l9\"> <div class=row> <md-input name=nombreClub :value.sync=nombreClub> Nombre </md-input> <md-input name=descripcionClub :value.sync=descripcionClub> Descripción </md-input> <md-input name=linkClub :value.sync=linkClub> Link </md-input> <md-input name=precioClub :value.sync=precioClub> Precio </md-input> <md-input name=emailClub :value.sync=emailClub placeholder=info@mainchess.com success-msg=Success error-msg=Error :valid=bool(firstNameValid)> Email <template slot=icon-name>account_circle</template> </md-input> <md-input type=password name=passwordClub :value.sync=passwordClub> Password </md-input> <md-input name=menu1_title :value.sync=MENU1Titulo> Título del menú 1 </md-input> <div class=row> <div class=\"input-field s12\"> <textarea id=menu1_text class=materialize-textarea @change=changeMENU1Texto>{{ MENU1Texto }}</textarea> <label for=menu1_text>Texto de menú 1</label> </div> </div> <md-input name=menu1_link :value.sync=MENU1Link> Link del menú 1 </md-input> <md-input name=menu1_video :value.sync=MENU1Video> Video del menú 1 </md-input> <md-input name=menu2_title :value.sync=MENU2Titulo> Título del menú 2 </md-input> <div class=row> <div class=\"input-field s12\"> <textarea id=menu1_text class=materialize-textarea @change=changeMENU2Texto>{{ MENU2Texto }}</textarea> <label for=menu2_text>Texto de menú 2</label> </div> </div> <md-input name=menu2_link :value.sync=MENU2Link> Link del menú 2 </md-input> <md-input name=menu2_video :value.sync=MENU2Video> Video del menú 2 </md-input> <md-input name=menu3_title :value.sync=MENU3Titulo> Título del menú 3 </md-input> <div class=row> <div class=\"input-field s12\"> <textarea id=menu3_text class=materialize-textarea @change=changeMENU3Texto>{{ MENU3Texto }}</textarea> <label for=menu3_text>Texto de menú 3</label> </div> </div> <md-input name=menu3_link :value.sync=MENU3Link> Link del menú 3 </md-input> <md-input name=menu3_video :value.sync=MENU3Video> Video del menú 3 </md-input> </div> </div> </div> <span slot=footer> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=createClub(true)> {{[mode === 'add'?$t(\"clubs.create.create\"):$t(\"clubs.create.edit\")]}} </md-button> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=createClub(false)> {{ $t(\"clubs.create.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=modalResultados class=modal-fixed-footer> <h4 style=\"text-align: center\">Resultado de {{ nombreClubResult }} </h4> <div class=scrollpurple style=\"overflow: auto; padding: 30px\"> <table style=\"padding: 10px; overflow: auto;font-size:x-large\" class=\"grid scrollpurple col s12 m12 l12\"> <thead> <tr> <th width=10% class=\"\">Puesto</th> <th width=1% class=\"\"></th> <th width=10% class=\"\">ELO</th> <th width=\"\" class=\"\">Nombre</th> <th width=15% class=\"\"><span class=\"middle chip purple left\" style=\"color: white\"> Puntos </span></th> <th width=15% class=\"\"><span class=chip> BUC </span></th> </tr> </thead> <tbody> <tr v-for=\"play in playersResult\"> <td width=10% class=\"\">{{ $index + 1 }}</td> <td width=10% class=\"\"> <span v-if=\"$index == 0\" style=font-size:xx-large>🥇</span> <span v-if=\"$index == 1\" style=font-size:xx-large>🥈</span> <span v-if=\"$index == 2\" style=font-size:xx-large>🥉</span> </td> <td width=10% class=\"\"> <span class=\"\"> {{ play.elo }}</span> </td> <td width=\"\" class=\"\"> <span class=\"\"> {{ play.name }}</span> </td> <td width=15% class=\"\"><span class=\"chip purple\" style=\"color: white\"> {{ play.score }} </span></td> <td width=15% class=\"\"><span class=chip> {{ play.buchholz }} </span></td> </tr> </tbody> </table> </div> <span slot=footer> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'modalResultados')\"> {{ $t(\"about.close\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> </div> ";

/***/ }),
/* 516 */
/***/ (function(module, exports) {

	module.exports = " <md-modal id=pgnFilesModal> <h5 style=\"text-align: center\">Lista de partidas</h5> <md-collection-list id=partidasPgn class=\"col s12 m12 l12\" style=\"display: flex;flex-flow: row wrap;justify-content: space-around;padding: 0;\r\n    margin: 0\"> <md-collection-list-item v-for=\"u in pgnFiles\" @click=openPGN(u.pgn) style=\"width: 170px\" :key=u._id> <board-visor-small :game=u :id=u._id :classboard=classBoard></board-visor-small> <span class=title>{{ generateHeader(u.pgn, false, true) }}</span> </md-collection-list-item> </md-collection-list> </md-modal> <div class=\"col s12 change-order\"> <div class=\"col s12 m12 l4\"> <table v-if=\"hasBoards() === true\" class=\"table highlight\"> <thead> <tr> <th class=\"valign-wrapper purple darken-4\" style=\"color: white\"> <md-icon @click=\"ShowTorneo('idTorneo3')\">photo_size_select_small</md-icon> <span @click=\"ShowTorneo('idTorneo3')\" style=\"text-align: left; overflow: hidden; text-overflow:ellipsis\">&nbsp; ANALISIS TORNEOS</span> </th> </tr> </thead> <tbody id=idTorneoAnalisis class=flex-container> <tr v-if=\"iFrameSrc.length > 0\" style=\"width: 100%; padding: 5px\"> <th class=valign-wrapper> <div id=\"\" class=box style=\"height: 146px; width: 100%; z-index: 4\"> <div class=boxMid id=\"\"> <iframe sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" class=\"\" width=100% height=100% :src=iFrameSrc frameborder=0 autoplay=true allowfullscreen=true scrolling=yes width=100% autoplay=true allowfullscreen=true scrolling=no allow=\"camera; microphone\"></iframe> </div> </div> </th> </tr> <tr v-for=\"analisis in boards\" @click=showBoard(analisis) :key=analisis._id v-if=\"analisis.broadcast === 'true'\"> <td class=valign-wrapper> <div class=containersmall> <board-visor-small-events v-if=\"$index < 4 || true\" :game=analisis :classboard=classBoard></board-visor-small-events> <div class=overlay><span class=valign-wrapper> <img v-bind:src=imagePersona(analisis.u1) alt=\"\" class=imgPersona> <span style=\"text-align: center; overflow: hidden; text-overflow:ellipsis;font-size: xx-small; margin-right: auto\"> <b>{{ analisis.name }}</b>&nbsp;({{ analisis.u1 }})&nbsp;</span> <img v-bind:src=imagePersona(analisis.u2) alt=\"\" class=imgPersona> </span></div> </div> </td> </tr> </tbody> </table> <p style=\"font-size: medium\"></p> <table v-if=\"(getLength(boardFiles) > 0)\" class=\"table highlight\"> <thead> <tr> <th class=\"valign-wrapper purple darken-4\" style=\"color: white\"> <md-icon @click=\"ShowTorneo('idTorneo1')\">photo_size_select_small</md-icon> <span @click=\"ShowTorneo('idTorneo1')\" style=\"text-align: left; overflow: hidden; text-overflow:ellipsis\">&nbsp; Evento: {{ boardFilesName }}</span> <md-icon style=\"margin-left: auto; margin-right: 10px\" @click=OpenTorneo(1)>link</md-icon> </th> </tr> </thead> <tbody id=idTorneo1 class=flex-container> <tr v-if=\"srcVideo1.length > 0\" style=\"width: 100%; padding: 5px\"> <th class=valign-wrapper> <div id=\"\" class=box style=\"height: 146px; width: 100%; z-index: 4\"> <div class=boxMid id=\"\"> <iframe sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" class=\"\" width=100% height=100% :src=srcVideo1 frameborder=0 allow=\"\" allowfullscreen></iframe> </div> </div> </th> </tr> <tr v-for=\"game in boardFiles\" @click=showBoard(game) :key:=game._id> <td class=valign-wrapper> <div class=containersmall> <board-visor-small-events :game=game :classboard=classBoard></board-visor-small-events> <div class=overlay> <span class=valign-wrapper> <img v-bind:src=imagePersona(game.u1) alt=\"\" class=imgPersona> <span style=\"text-align: center; overflow: hidden; text-overflow:ellipsis;font-size: xx-small; margin-right: auto;max-height: 48px\"> {{ generateHeader(game.pgn, false, true) }}</span> <img v-bind:src=imagePersona(game.u2) alt=\"\" class=imgPersona> </span> </div> </div> </td> </tr> </tbody> </table> <table v-if=\"(getLength(boardFiles2) > 0) \" class=\"table highlight\"> <thead> <tr> <th class=\"valign-wrapper purple darken-4\" style=\"color: white\"> <md-icon @click=\"ShowTorneo('idTorneo2')\">photo_size_select_small</md-icon> <span @click=\"ShowTorneo('idTorneo2')\" style=\"text-align: left; overflow: hidden; text-overflow:ellipsis\">&nbsp; Evento: {{ boardFilesName2 }}</span> <md-icon style=\"margin-left: auto; margin-right: 10px\" @click=OpenTorneo(2)>link</md-icon> </th> </tr> </thead> <tbody id=idTorneo2 class=flex-container style=\"display: none\"> <tr v-if=\"srcVideo2.length > 0\" style=\"width: 100%; padding: 5px\"> <th class=valign-wrapper> <div id=\"\" class=box style=\"height: 146px; width: 100%; z-index: 4\"> <div class=boxMid id=\"\"> <iframe class=\"\" sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" width=100% height=100% :src=srcVideo2 frameborder=0 allow=\"\" allowfullscreen></iframe> </div> </div> </th> </tr> <tr v-for=\"game2 in boardFiles2\" @click=showBoard(game2) :key=game2._id> <td class=valign-wrapper> <div class=containersmall> <board-visor-small-events :game=game2 :classboard=classBoard></board-visor-small-events> <div class=overlay> <span class=valign-wrapper> <img v-bind:src=imagePersona(game2.u1) alt=\"\" class=imgPersona> <span style=\"text-align: center; overflow: hidden; text-overflow:ellipsis;font-size: xx-small; margin-right: auto;max-height: 48px\"> {{ generateHeader(game2.pgn, false, true) }}</span> <img v-bind:src=imagePersona(game2.u2) alt=\"\" class=imgPersona> </span> </div> </div> </td> </tr> </tbody> </table> <table v-if=\"(getLength(boardFiles3) > 0) \" class=\"table highlight\"> <thead> <tr> <th class=\"valign-wrapper purple darken-4\" style=\"color: white\"> <md-icon @click=\"ShowTorneo('idTorneo3')\">photo_size_select_small</md-icon> <span @click=\"ShowTorneo('idTorneo3')\" style=\"text-align: left; overflow: hidden; text-overflow:ellipsis\">&nbsp; Evento: {{ boardFilesName3 }}</span> <md-icon style=\"margin-left: auto; margin-right: 10px\" @click=OpenTorneo(3)>link</md-icon> </th> </tr> </thead> <tbody id=idTorneo3 class=flex-container style=\"display: none\"> <tr v-if=\"srcVideo3.length > 0\" style=\"width: 100%; padding: 5px\"> <th class=valign-wrapper> <div id=\"\" class=box style=\"height: 146px; width: 100%; z-index: 4\"> <div class=boxMid id=\"\"> <iframe class=\"\" width=100% height=100% :src=srcVideo3 frameborder=0 allow=\"\" allowfullscreen></iframe> </div> </div> </th> </tr> <tr v-for=\"game3 in boardFiles3\" @click=showBoard(game3) :key=game3._id> <td class=valign-wrapper> <div class=containersmall> <board-visor-small-events :game=game3 :classboard=classBoard></board-visor-small-events> <div class=overlay><span class=valign-wrapper> <img v-bind:src=imagePersona(game3.u1) alt=\"\" class=imgPersona> <span style=\"text-align: center; overflow: hidden; text-overflow:ellipsis;font-size: xx-small; margin-right: auto;max-height: 48px\"> {{ generateHeader(game3.pgn, false, true) }}</span> <img v-bind:src=imagePersona(game3.u2) alt=\"\" class=imgPersona> </span> </div> </div> </td> </tr> </tbody> </table> </div> <div class=\"col s12 m12 l8\"> <md-tabs :active.sync=activeChat class=\"\"> <md-tab name=Visor class=s8> <a :class=\"activeChat === 'Visor' ? 'indicatorTab' : ''\" @click=resizeBoard()>Visor</a> </md-tab> <md-tab name=Chat class=s4> <a :class=\"activeChat === 'Chat' ? 'indicatorTab' : ''\">Chat {{ $t(\"events.title\") }} <span v-show=\"chatRecibido === true\" class=\"badge green darken-4\" style=color:white>{{ chatRecibido === true ? 'Check' : '' }}</span> </a> </md-tab> <div slot=contents> <div id=content_Visor v-if=\"activeChat == 'Visor'\" class=scrollpurple v-on:scroll=userScroll> <board-visor-events v-if=\"active === 'boardVisorEvents'\" :board=board :classboard=classBoard></board-visor-events> </div> <div id=content_Chat v-if=\"activeChat == 'Chat'\" class=scrollpurple v-on:scroll=userScroll> <div class=\"col s12 m12 l12\"> <p style=\"height: 10px\"></p> <div class=\"scrollpurple borderround\" style=\"height: 10vh;overflow: auto;border: 1px solid #5c005c\" id=chatConvertGame> <body-men :mens=mensjGame :dir-server=dirServer :user=user></body-men> </div> <form v-if=\"user.chattext === undefined || user.chattext === true\" v-on:submit.prevent=sendMensaje()> <div class=\"col s9 m9 l9\"> <input class=left name=text id=textChatInput v-model.lazy=chattext /> </div> <div class=\"col s3 m3 l3\"> <select class=emojiclass v-model.lazy=newEmoji style=display:inline;width:auto> <option value=&#128512;>&#128512;</option> <option value=&#128513;>&#128513;</option> <option value=&#128514;>&#128514;</option> <option value=&#128515;>&#128515;</option> <option value=&#128516;>&#128516;</option> <option value=&#128517;>&#128517;</option> <option value=&#128518;>&#128518;</option> <option value=&#128519;>&#128519;</option> <option value=&#128520;>&#128520;</option> <option value=&#128521;>&#128521;</option> <option value=&#128522;>&#128522;</option> <option value=&#128523;>&#128523;</option> <option value=&#128524;>&#128524;</option> <option value=&#128525;>&#128525;</option> <option value=&#128526;>&#128526;</option> <option value=&#128527;>&#128527;</option> <option value=&#128528;>&#128528;</option> <option value=&#128529;>&#128529;</option> <option value=&#128530;>&#128530;</option> <option value=&#128531;>&#128531;</option> <option value=&#128532;>&#128532;</option> <option value=&#128533;>&#128533;</option> <option value=&#128534;>&#128534;</option> </select> <md-btn style=float:right class=\"right md-button btn-floating btn-flat purple darken-4 btn\"> <i class=\"material-icons small\">navigate_next</i> </md-btn> </div> </form> </div> </div> </div> </md-tabs> </div> </div>  <style scoped> /* @import '../../../static/dist/css/pgnvjs.min.css';*/\r\n    \r\n    .emojiclass {\r\n        font-size: large;\r\n    }\r\n    .borderround\r\n    {\r\n        max-height: 400px;\r\n    overflow-y: scroll;\r\n    min-height: 200px;\r\n    border: 1px solid #5c005c;\r\n    border-radius: 5px;\r\n    padding: 5px;\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    /* background: url(/static/img/logo.db1b338.png) right bottom #d0d0d0;*/\r\n    background: right bottom #d0d0d0;\r\n    background-blend-mode: overlay;\r\n    background-size: auto 100px;\r\n    background-repeat: no-repeat;\r\n    }\r\n    .role-piece {\r\n        height: 60px;\r\n        position: relative;\r\n        top: -15px;\r\n    }\r\n\r\n    .imageShow {\r\n        position: fixed;\r\n        z-index: 2;\r\n        left: 10%;\r\n        width: 80%;\r\n        top: 10px;\r\n    }\r\n\r\n    .menText p {\r\n        text-align: justify;\r\n        /* -moz-hyphens: auto;*/\r\n        word-wrap: break-word;\r\n    }\r\n\r\n    .send-btn {\r\n        height: 60px;\r\n    }\r\n\r\n    .close-tab:hover {\r\n        color: #9E1D1D;\r\n    }\r\n\r\n    .collection-item:hover {\r\n        background-color: #b1a58b !important;\r\n        border-bottom: 3px solid #dcdfe2;\r\n    }\r\n    .imgPersona:hover {\r\n        transform: scale(5);\r\n        z-index: 100;\r\n    }\r\n    .imgPersona {\r\n        transition: transform .4s;\r\n        height: 30px;\r\n        max-width: 30%;\r\n        -webkit-transform: scaleX(-1);\r\n        transform: scaleX(-1);\r\n        transition: transform .4s;\r\n    }\r\n    .tabConvert {\r\n        height: 60vh;\r\n        overflow: auto;\r\n    }\r\n\r\n    .popover {\r\n        z-index: 0;\r\n    }\r\n    .logofestival{\r\n        margin: auto;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n    .logofestival img{\r\n        width: 100%;\r\n        /* max-width: 180px;*/\r\n        vertical-align: middle;\r\n    }\r\n    .flex-container {\r\n  /* We first create a flex layout context */\r\n  display: flex;\r\n  \r\n  /* Then we define the flow direction \r\n     and if we allow the items to wrap \r\n   * Remember this is the same as:\r\n   * flex-direction: row;\r\n   * flex-wrap: wrap;\r\n   */\r\n  flex-flow: row wrap;\r\n  \r\n  /* Then we define how is distributed the remaining space */\r\n  justify-content: space-around;\r\n  \r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n.flex-container-reverse {\r\n  /* We first create a flex layout context */\r\n  display: flex;\r\n  \r\n  /* Then we define the flow direction \r\n     and if we allow the items to wrap \r\n   * Remember this is the same as:\r\n   * flex-direction: row;\r\n   * flex-wrap: wrap;\r\n   */\r\n  flex-flow: row wrap-reverse;\r\n  \r\n  /* Then we define how is distributed the remaining space */\r\n  justify-content: space-around;\r\n  \r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\n.flex-item {\r\n  background: tomato;\r\n  padding: 5px;\r\n  width: 200px;\r\n  height: 150px;\r\n  margin-top: 10px;\r\n  line-height: 150px;\r\n  color: white;\r\n  font-weight: bold;\r\n  font-size: 3em;\r\n  text-align: center;\r\n}\r\n\r\n.overlay {\r\n  /*position: absolute; */\r\n  background: rgba(0, 0, 0, 0.7); /* Black see-through */\r\n  color: #f1f1f1; \r\n  width: fit-content;\r\n  transition: .5s ease;\r\n  opacity:1;\r\n  color: white;\r\n  text-align: center;\r\n  /* height: 45px;*/\r\n  z-index: 6;\r\n  height: 50px;\r\n  width: 182px;\r\n}\r\n.containersmall:hover .overlay {\r\n  opacity: 1;\r\n}\r\n* {box-sizing: border-box;}\r\n\r\n.containersmall {\r\n  position: relative;\r\n  /*height: 240px;*/\r\n  width: min-content;\r\n  border: 1px solid gray;\r\n  /*width: 50%;\r\n  max-width: 300px;*/\r\n}\r\n\r\n.imagesmall {\r\n  display: block;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n#mydiv {\r\n  position: relative;\r\n  z-index: 9;\r\n  background-color: #f1f1f1;\r\n  border: 1px solid #d3d3d3;\r\n  text-align: center;\r\n  overflow: scroll;\r\n\tresize: both;\r\n\tmax-width: 1500px;\r\n\tmax-height: 1560px;\r\n}\r\n\r\n#mydivheader {\r\n  padding: 10px;\r\n  z-index: 10;\r\n  background-color: purple;\r\n  color: white;\r\n}\r\n[draggable=true] {\r\n\tcursor: move;\r\n}\r\n\r\n.resizable {\r\n\toverflow: scroll;\r\n\tresize: both;\r\n\tmax-width: 1500px;\r\n\tmax-height: 1560px;\r\n}\r\n\r\n.fade-enter-active, .fade-leave-active {\r\n  transition: opacity .5s\r\n}\r\n.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {\r\n  opacity: 0\r\n}\r\n\r\n/*** Nuevo sistema de movimientos ***/\r\n/* .moves .move .comment {\r\n   display: none; \r\n}\r\n.moves .move a \r\n{\r\n    width: 100%;\r\n    padding-left: 5px;\r\n    height: 28px;\r\n    line-height: 1.75em;\r\n    /* padding: 0 .3em 0 .5em;*\r\n}\r\n.moves .move :hover\r\n{\r\n    width: 100%;\r\n    line-height: 1.75em;\r\n    /* padding: 0 .3em 0 .5em;*\r\n}\r\n.moves .move a:hover {\r\n    border: 0px black;\r\n    background-color: #1B5E20;\r\n    cursor: pointer;\r\n    color: white;\r\n    line-height: 1.75em;\r\n    /* padding: 0 .3em 0 .5em;*\r\n}\r\n.move {\r\n    flex: 0 0 50%;\r\n    display: inline-flex ;\r\n    width: 100%;\r\n    line-height: 1.75em;\r\n    /* padding: 0 .3em 0 .5em;*\r\n}\r\n.moveNumber {\r\n    flex: 0 0 35%;\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    border-inline-end: 1px solid var(--c-border);\r\n    background: #5c005c;\r\n    color: white;\r\n}\r\n.moves {\r\n    display: flex;\r\n    flex-flow: row wrap;\r\n    align-content: flex-start;\r\n}\r\n#pgnMovesEvents, #pgnMoves {\r\n  max-height: 350px;\r\n  overflow-y: scroll;\r\n  /* min-height: auto;*\r\n  border: 1px solid #5c005c;\r\n  border-radius: 5px;\r\n  padding: 1px;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n}*/\r\n/***********/ </style> ";

/***/ }),
/* 517 */,
/* 518 */
/***/ (function(module, exports) {

	module.exports = " <md-modal id=usersConnectWhite class=modal-fixed-footer> <h4 style=\"text-align: center\">{{ $t(\"home.online\") }}</h4> <md-input name=search :value.sync=finduser> {{ $t(\"user.finduser\") }} </md-input> <md-collection-list style=\"overflow-y: scroll\" class=\"row s12 m12 l12\"> <md-collection-list-item class=avatar v-if=\"user.username !== u.nickname && u.club === user.club\" v-for=\"u in usersConnect | filterBy finduser\" @click=userToConversationWhite(u)> <div v-if=\"user.username !== u.nickname && u.club === user.club\"> <img v-bind:src=imageUrl(u.image) @error=imageUrlAlt alt=\"\" class=circle> <span class=title>{{u.nickname}}</span> </div> </md-collection-list-item> </md-collection-list> <span slot=footer> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'usersConnectWhite')\"> {{ $t(\"about.close\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=usersConnectBlack class=modal-fixed-footer> <h4 style=\"text-align: center\">{{ $t(\"home.online\") }}</h4> <md-input name=search :value.sync=finduser> {{ $t(\"user.finduser\") }} </md-input> <md-collection-list style=\"overflow-y: scroll\" class=\"row s12 m12 l12\"> <md-collection-list-item class=avatar v-if=\"user.username !== u.nickname && u.club === user.club\" v-for=\"u in usersConnect | filterBy finduser\" @click=userToConversationBlack(u)> <div v-if=\"user.username !== u.nickname && u.club === user.club\"> <img v-bind:src=imageUrl(u.image) @error=imageUrlAlt alt=\"\" class=circle> <span class=title>{{u.nickname}}</span> </div> </md-collection-list-item> </md-collection-list> <span slot=footer> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'usersConnectBlack')\"> {{ $t(\"about.close\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=inviteGameVersus class=modal-fixed-footer> <div class=\"col s12 m12 l12\"> <div v-if=\"user.role === 'Admin' || user.role === 'Teacher'\" class=\"col s12 card\"> <div class=\"col s6 m6 l6\"> <md-collection-list @click=selectUserToConversationWhite v-if=\"activeWhite.username || activeWhite.nickname\"> <md-collection-list-item class=avatar> <img v-bind:src=imageUrl(activeWhite.image) @error=imageUrlAlt alt=\"\" class=circle> <span class=title>{{activeWhite.nickname || activeWhite.username}}</span> </md-collection-list-item> </md-collection-list> <md-btn v-else class=\"waves-effect waves-light col s12 m12 l12 purple darken-4\" style=\"margin: 10px\" @click=selectUserToConversationWhite> {{ $t(\"game.white\") }} ... </md-btn> </div> <md-input style=display:none :value.sync=newboard.contrincante></md-input> <div class=\"col s6 m6 l6\"> <md-collection-list @click=selectUserToConversationBlack v-if=\"userconvert.username || userconvert.nickname\"> <md-collection-list-item class=avatar> <img v-bind:src=imageUrl(userconvert.image) @error=imageUrlAlt alt=\"\" class=circle> <span class=title>{{userconvert.nickname || userconvert.username}}</span> </md-collection-list-item> </md-collection-list> <md-btn v-else class=\"waves-effect waves-light col s12 m12 l12 purple darken-4\" style=\"margin: 10px\" @click=selectUserToConversationBlack> {{ $t(\"game.black\") }} ... </md-btn> </div> </div> <div class=\"col s6 m6 l6\"> <div class=\"row s12 m12 l12\" v-if=\"user.name === 'PC' || active === 'PC'\"> ELO del Bot ({{ newboard.elo }}) <p class=range-field> <input type=range id=levelStockfish min=500 max=2400 step=100 v-model=newboard.elo /> </p> </div> </div> <div class=\"col s6 m12 l12\"> <div class=\"row s12 m12 l12\"> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.time\") }}</p> <div class=\"col s12 m12 l12 radio-toolbar\" v-if=!timePersonal> <md-radio-group group=time> <md-radio :value.sync=newboard.time radio-value=1 class=with-gap> 1 </md-radio> <md-radio :value.sync=newboard.time radio-value=3 class=with-gap> 3 </md-radio> <md-radio :value.sync=newboard.time radio-value=5 class=with-gap> 5 </md-radio> <md-radio :value.sync=newboard.time radio-value=10 class=with-gap> 10 </md-radio> <md-radio :value.sync=newboard.time radio-value=30 class=with-gap> 30 </md-radio> </md-radio-group> </div> <div class=\"col s12\"> <md-checkbox :value.sync=timePersonal> {{ $t(\"home.createPart.timePersonal\") }} </md-checkbox> <md-input v-if=timePersonal :value.sync=newboard.time type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.fieldTime\") }} </md-input> </div> </div> <div class=\"col s6 m12 l12\"> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.type\") }}</p> <md-switch :value.sync=\"newboard.public !== ''\"> <span slot=on>{{ $t(\"home.createPart.public\") }}</span> <span slot=off>{{ $t(\"home.createPart.private\") }}</span> </md-switch> <md-input :value.sync=newboard.incremento type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.incremento\") }} </md-input> </div> </div> </div> <span slot=footer> <md-button href=# v-if=\"(activeWhite.username || activeWhite.nickname) && (userconvert.username || userconvert.nickname)\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin-left:10px @click=createdInviteGame(true)> {{ $t(\"home.createPart.create\") }} </md-button> <md-button href=# class=\"btn waves-effect waves-purple red darken-4\" style=margin-left:10px @click=createdInviteGame(false)> {{ $t(\"home.createPart.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=inviteGameFast class=modal-fixed-footer> <div class=\"col s12 m12 l12\"> <div class=row> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(1, 0)\">1'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(2, 1)\">2' + 1''</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(3, 0)\">3'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(3, 2)\">3' + 2''</a></p></div> </div> <div class=row> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(5, 0)\">5'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(5, 3)\">5' + 3''</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(10, 0)\">10'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(10, 5)\">10' + 5''</a></p></div> </div> <div class=row> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(15, 0)\">15'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(15, 10)\">15' + 10''</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(30, 0)\">30'</a></p></div> <div class=\"col s12 m6 l3\"><p><a class=\"waves-effect waves-light btn-large btnfast purple darken-4\" @click=\"createdInviteFast(30, 20)\">30' + 20''</a></p></div> </div> </div> <span slot=footer> <md-button href=# class=\"btn waves-effect waves-light purple darken-4\" style=margin-left:10px @click=\"this.$broadcast('modal::open', 'inviteGame')\"> Personalizar </md-button> <md-button href=# class=\"btn waves-effect waves-light red darken-4\" style=margin-left:10px @click=\"this.$broadcast('modal::close', 'some', 'inviteGameFast')\"> {{ $t(\"home.createPart.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=inviteGame class=modal-fixed-footer> <div class=\"col s12 m12 l12\"> <div class=\"\"> <div class=\"col s12 m12 l12 center\"> <div class=\"row s12 m12 l12\" v-if=\"user.name === 'PC' || active === 'PC'\"> <h5 class=header> ELO del Bot <b>({{ newboard.elo }})</b></h5> Puedes modificar el nivel moviendo el rango <p class=range-field> <input type=range id=levelStockfish min=500 max=2400 step=100 v-model=newboard.elo /> </p> </div> <div class=\"col s12 m12 l12 center\"> <div class=\"row s12 m12 l12\"> <md-radio-group group=color class=\"col s12 radio-toolbar\"> <md-radio :value.sync=newboard.color radio-value=w class=with-gap> {{ $t(\"home.createPart.white\") }} </md-radio> <md-radio :value.sync=newboard.color radio-value=b class=with-gap> {{ $t(\"home.createPart.black\") }} </md-radio> </md-radio-group> </div> </div> <h5 class=header><span class=\"flat-text-header hello\">{{ $t(\"home.createPart.time\") }}</span></h5> <div class=\"col s12 m12 l12 radio-toolbar center\" v-if=!timePersonal> <md-radio-group group=time> <md-radio :value.sync=newboard.time radio-value=1 class=with-gap> 1 </md-radio> <md-radio :value.sync=newboard.time radio-value=3 class=with-gap> 3 </md-radio> <md-radio :value.sync=newboard.time radio-value=5 class=with-gap> 5 </md-radio> <md-radio :value.sync=newboard.time radio-value=10 class=with-gap> 10 </md-radio> <md-radio :value.sync=newboard.time radio-value=30 class=with-gap> 30 </md-radio> </md-radio-group> </div> <div class=\"col s12\"> <md-checkbox :value.sync=timePersonal> {{ $t(\"home.createPart.timePersonal\") }} </md-checkbox> <p></p> <md-input v-if=timePersonal :value.sync=newboard.time type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.fieldTime\") }} </md-input> <md-input :value.sync=newboard.incremento type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.incremento\") }} </md-input> </div> </div> <div class=\"col s6 m6 l6\"> <blockquote><span class=\"flat-text-header hello\">{{ $t(\"home.createPart.type\") }}</span></blockquote> <md-switch :value.sync=\"newboard.public !== ''\"> <span slot=on>{{ $t(\"home.createPart.public\") }}</span> <span slot=off>{{ $t(\"home.createPart.private\") }}</span> </md-switch> </div> </div> </div> <span slot=footer> <md-button href=# class=\"btn waves-effect waves-light purple darken-4\" style=margin-left:10px @click=createdInviteGame(true)> {{ $t(\"home.createPart.create\") }} </md-button> <md-button href=# class=\"btn waves-effect waves-light red darken-4\" style=margin-left:10px @click=createdInviteGame(false)> {{ $t(\"home.createPart.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <div class=\"col s12 change-order\"> <div class=\"col s12 m12 l4\"> <div class=\"col s12 m12 l12\"> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> <th class=valign-wrapper><md-icon>playlist_play</md-icon> {{ $t(\"home.played\") }} ({{ getLength(boards) }}) </th> </tr> </thead> <tbody class=flex-container_rev> <template v-for=\"game in boards\" :key=game._id> <tr v-if=isBoardVisible(game) class=\"\"> <td class=valign-wrapper v-if=\"(game.u1 === game.u2 && (game.public || game.all)) || isMine(game) === true\"> <board-visor-small class=imagesmall style=\"margin-left: auto\" :game=game :classboard=classBoard :callback-function=showBoard></board-visor-small> </td> </tr> </template> </tbody> </table> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> <th><hr/></th> </tr> </thead> <tbody> <tr v-for=\"game in boards\" :key=game._id v-show=isBoardVisible(game) class=bkPurple> <td class=\"valign-wrapper bkPurple\" v-if=\"isMine(game) === false && game.u1 !== game.u2\" @click=\"showBoard(game, false)\"> <span class=\"col s12 m12 l12 valign-wrapper\" v-if=\"game.u1 !== game.u2\"> <md-icon>people</md-icon> &nbsp;{{ game.u1 }} <b>&nbsp;VS&nbsp;</b> {{ game.u2 }}&nbsp; <span v-if=\"game.torneo && game.torneo.length > 0\">{{ game.torneo }} ({{ game.ronda }})</span> </span> <span class=\"col s12 m12 l12 valign-wrapper\" v-if=\"game.u1 === game.u2\"> <md-icon>cast</md-icon> &nbsp;<b>{{ game.name }}</b>&nbsp;({{ game.u1 }})&nbsp; </span> </td> <td v-if=\"isMine(game) === false && game.u1 !== game.u2\" v-show=\"game.u1 === game.u2\"> <div class=right> <md-button class=\"btn-floating btn-flat purple darken-4\" @click=\"showBoard(game, true)\"> <md-icon class=\"tiny centered\">open_in_browser</md-icon> </md-button> </div> </td> </tr> </tbody> </table> </div> <div class=\"row s12 m12 l12\"> <div class=\"col s12 m12 l12\"> <md-input name=search v-if=\"getLength(users) > 0 && user.firstName !== 'Guest'\" :value.sync=finduser> {{ $t(\"user.finduser\") }} </md-input> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> <th class=valign-wrapper><md-icon>people</md-icon> <span>{{ $t(\"home.online\") }} ({{ getLength(users) }})</span></th> <th> <md-button data-tooltip=\"Retos entre usuarios\" v-if=\"user.role === 'Admin' || user.role === 'Teacher'\" class=\"tooltip-top right btn-floating btn-flat green darken-3\" style=\"margin-right: 3px\" @click=inviteChessGameDirectVersus()> <md-icon>people</md-icon> </md-button> <md-button slot=secondary-content data-tooltip=\"Reto a todos\" class=\"right green darken-3\" style=\"margin-right: 3px\" @click=\"sendReto('-ALL-');\"> <span style=\"vertical-align: top\">RETAR</span> <i class=\"material-icons small\">people_outline</i> </md-button> </th> </tr> </thead> </table> </div> <div class=\"col s12 m12 l12 scrollpurple\" style=\"max-height: 65vh;overflow: auto\"> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> </tr> </thead> <tbody v-if=\"user.firstName !== 'Guest'\"> <template v-for=\"online in users | filterBy finduser\" v-bind:key=online._id> <tr v-show=\"user.club === online.club || user.role === 'Admin'\"> <td class=valign-wrapper> <img v-bind:src=imageUrl(online.image) @error=imageUrlAlt alt=\"\" style=\"width: 25px; margin-right: 10px\" class=img-responsive> <span v-if=\"online.role !== 'user'\" class=title>[{{ online.role }}] {{ online.nickname }} ({{ online.elo }})</span> <span v-else class=title>{{ online.nickname }} ({{ online.elo }})</span> </td> <td> <div class=right style=\"padding-right: 10px\"> <md-button data-tooltip=Chatear v-if=\"online.username !== user.username\" class=\"btn-floating btn-flat purple darken-2\" @click=openTab(online)> <md-icon>chat</md-icon> </md-button> <md-button data-tooltip=\"Retar a {{ online.nickname }}\" v-if=\"online.username !== user.username\" class=\"btn-floating btn-flat purple darken-4\" @click=inviteChessGameDirect(online)> <i class=material-symbols-outlined>swords</i> </md-button> </div> </td> </tr> </template> <tr> <td class=valign-wrapper> <img v-bind:src=\"imageUrl('Droid-Robot-512.png')\" alt=\"\" style=\"width: 25px; margin-right: 10px\" class=img-responsive> <span class=title>[Bot] Stockfish</span> </td> <td> <div class=right style=\"padding-right: 10px\"> <md-button data-tooltip=\"Retar al bot\" class=\"btn-floating btn-flat purple darken-4\" @click=\"inviteChessGameDirectComputer('PC', 800)\"> <i class=material-symbols-outlined>swords</i> </md-button> </div> </td> </tr> </tbody> </table> </div> </div> </div> <div class=\"col s12 m12 l8\"> <md-tabs :active.sync=active class=z-depth-1 v-show=\"tabs.length > 0 && active !== 'boardVisor'\"> <md-tab :name.sync=tabconver.idTab v-link=\"{path: '/home'}\" class=s4 v-for=\"tabconver in tabs\"> <a :class=\"active === tabconver.name ? 'indicatorTab' : ''\">{{ tabconver.name }} <label class=close-tab @click=closeTab(tabconver.idTab)> <i class=material-icons>close</i></label></a> </md-tab> <div slot=contents> <div v-for=\"tabconver in tabs\" id=\"content_{{ tabconver.idTab }}\" v-show=\"active == tabconver.idTab\" class=\"tabConvert scrollpurple\" v-on:scroll=userScroll> <body-men :mens=tabconver.men :dir-server=dirServer :user=user></body-men> </div> <div class=\"row s12 m12 l12\"> <form v-on:submit.prevent=sendMensaje()> <div class=\"col s9 m9 l9\"> <input class=left name=text id=textChatInput v-model.lazy=chattext /> </div> <div class=\"col s3 m3 l3\"> <select class=emojiclass v-model.lazy=newEmoji style=display:inline;width:auto> <option value=&#128512;>&#128512;</option> <option value=&#128513;>&#128513;</option> <option value=&#128514;>&#128514;</option> <option value=&#128515;>&#128515;</option> <option value=&#128516;>&#128516;</option> <option value=&#128517;>&#128517;</option> <option value=&#128518;>&#128518;</option> <option value=&#128519;>&#128519;</option> <option value=&#128520;>&#128520;</option> <option value=&#128521;>&#128521;</option> <option value=&#128522;>&#128522;</option> <option value=&#128523;>&#128523;</option> <option value=&#128524;>&#128524;</option> <option value=&#128525;>&#128525;</option> <option value=&#128526;>&#128526;</option> <option value=&#128527;>&#128527;</option> <option value=&#128528;>&#128528;</option> <option value=&#128529;>&#128529;</option> <option value=&#128530;>&#128530;</option> <option value=&#128531;>&#128531;</option> <option value=&#128532;>&#128532;</option> <option value=&#128533;>&#128533;</option> <option value=&#128534;>&#128534;</option> </select> <md-btn style=float:right class=\"right md-button btn-floating btn-flat purple darken-4 btn\"> <i class=\"material-icons small\">navigate_next</i> </md-btn> </div> </form> </div> </div> </md-tabs> <board-visor v-if=\"active === 'boardVisor'\" :board=boardHome :classboard=classBoard></board-visor> </div> <style scoped> /* @import '../../../static/dist/css/pgnvjs.min.css';*/\r\n       \r\n        td, th {\r\n            padding: 5px 2px;\r\n        }\r\n        .role-piece {\r\n            height: 60px;\r\n            position: relative;\r\n            top: -15px;\r\n        }\r\n\r\n        .imageShow {\r\n            position: fixed;\r\n            z-index: 2;\r\n            left: 10%;\r\n            width: 80%;\r\n            top: 10px;\r\n        }\r\n\r\n        .menText p {\r\n            text-align: justify;\r\n            /* -moz-hyphens: auto;*/\r\n            word-wrap: break-word;\r\n        }\r\n\r\n        .send-btn {\r\n            height: 60px;\r\n        }\r\n\r\n        .close-tab:hover {\r\n            color: #9E1D1D;\r\n        }\r\n\r\n        .collection-item:hover {\r\n            background-color: #b1a58b !important;\r\n            border-bottom: 3px solid #dcdfe2;\r\n        }\r\n\r\n        .tabConvert {\r\n            height: 60vh;\r\n            overflow: auto;\r\n        }\r\n\r\n        .popover {\r\n            z-index: 0;\r\n        }\r\n        .flex-container_rev tr {\r\n            margin-top: 20px;\r\n        }\r\n        .flex-container_rev {\r\n            display: flex;\r\n            flex-flow: wrap-reverse;\r\n            justify-content: space-evenly;\r\n            padding: 0;\r\n            margin: 0;\r\n            list-style: none;\r\n            margin-bottom: 20px;\r\n        }\r\n        .flex-container {\r\n            display: flex;\r\n            flex-flow: row wrap;\r\n            justify-content: center;\r\n            padding: 0;\r\n            margin: 0;\r\n            list-style: none;\r\n        }\r\n.flex-item {\r\n  background: tomato;\r\n  padding: 5px;\r\n  width: 200px;\r\n  height: 150px;\r\n  margin-top: 10px;\r\n  line-height: 150px;\r\n  color: white;\r\n  font-weight: bold;\r\n  font-size: 3em;\r\n  text-align: center;\r\n}\r\n\r\n.overlay {\r\n  position: absolute; \r\n  transition: .5s ease;\r\n  opacity: 1;\r\n  color: white;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  /* height: 45px;*/\r\n  z-index: 6;\r\n  /*position: absolute; */\r\n  background: rgba(0, 0, 0, 0.7); /* Black see-through */\r\n  color: #f1f1f1; \r\n  transition: .5s ease;\r\n  width: 100%;\r\n}\r\n\r\n.containersmall:hover .overlay {\r\n  opacity: 1;\r\n}\r\n\r\n* {box-sizing: border-box;}\r\n\r\n.containersmall {\r\n  position: relative;\r\n  /*height: 220px;*/\r\n  width: min-content;\r\n  /*width: 50%;\r\n  max-width: 300px;*/\r\n  border: 1px solid gray;\r\n}\r\n.emojiclass {\r\n    font-size: large;\r\n}\r\n.imagesmall {\r\n  display: block;\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n.radio-toolbar {\r\n  margin: 0px;\r\n}\r\n\r\n.radio-toolbar input[type=\"radio\"] {\r\n  opacity: 0;\r\n  position: fixed;\r\n  width: 100px;\r\n}\r\n\r\n.radio-toolbar label {\r\n    display: inline-block;\r\n    background-color: #ddd;\r\n    padding: 40px 40px;\r\n    font-family: sans-serif, Arial;\r\n    font-size: 26px;\r\n    border: 2px solid #444;\r\n    border-radius: 4px;\r\n}\r\n\r\n.radio-toolbar label:hover {\r\n  background-color: #dfd;\r\n}\r\n\r\n.radio-toolbar input[type=\"radio\"]:focus + label {\r\n    border: 2px dashed #444;\r\n}\r\n\r\n.radio-toolbar input[type=\"radio\"]:checked + label {\r\n    background-color: #bfb;\r\n    border-color: #4c4;\r\n}\r\n.btnfast {\r\n  height: 100px;\r\n  line-height: 56px;\r\n  width: -moz-available;\r\n  width: -webkit-fill-available;\r\n  margin: 0px;\r\n  padding: 0px;\r\n  font-size: xx-large;\r\n  padding: 20px;\r\n}\r\n.pulsingButton {\r\n  box-shadow: 0 0 0 0 #5c005c;\r\n  background-color: #5c005c;\r\n  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);\r\n  transition: all 300ms ease-in-out;\r\n}\r\n.bkPurple\r\n{\r\n    background-color: #c9bbc9;\r\n    color: black;\r\n}\r\n.bkPurple:hover\r\n{\r\n    background-color: #5c005c;\r\n    color: white;\r\n}\r\n\r\n/* Comment-out to have the button continue to pulse on mouseover */\r\n\r\na.pulsingButton:hover {\r\n  -webkit-animation: none;\r\n  -moz-animation: none;\r\n  -ms-animation: none;\r\n  animation: none;\r\n  color: #ffffff;\r\n}\r\n\r\n\r\n/* Animation */\r\n\r\n@-webkit-keyframes pulsing {\r\n  to {\r\n    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);\r\n  }\r\n}\r\n\r\n@-moz-keyframes pulsing {\r\n  to {\r\n    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);\r\n  }\r\n}\r\n\r\n@-ms-keyframes pulsing {\r\n  to {\r\n    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);\r\n  }\r\n}\r\n\r\n@keyframes pulsing {\r\n  to {\r\n    box-shadow: 0 0 0 30px rgba(232, 76, 61, 0);\r\n  }\r\n} </style> </div> ";

/***/ }),
/* 519 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12 change-order\"> <div class=\"col s12 m12 l2\"> <md-collection> <md-collection-item v-for=\"puzzleT in puzzlesType\" @click=selectPuzzleType(puzzleT) :class=\"puzzleT.type === puzzleType.type?'active hightlight':'hightlight'\"> <span v-if=\"puzzleT.type === 'Iniciacion'\">Iniciación<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Aperturas'\">Aperturas<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Tactic'\">Táctica<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Estrategia'\">Estrategia<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Finales'\">Finales teóricos<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'MateIn'\">Mates<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Practica'\">Practica<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> <span v-if=\"puzzleT.type === 'Test'\">Ejercicios<md-badge v-if=\"this.puzzleType === puzzleT\">{{ puzzles.length }}</md-badge></span> </md-collection-item> </md-collection> <md-card class=\"purple darken-4\" content-class=white-text v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <span slot=\"\"> <b>{{ $t(\"puzzles.create.title\") }}</b> </span> <p> <i>{{ $t(\"puzzles.create.description\") }}</i> </p> <div slot=actions> <a @click=addClubToGeneralPuzzles(user.club) v-if=\"user.role === 'Admin'\">Importar</a> <a @click=\"addPuzzle('add')\">{{ $t(\"puzzles.create.create\") }}</a> <a @click=editPuzzle() v-if=\"puzzles.length > 0 && (user.username === item.createby || user.role === 'Admin')\">{{ $t(\"puzzles.create.edit\") }}</a> <a @click=delPuzzle() v-if=\"puzzles.length > 0 && (user.username === item.createby || user.role === 'Admin')\">{{ $t(\"puzzles.create.delete\") }}</a> </div> </md-card> </div> <div class=\"col s12 m12 l10 change-order\"> <div class=\"col s12 m12 l5\"> <div class=\"col s12 m12\" v-if=\"puzzles.length === 0\"> <div class=\"card-panel red lighten-2 light center promo\"> <md-icon>info</md-icon> <p class=promo-caption>{{ $t(\"puzzles.attention\") }}</p> <p class=\"light center\"> {{ $t(\"puzzles.attMen\") }} </p> </div> </div> <div style=\"text-align: center\"> <span v-if=puzzleType.type> {{ $t(\"puzzles.types.\"+ puzzleType.type + \".descript\") }} </span> </div> <md-collection v-if=\"puzzles.length > 0\" id=listSomePuzzles style=\"max-height: 80vh;overflow: auto\" class=scrollpurple> <md-collection-item v-for=\"puzzle in puzzles\" :class=\"item._id === puzzle._id ? 'active':''\" @click=selectItm(puzzle)> <div v-if=\"puzzle.type === 'MateIn'\"> <table class=table> <tr> <td width=70%> <span>{{ $index + 1 }}. {{ puzzle.titlefen ? puzzle.titlefen : 'Ejemplo' }}</span> <span v-if=\"user.role === 'Admin'\"> ({{ puzzle.pos }}) </span> </td> <td width=30px class=left> <span v-if=\"user.role === 'Admin'\" @click=subirPuzzle(puzzle._id) style=\"float: right;margin-left: 0px\" data-tooltip=Subir> <i class=\"tooltip-left tiny material-icons right\">arrow_upward</i> </span> </td> <td width=30px class=left> <span v-if=\"user.role === 'Admin'\" @click=bajarPuzzle(puzzle._id) style=\"float: right;margin-left: 0px\" data-tooltip=Bajar> <i class=\"tooltip-left tiny material-icons right\">arrow_downward</i> </span> </td> <td v-if=\"user.role === 'Admin'\" width=40px class=right> <md-input :number=true type=number name=puzzlePos class=puzzlepos :value.sync=puzzle.pos @change=\"putPosPuzzle(puzzle._id, puzzle.pos)\"> </md-input> </td> </tr> </table> </div> <div v-else> <table class=table> <tr> <td width=70%> <span>{{ $index + 1 }}. {{ puzzle.titlefen ? puzzle.titlefen : 'Ejemplo' }} </span> <span v-if=\"user.role === 'Admin'\"> ({{ puzzle.pos }})</span> </td> <td width=30px class=left> <span v-if=\"user.role === 'Admin'\" @click=subirPuzzle(puzzle._id) style=\"float: right;margin-left: 0px\" data-tooltip=Subir> <i class=\"tooltip-left tiny material-icons right\">arrow_upward</i> </span> </td> <td width=30px class=left> <span v-if=\"user.role === 'Admin'\" @click=bajarPuzzle(puzzle._id) style=\"float: right;margin-left: 0px\" data-tooltip=Bajar> <i class=\"tooltip-left tiny material-icons right\">arrow_downward</i> </span> </td> <td v-if=\"user.role === 'Admin'\" width=40px class=right> <md-input :number=true type=number name=puzzlePos class=puzzlepos :value.sync=puzzle.pos @change=\"putPosPuzzle(puzzle._id, puzzle.pos)\"> </md-input> </td> </tr> </table> </div> </md-collection-item> </md-collection> </div> <div class=\"col s12 m12 l7\"> <puzzle-chess :puzzle=item :next-puzzle=nextPuzzle :titlefen=tituloFen :classboard=classBoard></puzzle-chess> </div> </div> <md-modal id=modalCreatePuzzle class=modal-fixed-footer> <h4 style=\"text-align: center\">{{ $t(\"puzzles.create.title\") }} {{ puzzleType.type }}</h4> <div v-show=\"showFenPosition || puzzleType.type === 'Practica'\" class=\"col s12 m12 l12\"> <div style=\"text-align: center\"> <iframe id=iFramePosition width=100% height=450px sandbox=\"allow-same-origin allow-scripts allow-popups allow-forms\" src=./static/libs/cm-fen-editor-main/index.html frameborder=0></iframe> <div v-show=showFenPosition> <hr> <md-button class=\"waves-effect waves-light purple darken-4 center\" style=\"margin-right: 10px\" @click=setFenPosition()> Set </md-button> <hr> </div> </div> </div> <div class=\"col s12 m12 l12\"> <div v-if=\"puzzleType.type !== 'Practica'\" class=\"col s12 m12 l12\"> <div class=\"col s6 m6 l6\"> <div style=\"margin: auto;width: 100%\"> <input name=file type=file id=files class=form-control value=\"\" @change=fileChosen accept=.pgn> <a class=\"default md-button btn-floating purple darken-4 btn\" @click=\"showFenPosition = !showFenPosition\"><md-icon class=\"\">build</md-icon></a> </div> <div class=row></div> <div id=puzzleGenerateFenInit style=\"margin: auto; width: auto; height: 260px\" :class=classBoard></div> </div> <div class=\"col s6 m6 l6\"> <div id=pgnHeader></div> <div id=pgnButtons></div> <div id=pgnMoves></div> </div> </div> <div class=row></div> <div class=\"col s12 m12 l12\"> <md-input style=\"display: none\" name=text :value.sync=fenInit class=\"col s9 m9 l6\"> {{ $t(\"puzzles.create.fenInit\") }} </md-input> <div style=\"display: none\"><b class=flat-text-header>PGN: </b><input id=myPGNValue v-model.lazy=myPGNValue /></div> <div style=\"display: none\"><b class=flat-text-header>FEN: </b><input id=myFENValue v-model.lazy=myFENValue /></div> <md-input name=text :value.sync=numMoves class=\"col s9 m9 l6\"> Número de movimientos </md-input> <md-input name=text :value.sync=tituloFen class=\"col s9 m9 l6\"> Título </md-input> <div class=\"col s12 m4 l4 input-field\"> <select multiple=multiple class=\"\" v-on:change=handleSelectChange style=display:inline;width:100%;height:auto> <option v-for=\"club in listaclubs\" :selected=isSelected(club.name) v-bind:key=isSelected(club.name)>{{ club.name }}</option> </select> </div> <md-input name=text :value.sync=timeMove class=\"col s9 m9 l6\"> Tiempo (en segundos) </md-input> </div> <div class=row></div> <div v-if=\"puzzleType.type !== 'Practica'\"> <textarea style=\"display: none\" id=idTextAreaPGN @change=changePGNTextArea></textarea> <h5 style=\"text-align: center\">Lista de partidas</h5> <md-collection-list id=partidasPgn class=\"col s12 m12 l12\" style=\"display: flex;flex-flow: row wrap;justify-content: space-around;padding: 0;\r\n                margin: 0\"> <md-collection-list-item v-for=\"u in pgnFiles\" @click=openPGN(u.pgn) style=\"width: 170px\" :key=u._id> <board-visor-small :game=u :id=u._id :classboard=classBoard></board-visor-small> <span class=title>{{ generateHeader(u.pgn) }}</span> </md-collection-list-item> </md-collection-list> </div> </div> <span slot=footer> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=createPuzzle(true)> {{[mode === 'add'?$t(\"puzzles.create.create\"):$t(\"puzzles.create.edit\")]}} </md-button> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=createPuzzle(false)> {{ $t(\"puzzles.create.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> </div> <style scoped> .active .puzzlepos input {\r\n        color: white;\r\n        height: auto;\r\n        background: transparent;\r\n    }\r\n    .puzzlepos input {\r\n        color: black;\r\n        height: auto;\r\n        background: transparent;\r\n    }\r\n    #listSomePuzzles .input-field {\r\n      margin-top: auto !important;\r\n    } </style>";

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12\"> <div class=\"col s12 m12 l3\"> <md-collection> <md-collection-item v-for=\"torneoT in torneosType\" @click=selectTorneoType(torneoT) :class=\"torneoT.type === torneoType.type?'active hightlight':'hightlight'\"> <span v-if=\"torneoT.type === 'Liga'\">Liga<md-badge v-if=\"this.torneoType === torneoT\">{{ torneos.length }}</md-badge></span> <span v-if=\"torneoT.type === 'Simultanea'\">Simultánea<md-badge v-if=\"this.torneoType === torneoT\">{{ torneos.length }}</md-badge></span> <span v-if=\"torneoT.type === 'Suizo'\">Suizo<md-badge v-if=\"this.torneoType === torneoT\">{{ torneos.length }}</md-badge></span> <span v-if=\"torneoT.type === 'Aleatorio'\">Aleatorio<md-badge v-if=\"this.torneoType === torneoT\">{{ torneos.length }}</md-badge></span> </md-collection-item> </md-collection> <md-card class=\"purple darken-4\" content-class=white-text v-if=\"user.role === 'Admin' || user.role === 'Teacher'\"> <span slot=title> {{ $t(\"torneos.create.title\") }} </span> <p> {{ $t(\"torneos.create.description\") }} </p> <div slot=actions> <a @click=\"addTorneo('add')\">{{ $t(\"torneos.create.create\") }}</a> <a @click=editTorneo() v-if=\"(user.username === item.createby || user.role === 'Admin') && getLength(item.round1) > 0 && (isBegin() === false || torneoType.type == 'Suizo')\">{{ $t(\"torneos.create.edit\") }}</a> <a @click=delTorneo() v-if=\"(user.username === item.createby || user.role === 'Admin') && getLength(item.round1) > 0\">{{ $t(\"torneos.create.delete\") }}</a> </div> </md-card> </div> <div class=\"col s12 m12 l9\"> <div class=\"col s12 m12 l3\"> <div class=\"col s12 m12\" v-if=\"torneos.length === 0\"> <div class=\"card-panel red lighten-2 light center promo\"> <md-icon>info</md-icon> <p class=promo-caption>{{ $t(\"torneos.attention\") }}</p> <p class=\"light center\"> {{ $t(\"torneos.attMen\") }} </p> </div> </div> <div style=\"text-align: center\"> <span v-if=torneoType.type> {{ $t(\"torneos.types.\"+ torneoType.type + \".descript\") }} </span> </div> <md-collection v-if=\"torneos.length > 0\" id=listSomeTorneos style=\"max-height: 80vh;overflow: auto\" class=scrollpurple> <md-collection-item v-for=\"torneo in torneos\" :class=\"item._id === torneo._id?'active':''\" v-show=\"user.club === item.club && torneo\" @click=selectItm(torneo)> <div v-if=\"torneo.type === 'MateIn'\"> {{ $index + 1 }}. {{ torneo.titlefen }} <md-badge>{{torneo.results}}</md-badge> </div> <div v-else> {{ $index + 1 }}. {{ torneo.titlefen }} <md-badge>{{torneo.results}}</md-badge> </div> </md-collection-item> </md-collection> </div> <div class=\"col s12 m12 l9\"> <div class=\"col s12 m12 l4\"> <div v-for=\"round in item.round1\" class=\"\"> <blockquote style=\"min-width:90px; margin-bottom: 12px;margin-top: 12px\" class=\"pulse chipsmall\">Ronda {{ $index + 1 }}</blockquote> <md-button v-if=\"isBeginRonda($index + 1) === false && user.role === 'Admin' || user.role === 'Teacher'\" class=\"btn-floating purple darken-4\" @click=\"createInvites($index + 1, item.round1, item.titlefen)\"> <i class=material-icons>play_circle_outline</i> </md-button> <md-button v-else class=\"disabled btn-floating purple darken-4\"> <i class=material-icons>play_circle_outline</i> </md-button> </div> <div v-if=\"getLength(item.round1) > 0 && isBegin() === true\"> <md-button class=\"purple darken-4\" style=\"min-width:90px; margin-bottom: 12px;margin-top: 12px; color: white\" @click=\"showResults(item.round1, item.titlefen)\">Resultados </md-button> <md-button class=\"purple darken-4\" style=\"min-width:90px; margin-bottom: 12px;margin-top: 12px; color: white\" @click=refresh()>Refrescar </md-button> </div> </div> <div class=\"col s12 m12 l8\" v-if=\"item.round1 !== undefined && getLength(item.round1) > 0\"> Incremento: {{ item.incremento }}<hr> Tiempo por jugada: {{ item.time }}<hr> Partidas por ronda: {{ getLength(item.round1[0].rounds) }}<hr> Rondas: {{ getLength(item.round1) }}<hr> <table> <thead> <tr> <th width=40% class=\"\">Blancas</th> <th width=40% class=\"\">Negras</th> <th width=20% class=\"\">Resultado</th> </tr> </thead> </table> <div class=scrollpurple style=\"max-height: 65vh;overflow: auto\"> <div v-for=\"round in item.round1\" class=\"\"> <table style=\"max-height: 65vh;overflow: auto\" class=\"scrollpurple col s12 m12 l12\"> <thead> <tr> <th style=\"padding: 0;border-bottom: 2px solid darkgreen\" class=left colspan=3> <blockquote class=\"chip chipsmall\" style=\"min-width: 95%\">Ronda: {{ $index + 1 }}</blockquote> </th> </tr> </thead> <tbody> <tr v-for=\"play in round.rounds\"> <td width=40% class=\"\"><span class=title> {{ play.white }} </span><span class=\"\">&nbsp;{{[isConnected(play.white)?'✔':'']}}</span></td> <td width=40% class=\"\"><span class=title> {{ play.black }} </span><span>&nbsp;{{[isConnected(play.black)?'✔':'']}}</span></td> <td v-if=\"totalRecords > 0\" width=20% class=\"\"><span class=title> {{ (play.wins === 'draw') ? '½ - ½' : (play.wins === 'white' ? '1 - 0' : (play.wins === 'black' ? '0 - 1' : '')) }}</span> <span></span> </td> <td v-else width=20% class=\"\"><span class=title> - </span> <span></span> </td> </tr> </tbody> </table> </div> </div> </div> </div> </div> <md-modal id=modalCreateTorneo class=modal-fixed-footer> <h4 style=\"text-align: center\">{{ $t(\"torneos.create.title\") }} {{ torneoType.type }}</h4> <div class=\"col s12\"> <div class=\"col s12 m12 l3\"> <div class=row> <md-input name=nombretorneo v-if=\"getLength(users) > 0\" :value.sync=nombretorneo> Nombre </md-input> <md-input name=rondas v-if=\"torneoType.type === 'Aleatorio' && getLength(users) > 0\" :value.sync=rondas> Rondas </md-input> <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.time\") }}</p> <div v-if=!timePersonal> <div class=\"col s12\"> <md-radio-group group=time> <md-radio :value.sync=newboard.time radio-value=1 class=with-gap> 1 </md-radio> <md-radio :value.sync=newboard.time radio-value=3 class=with-gap> 3 </md-radio> <md-radio :value.sync=newboard.time radio-value=5 class=with-gap> 5 </md-radio> <md-radio :value.sync=newboard.time radio-value=10 class=with-gap> 10 </md-radio> <md-radio :value.sync=newboard.time radio-value=30 class=with-gap> 30 </md-radio> </md-radio-group> </div> </div> <div class=\"col s12\"> <md-checkbox :value.sync=timePersonal> {{ $t(\"home.createPart.timePersonal\") }} </md-checkbox> <md-input v-if=timePersonal :value.sync=newboard.time type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.fieldTime\") }} </md-input> </div> </div> <hr/> <div class=\"row s12\"> <md-input :value.sync=newboard.incremento type=number :number=true> {{ $t(\"home.createPart.incremento\") }} </md-input> </div> <div v-if=\"torneoType.type === 'Simultanea'\" class=\"row s12 valign-wrapper\" v-if=bSimultanea> <h5>Color aleatorio</h5> <div class=\"\"> <md-switch id=bRandColor name=bRandColor :value.sync=bRandColor> <span slot=on></span> <span slot=off></span> </md-switch> </div> </div> <div v-if=\"torneoType.type === 'Liga'\" class=\"row s12 valign-wrapper\"> <h5>Una vuelta</h5> <div class=\"\"> <md-switch id=bOneRound name=bOneRound :value.sync=bOneRound> <span slot=on></span> <span slot=off></span> </md-switch> </div> </div> </div> <div class=\"col s12 m12 l5\"> <div class=row> <md-input name=search v-if=\"getLength(users) > 0 && user.firstName !== 'Guest'\" :value.sync=finduser> {{ $t(\"user.finduser\") }} </md-input> <div style=\"max-height: 90vh;overflow: auto\" class=\"scrollpurple col s12 m12 l12\"> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> <th class=valign-wrapper><md-icon>person</md-icon> <span>{{ $t(\"home.online\") }} ({{ getLength(users) }})</span></th> <th></th> </tr> </thead> <tbody v-if=\"user.firstName !== 'Guest'\"> <tr v-for=\"online in filteredAndOrderedUsers\" v-bind:key=online.id v-show=\"(bSimultanea === false || online.id !== user._id)\"> <td class=valign-wrapper> <img v-bind:src=imageUrl(online.image) @error=imageUrlAlt alt=\"\" style=\"height: 20px; margin-right: 10px\" class=img-responsive> <span class=title>{{ online.username }}</span> <span class=\"\">&nbsp;{{ [isConnected(online.username) ? '✔' : ''] }}</span> </td> <td> <div class=right> <div class=title>{{ user.club }} ({{ online.elo }})</div> </div> </td> <td> <div class=right> <md-switch id=online.username name=online.username v-if=players[online.username] :value.sync=players[online.username].juega> <span slot=on></span> <span slot=off></span> </md-switch> </div> </td> </tr> </tbody> </table> </div> </div> <md-button v-if=\"torneoType.type === 'Simultanea'\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createAllTournament()> {{ $t(\"home.createPart.create\") }} Simultanea </md-button> <md-button v-if=\"torneoType.type === 'Aleatorio'\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createAllTournament()> {{ $t(\"home.createPart.create\") }} Aleatorio </md-button> <md-button v-if=\"torneoType.type === 'Liga'\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createRoundRobin()> {{ $t(\"home.createPart.create\") }} Liga </md-button> <md-button v-if=\"torneoType.type === 'Suizo'\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createSwiss()> {{ $t(\"home.createPart.create\") }} Ronda </md-button> </div> <div class=\"col s12 m12 l4\"> Usuarios: {{ getLength(players) }}<hr> Partidas por ronda: {{ round1[0] !== undefined ? getLength(round1[0].rounds) : 0 }}<hr> Rondas: {{ getLength(round1) }}<hr> <table> <thead> <tr> <th width=40% class=\"\">Blancas</th> <th width=40% class=\"\">Negras</th> <th width=20% class=\"\">Resultado</th> </tr> </thead> </table> <div class=scrollpurple style=\"max-height: 40vh;overflow: auto\"> <div v-for=\"round in round1\" class=\"\" :value.sync=round1> <table style=\"max-height: 65vh;overflow: auto\" class=\"scrollpurple col s12 m12 l12\"> <thead> <tr> <th style=\"padding: 0; border-bottom: 2px solid darkgreen\" class=center colspan=3>Ronda: {{ $index + 1 }}</th> </tr> </thead> <tbody> <tr v-for=\"play in round.rounds\"> <td width=40% class=\"\"><span class=title> {{ play.white }} </span><span class=\"\">&nbsp;{{[isConnected(play.white)?'✔':'']}}</span></td> <td width=40% class=\"\"><span class=title> {{ play.black }} </span><span>&nbsp;{{[isConnected(play.black)?'✔':'']}}</span></td> <td v-if=\"totalRecords > 0\" width=20% class=\"\"><span class=title> {{ (play.wins === 'draw') ? '½ - ½' : (play.wins === 'white' ? '1 - 0' : (play.wins === 'black' ? '0 - 1' : '')) }}</span> <span></span> </td> <td v-else width=20% class=\"\"><span class=title> - </span> <span></span> </td> </tr> </tbody> </table> </div> </div> </div> </div> <span slot=footer> <md-button :class=\"getLength(round1) <= 0 ? 'disabled' : 'waves-effect waves-light purple darken-4'\" style=\"margin-right: 10px\" @click=createTorneo(true)> {{[mode === 'add'?$t(\"torneos.create.create\"):$t(\"torneos.create.edit\")]}} </md-button> <md-button class=\"waves-effect waves-light purple darken-4\" style=\"margin-right: 10px\" @click=createTorneo(false)> {{ $t(\"torneos.create.cancel\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> <md-modal id=modalResultados class=modal-fixed-footer> <h4 style=\"text-align: center\">Resultado de {{ nombreTorneoResult }} </h4> <div class=scrollpurple style=\"overflow: auto; padding: 30px\"> <table style=\"padding: 10px; overflow: auto;font-size:x-large\" class=\"grid scrollpurple col s12 m12 l12\"> <thead> <tr> <th width=10% class=\"\">Puesto</th> <th width=1% class=\"\"></th> <th width=10% class=\"\">ELO</th> <th width=\"\" class=\"\">Nombre</th> <th width=15% class=\"\"><span class=\"middle chip purple left\" style=\"color: white\"> Puntos </span></th> <th width=15% class=\"\"><span class=chip> BUC </span></th> </tr> </thead> <tbody> <tr v-for=\"play in playersResult\"> <td width=10% class=\"\">{{ $index + 1 }}</td> <td width=10% class=\"\"> <span v-if=\"$index == 0\" style=font-size:xx-large>🥇</span> <span v-if=\"$index == 1\" style=font-size:xx-large>🥈</span> <span v-if=\"$index == 2\" style=font-size:xx-large>🥉</span> </td> <td width=10% class=\"\"> <span class=\"\"> {{ play.elo }}</span> </td> <td width=\"\" class=\"\"> <span class=\"\"> {{ play.name }}</span> </td> <td width=15% class=\"\"><span class=\"chip purple\" style=\"color: white\"> {{ play.score }} </span></td> <td width=15% class=\"\"><span class=chip> {{ play.buchholz }} </span></td> </tr> </tbody> </table> </div> <span slot=footer> <md-button class=\"waves-effect waves-light red darken-4\" style=\"margin-right: 10px\" @click=\"this.$broadcast('modal::close', 'some', 'modalResultados')\"> {{ $t(\"about.close\") }} <md-icon right>cancel</md-icon> </md-button> </span> </md-modal> </div> ";

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"col s12\"> <div class=\"col s12 m12 l3\"> <div class=row> <md-input name=nombretorneo v-if=\"getLength(users) > 0\" :value.sync=nombretorneo> Nombre </md-input> <input name=rondas v-if=\"getLength(users) > 0\" v-model.lazy=rondas> Rondas  <p class=\"flat-text-header hello\">{{ $t(\"home.createPart.time\") }}</p> <div v-if=!timePersonal> <div class=\"col s12\"> <md-radio-group group=time> <md-radio :value.sync=newboard.time radio-value=1 class=with-gap> 1 </md-radio> <md-radio :value.sync=newboard.time radio-value=3 class=with-gap> 3 </md-radio> <md-radio :value.sync=newboard.time radio-value=5 class=with-gap> 5 </md-radio> <md-radio :value.sync=newboard.time radio-value=10 class=with-gap> 10 </md-radio> <md-radio :value.sync=newboard.time radio-value=30 class=with-gap> 30 </md-radio> </md-radio-group> </div> </div> <div class=\"col s12\"> <md-checkbox :value.sync=timePersonal> {{ $t(\"home.createPart.timePersonal\") }} </md-checkbox> <md-input v-if=timePersonal :value.sync=newboard.time type=number :number=true class=\"col s12\"> {{ $t(\"home.createPart.fieldTime\") }} </md-input> </div> </div> <hr/> <div class=\"row s12\"> <md-input :value.sync=newboard.incremento type=number :number=true> {{ $t(\"home.createPart.incremento\") }} </md-input> </div> <div class=\"row s12 valign-wrapper\"> <h5>Simultanea</h5> <div class=\"\"> <md-switch id=bSimultanea name=bSimultanea :value.sync=bSimultanea> <span slot=on></span> <span slot=off></span> </md-switch> </div> </div> <div class=\"row s12 valign-wrapper\" v-if=bSimultanea> <h5>Color aleatorio</h5> <div class=\"\"> <md-switch id=bRandColor name=bRandColor :value.sync=bRandColor> <span slot=on></span> <span slot=off></span> </md-switch> </div> </div> </div> <div class=\"col s12 m12 l5\"> <div class=row> <md-input name=search v-if=\"getLength(users) > 0 && user.firstName !== 'Guest'\" :value.sync=finduser> {{ $t(\"user.finduser\") }} </md-input> <div style=\"max-height: 90vh;overflow: auto\" class=\"scrollpurple col s12 m12 l12\"> <table class=\"table highlight col s12 m12 l12\"> <thead> <tr> <th class=valign-wrapper><md-icon>person</md-icon> <span>{{ $t(\"home.online\") }} ({{ getLength(users) }})</span></th> <th></th> </tr> </thead> <tbody v-if=\"user.firstName !== 'Guest'\"> <tr v-for=\"online in users | filterBy finduser\" v-bind:key=online.id v-show=\"(bSimultanea === false || online.id !== user._id) && user.club === online.club\"> <td class=valign-wrapper> <img v-bind:src=imageUrl(online.image) @error=imageUrlAlt alt=\"\" style=\"height: 20px; margin-right: 10px\" class=img-responsive> <span class=title>[{{ online.role }}] {{ online.nickname }} {{ online.club }} ({{ online.elo }})</span> </td> <td> <div class=right> <md-switch id=online.nickname name=online.nickname :value.sync=players[online.nickname].juega> <span slot=on></span> <span slot=off></span> </md-switch> </div> </td> </tr> <tr> <td class=valign-wrapper> <img v-bind:src=\"imageUrl('Droid-Robot-512.png')\" alt=\"\" style=\"height: 20px; margin-right: 10px\" class=img-responsive> <span class=title>[Bot] Stockfish</span> </td> <td> <div class=right> <md-switch id=PC name=PC :value.sync=\"players['PC'].juega\"> <span slot=on></span> <span slot=off></span> </md-switch> </div> </td> </tr> </tbody> </table> </div> </div> <md-button class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createAllTournament()> {{ $t(\"home.createPart.create\") }} Aleatorio </md-button> <md-button v-model=bSimultanea v-if=\"bSimultanea === false\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=createRoundRobin()> {{ $t(\"home.createPart.create\") }} Liga </md-button> <md-button v-model=bGuardar v-if=\"bGuardar === true\" class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=saveTournament()> Guardar torneo </md-button> <div v-for=\"round in round1\" class=\"\"> <md-button class=\"btn waves-effect waves-purple purple darken-4\" style=margin:10px @click=\"createInvites($index + 1)\"> Lanzar partidas de la ronda {{ $index + 1 }} </md-button> </div> </div> <div class=\"col s12 m12 l4\"> Usuarios: {{ getLength(players) }}<hr> Partidas por ronda: {{ round1[0] !== undefined ? getLength(round1[0].rounds) : 0 }}<hr> Rondas: {{ getLength(round1) }}<hr> <div class=scrollpurple style=\"max-height: 65vh;overflow: auto\"> <div v-for=\"round in round1\" class=\"\"> <blockquote class=chip style=\"min-width: 95%\">Ronda: {{ $index + 1 }} </blockquote> <table style=\"max-height: 65vh;overflow: auto\" class=\"scrollpurple col s12 m12 l12\"> <thead> <tr> <th class=\"\">Blancas</th> <th class=\"\">Negras</th> </tr> </thead> <tbody> <tr v-for=\"play in round.rounds\" v-bind:key=play.white> <td class=\"\"><span class=title>{{ play.white }}</span></td> <td class=\"\"><span class=title>{{ play.black }}</span></td> </tr> </tbody> </table> </div> </div> </div> <style scoped> </style> </div> ";

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	module.exports = " <div class=row> <div class=\"col s12\" v-cloak> <div class=\"col s12 m6 l2\"> <div class=\"col s12 m12 l12\"> <md-card class=center> <span slot=title> {{user.name || user.username}} </span> <div slot=image> <img class=card-image v-if=\"$route.name!=='edituser'\" v-bind:src=imageUrl(user.image) alt=\"\" @error=imageUrlAlt> <upload-files v-if=\"$route.name==='edituser'\" :value.sync=filesUpload name=files :action=dirActionUpload maxsize=100 pathpermit=|jpeg|png|gif> <md-icon right>edit</md-icon> <img v-bind:src=imageUrl(user.image) alt=\"\" @error=imageUrlAlt> </upload-files> </div> </md-card> </div> <div class=\"col s12 m12 l12\"> <md-collection> <md-collection-item v-link=\"{name: 'userdata'}\"> {{ $t(\"account.personalData.title\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-link=\"{name: 'activity'}\"> {{ $t(\"account.activity.title\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-link=\"{name: 'edituser'}\"> {{ $t(\"account.personalData.edit\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-if=\"user.role === 'Admin' || user.role === 'Teacher'\" v-link=\"{name: 'registernew'}\"> {{ $t(\"login.createaccount\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-link=\"{name: 'elo'}\"> {{ $t(\"ELO.eloaccount\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-if=\"user.role === 'Admin'\" v-link=\"{name: 'admin'}\"> {{ $t(\"events.title\") }} <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> <md-collection-item v-if=\"user.role === 'Admin' || user.role === 'Teacher'\" v-link=\"{name: 'otheruser'}\"> Club <md-icon slot=secondary-content>navigate_next</md-icon> </md-collection-item> </md-collection> </div> </div> <div class=\"col s12 m6 l10\"> <router-view></router-view> </div> </div> </div> ";

/***/ }),
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(405)
	__vue_script__ = __webpack_require__(302)
	__vue_template__ = __webpack_require__(510)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(408)
	__vue_script__ = __webpack_require__(305)
	__vue_template__ = __webpack_require__(512)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(406)
	__vue_script__ = __webpack_require__(306)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(307)
	__vue_template__ = __webpack_require__(489)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(395)
	__vue_script__ = __webpack_require__(308)
	__vue_template__ = __webpack_require__(502)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(401)
	__vue_script__ = __webpack_require__(309)
	__vue_template__ = __webpack_require__(507)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(310)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 534 */,
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(397)
	__vue_script__ = __webpack_require__(313)
	__vue_template__ = __webpack_require__(504)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 536 */,
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(316)
	__vue_template__ = __webpack_require__(491)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 538 */,
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(402)
	__vue_script__ = __webpack_require__(319)
	__vue_template__ = __webpack_require__(508)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(321)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(322)
	__vue_template__ = __webpack_require__(494)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(398)
	__vue_script__ = __webpack_require__(324)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(396)
	__vue_script__ = __webpack_require__(325)
	__vue_template__ = __webpack_require__(503)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(404)
	__vue_script__ = __webpack_require__(326)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(327)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 546 */,
/* 547 */,
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(330)
	__vue_template__ = __webpack_require__(498)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 549 */,
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(332)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 551 */,
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(403)
	__vue_script__ = __webpack_require__(335)
	__vue_template__ = __webpack_require__(509)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./boards.js": 298,
		"./index.js": 120,
		"./user.js": 299
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 579;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./adams.jpg": 436,
		"./alekseenko.jpg": 437,
		"./anton guijarro.jpg": 438,
		"./anton guijarro2.jpg": 439,
		"./anton-150x150.jpg": 440,
		"./calzetta.jpg": 441,
		"./carlsen.jpg": 442,
		"./caruana.jpg": 443,
		"./cramling.jpg": 444,
		"./ding.jpg": 445,
		"./dingliren.jpg": 446,
		"./duda.jpg": 447,
		"./edouard.jpg": 448,
		"./eduardoiturrizaga-150x150.jpg": 449,
		"./esipenko.jpg": 450,
		"./firouzja.jpg": 451,
		"./gara.jpg": 452,
		"./giri.jpg": 453,
		"./gukesh d.jpg": 454,
		"./gukesh.jpg": 455,
		"./harikrishna.jpg": 456,
		"./iturrizaga bonelli.jpg": 457,
		"./iturrizaga.jpg": 458,
		"./ivanchuk.jpg": 459,
		"./javakhishvili.jpg": 460,
		"./kamsky.jpg": 461,
		"./keymer.jpg": 462,
		"./khademalsharieh.jpg": 463,
		"./kosteniuk.jpg": 464,
		"./mammadzada.jpg": 465,
		"./matnadze.jpg": 466,
		"./muzychuk.jpg": 467,
		"./nakamura.jpg": 468,
		"./nepomniachtchi.jpg": 469,
		"./nurgyul-salimova-150x150.jpg": 470,
		"./paehtz.jpg": 471,
		"./ponomariov.jpg": 472,
		"./radjabov.jpg": 473,
		"./raport.jpg": 474,
		"./rapport.jpg": 475,
		"./sabrinavega-150x150.jpg": 476,
		"./salimova.jpg": 477,
		"./santos latasa.jpg": 478,
		"./shirov.jpg": 479,
		"./skripchenko-150x150.jpg": 480,
		"./skripchenko.jpg": 481,
		"./socko.jpg": 482,
		"./tari.jpg": 483,
		"./topalov-150x150.jpg": 484,
		"./topalov.jpg": 485,
		"./ushenina.jpg": 486,
		"./vega gutierrez.jpg": 487
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 580;


/***/ }),
/* 581 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(386)();
	// imports
	
	
	// module
	exports.push([module.id, "#container{position:relative;background-color:transparent}#boardWrapper{position:absolute;width:156px;height:364px;top:16px;left:10px;text-align:center;border-width:2px;border-style:solid;border-color:hsla(0,0%,100%,.2) #000 #000 hsla(0,0%,100%,.2);background-color:#384359}.cb{position:relative;font-size:10px;color:#fff;font-weight:600;text-align:center}.cb>div{position:absolute;width:40px;height:40px;background-repeat:no-repeat;font-weight:700;line-height:40px}#cbTable{font-size:10px;padding:0;margin:auto;color:#fff;font-weight:600;border-collapse:collapse}#cbTable td{min-width:16px;line-height:18px;height:20.5px;padding:0;margin:0}#cbTable td.cbCell{padding:0;vertical-align:top;border-width:2px;border-style:solid;border-color:hsla(0,0%,100%,.2) #000 #000 hsla(0,0%,100%,.2);width:320px;height:320px}.cb>div{background-position:50%;font-size:80%;color:#00d200}.cb>.l{background-color:#f0f0f0;background:linear-gradient(to bottom right,#e1e1d9,#fff)}.cb>.d{background-color:#7086b8;background:linear-gradient(to bottom right,#697fb0,#778cc5)}.cb>.h2:before{border:4px solid #d20000;border-radius:12px}.cb>.h0:before,.cb>.h2:before{content:\"\";background-color:transparent;display:block;width:32px!important;height:32px!important}.cb>.h0:before{border:4px solid purple;border-radius:12px}.cb>.h1:before{position:absolute;content:\"\";background-color:transparent;display:block;width:32px!important;height:32px!important;border:4px solid #00d200;border-radius:12px}.cb>.k:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linejoin='miter'%3E%3Cpath d='M22.5 11.63V6'/%3E%3Cpath d='M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5' fill='%23000' stroke-linecap='butt'/%3E%3C/g%3E%3Cpath d='M11.5 37c5.5 3.5 15.5 3.5 21 0v-7s9-4.5 6-10.5c-4-6.5-13.5-3.5-16 4V27v-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10V37z' fill='%23000'/%3E%3Cpath d='M20 8h5' stroke-linejoin='miter'/%3E%3Cg stroke='%23ececec'%3E%3Cpath d='M32 29.5s8.5-4 6.03-9.65C34.15 14 25 18 22.5 24.5l.01 2.1-.01-2.1C20 18 9.906 14 6.997 19.85c-2.497 5.65 4.853 9 4.853 9'/%3E%3Cpath d='M11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.k:before,.cb>.q:before{content:\"\";display:block;width:40px;height:40px}.cb>.q:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke='none'%3E%3Ccircle cx='6' cy='12' r='2.75'/%3E%3Ccircle cx='14' cy='9' r='2.75'/%3E%3Ccircle cx='22.5' cy='8' r='2.75'/%3E%3Ccircle cx='31' cy='9' r='2.75'/%3E%3Ccircle cx='39' cy='12' r='2.75'/%3E%3C/g%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='M9 26c8.5-1.5 21-1.5 27 0l2.5-12.5L31 25l-.3-14.1-5.2 13.6-3-14.5-3 14.5-5.2-13.6L14 25 6.5 13.5 9 26z'/%3E%3Cpath d='M9 26c0 2 1.5 2 2.5 4 1 1.5 1 1 .5 3.5-1.5 1-1.5 2.5-1.5 2.5-1.5 1.5.5 2.5.5 2.5 6.5 1 16.5 1 23 0 0 0 1.5-1 0-2.5 0 0 .5-1.5-1-2.5-.5-2.5-.5-2 .5-3.5 1-2 2.5-2 2.5-4-8.5-1.5-18.5-1.5-27 0z'/%3E%3Cpath d='M11 38.5a35 35 1 0 0 23 0' fill='none'/%3E%3C/g%3E%3Cg fill='none' stroke='%23ececec'%3E%3Cpath d='M11 29a35 35 1 0 1 23 0M12.5 31.5h20M11.5 34.5a35 35 1 0 0 22 0M10.5 37.5a35 35 1 0 0 24 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.r:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='M9 39h27v-3H9v3zM12.5 32l1.5-2.5h17l1.5 2.5h-20zM12 36v-4h21v4H12z'/%3E%3Cpath d='M14 29.5v-13h17v13H14z' stroke-linejoin='miter'/%3E%3Cpath d='M14 16.5L11 14h23l-3 2.5H14zM11 14V9h4v2h5V9h5v2h5V9h4v5H11z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23ececec' stroke-linejoin='miter' stroke-width='1'%3E%3Cpath d='M12 35.5h21M13 31.5h19M14 29.5h17M14 16.5h17M11 14h23'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.b:before,.cb>.r:before{content:\"\";display:block;width:40px;height:40px}.cb>.b:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23000' stroke-linecap='butt'%3E%3Cpath d='M9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z'/%3E%3Cpath d='M15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z'/%3E%3Cpath d='M25 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0z'/%3E%3C/g%3E%3Cpath d='M17.5 26h10M15 30h15m-7.5-14.5v5M20 18h5' stroke='%23ececec' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.n:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23000'%3E%3Cpath d='M22 10c10.5 1 16.5 8 16 29H15c0-9 10-6.5 8-21'/%3E%3Cpath d='M24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4 1-4-4 0-2 6-12 6-12s1.89-1.9 2-3.5c-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2s.78-1.992 2.5-3c1 0 1 3 1 3'/%3E%3C/g%3E%3Cg fill='%23ececec'%3E%3Cg stroke='%23ececec'%3E%3Cpath d='M9.5 25.5a.5.5 0 1 1-1 0 .5.5 0 1 1 1 0z'/%3E%3Cpath d='M14.933 15.75a.5 1.5 30 1 1-.866-.5.5 1.5 30 1 1 .866.5z' stroke-width='1.49997'/%3E%3C/g%3E%3Cpath d='M24.55 10.4l-.45 1.45.5.15c3.15 1 5.65 2.49 7.9 6.75S35.75 29.06 35.25 39l-.05.5h2.25l.05-.5c.5-10.06-.88-16.85-3.25-21.34-2.37-4.49-5.79-6.64-9.19-7.16l-.51-.1' stroke='none'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.n:before,.cb>.p:before{content:\"\";display:block;width:40px;height:40px}.cb>.p:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath d='M22 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38-1.95 1.12-3.28 3.21-3.28 5.62 0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z' stroke='%23000' stroke-linecap='round' stroke-width='1.5'/%3E%3C/svg%3E\")}.cb>.K:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linejoin='miter'%3E%3Cpath d='M22.5 11.63V6M20 8h5'/%3E%3Cpath d='M22.5 25s4.5-7.5 3-10.5c0 0-1-2.5-3-2.5s-3 2.5-3 2.5c-1.5 3 3 10.5 3 10.5' fill='%23fff' stroke-linecap='butt'/%3E%3C/g%3E%3Cpath d='M11.5 37c5.5 3.5 15.5 3.5 21 0v-7s9-4.5 6-10.5c-4-6.5-13.5-3.5-16 4V27v-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10V37z' fill='%23fff'/%3E%3Cpath d='M11.5 30c5.5-3 15.5-3 21 0M11.5 33.5c5.5-3 15.5-3 21 0M11.5 37c5.5-3 15.5-3 21 0'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.K:before,.cb>.Q:before{content:\"\";display:block;width:40px;height:40px}.cb>.Q:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M9 13a2 2 0 1 1-4 0 2 2 0 1 1 4 0z'/%3E%3C/defs%3E%3Cg fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cuse transform='translate(-1 -1)' xlink:href='%23a'/%3E%3Cuse transform='translate(15.5 -5.5)' xlink:href='%23a'/%3E%3Cuse transform='translate(32 -1)' xlink:href='%23a'/%3E%3Cuse transform='translate(7 -4.5)' xlink:href='%23a'/%3E%3Cuse transform='translate(24 -4)' xlink:href='%23a'/%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='M9 26c8.5-1.5 21-1.5 27 0l2-12-7 11V11l-5.5 13.5-3-15-3 15-5.5-14V25L7 14l2 12z'/%3E%3Cpath d='M9 26c0 2 1.5 2 2.5 4 1 1.5 1 1 .5 3.5-1.5 1-1.5 2.5-1.5 2.5-1.5 1.5.5 2.5.5 2.5 6.5 1 16.5 1 23 0 0 0 1.5-1 0-2.5 0 0 .5-1.5-1-2.5-.5-2.5-.5-2 .5-3.5 1-2 2.5-2 2.5-4-8.5-1.5-18.5-1.5-27 0z'/%3E%3C/g%3E%3Cg fill='none'%3E%3Cpath d='M11.5 30c3.5-1 18.5-1 22 0M12 33.5c6-1 15-1 21 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.R:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='M9 39h27v-3H9v3zM12 36v-4h21v4H12zM11 14V9h4v2h5V9h5v2h5V9h4v5'/%3E%3C/g%3E%3Cpath d='M34 14l-3 3H14l-3-3'/%3E%3Cpath d='M31 17v12.5H14V17' stroke-linejoin='miter' stroke-linecap='butt'/%3E%3Cpath d='M31 29.5l1.5 2.5h-20l1.5-2.5'/%3E%3Cpath d='M11 14h23' fill='none' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.B:before,.cb>.R:before{content:\"\";display:block;width:40px;height:40px}.cb>.B:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23fff' stroke-linecap='butt'%3E%3Cpath d='M9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z'/%3E%3Cpath d='M15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z'/%3E%3Cpath d='M25 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 1 1 5 0z'/%3E%3C/g%3E%3Cpath d='M17.5 26h10M15 30h15m-7.5-14.5v5M20 18h5' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.N:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23fff'%3E%3Cpath d='M22 10c10.5 1 16.5 8 16 29H15c0-9 10-6.5 8-21'/%3E%3Cpath d='M24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4 1-4-4 0-2 6-12 6-12s1.89-1.9 2-3.5c-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2s.78-1.992 2.5-3c1 0 1 3 1 3'/%3E%3C/g%3E%3Cg fill='%23000'%3E%3Cpath d='M9.5 25.5a.5.5 0 1 1-1 0 .5.5 0 1 1 1 0z'/%3E%3Cpath d='M14.933 15.75a.5 1.5 30 1 1-.866-.5.5 1.5 30 1 1 .866.5z' stroke-width='1.49997'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.N:before,.cb>.P:before{content:\"\";display:block;width:40px;height:40px}.cb>.P:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath d='M22 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38-1.95 1.12-3.28 3.21-3.28 5.62 0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z' fill='%23fff' stroke='%23000' stroke-linecap='round' stroke-width='1.5'/%3E%3C/svg%3E\")}.cb>.S:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3 -3 48 48'%3E%3Cpath d='M32.91 22.97L13.73 7.07a.478.478 0 0 0-.5-.06.48.48 0 0 0-.27.43v25.22c0 .19.11.35.28.43.17.07.37.04.51-.08l6.08-5.63 4.41 9.25a2.689 2.689 0 0 0 3.57 1.26 2.689 2.689 0 0 0 1.26-3.57l-4.44-9.31 8.07-1.21c.18-.03.32-.17.37-.34a.46.46 0 0 0-.15-.48z' fill='%23fff' stroke='%23000' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E\")}#searchWrapper{position:absolute;top:10px;left:95px}#simpleSearch input:focus,#simpleSearch input:hover{background-color:#fff}#simpleSearch{display:block;width:493px;position:relative;color:#000;background-color:#e3e6e7;border:1px solid #596066;border-radius:2px}#simpleSearch input{margin:0;padding:0;border:0;background-color:transparent;color:#000}#simpleSearch #searchInput{font-family:Segoe UI,Arial,Helvetica,sans-serif;width:100%;padding:3px 4px 2px;font-size:10px;-webkit-appearance:textfield}#simpleSearch #searchInput:focus{outline:0}#simpleSearch #searchInput.placeholder{color:#999}#simpleSearch #searchInput:-ms-input-placeholder{color:#999}#simpleSearch #searchInput:-moz-placeholder{color:#999}#simpleSearch #searchInput::-webkit-search-cancel-button,#simpleSearch #searchInput::-webkit-search-decoration,#simpleSearch #searchInput::-webkit-search-results-button,#simpleSearch #searchInput::-webkit-search-results-decoration{-webkit-appearance:textfield}#buttonBack{top:10px;left:2px}#buttonForward{top:10px;left:32px}#buttonRefresh{top:10px;left:62px}#buttonRevert{top:16px;left:382px}#buttonWindow{top:16px;left:418px}#buttonEdit{top:16px;left:454px}#buttonInfo{top:16px;left:490px}#buttonGraph{top:16px;left:526px}#buttonMenu{top:16px;left:562px}#buttonGo{position:absolute;top:0;right:0;background-color:#fff;width:16px;height:16px;padding:2px 4px 6px;cursor:pointer}#buttonGo:hover{background-color:#ebebeb}#buttonGo{fill:#5e5e5e}.down{background-color:#999da1}.off,.on{position:absolute;color:#e3e6e7;background-position:50%;background-repeat:no-repeat;width:16px;height:16px;padding:5px;border-radius:2px}.on:hover{background-color:#909aa2;cursor:pointer}.off svg{fill:#a1aab1}.off svg,.on svg{position:absolute}.on svg{fill:#e3e6e7}#buttonFlip{line-height:18px;height:16px;padding-top:2.5px;padding-bottom:2px;cursor:pointer}#buttonFlip:hover{background-color:rgba(117,131,142,.4)}#buttonStm{width:9px;height:9px;padding:5.75px 4px;cursor:pointer}#buttonStm div{width:9px;height:9px;border-radius:4.5px}#buttonStm:hover{background-color:rgba(117,131,142,.4)}#buttonStm.white:hover div,#buttonStm.white div{background-color:#fff}#buttonStm.black:hover div,#buttonStm.black div{background-color:#000}#status{background-color:#f9f9fa;color:#444;height:21px;border-style:solid;border-color:#e3e3e3;border-width:1px 0 0 1px;font-size:10px;line-height:20px;display:inline-block;padding:0 4px;pointer-events:none;position:absolute;right:0;bottom:0}#moves{line-height:22px;font-size:10px;font-weight:600;position:relative;width:100%;top:10px;left:0;color:#000;background-color:transparent;overflow-y:scroll}#container.edit #moves{height:358px}#container.graph #moves{height:240px}#container.info #moves{height:200px}.line:nth-child(2n){background-color:rgba(117,131,142,.2)}.line{height:25px;cursor:pointer;position:relative;overflow-x:hidden}.line .san{display:inline-block;width:40px;text-align:center;position:absolute;left:0}.line .info{width:900px;left:140px}.line .eval,.line .info{display:inline-block;text-align:left;position:absolute}.line .eval{width:119px;left:50px}.line .eval .numleft{display:inline-block;min-width:35px;text-align:right}.line .eval .numright{display:inline-block;min-width:40px;text-align:left}.line:hover{background-color:rgba(117,131,142,.4)}#editWrapper{width:0;height:0;opacity:0;overflow:hidden}#container.edit #editWrapper{display:block;line-height:22px;width:110px;height:60px;bottom:10px;right:10px;border-width:0;border-style:none;border-color:hsla(0,0%,100%,.2) #000 #000 hsla(0,0%,100%,.2);background-color:transparent;position:absolute;overflow:hidden;opacity:1;box-shadow:0 0 5px #000}#container.edit #editWrapper,#edit{font-size:10px;font-weight:600;color:#fff}#edit{position:relative;text-align:center}#editWrapper>.cb>div{position:absolute;width:30px;height:30px;line-height:30px}#editWrapper>.cb>div:before{width:28px;height:28px;border:1px solid transparent;border-radius:9px}#infoWrapper{width:0;height:0;opacity:0;overflow:hidden;user-select:text;-moz-user-select:text}#container.info #infoWrapper{display:block;line-height:21px;font-size:12px;width:270px;height:200px;bottom:140px;right:270px;color:#000;border:2px solid #000;background-color:transparent;position:absolute;overflow:hidden;opacity:1;overflow-y:scroll}#infoWrapper>div{position:relative;width:100%;height:100%}#infoContent{padding:1px 3px;height:155px;overflow-y:auto}#infoWrapper .infoIcon{width:16px;height:16px;position:absolute;cursor:pointer;text-align:center;line-height:16px;padding:0;color:#000}#infoWrapper .infoIcon:hover{color:orange}#infoWrapper .infoIcon.selected{color:#000}#infoContent div.underline{padding-bottom:3px;display:block}#infoContent .movelink{color:#000;cursor:pointer}#infoContent .movelink:hover{text-decoration:underline}#infoContent .movelink.selected{color:#000}#graphWrapper{width:0;height:0;opacity:0;overflow:hidden}#container.graph #graphWrapper{display:block;line-height:22px;font-size:10px;font-weight:600;width:100%;height:100px;top:20px;bottom:15px;background-color:transparent;position:relative;overflow:hidden;opacity:1;transform:scale(1);transform-origin:top left}#graph{padding-bottom:.5px;display:none}#container.graph #graph{display:block;background-color:transparent}#arrowWrapper1,#arrowWrapper2{position:absolute;pointer-events:none;display:none;filter:drop-shadow(-1px -1px 1px #fff) drop-shadow(1px 1px 1px #000);opacity:.5}#arrowWrapper1 svg,#arrowWrapper2 svg{opacity:.66}#menu{background-color:#fff;border:1px solid #a0a0a0;top:75px;right:10px;position:absolute;box-shadow:0 0 4px rgba(0,0,0,.2);padding-top:6px;padding-bottom:6px;font-size:12px;color:#000}.menuLine{height:1px;margin-top:6px;margin-bottom:6px;background-color:#dedede}.menuItem{height:12px;line-height:12px;padding:6px 14px 6px 36px;cursor:pointer;background-repeat:no-repeat;background-position:12px 4px}.menuItem:hover{background-color:#f0f0f0}.menuItem.disabled{color:#6d6d6d;cursor:default}.menuItem.disabled:hover{background-color:#fff}.menuItem span.key{float:right;text-align:right;color:#6d6d6d;width:47px}.menuItem.menuEngine{padding-bottom:0;padding-top:0;height:24px;padding-right:9px}.menuItem.menuEngine>span{display:inline-block;padding-top:6px;padding-bottom:6px;vertical-align:top}.menuItem.menuEngine:hover{background-color:#fff;cursor:default}#buttonEngineMinus,#buttonEnginePlus,#buttonEngineValue{float:right;cursor:pointer;margin-left:5px}#buttonEngineMinus:hover,#buttonEnginePlus:hover,#buttonEngineValue:hover{background-color:#f0f0f0}#buttonEngineMinus,#buttonEnginePlus{width:24px;height:24px;padding:0 1px;background-repeat:no-repeat;background-position:50%}#buttonEngineValue{width:24px;height:12px;padding:5px 0;background-color:#f0f0f0;border:1px solid #d1d1d1;border-radius:6px;text-align:center}#buttonEngineValue:hover{background-color:#e8e8e8}#buttonEngineMinus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cpath d='M6 12h12'/%3E%3C/svg%3E\")}#buttonEnginePlus{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-plus'%3E%3Cpath d='M12 6v12M6 12h12'/%3E%3C/svg%3E\")}.menuItem.menuPlay{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M10 8l6 4-6 4V8z'/%3E%3C/svg%3E\")}.menuItem.menuFlip{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 443 443' width='16' height='16' fill='currentColor'%3E%3Cpath d='M254.56 118.55v205.9l68.77-27.17c2.31-.9 4.93-.16 6.43 1.81.73.99 1.11 2.16 1.11 3.32 0 1.17-.38 2.36-1.14 3.36L225.88 440.85a5.543 5.543 0 0 1-4.37 2.15c-1.71 0-3.33-.8-4.38-2.15L113.29 305.77c-1.53-1.97-1.53-4.69-.04-6.69a5.539 5.539 0 0 1 6.42-1.8l68.77 27.16V118.55l-68.76 27.16c-2.31.9-4.93.16-6.43-1.8a5.567 5.567 0 0 1-1.11-3.32c0-1.17.38-2.36 1.14-3.36L217.13 2.15A5.543 5.543 0 0 1 221.5 0c1.71 0 3.33.8 4.38 2.15l103.83 135.08a5.492 5.492 0 0 1 .04 6.68c-1.48 1.97-4.11 2.7-6.42 1.8z'/%3E%3C/svg%3E\")}.menuItem.menuStm{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 2a1 1 0 0 0 0 20' fill='currentColor' stroke='none'/%3E%3C/svg%3E\")}.menuItem.menuKeep{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-save'%3E%3Cpath d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z'/%3E%3Cpath d='M17 21v-8H7v8M7 3v5h8'/%3E%3C/svg%3E\")}.menuItem.menuKeep.disabled{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-save'%3E%3Cpath d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z'/%3E%3Cpath d='M17 21v-8H7v8M7 3v5h8'/%3E%3C/svg%3E\")}.menuItem.menuRevert{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' width='16' height='16'%3E%3Cpath d='M431.85 79.13L-1.51 512.5l433.37 431.64V670.8c463.64-39.79 591.66 197.22 591.66 197.22s0-431.63-591.66-512.94z'/%3E%3C/svg%3E\")}.menuItem.menuRevert.disabled{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' fill='%236d6d6d' width='16' height='16'%3E%3Cpath d='M431.85 79.13L-1.51 512.5l433.37 431.64V670.8c463.64-39.79 591.66 197.22 591.66 197.22s0-431.63-591.66-512.94z'/%3E%3C/svg%3E\")}.menuItem.menuEngine{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-layers'%3E%3Cpath d='M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5'/%3E%3C/svg%3E\")}.menuItem.menuReset{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-home'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'/%3E%3Cpath d='M9 22V12h6v10'/%3E%3C/svg%3E\")}.menuItem.menuAbout{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-help-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3M12 17'/%3E%3C/svg%3E\")}.menuItem.menuStart{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-left-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 8l-4 4 4 4M16 12H8'/%3E%3C/svg%3E\")}.menuItem.menuStart.disabled{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-left-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 8l-4 4 4 4M16 12H8'/%3E%3C/svg%3E\")}.menuItem.menuEnd{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-right-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 16l4-4-4-4M8 12h8'/%3E%3C/svg%3E\")}.menuItem.menuEnd.disabled{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-right-circle'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 16l4-4-4-4M8 12h8'/%3E%3C/svg%3E\")}", "", {"version":3,"sources":["/./static/libs/simplechessboard.min.css"],"names":[],"mappings":"AAAA,WAAW,kBAAkB,4BAA4B,CAAC,cAAc,kBAAkB,YAAY,aAAa,SAAS,UAAU,kBAAkB,iBAAiB,mBAAmB,6DAAiE,wBAAwB,CAAC,IAAI,kBAAkB,eAAe,WAAW,gBAAgB,iBAAiB,CAAC,QAAQ,kBAAkB,WAAW,YAAY,4BAA4B,AAA2B,gBAAgB,gBAAgB,CAAC,SAAS,eAAe,UAAU,YAAY,WAAW,gBAAgB,wBAAwB,CAAC,YAAY,eAAe,iBAAiB,cAAc,UAAU,QAAQ,CAAC,mBAAmB,UAAU,mBAAmB,iBAAiB,mBAAmB,6DAAiE,YAAY,YAAY,CAAC,QAAQ,wBAA2B,cAAc,aAAqB,CAAC,OAAO,yBAAyB,wDAAmF,CAAC,OAAO,yBAAyB,2DAAmF,CAAC,eAAgH,yBAAiC,kBAAkB,CAAC,8BAArJ,WAAW,6BAA6B,cAAc,qBAAqB,qBAAsB,CAA0N,AAAtK,eAAgH,wBAAmC,kBAAkB,CAAC,eAAe,kBAAkB,WAAW,6BAA6B,cAAc,qBAAqB,sBAAsB,yBAAiC,kBAAkB,CAAC,cAA8D,64BAA48B,CAAC,4BAA7/B,WAAW,cAAc,WAAW,WAAY,CAA0mE,AAA7pC,cAA8D,sgCAA8lC,CAAC,cAA8D,qpBAAiwB,CAAC,4BAAlzB,WAAW,cAAc,WAAW,WAAY,CAAioD,AAA/3B,cAA8D,uzBAAg0B,CAAC,cAA8D,w8BAA2/B,CAAC,4BAA5iC,WAAW,cAAc,WAAW,WAAY,CAA0/C,AAA9f,cAA8D,6cAA+b,CAAC,cAA8D,6rBAA6uB,CAAC,4BAA9xB,WAAW,cAAc,WAAW,WAAY,CAA63D,AAA/oC,cAA8D,6kCAAglC,CAAC,cAA8D,olBAAioB,CAAC,4BAAlrB,WAAW,cAAc,WAAW,WAAY,CAA89C,AAA51B,cAA8D,oyBAA6xB,CAAC,cAA8D,quBAA6vB,CAAC,4BAA9yB,WAAW,cAAc,WAAW,WAAY,CAA0wC,AAA5gB,cAA8D,2dAA6c,CAAC,cAAc,WAAW,cAAc,WAAW,YAAY,qdAA4hB,CAAC,eAAe,kBAAkB,SAAS,SAAS,CAAC,oDAAoD,qBAAqB,CAAC,cAAc,cAAc,YAAY,kBAAkB,WAAW,yBAAyB,yBAAyB,iBAAiB,CAAC,oBAAoB,SAAS,UAAU,SAAS,6BAA6B,UAAU,CAAC,2BAA2B,gDAAkD,WAAW,oBAAwB,eAAe,4BAA4B,CAAC,iCAAiC,SAAS,CAAC,uCAAuC,UAAU,CAAC,iDAAiD,UAAU,CAAC,4CAA4C,UAAU,CAAC,uOAAuO,4BAA4B,CAAC,YAAY,SAAS,QAAQ,CAAC,eAAe,SAAS,SAAS,CAAC,eAAe,SAAS,SAAS,CAAC,cAAc,SAAS,UAAU,CAAC,cAAc,SAAS,UAAU,CAAC,YAAY,SAAS,UAAU,CAAC,YAAY,SAAS,UAAU,CAAC,aAAa,SAAS,UAAU,CAAC,YAAY,SAAS,UAAU,CAAC,UAAU,kBAAkB,MAAM,QAAQ,sBAAsB,WAAW,YAAY,oBAAwB,cAAc,CAAC,gBAAgB,wBAAwB,CAAC,UAAU,YAAY,CAAC,MAAM,wBAAwB,CAAC,SAAS,kBAAkB,cAAc,wBAA2B,4BAA4B,WAAW,YAAY,YAAY,iBAAiB,CAAC,UAAU,yBAAyB,cAAc,CAAC,SAAS,YAAa,CAAkB,iBAAlB,iBAAiB,CAAwC,AAAvC,QAAQ,YAAa,CAAkB,YAAY,iBAAiB,YAAY,kBAAkB,mBAAmB,cAAc,CAAC,kBAAkB,qCAAqC,CAAC,WAAW,UAAU,WAAW,mBAAmB,cAAc,CAAC,eAAe,UAAU,WAAW,mBAAmB,CAAC,iBAAiB,qCAAqC,CAAC,gDAAgD,qBAAqB,CAAC,gDAAgD,qBAAqB,CAAC,QAAQ,yBAAyB,WAAW,YAAY,mBAAmB,qBAAqB,yBAAyB,eAAe,iBAAiB,qBAAqB,cAAoB,oBAAoB,kBAAkB,QAAQ,QAAQ,CAAC,OAAO,iBAAiB,eAAe,gBAAgB,kBAAkB,WAAW,SAAS,OAAO,WAAW,6BAA6B,iBAAiB,CAAC,uBAAuB,YAAY,CAAC,wBAAwB,YAAY,CAAC,uBAAuB,YAAY,CAAC,oBAAsB,qCAAqC,CAAC,MAAM,YAAY,eAAe,kBAAkB,iBAAiB,CAAC,WAAW,qBAAqB,WAAW,kBAAkB,kBAAkB,MAAM,CAAC,YAAiC,YAAY,AAAkC,UAAU,CAAC,wBAA9E,qBAAqB,AAAY,gBAAgB,iBAAkB,CAAoG,AAAzF,YAAiC,YAAY,AAAkC,SAAS,CAAC,qBAAqB,qBAAqB,eAAe,gBAAgB,CAAC,sBAAsB,qBAAqB,eAAe,eAAe,CAAC,YAAY,qCAAqC,CAAC,aAAa,QAAQ,SAAS,UAAU,eAAe,CAAC,6BAA6B,cAAc,iBAAiB,AAA+B,YAAY,YAAY,YAAY,WAAW,AAAW,eAAe,kBAAkB,6DAAiE,6BAA6B,kBAAkB,gBAAgB,UAAU,uBAAuB,CAAC,mCAA5R,eAAe,gBAAgB,AAA+C,UAAW,CAAuR,AAApF,MAAM,kBAAkB,AAA0C,iBAAiB,CAAC,qBAAqB,kBAAkB,WAAW,YAAY,gBAAgB,CAAC,4BAA6B,WAAW,YAAY,6BAA6B,iBAAiB,CAAC,aAAa,QAAQ,SAAS,UAAU,gBAAgB,iBAAiB,qBAAqB,CAAC,6BAA6B,cAAc,iBAAiB,eAAe,YAAY,aAAa,aAAa,YAAY,WAAW,AAAoC,sBAAkB,6BAA6B,kBAAkB,gBAAgB,UAAU,iBAAiB,CAAC,iBAAiB,kBAAkB,WAAW,WAAW,CAAC,aAAa,gBAAwB,aAAa,eAAe,CAAC,uBAAuB,WAAW,YAAY,kBAAkB,eAAe,kBAAkB,iBAAiB,UAAU,UAAU,CAAC,6BAA6B,YAAY,CAAC,gCAAgC,UAAU,CAAC,2BAA2B,mBAAmB,aAAa,CAAC,uBAAuB,WAAW,cAAc,CAAC,6BAA6B,yBAAyB,CAAC,gCAAgC,UAAU,CAAC,cAAc,QAAQ,SAAS,UAAU,eAAe,CAAC,+BAA+B,cAAc,iBAAiB,eAAe,gBAAgB,WAAW,aAAa,SAAS,YAAY,6BAA6B,kBAAkB,gBAAgB,UAAU,mBAAqB,yBAAyB,CAAC,OAAO,oBAAoB,YAAY,CAAC,wBAAwB,cAAc,4BAA4B,CAAC,8BAA8B,kBAAkB,oBAAoB,aAAa,qEAAqE,UAAU,CAAC,sCAAsC,WAAW,CAAC,MAAM,sBAAsB,yBAAyB,SAAS,WAAW,kBAAkB,kCAAoC,gBAAgB,mBAAmB,eAAe,UAAU,CAAC,UAAU,WAAW,eAAe,kBAAkB,wBAAwB,CAAC,UAAU,YAAY,iBAAiB,0BAAkB,AAAsD,eAAe,4BAA4B,4BAA4B,CAAC,gBAAgB,wBAAwB,CAAC,mBAAmB,cAAc,cAAc,CAAC,yBAAyB,qBAAqB,CAAC,mBAAmB,YAAY,iBAAiB,cAAc,UAAU,CAAC,qBAAqB,iBAAiB,cAAc,YAAY,iBAAiB,CAAC,0BAA0B,qBAAqB,gBAAgB,mBAAmB,kBAAkB,CAAC,2BAA2B,sBAAsB,cAAc,CAAC,wDAAwD,YAAY,eAAe,eAAe,CAAC,0EAA0E,wBAAwB,CAAC,qCAAqC,WAAW,YAAY,cAAc,4BAA4B,uBAA0B,CAAC,mBAAmB,WAAW,YAAY,cAAc,yBAAyB,yBAAyB,kBAAkB,iBAAiB,CAAC,yBAAyB,wBAAwB,CAAC,mBAAmB,kTAAgU,CAAC,kBAAkB,yTAAmX,CAAC,mBAAmB,oWAA4X,CAAC,mBAAmB,6qBAAyuB,CAAC,kBAAkB,0YAA6Y,CAAC,mBAAmB,6YAAsd,CAAC,4BAA4B,0YAAmd,CAAC,qBAAqB,4RAA+R,CAAC,8BAA8B,6SAAgT,CAAC,qBAAqB,kWAA2b,CAAC,oBAAoB,oXAAkZ,CAAC,oBAAoB,8XAAwb,CAAC,oBAAoB,gXAAqb,CAAC,6BAA6B,6WAAkb,CAAC,kBAAkB,gXAAub,CAAC,2BAA2B,6WAAob,CAAC","file":"simplechessboard.min.css","sourcesContent":["#container{position:relative;background-color:transparent}#boardWrapper{position:absolute;width:156px;height:364px;top:16px;left:10px;text-align:center;border-width:2px;border-style:solid;border-color:rgba(255,255,255,.2) #000 #000 rgba(255,255,255,.2);background-color:#384359}.cb{position:relative;font-size:10px;color:#fff;font-weight:600;text-align:center}.cb>div{position:absolute;width:40px;height:40px;background-repeat:no-repeat;background-position:center;font-weight:700;line-height:40px}#cbTable{font-size:10px;padding:0;margin:auto;color:#fff;font-weight:600;border-collapse:collapse}#cbTable td{min-width:16px;line-height:18px;height:20.5px;padding:0;margin:0}#cbTable td.cbCell{padding:0;vertical-align:top;border-width:2px;border-style:solid;border-color:rgba(255,255,255,.2) #000 #000 rgba(255,255,255,.2);width:320px;height:320px}.cb>div{background-position:center;font-size:80%;color:rgba(0,210,0,1)}.cb>.l{background-color:#f0f0f0;background:linear-gradient(to bottom right,rgba(225,225,217,1),rgba(255,255,255,1))}.cb>.d{background-color:#7086b8;background:linear-gradient(to bottom right,rgba(105,127,176,1),rgba(119,140,197,1))}.cb>.h2:before{content:\"\";background-color:transparent;display:block;width:32px!important;height:32px!important;border:4px solid rgba(210,0,0,1);border-radius:12px}.cb>.h0:before{content:\"\";background-color:transparent;display:block;width:32px!important;height:32px!important;border:4px solid rgba(128,0,128,1);border-radius:12px}.cb>.h1:before{position:absolute;content:\"\";background-color:transparent;display:block;width:32px!important;height:32px!important;border:4px solid rgba(0,210,0,1);border-radius:12px}.cb>.k:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linejoin='miter'%3E%3Cpath d='m22.5 11.63v-5.63' stroke='%23000'/%3E%3Cpath d='m22.5 25c0 0 4.5-7.5 3-10.5 0 0-1-2.5-3-2.5-2 0-3 2.5-3 2.5-1.5 3 3 10.5 3 10.5' fill='%23000' stroke-linecap='butt'/%3E%3C/g%3E%3Cg stroke='%23000'%3E%3Cpath d='m11.5 37c5.5 3.5 15.5 3.5 21 0v-7c0 0 9-4.5 6-10.5-4-6.5-13.5-3.5-16 4v3.5-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10v7.5z' fill='%23000'/%3E%3Cpath d='m20 8h5' stroke-linejoin='miter'/%3E%3C/g%3E%3Cg stroke='%23ececec'%3E%3Cpath d='m32 29.5c0 0 8.5-4 6.03-9.65-3.88-5.85-13.03-1.85-15.53 4.65l.01 2.1-.01-2.1c-2.5-6.5-12.594-10.5-15.503-4.65-2.497 5.65 4.853 9 4.853 9'/%3E%3Cpath d='m11.5 30c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0m-21 3.5c5.5-3 15.5-3 21 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.q:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke='none'%3E%3Ccircle cx='6' cy='12' r='2.75'/%3E%3Ccircle cx='14' cy='9' r='2.75'/%3E%3Ccircle cx='22.5' cy='8' r='2.75'/%3E%3Ccircle cx='31' cy='9' r='2.75'/%3E%3Ccircle cx='39' cy='12' r='2.75'/%3E%3C/g%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='m9 26c8.5-1.5 21-1.5 27 0l2.5-12.5-7.5 11.5-.3-14.1-5.2 13.6-3-14.5-3 14.5-5.2-13.6-.3 14.1-7.5-11.5 2.5 12.5z' stroke='%23000'/%3E%3Cpath d='m9 26c0 2 1.5 2 2.5 4 1 1.5 1 1 .5 3.5-1.5 1-1.5 2.5-1.5 2.5-1.5 1.5.5 2.5.5 2.5 6.5 1 16.5 1 23 0 0 0 1.5-1 0-2.5 0 0 .5-1.5-1-2.5-.5-2.5-.5-2 .5-3.5 1-2 2.5-2 2.5-4-8.5-1.5-18.5-1.5-27 0z'/%3E%3Cpath d='M11 38.5A35 35 1 0 0 34 38.5' fill='none' stroke='%23000'/%3E%3C/g%3E%3Cg fill='none' stroke='%23ececec'%3E%3Cpath d='M11 29A35 35 1 0 1 34 29'/%3E%3Cpath d='m12.5 31.5h20'/%3E%3Cpath d='M11.5 34.5A35 35 1 0 0 33.5 34.5'/%3E%3Cpath d='M10.5 37.5A35 35 1 0 0 34.5 37.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.r:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='m9 39h27v-3h-27v3z'/%3E%3Cpath d='m12.5 32l1.5-2.5h17l1.5 2.5h-20z'/%3E%3Cpath d='m12 36v-4h21v4h-21z'/%3E%3Cpath d='m14 29.5v-13h17v13h-17z' stroke-linejoin='miter'/%3E%3Cpath d='m14 16.5l-3-2.5h23l-3 2.5h-17z'/%3E%3Cpath d='m11 14v-5h4v2h5v-2h5v2h5v-2h4v5h-23z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23ececec' stroke-linejoin='miter' stroke-width='1'%3E%3Cpath d='m12 35.5h21'/%3E%3Cpath d='m13 31.5h19'/%3E%3Cpath d='m14 29.5h17'/%3E%3Cpath d='m14 16.5h17'/%3E%3Cpath d='m11 14h23'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.b:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23000' stroke='%23000' stroke-linecap='butt'%3E%3Cpath d='m9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z'/%3E%3Cpath d='m15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z'/%3E%3Cpath d='M25 8A2.5 2.5 0 1 1 20 8 2.5 2.5 0 1 1 25 8z'/%3E%3C/g%3E%3Cpath d='m17.5 26h10m-12.5 4h15m-7.5-14.5v5m-2.5-2.5h5' stroke='%23ececec' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.n:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23000' stroke='%23000'%3E%3Cpath d='m22 10c10.5 1 16.5 8 16 29h-23c0-9 10-6.5 8-21'/%3E%3Cpath d='m24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4 1-4-4 0-2 6-12 6-12 0 0 1.89-1.9 2-3.5-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2c0 0 .78-1.992 2.5-3 1 0 1 3 1 3'/%3E%3C/g%3E%3Cg fill='%23ececec'%3E%3Cg stroke='%23ececec'%3E%3Cpath d='M9.5 25.5A.5 .5 0 1 1 8.5 25.5 .5 .5 0 1 1 9.5 25.5z'/%3E%3Cpath d='M15 15.5A.5 1.5 0 1 1 14 15.5 .5 1.5 0 1 1 15 15.5z' transform='matrix(.866.5-.5.866 9.693-5.173)'/%3E%3C/g%3E%3Cpath d='m24.55 10.4l-.45 1.45.5.15c3.15 1 5.65 2.49 7.9 6.75 2.25 4.26 3.25 10.31 2.75 20.25l-.05.5h2.25l.05-.5c.5-10.06-.88-16.85-3.25-21.34-2.37-4.49-5.79-6.64-9.19-7.16l-.51-.1' stroke='none'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.p:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath d='m22 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38-1.95 1.12-3.28 3.21-3.28 5.62 0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z' stroke='%23000' stroke-linecap='round' stroke-width='1.5'/%3E%3C/svg%3E\")}.cb>.K:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linejoin='miter'%3E%3Cpath d='m22.5 11.63v-5.63'/%3E%3Cpath d='m20 8h5'/%3E%3Cpath d='m22.5 25c0 0 4.5-7.5 3-10.5 0 0-1-2.5-3-2.5-2 0-3 2.5-3 2.5-1.5 3 3 10.5 3 10.5' fill='%23fff' stroke-linecap='butt'/%3E%3C/g%3E%3Cpath d='m11.5 37c5.5 3.5 15.5 3.5 21 0v-7c0 0 9-4.5 6-10.5-4-6.5-13.5-3.5-16 4v3.5-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10v7.5z' fill='%23fff'/%3E%3Cpath d='m11.5 30c5.5-3 15.5-3 21 0'/%3E%3Cpath d='m11.5 33.5c5.5-3 15.5-3 21 0'/%3E%3Cpath d='m11.5 37c5.5-3 15.5-3 21 0'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.Q:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='0' d='M9 13A2 2 0 1 1 5 13 2 2 0 1 1 9 13z'/%3E%3C/defs%3E%3Cg fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cuse transform='translate(-1-1)' xlink:href='%230'/%3E%3Cuse transform='translate(15.5-5.5)' xlink:href='%230'/%3E%3Cuse transform='translate(32-1)' xlink:href='%230'/%3E%3Cuse transform='translate(7-4.5)' xlink:href='%230'/%3E%3Cuse transform='translate(24-4)' xlink:href='%230'/%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='m9 26c8.5-1.5 21-1.5 27 0l2-12-7 11v-14l-5.5 13.5-3-15-3 15-5.5-14v14.5l-7-11 2 12z'/%3E%3Cpath d='m9 26c0 2 1.5 2 2.5 4 1 1.5 1 1 .5 3.5-1.5 1-1.5 2.5-1.5 2.5-1.5 1.5.5 2.5.5 2.5 6.5 1 16.5 1 23 0 0 0 1.5-1 0-2.5 0 0 .5-1.5-1-2.5-.5-2.5-.5-2 .5-3.5 1-2 2.5-2 2.5-4-8.5-1.5-18.5-1.5-27 0z'/%3E%3C/g%3E%3Cg fill='none'%3E%3Cpath d='m11.5 30c3.5-1 18.5-1 22 0'/%3E%3Cpath d='m12 33.5c6-1 15-1 21 0'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.R:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg stroke-linecap='butt'%3E%3Cpath d='m9 39h27v-3h-27v3z'/%3E%3Cpath d='m12 36v-4h21v4h-21z'/%3E%3Cpath d='m11 14v-5h4v2h5v-2h5v2h5v-2h4v5'/%3E%3C/g%3E%3Cpath d='m34 14l-3 3h-17l-3-3'/%3E%3Cpath d='m31 17v12.5h-17v-12.5' stroke-linejoin='miter' stroke-linecap='butt'/%3E%3Cpath d='m31 29.5l1.5 2.5h-20l1.5-2.5'/%3E%3Cpath d='m11 14h23' fill='none' stroke='%23000' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.B:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23fff' stroke-linecap='butt'%3E%3Cpath d='m9 36c3.39-.97 10.11.43 13.5-2 3.39 2.43 10.11 1.03 13.5 2 0 0 1.65.54 3 2-.68.97-1.65.99-3 .5-3.39-.97-10.11.46-13.5-1-3.39 1.46-10.11.03-13.5 1-1.354.49-2.323.47-3-.5 1.354-1.94 3-2 3-2z'/%3E%3Cpath d='m15 32c2.5 2.5 12.5 2.5 15 0 .5-1.5 0-2 0-2 0-2.5-2.5-4-2.5-4 5.5-1.5 6-11.5-5-15.5-11 4-10.5 14-5 15.5 0 0-2.5 1.5-2.5 4 0 0-.5.5 0 2z'/%3E%3Cpath d='M25 8A2.5 2.5 0 1 1 20 8 2.5 2.5 0 1 1 25 8z'/%3E%3C/g%3E%3Cpath d='m17.5 26h10m-12.5 4h15m-7.5-14.5v5m-2.5-2.5h5' stroke-linejoin='miter'/%3E%3C/g%3E%3C/svg%3E\")}.cb>.N:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cg fill='none' fill-rule='evenodd' stroke='%23000' stroke-linejoin='round' stroke-linecap='round' stroke-width='1.5'%3E%3Cg fill='%23fff'%3E%3Cpath d='m22 10c10.5 1 16.5 8 16 29h-23c0-9 10-6.5 8-21'/%3E%3Cpath d='m24 18c.38 2.91-5.55 7.37-8 9-3 2-2.82 4.34-5 4-1.042-.94 1.41-3.04 0-3-1 0 .19 1.23-1 2-1 0-4 1-4-4 0-2 6-12 6-12 0 0 1.89-1.9 2-3.5-.73-.994-.5-2-.5-3 1-1 3 2.5 3 2.5h2c0 0 .78-1.992 2.5-3 1 0 1 3 1 3'/%3E%3C/g%3E%3Cg fill='%23000'%3E%3Cpath d='M9.5 25.5A.5 .5 0 1 1 8.5 25.5 .5 .5 0 1 1 9.5 25.5z'/%3E%3Cpath d='M15 15.5A.5 1.5 0 1 1 14 15.5 .5 1.5 0 1 1 15 15.5z' transform='matrix(.866.5-.5.866 9.693-5.173)'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")}.cb>.P:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 45 45'%3E%3Cpath d='m22 9c-2.21 0-4 1.79-4 4 0 .89.29 1.71.78 2.38-1.95 1.12-3.28 3.21-3.28 5.62 0 2.03.94 3.84 2.41 5.03-3 1.06-7.41 5.55-7.41 13.47h23c0-7.92-4.41-12.41-7.41-13.47 1.47-1.19 2.41-3 2.41-5.03 0-2.41-1.33-4.5-3.28-5.62.49-.67.78-1.49.78-2.38 0-2.21-1.79-4-4-4z' fill='%23fff' stroke='%23000' stroke-linecap='round' stroke-width='1.5'/%3E%3C/svg%3E\")}.cb>.S:before{content:\"\";display:block;width:40px;height:40px;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3 -3 48 48'%3E%3Cpath d='M32.91,22.97l-19.18,-15.9c-0.14,-0.11 -0.34,-0.14 -0.5,-0.06c-0.16,0.08 -0.27,0.24 -0.27,0.43v25.22c0,0.19 0.11,0.35 0.28,0.43c0.17,0.07 0.37,0.04 0.51,-0.08l6.08,-5.63l4.41,9.25c0.64,1.33 2.24,1.89 3.57,1.26c1.33,-0.64 1.89,-2.24 1.26,-3.57l-4.44,-9.31l8.07,-1.21c0.18,-0.03 0.32,-0.17 0.37,-0.34c0.05,-0.18 -0.01,-0.36 -0.15,-0.48z' fill='%23fff' stroke='%23000' stroke-width='1.5' stroke-linecap='round'/%3E%3C/svg%3E\")}#searchWrapper{position:absolute;top:10px;left:95px}#simpleSearch input:focus,#simpleSearch input:hover{background-color:#fff}#simpleSearch{display:block;width:493px;position:relative;color:#000;background-color:#e3e6e7;border:1px solid #596066;border-radius:2px}#simpleSearch input{margin:0;padding:0;border:0;background-color:transparent;color:#000}#simpleSearch #searchInput{font-family:\"Segoe UI\",Arial,Helvetica,sans-serif;width:100%;padding:3px 4px 2px 4px;font-size:10px;-webkit-appearance:textfield}#simpleSearch #searchInput:focus{outline:0}#simpleSearch #searchInput.placeholder{color:#999}#simpleSearch #searchInput:-ms-input-placeholder{color:#999}#simpleSearch #searchInput:-moz-placeholder{color:#999}#simpleSearch #searchInput::-webkit-search-cancel-button,#simpleSearch #searchInput::-webkit-search-decoration,#simpleSearch #searchInput::-webkit-search-results-button,#simpleSearch #searchInput::-webkit-search-results-decoration{-webkit-appearance:textfield}#buttonBack{top:10px;left:2px}#buttonForward{top:10px;left:32px}#buttonRefresh{top:10px;left:62px}#buttonRevert{top:16px;left:382px}#buttonWindow{top:16px;left:418px}#buttonEdit{top:16px;left:454px}#buttonInfo{top:16px;left:490px}#buttonGraph{top:16px;left:526px}#buttonMenu{top:16px;left:562px}#buttonGo{position:absolute;top:0;right:0;background-color:#fff;width:16px;height:16px;padding:2px 4px 6px 4px;cursor:pointer}#buttonGo:hover{background-color:#ebebeb}#buttonGo{fill:#5e5e5e}.down{background-color:#999da1}.off,.on{position:absolute;color:#e3e6e7;background-position:center;background-repeat:no-repeat;width:16px;height:16px;padding:5px;border-radius:2px}.on:hover{background-color:#909aa2;cursor:pointer}.off svg{fill:#a1aab1;position:absolute}.on svg{fill:#e3e6e7;position:absolute}#buttonFlip{line-height:18px;height:16px;padding-top:2.5px;padding-bottom:2px;cursor:pointer}#buttonFlip:hover{background-color:rgba(117,131,142,.4)}#buttonStm{width:9px;height:9px;padding:5.75px 4px;cursor:pointer}#buttonStm div{width:9px;height:9px;border-radius:4.5px}#buttonStm:hover{background-color:rgba(117,131,142,.4)}#buttonStm.white div,#buttonStm.white:hover div{background-color:#fff}#buttonStm.black div,#buttonStm.black:hover div{background-color:#000}#status{background-color:#f9f9fa;color:#444;height:21px;border-style:solid;border-color:#e3e3e3;border-width:1px 0 0 1px;font-size:10px;line-height:20px;display:inline-block;padding:0 4px 0 4px;pointer-events:none;position:absolute;right:0;bottom:0}#moves{line-height:22px;font-size:10px;font-weight:600;position:relative;width:100%;top:10px;left:0;color:#000;background-color:transparent;overflow-y:scroll}#container.edit #moves{height:358px}#container.graph #moves{height:240px}#container.info #moves{height:200px}.line:nth-child(even){background-color:rgba(117,131,142,.2)}.line{height:25px;cursor:pointer;position:relative;overflow-x:hidden}.line .san{display:inline-block;width:40px;text-align:center;position:absolute;left:0}.line .info{display:inline-block;width:900px;text-align:left;position:absolute;left:140px}.line .eval{display:inline-block;width:119px;text-align:left;position:absolute;left:50px}.line .eval .numleft{display:inline-block;min-width:35px;text-align:right}.line .eval .numright{display:inline-block;min-width:40px;text-align:left}.line:hover{background-color:rgba(117,131,142,.4)}#editWrapper{width:0;height:0;opacity:0;overflow:hidden}#container.edit #editWrapper{display:block;line-height:22px;font-size:10px;font-weight:600;width:110px;height:60px;bottom:10px;right:10px;color:#fff;border-width:0;border-style:none;border-color:rgba(255,255,255,.2) #000 #000 rgba(255,255,255,.2);background-color:transparent;position:absolute;overflow:hidden;opacity:1;box-shadow:0 0 5px #000}#edit{position:relative;font-size:10px;color:#fff;font-weight:600;text-align:center}#editWrapper>.cb>div{position:absolute;width:30px;height:30px;line-height:30px}#editWrapper>.cb>div::before{width:28px;height:28px;border:1px solid transparent;border-radius:9px}#infoWrapper{width:0;height:0;opacity:0;overflow:hidden;user-select:text;-moz-user-select:text}#container.info #infoWrapper{display:block;line-height:21px;font-size:12px;width:270px;height:200px;bottom:140px;right:270px;color:#000;border-width:2px;border-style:solid;border-color:#000;background-color:transparent;position:absolute;overflow:hidden;opacity:1;overflow-y:scroll}#infoWrapper>div{position:relative;width:100%;height:100%}#infoContent{padding:1px 3px 1px 3px;height:155px;overflow-y:auto}#infoWrapper .infoIcon{width:16px;height:16px;position:absolute;cursor:pointer;text-align:center;line-height:16px;padding:0;color:#000}#infoWrapper .infoIcon:hover{color:orange}#infoWrapper .infoIcon.selected{color:#000}#infoContent div.underline{padding-bottom:3px;display:block}#infoContent .movelink{color:#000;cursor:pointer}#infoContent .movelink:hover{text-decoration:underline}#infoContent .movelink.selected{color:#000}#graphWrapper{width:0;height:0;opacity:0;overflow:hidden}#container.graph #graphWrapper{display:block;line-height:22px;font-size:10px;font-weight:600;width:100%;height:100px;top:20px;bottom:15px;background-color:transparent;position:relative;overflow:hidden;opacity:1;transform:scale(1,1);transform-origin:top left}#graph{padding-bottom:.5px;display:none}#container.graph #graph{display:block;background-color:transparent}#arrowWrapper1,#arrowWrapper2{position:absolute;pointer-events:none;display:none;filter:drop-shadow(-1px -1px 1px #fff) drop-shadow(1px 1px 1px #000);opacity:.5}#arrowWrapper1 svg,#arrowWrapper2 svg{opacity:.66}#menu{background-color:#fff;border:solid 1px #a0a0a0;top:75px;right:10px;position:absolute;box-shadow:0 0 4px hsla(0,0%,0%,.2);padding-top:6px;padding-bottom:6px;font-size:12px;color:#000}.menuLine{height:1px;margin-top:6px;margin-bottom:6px;background-color:#dedede}.menuItem{height:12px;line-height:12px;padding-left:36px;padding-right:14px;padding-top:6px;padding-bottom:6px;cursor:pointer;background-repeat:no-repeat;background-position:12px 4px}.menuItem:hover{background-color:#f0f0f0}.menuItem.disabled{color:#6d6d6d;cursor:default}.menuItem.disabled:hover{background-color:#fff}.menuItem span.key{float:right;text-align:right;color:#6d6d6d;width:47px}.menuItem.menuEngine{padding-bottom:0;padding-top:0;height:24px;padding-right:9px}.menuItem.menuEngine>span{display:inline-block;padding-top:6px;padding-bottom:6px;vertical-align:top}.menuItem.menuEngine:hover{background-color:#fff;cursor:default}#buttonEngineMinus,#buttonEnginePlus,#buttonEngineValue{float:right;cursor:pointer;margin-left:5px}#buttonEngineMinus:hover,#buttonEnginePlus:hover,#buttonEngineValue:hover{background-color:#f0f0f0}#buttonEngineMinus,#buttonEnginePlus{width:24px;height:24px;padding:0 1px;background-repeat:no-repeat;background-position:center}#buttonEngineValue{width:24px;height:12px;padding:5px 0;background-color:#f0f0f0;border:solid #d1d1d1 1px;border-radius:6px;text-align:center}#buttonEngineValue:hover{background-color:#e8e8e8}#buttonEngineMinus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-minus'%3E%3Cline x1='6' y1='12' x2='18' y2='12'%3E%3C/line%3E%3C/svg%3E\")}#buttonEnginePlus{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-plus'%3E%3Cline x1='12' y1='6' x2='12' y2='18'%3E%3C/line%3E%3Cline x1='6' y1='12' x2='18' y2='12'%3E%3C/line%3E%3C/svg%3E\")}.menuItem.menuPlay{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolygon points='10 8 16 12 10 16 10 8'%3E%3C/polygon%3E%3C/svg%3E\")}.menuItem.menuFlip{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 443 443' width='16' height='16' fill='currentColor'%3E%3Cpath d='M254.56,118.55v205.9l68.77,-27.17c2.31,-0.9 4.93,-0.16 6.43,1.81c0.73,0.99 1.11,2.16 1.11,3.32c0,1.17 -0.38,2.36 -1.14,3.36l-103.85,135.08c-1.05,1.35 -2.66,2.15 -4.37,2.15c-1.71,0 -3.33,-0.8 -4.38,-2.15l-103.84,-135.08c-1.53,-1.97 -1.53,-4.69 -0.04,-6.69c1.49,-1.96 4.11,-2.7 6.42,-1.8l68.77,27.16v-205.89l-68.76,27.16c-2.31,0.9 -4.93,0.16 -6.43,-1.8c-0.74,-0.99 -1.11,-2.17 -1.11,-3.32c0,-1.17 0.38,-2.36 1.14,-3.36l103.85,-135.08c1.05,-1.35 2.66,-2.15 4.37,-2.15c1.71,0 3.33,0.8 4.38,2.15l103.83,135.08c1.52,1.97 1.54,4.69 0.04,6.68c-1.48,1.97 -4.11,2.7 -6.42,1.8z' /%3E%3C/svg%3E\")}.menuItem.menuStm{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-play-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpath d='M12,2 a1,1 0 0,0 0,20' fill='currentColor' stroke='none' /%3E%3C/svg%3E%0A\")}.menuItem.menuKeep{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-save'%3E%3Cpath d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z'%3E%3C/path%3E%3Cpolyline points='17 21 17 13 7 13 7 21'%3E%3C/polyline%3E%3Cpolyline points='7 3 7 8 15 8'%3E%3C/polyline%3E%3C/svg%3E%0A\")}.menuItem.menuKeep.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-save'%3E%3Cpath d='M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z'%3E%3C/path%3E%3Cpolyline points='17 21 17 13 7 13 7 21'%3E%3C/polyline%3E%3Cpolyline points='7 3 7 8 15 8'%3E%3C/polyline%3E%3C/svg%3E%0A\")}.menuItem.menuRevert{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' width='16' height='16'%3E%3Cpath d='M431.85,79.13l-433.36,433.37l433.37,431.64v-273.34c463.64,-39.79 591.66,197.22 591.66,197.22c0,0 0,-431.63 -591.66,-512.94z' /%3E%3C/svg%3E%0A\")}.menuItem.menuRevert.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024' fill='%236d6d6d' width='16' height='16'%3E%3Cpath d='M431.85,79.13l-433.36,433.37l433.37,431.64v-273.34c463.64,-39.79 591.66,197.22 591.66,197.22c0,0 0,-431.63 -591.66,-512.94z' /%3E%3C/svg%3E%0A\")}.menuItem.menuEngine{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-layers'%3E%3Cpolygon points='12 2 2 7 12 12 22 7 12 2'%3E%3C/polygon%3E%3Cpolyline points='2 17 12 22 22 17'%3E%3C/polyline%3E%3Cpolyline points='2 12 12 17 22 12'%3E%3C/polyline%3E%3C/svg%3E%0A\")}.menuItem.menuReset{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-home'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'%3E%3C/path%3E%3Cpolyline points='9 22 9 12 15 12 15 22'%3E%3C/polyline%3E%3C/svg%3E%0A\")}.menuItem.menuAbout{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-help-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpath d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'%3E%3C/path%3E%3Cline x1='12' y1='17' x2='12' y2='17'%3E%3C/line%3E%3C/svg%3E%0A\")}.menuItem.menuStart{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-left-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolyline points='12 8 8 12 12 16'%3E%3C/polyline%3E%3Cline x1='16' y1='12' x2='8' y2='12'%3E%3C/line%3E%3C/svg%3E%0A\")}.menuItem.menuStart.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-left-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolyline points='12 8 8 12 12 16'%3E%3C/polyline%3E%3Cline x1='16' y1='12' x2='8' y2='12'%3E%3C/line%3E%3C/svg%3E%0A\")}.menuItem.menuEnd{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-right-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolyline points='12 16 16 12 12 8'%3E%3C/polyline%3E%3Cline x1='8' y1='12' x2='16' y2='12'%3E%3C/line%3E%3C/svg%3E%0A\")}.menuItem.menuEnd.disabled{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236d6d6d' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-arrow-right-circle'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolyline points='12 16 16 12 12 8'%3E%3C/polyline%3E%3Cline x1='8' y1='12' x2='16' y2='12'%3E%3C/line%3E%3C/svg%3E%0A\")}"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.b91f7fbe8e40c0c5a7d2.js